import './assets/index.css';
import { B as bn, W as Ql, T as an, H as Hn, i as su, R as z, K as tu, L as au, D as nu, M as ma, N as ct, U as Qe, O as Sn, P as jo, Q as Zl, V as ei, X as Pr, Y as Rr, Z as ou, _ as ru, $ as lu, a0 as bt, a1 as Lr, a2 as iu, a3 as kr, a4 as $a, a5 as si, a6 as cu, a7 as re, a8 as du, a9 as uu, aa as In, ab as fe, ac as pu, ad as mu, ae as hu, af as _u, ag as Dr, ah as fu, ai as gu, aj as xu, ak as Cu, al as bu, am as Su, an as gs, ao as Nu, ap as Eu, aq as vu, ar as Mr, as as La, at as Tu, au as ho, av as Au, h as Ce, aw as yu, ax as Br, E as ju, ay as Ur, az as Ou, aA as Iu, aB as _a, aC as Yt, aD as Lt, aE as ti, aF as ai, aG as Nn, aH as wu, aI as Pu, aJ as Ru, aK as Lu, aL as ku, aM as Fr, aN as Yn, aO as zo, aP as Du, aQ as Mu } from "./@global-configuration-DvZkjZJA.js";
import { eg as ET, ek as vT, cZ as TT, dY as AT, ba as yT, a$ as jT, b0 as OT, b1 as IT, b2 as wT, b3 as PT, bf as RT, b4 as LT, bz as kT, b as DT, dc as MT, dN as BT, cx as UT, cy as FT, di as VT, dh as GT, d7 as WT, cp as $T, cg as KT, cs as HT, cF as YT, c1 as zT, cq as qT, cC as XT, eh as JT, cw as QT, cv as ZT, dP as eA, dw as sA, dQ as tA, dR as aA, ef as nA, dS as oA, dx as rA, dC as lA, bD as iA, bT as cA, C as dA, bA as uA, c2 as pA, bH as mA, bI as hA, c9 as _A, bw as fA, d9 as gA, c_ as xA, bB as CA, bC as bA, bg as SA, bh as NA, b5 as EA, df as vA, dd as TA, c6 as AA, bO as yA, d1 as jA, ei as OA, ci as IA, bi as wA, by as PA, db as RA, b6 as LA, bE as kA, bx as DA, dD as MA, x as BA, ch as UA, dy as FA, dA as VA, dz as GA, aS as WA, el as $A, c$ as KA, dF as HA, d0 as YA, em as zA, en as qA, cu as XA, c7 as JA, ee as QA, dn as ZA, b7 as ey, bU as sy, dT as ty, dE as ay, dm as ny, aW as oy, ca as ry, dj as ly, bF as iy, eo as cy, bV as dy, bG as uy, bW as py, bX as my, du as hy, dt as _y, dX as fy, dp as gy, dG as xy, dM as Cy, dO as by, dZ as Sy, d_ as Ny, d$ as Ey, e0 as vy, e1 as Ty, ed as Ay, es as yy, er as jy, aT as Oy, bj as Iy, dl as wy, dk as Py, S as Ry, cm as Ly, dq as ky, cr as Dy, cG as My, cH as By, cI as Uy, cd as Fy, ce as Vy, cf as Gy, d2 as Wy, dr as $y, et as Ky, eu as Hy, ev as Yy, da as zy, b8 as qy, cJ as Xy, cK as Jy, cL as Qy, cM as Zy, ew as ej, cj as sj, ck as tj, cl as aj, cN as nj, ds as oj, aV as rj, dg as lj, eE as ij, dU as cj, cn as dj, cz as uj, dK as pj, d3 as mj, d4 as hj, bk as _j, eB as fj, g as gj, bl as xj, aY as Cj, aX as bj, cA as Sj, d as Nj, d8 as Ej, c0 as vj, cO as Tj, cP as Aj, dJ as yj, bY as jj, bp as Oj, co as Ij, c8 as wj, bq as Pj, br as Rj, bs as Lj, c3 as kj, eC as Dj, a as Mj, bm as Bj, bn as Uj, bZ as Fj, b_ as Vj, eA as Gj, bQ as Wj, cQ as $j, de as Kj, w as Hj, dV as Yj, dW as zj, cR as qj, bP as Xj, bK as Jj, bL as Qj, bR as Zj, ec as eO, ct as sO, eb as tO, dH as aO, dI as nO, cD as oO, d5 as rO, cc as lO, e7 as iO, aZ as cO, e5 as dO, e3 as uO, e6 as pO, e2 as mO, cb as hO, d6 as _O, ez as fO, ep as gO, cS as xO, cT as CO, cU as bO, a_ as SO, b$ as NO, bb as EO, bS as vO, be as TO, cV as AO, cE as yO, cW as jO, cX as OO, cY as IO, bd as wO, eG as PO, aR as RO, bJ as LO, ey as kO, dL as DO, e8 as MO, e4 as BO, e9 as UO, cB as FO, bt as VO, bu as GO, bv as WO, bM as $O, bN as KO, bc as HO, c4 as YO, c5 as zO, aU as qO, dv as XO, eF as JO, bo as QO, ea as ZO, ex as eI, eD as sI, dB as tI, ej as aI, eq as nI, b9 as oI } from "./@global-configuration-DvZkjZJA.js";
import { R as Bu } from "./@software-distribution-hub-jR-wGY1k.js";
import { A as lI, B as iI, C as cI, a as dI, h as uI, D as pI, G as mI, H as hI, P as _I, c as fI, b as gI, o as xI, S as CI, V as bI, d as SI, e as NI, f as EI, g as vI, n as TI, p as AI, r as yI, i as jI, j as OI, l as II, m as wI, k as PI, u as RI, v as LI } from "./@software-distribution-hub-jR-wGY1k.js";
import { j as e, i as Es, R as Qt, d as Ut, p as ni } from "./@vendor-BxhYAQFM.js";
import { ConfirmationModal as vt, ConfirmationModalVariantType as mt, Icon as D, ButtonStyleType as q, getComponentSpecificThemeClass as Vr, AppThemeType as Oo, Button as B, ButtonVariantType as U, ComponentSizeType as P, SelectPicker as te, SelectPickerVariantType as We, CodeEditor as bs, MODES as ht, isNullOrUndefined as nn, getSelectPickerOptionByValue as Xt, InfoIconTippy as Tt, DependencyType as Gr, get as xe, getUrlWithSearchParams as $e, ResourceVersionType as zn, showError as ve, put as Aa, Drawer as Vs, Progressing as cs, ToastManager as Se, ToastVariantType as Ne, AppStatus as Wr, StatusType as Ht, URLS as R, getRandomColor as Uu, processDeployedTime as Fu, useAsync as wn, Reload as ya, GenericEmptyState as Xe, getAlphabetIcon as oi, ConditionalWrap as on, TippyCustomized as ea, TippyTheme as sa, stopPropagation as Rs, useUserEmail as Vu, DEPLOYMENT_WINDOW_TYPE as Ge, ACTION_STATE as zt, MODAL_TYPE as je, VisibleModal2 as Gu, GenericSectionErrorState as hs, capitalizeFirstLetter as ta, InfoBlock as Us, Checkbox as Ft, CHECKBOX_VALUE as De, post as _s, useSearchString as Re, LoadingCard as Wu, ServerErrors as qo, API_STATUS_CODES as Xo, APPROVAL_MODAL_TYPE as js, ResponseHeaders as $u, INVALID_LICENSE_KEY as Ku, handleRedirectToLicenseActivation as Hu, ImageType as Io, DevtronCopyright as Yu, WorkflowNodeType as $r, preventDefault as zu, DeleteCINodeButton as ri, getTemplateAPIRoute as qu, GetTemplateAPIRouteType as Xu, DebouncedSearch as li, useClickOutside as Ju, ZERO_TIME_STRING as Qu, MaterialDataSource as Kr, FilterStates as Hr, FeatureTitleWithInfo as Jo, ClearIndicator as Zu, CustomInput as ke, Textarea as At, FilterConditionType as As, ApplyPolicyToStage as ka, PluginRequiredStage as ze, Option as Yr, TabGroup as ep, noop as ks, NestedBreadCrumb as sp, Grid as it, DeleteConfirmationModal as Xa, ErrorScreenNotAuthorized as rn, ResourceKindType as Is, PluginType as ii, ConsequenceAction as wo, ButtonComponentType as me, PluginImageContainer as tp, Tooltip as we, RefVariableType as ap, PipelineStageTaskActionModalType as zr, getPolicyApiUrl as np, PolicyKindType as op, getPluginsDetail as rp, getUpdatedPluginStore as lp, ErrorScreenManager as _t, MarkDown as ip, SearchBar as aa, GenericFilterEmptyState as cp, DocLink as ln, DTSwitch as ft, RemoteConnectionType as es, RadioGroup as zs, REMOTE_CONNECTION_TYPE_LABEL_MAP as _o, DEFAULT_SECRET_PLACEHOLDER as qr, RadioGroupItem as Be, useEffectAfterMount as ci, multiSelectStyles as fo, useRegisterShortcut as dp, ERROR_EMPTY_SCREEN as up, TOAST_ACCESS_DENIED as pp, Collapse as Qo, UserRoleGroupsTable as mp, DeploymentPolicy as Ye, validateTagKeyValue as di, VisibleModal as hp, validateTagValue as _p, DynamicDataTableRowDataType as ws, DynamicDataTable as Zo, useBreadcrumb as nt, BreadcrumbText as tt, getTeamListMin as er, BreadCrumb as ot, DraggableWrapper as fp, DraggablePositionVariant as gp, DraggableButton as xp, BreadcrumbStore as Cp, useMainContext as Ot, getApplicationManagementBreadcrumb as bp, SERVER_MODE as Vt, PageHeader as xt, DOCUMENTATION as sr, SideNavigation as Sp, Nodes as Os, SortingOrder as Ss, CostBreakdownViewType as V, K8S_EMPTY_GROUP as Np, DATE_TIME_FORMATS as ls, ProdNonProdSelectValueTypes as Ns, formatNumberToCurrency as Te, useQuery as se, stringComparatorBySortOrder as Ae, getAllClusterListMin as tr, Chart as na, handleAnalyticsEvent as is, Card as Ze, Pagination as ui, useStateFilters as qn, Illustration as pi, getEnvironmentOptionsGroupedByClusters as Ep, getAppOptionsGroupedByProjects as vp, CostBreakdownItemViewParamsType as Tn, useTheme as Tp, CHART_COLORS as Ap, SectionEmptyState as cn, TableSignalEnum as Sa, Badge as yt, CLUSTER_PROVIDER_TO_ICON_NAME as yp, CLUSTER_PROVIDER_TO_LABEL as jp, getUniqueId as vs, Table as oa, PaginationEnum as ra, FiltersTypeEnum as la, validateName as dn, validateDescription as ar, APIResponseHandler as at, SegmentedBarChart as mi, trash as ia, TreeView as Op, SegmentedControl as ca, DevtronProgressing as hi, getDetailedClusterList as Ip, ClusterStatusIcon as wp, DOCUMENTATION_HOME_PAGE as Pp, useBulkSelection as nr, BulkOperations as Rp, DEFAULT_ROUTE_PROMPT_MESSAGE as _i, BulkSelectionEvents as fi, logExceptionToSentry as gi, KeyValueTable as un, requiredField as Ps, getClusterOptions as or, ActionMenu as xi, getIsRequestAborted as Ci, BackupAndScheduleListViewEnum as be, StatusComponent as rr, highlightSearchText as bi, ClipboardButton as Xn, explainCronExpression as lr, Chip as Lp, getTimeDifference as Si, YAMLStringify as ir, PortalContainer as Ni, validateCronExpression as kp, usePrompt as Dp, ModalSidebarPanel as Mp, GenericModal as En, GroupedFilterSelectPicker as Na, FilterChips as Jn, SelectAllDialogStatus as Qn, BackupLocationsTypes as ge, UserIdentifier as Ei, handleUTCTime as Pn, dateComparatorBySortOrder as Xr, useQueryClient as Bp, MetricsInfoLoadingCard as vi, MetricsInfoCard as Ti, OVERVIEW_PAGE_SIZE_OPTIONS as go, LoadingDonutChart as Up, URL_FILTER_KEYS as Ai, RESOURCE_BROWSER_ROUTES as Fp, TARGET_K8S_VERSION_SEARCH_KEY as Vp, getSecurityCenterBreadcrumb as Gp, useMutation as Wp, useGetResourceKindsOptions as $p, SortableTableHeaderCell as Da, getSelectPickerOptionsByValue as xo } from "@devtron-labs/devtron-fe-common-lib";
import { ReactComponent as Zn } from "./assets/ic-arrow-square-out.5ad40e74.svg";
import { ReactComponent as Kp } from "./assets/illustration-page-blocked.b4c20189.svg";
import Hp from "./assets/how-to-unblock.e29d6544.png";
import Yp from "./assets/how-to-unblock-job.2561f2b5.png";
import zp from "./assets/post-deployment-action-required.ec0af23d.png";
import qp from "./assets/pre-deployment-action-required.59bdaef8.png";
import * as Xp from "react";
import { useState as E, createContext as eo, useContext as so, useRef as Ms, useEffect as ue, useMemo as de, useCallback as Wt, memo as Jp } from "react";
import { ReactComponent as Qp } from "./assets/ic-caret-down.c459567f.svg";
import { ReactComponent as Zp } from "./assets/ic-help-filled.c5b6b8a9.svg";
import { ReactComponent as em } from "./assets/ic-medium-arrow-right-circle.1e9cef9c.svg";
import { Link as as, useHistory as ae, useParams as ce, useLocation as he, Switch as rt, Route as le, useRouteMatch as Ts, Redirect as pn, generatePath as Q, matchPath as Po, NavLink as sm, Prompt as tm } from "react-router-dom";
import { ReactComponent as am } from "./assets/ic-global-image-digest.5676f49a.svg";
import { ReactComponent as nm } from "./assets/ic-filter.72e53c00.svg";
import { ReactComponent as om } from "./assets/ic-filter-noapply.7beac020.svg";
import { ReactComponent as rm } from "./assets/ic-clear-square.e60de021.svg";
import { ReactComponent as ja } from "./assets/ic-close.40c46877.svg";
import Ro, { components as lm } from "react-select";
import { ReactComponent as da } from "./assets/ic-add.b1e7fd27.svg";
import { h as Pe } from "./@moment-hdGw1hqW.js";
import { ReactComponent as im } from "./assets/ic-activity.e7aa48a5.svg";
import { ReactComponent as cm } from "./assets/ic-arrow-line-down.f554943b.svg";
import { ReactComponent as dm } from "./assets/dependency-empty-state.1d5de814.svg";
import { ReactComponent as Lo } from "./assets/ic-arrow-right.f942ee03.svg";
import { ReactComponent as Rn } from "./assets/ic-cross.54cad648.svg";
import { ReactComponent as cr } from "./assets/ic-help-outline.bd39bc26.svg";
import { ReactComponent as um } from "./assets/ic-devtron-app.fda22992.svg";
import { ReactComponent as pm } from "./assets/docker.447ef1f9.svg";
import { ReactComponent as mm } from "./assets/ic-arrow-backward.edab524e.svg";
import { ReactComponent as hm } from "./assets/ic-info-filled.c412513b.svg";
import { ReactComponent as yi } from "./assets/ic-user.cd5fab43.svg";
import { ReactComponent as dr } from "./assets/ic-chevron-down.c06b8238.svg";
import { ReactComponent as _m } from "./assets/ic-shield-warning.08f3ea2e.svg";
import { ReactComponent as Jr } from "./assets/arrow-chevron-down-black.3a8a8656.svg";
import { ReactComponent as to } from "./assets/ic-blackout-window.721874f5.svg";
import { ReactComponent as mn } from "./assets/ic-maintenance-window.5c0e183d.svg";
import { ReactComponent as fm } from "./assets/ic-arrows-clockwise.424f0538.svg";
import { ReactComponent as hn } from "./assets/ic-delete-interactive.63fabf04.svg";
import { ReactComponent as gm } from "./assets/ic-hibernate.e3a0a69b.svg";
import { ReactComponent as ji } from "./assets/ic-rocket.7be5910f.svg";
import { ReactComponent as xm } from "./assets/ic-unhibernate.f8ff90be.svg";
import { ReactComponent as ur } from "./assets/ic-help.a75a7835.svg";
import { ReactComponent as Cm } from "./assets/ic-timer.aa8f9398.svg";
import { ReactComponent as bm } from "./assets/ic-devtron-with-logo.c1ccfb50.svg";
import { ReactComponent as Sm } from "./assets/ic-mechanical-operation.201add3a.svg";
import Nm from "./assets/locked.15ab500b.svg";
import { ReactComponent as Em } from "./assets/ic-alert-triangle.2ec06597.svg";
import { ReactComponent as Oi } from "./assets/ic-check-encircle.273a9a7f.svg";
import { ReactComponent as vm } from "./assets/ic-timer-with-check.cca62bb5.svg";
import { ReactComponent as Ka } from "./assets/ic-linked-cd.af93dda0.svg";
import { ReactComponent as Ii } from "./assets/ic-CD.be714ab9.svg";
import { ReactComponent as wi } from "./assets/ic-search.d31b1c9d.svg";
import { ReactComponent as Tm } from "./assets/ic-calendar-blocked.2ef5940c.svg";
import { ReactComponent as Am } from "./assets/ic-check.73991ac2.svg";
import { ReactComponent as ym } from "./assets/ic-CI.97532ea1.svg";
import { ReactComponent as jm } from "./assets/ic-exclamation-outline.276ac43e.svg";
import { ReactComponent as Om } from "./assets/ic-nav-rocket.5b7562ba.svg";
import { ReactComponent as Im } from "./assets/ic-plain-filter.c0d83391.svg";
import { ReactComponent as wm } from "./assets/ic-webhook.f843d42b.svg";
import { ReactComponent as Pm } from "./assets/ic-checks.9005997e.svg";
import { ReactComponent as Ja } from "./assets/ic-warning.ddd476e3.svg";
import { ReactComponent as Qr } from "./assets/ic-like.e042e09e.svg";
import { ReactComponent as Pi } from "./assets/ic-error.b0bbe394.svg";
import Ln from "./assets/empty-tag.7e4b779e.png";
import { ReactComponent as Ri } from "./assets/ic-pencil.4b680b92.svg";
import { ReactComponent as Rm } from "./assets/ic-gear.1d95843c.svg";
import { ReactComponent as Lm } from "./assets/ic-medium-warning.410e7036.svg";
import { ReactComponent as km } from "./assets/ic-play-outline.f1ff1196.svg";
import { ReactComponent as Dm } from "./assets/ic-caret-left-small.eec57a21.svg";
import { ReactComponent as Li } from "./assets/ic-prohibit.7027aa97.svg";
import { ReactComponent as Mm } from "./assets/ic-maintenance.e5614017.svg";
import { ReactComponent as Bm } from "./assets/ic-zoom-in.cbd52794.svg";
import Um from "./assets/empty-state-key.b983ece5.svg";
import Fm from "./assets/inject-tag-info.b2eb5772.png";
import { ReactComponent as Vm } from "./assets/inject-tag.2d765245.svg";
import { ReactComponent as ki } from "./assets/ic-blue-circle.fbbe2709.svg";
import { ReactComponent as kn } from "./assets/ic-sliders-vertical.2db79ea4.svg";
import { ReactComponent as Gm } from "./assets/empty-policies-mandatory-tag.55602ed8.svg";
import { ReactComponent as Wm } from "./assets/ic-folder.4501781a.svg";
import { ReactComponent as $m } from "./assets/ic-sort-arrow.a057a930.svg";
import { ReactComponent as Di } from "./assets/ic-tag.34388acc.svg";
import { ReactComponent as Km } from "./assets/ic-arrow-clockwise.80fd562b.svg";
import { ReactComponent as Hm } from "./assets/ic-visibility-on.c2c19305.svg";
import { ReactComponent as Ym } from "./assets/ic-folder-edit.74e556c2.svg";
import zm from "./assets/no-artifact.fd2d84d9.webp";
const Cv = ({
  handleClose: s,
  handleDelete: t,
  isLoading: a,
  isOverride: n
}) => /* @__PURE__ */ e.jsx(
  vt,
  {
    variant: mt.custom,
    Icon: /* @__PURE__ */ e.jsx(D, { name: "ic-warning", color: null, size: 48 }),
    title: `Express Delete${n ? " Override" : ""}`,
    subtitle: /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 lh-20 cn-8", children: [
      n ? "This action will delete the override for this file , and the inherited configurations from the base will be used as-is." : "This action will delete this file.",
      /* @__PURE__ */ e.jsx("br", {}),
      /* @__PURE__ */ e.jsx("br", {}),
      "This action would not require any approval."
    ] }),
    buttonConfig: {
      secondaryButtonConfig: {
        text: "Cancel",
        onClick: s
      },
      primaryButtonConfig: {
        text: `Delete${n ? " Override" : ""}`,
        style: q.warning,
        onClick: t,
        isLoading: a
      }
    },
    confirmationConfig: {
      confirmationKeyword: `delete${n ? " override" : ""}`,
      identifier: n ? "express-delete-override" : "express-delete"
    },
    handleClose: s,
    shouldCloseOnEscape: !0
  }
), bv = ({
  disabled: s,
  showPromptTooltip: t,
  onClick: a,
  onClose: n,
  onDoNotShowAgainClose: o
}) => {
  const r = {
    arrow: !0,
    interactive: !0,
    visible: t,
    className: `express-edit-btn-prompt-tooltip dc__mxw-250 br-8 ${Vr(Oo.light)}`,
    placement: "bottom-end",
    content: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 p-16 bcn-8 br-8", children: [
      /* @__PURE__ */ e.jsxs("div", { className: `flex top dc__content-space ${Vr(Oo.dark)}`, children: [
        /* @__PURE__ */ e.jsx(D, { name: "ic-lightning-fill", size: 40, color: "Y500" }),
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "express-edit-prompt-tooltip-close",
            ariaLabel: "express-edit-prompt-tooltip-close",
            variant: U.borderLess,
            style: q.neutral,
            icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
            size: P.xs,
            onClick: n,
            showAriaLabelInTippy: !1
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 text__white", children: [
        /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-14 lh-20", children: "Express edit" }),
        /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20", children: "You can make direct changes in published & save without approval" })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "express-edit-btn-prompt-tooltip__do-not-show-again", children: /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "express-edit-prompt-do-not-show-again",
          variant: U.secondary,
          style: q.neutral,
          size: P.small,
          onClick: o,
          text: "Do not show me again",
          fullWidth: !0
        }
      ) })
    ] })
  }, l = {
    placement: "bottom-end",
    interactive: !0,
    content: /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 lh-20 text__white", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: s ? "Cannot express edit" : "Express edit" }),
      /* @__PURE__ */ e.jsx("br", {}),
      s ? "You can make changes and save them without approval only in the published version." : "Make changes in published & save without approval"
    ] })
  };
  return /* @__PURE__ */ e.jsx(
    B,
    {
      dataTestId: "express-edit-button",
      variant: U.secondary,
      style: q.neutral,
      text: "Edit",
      startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-lightning-fill", color: null }),
      size: P.xs,
      disabled: s,
      onClick: a,
      showTooltip: !0,
      tooltipProps: t && !s ? r : l
    },
    t.toString()
  );
}, Sv = ({
  handleClose: s,
  handleSave: t,
  isLoading: a
}) => /* @__PURE__ */ e.jsx(
  vt,
  {
    variant: mt.warning,
    title: "Existing draft will be discarded",
    subtitle: /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 lh-20 cn-8", children: [
      "Once published, existing draft will be discarded.",
      /* @__PURE__ */ e.jsx("br", {}),
      /* @__PURE__ */ e.jsx("br", {}),
      "Are you sure?"
    ] }),
    buttonConfig: {
      secondaryButtonConfig: {
        text: "Cancel",
        onClick: s
      },
      primaryButtonConfig: {
        text: "Discard Draft & Publish",
        onClick: t,
        isLoading: a
      }
    },
    handleClose: s,
    shouldCloseOnEscape: !0
  }
), Co = [
  {
    label: "Draft",
    value: "draft"
  },
  {
    label: "Published",
    value: "published"
  }
], qm = ({
  showDraftOption: s = !1,
  handleCompareWithChange: t
}) => {
  const [a, n] = E(
    Co[0]
  ), o = (r) => {
    n(r), t(r.value === Co[0].value);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half vertical-divider border__secondary--bottom py-8", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4 px-12", children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 cn-9", children: `Comparing with ${s ? "" : "Published"}` }),
      s && /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "express-edit-compare-with-dropdown",
          variant: We.COMPACT,
          value: a,
          options: Co,
          onChange: o
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "px-12", children: /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 lh-20 cn-9 flex left dc__gap-6", children: [
      /* @__PURE__ */ e.jsx(D, { name: "ic-pencil", color: "N700" }),
      /* @__PURE__ */ e.jsx("span", { children: "Editing Published" })
    ] }) })
  ] });
}, Xm = ({ title: s, lhs: t, rhs: a }) => {
  const n = (t.value ?? t.displayValue) !== (a.value ?? a.displayValue);
  return /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half", children: [
    t.displayValue ? /* @__PURE__ */ e.jsxs("div", { className: `py-8 px-16 ${n ? "bcr-1" : ""}`, children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 lh-18 cn-7", children: s }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 cn-9 dc__capitalize", children: t.displayValue })
    ] }) : /* @__PURE__ */ e.jsx("div", {}),
    !nn(a.displayValue || a.value) && /* @__PURE__ */ e.jsxs("div", { className: `py-8 px-16 ${n ? "bcg-1" : ""}`, children: [
      /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-12 lh-18 cn-7", children: s }),
      a.dropdownConfig ? /* @__PURE__ */ e.jsx("div", { className: "flex left", children: /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: `express-edit-comparison-rhs-${s}-dropdown`,
          variant: We.COMPACT,
          ...a.dropdownConfig ?? {},
          value: Xt(a.dropdownConfig.options, a.value),
          isSearchable: !1
        }
      ) }) : /* @__PURE__ */ e.jsx("p", { className: "m-0 fs-13 lh-20 cn-9 dc__capitalize", children: a.displayValue })
    ] })
  ] });
}, Nv = ({
  lhsEditor: s,
  rhsEditor: t,
  readOnly: a,
  showDraftOption: n,
  handleCompareWithChange: o,
  dataDiffConfig: r = [],
  hideEditor: l = {}
}) => {
  const i = !l.lhs && l.rhs, u = l.lhs && !l.rhs;
  return /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox-col dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(
      qm,
      {
        showDraftOption: n,
        handleCompareWithChange: o
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox-col dc__gap-16 p-16", children: [
      !!r.length && /* @__PURE__ */ e.jsx("div", { className: "border__primary br-4 py-4 vertical-divider", children: r.map((c) => /* @__PURE__ */ e.jsx(Xm, { ...c }, c.title)) }),
      !l.lhs && !l.rhs ? /* @__PURE__ */ e.jsx(bs.Container, { flexExpand: !0, children: /* @__PURE__ */ e.jsx(
        bs,
        {
          mode: ht.YAML,
          readOnly: a,
          noParsing: !0,
          diffView: !0,
          height: "fitToParent",
          originalValue: s.value,
          modifiedValue: t.value,
          onModifiedValueChange: t.onChange,
          children: /* @__PURE__ */ e.jsx("p", { className: "m-0 px-16 py-6 border__primary--bottom", children: "Data" })
        }
      ) }) : /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 dc__grid-half", children: [
        u && /* @__PURE__ */ e.jsx("div", {}),
        /* @__PURE__ */ e.jsx(bs.Container, { flexExpand: !0, children: /* @__PURE__ */ e.jsx(
          bs,
          {
            mode: ht.YAML,
            readOnly: i || a,
            noParsing: !0,
            diffView: !1,
            height: "fitToParent",
            ...u ? t : {},
            ...i ? s : {},
            children: /* @__PURE__ */ e.jsx("p", { className: "m-0 px-16 py-6 border__primary--bottom", children: "Data" })
          }
        ) }),
        i && /* @__PURE__ */ e.jsx("div", {})
      ] })
    ] })
  ] });
}, Ev = ({ isComparisonView: s, handleClose: t, toggleComparison: a }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center border__primary-warning--bottom bcy-1", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox dc__align-items-center dc__gap-12 px-8 pt-6 pb-5", children: [
    /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "express-edit-close-btn",
        ariaLabel: "express-edit-close-btn",
        icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-small", color: null }),
        showAriaLabelInTippy: !1,
        variant: U.secondary,
        style: q.negativeGrey,
        size: P.xs,
        onClick: t
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-6", children: [
      /* @__PURE__ */ e.jsx(D, { name: "ic-lightning-fill", color: "Y500" }),
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-13 lh-20 fw-6 cn-9", children: "Express Edit" }),
      /* @__PURE__ */ e.jsx(
        Tt,
        {
          heading: "Express edit",
          infoText: "Using Express Edit, you can make changes directly in the published version and save them without approval."
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "px-8 pt-4 pb-3", children: /* @__PURE__ */ e.jsx(
    B,
    {
      dataTestId: "express-edit-compare-btn",
      startIcon: /* @__PURE__ */ e.jsx(D, { name: s ? "ic-close-small" : "ic-arrows-left-right", color: null }),
      variant: U.borderLess,
      style: q.neutral,
      size: P.small,
      text: s ? "Hide comparison" : "Compare values",
      onClick: a
    }
  ) })
] }), Jm = Array.from(Array(3).keys()).map(
  (s) => ({
    environmentId: s,
    environmentName: "",
    appStatus: "",
    appName: "",
    appId: s + 1
  })
), Qm = {
  DEPENDENCIES_TITLE: "Dependencies provide better visibility into your application ecosystem",
  DEPENDENCIES_SUB_TITLE: "Clever decisions start with knowing dependencies. From design to deployment and troubleshooting, it powers an efficient application ecosystem."
}, Mi = -1, Mt = {
  UPSTREAM: Gr.UPSTREAM,
  DOWNSTREAM: Gr.DOWNSTREAM
}, qt = {
  ADD_DEPENDENCY: "addDependency",
  MAP_ENVIRONMENT: "mapEnvironment"
}, Bi = "dependency-list", Ui = eo({}), Zm = (s) => /* @__PURE__ */ e.jsx(Ui.Provider, { ...s }), ua = () => so(Ui), Fi = (s) => {
  switch (s) {
    case "app":
      return "application/devtron-application";
    default:
      throw new Error(`Invalid resource type: ${s}`);
  }
};
async function eh({
  resourceType: s,
  resourceId: t,
  version: a
}) {
  const n = `resource/dependencies/${Fi(s)}/${a}`, {
    result: { dependencies: o, childDependencies: r }
  } = await xe(
    $e(n, {
      id: t
    })
  ), l = o.reduce(
    (c, p) => (c[p.index] = {
      ...p,
      environmentDependencyMap: r.reduce((d, m) => (d[m.index] = (m.dependencies ?? []).filter(
        (_) => _.dependentOnParentIndex === p.index
      ), d), {})
    }, c),
    {}
  ), i = Object.values(l), u = r.map(({ dependencies: c, ...p }) => p);
  return Promise.resolve({ dependencyMapByDependencyIndex: l, appDependencies: i, appEnvironments: u });
}
const sh = () => xe("app/autocomplete/all"), th = async (s) => xe(`app/cd-pipeline/env/lite/${s}`), ah = async () => {
  try {
    const { result: s } = await xe("resource/list"), t = s.reduce((a, n) => {
      const o = structuredClone(n);
      return a[n.kind] = {
        ...o,
        versionSchemaDetails: (o.versionSchemaDetails ?? []).filter(
          // Only v1 is supported for now
          (r) => r.version === zn.v1
        )
      }, a;
    }, {});
    return {
      devtronResourceId: t[bn.DEVTRON_APPLICATION].devtronResourceId,
      devtronResourceSchemaId: t[bn.DEVTRON_APPLICATION].versionSchemaDetails[0].devtronResourceSchemaId,
      cdResourceId: t[bn.CD_PIPELINE].devtronResourceId,
      cdResourceSchemaId: t[bn.CD_PIPELINE].versionSchemaDetails[0].devtronResourceSchemaId
    };
  } catch (s) {
    throw ve(s), s;
  }
}, nh = ({
  dependencyMapByDependencyIndex: s,
  appEnvironments: t,
  resourceId: a,
  resourceType: n,
  version: o
}) => {
  const r = Object.values(s).map(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ({ environmentDependencyMap: i, ...u }) => u
  ), l = t.reduce((i, u) => (i[u.index] = { ...u, dependencies: [] }, i), {});
  return Object.values(s).forEach((i) => {
    Object.entries(i.environmentDependencyMap).forEach(([u, c]) => {
      l[u].dependencies.push(...c);
    });
  }), Aa(`resource/dependencies/${Fi(n)}/${o}`, {
    id: a,
    dependencies: r,
    childDependencies: Object.values(l)
  });
}, Qa = () => /* @__PURE__ */ e.jsx("svg", { height: "40", width: "100%", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ e.jsx("line", { x1: "50%", y1: "0", x2: "50%", y2: "100%", className: "svg__moving-line" }) }), Vi = () => /* @__PURE__ */ e.jsxs("svg", { width: "24", height: "36", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: [
  /* @__PURE__ */ e.jsx("circle", { cx: "12", cy: "12", r: "5", fill: "var(--B500)", className: "svg__pulse-animation" }),
  /* @__PURE__ */ e.jsx("circle", { cx: "12", cy: "12", r: "4", fill: "var(--N0)", stroke: "var(--B500)", strokeWidth: "2" })
] }), oh = ({
  handleEnvironmentChange: s,
  applicationId: t,
  selectedEnvironment: a,
  dependencyIndex: n
}) => {
  const o = {
    ...a,
    // already mapped environment is selected from metadata, because the options dropdown is not populated with the mapped environment, untill dropdown is opened
    displayName: a?.metadata?.environmentName || a?.displayName
  }, {
    resourceKindConfig: { cdResourceId: r, cdResourceSchemaId: l }
  } = ua(), [i, u] = E([]), [c, p] = E(!1), d = async () => {
    try {
      p(!0);
      const { result: x } = await th(t), C = x.map((f, h) => ({
        devtronResourceId: r,
        devtronResourceSchemaId: l,
        dependentOnParentIndex: n,
        name: f.pipelineName,
        id: f.pipelineId,
        index: h + 1,
        typeOfDependency: Mt.UPSTREAM,
        displayName: f.environmentName,
        label: f.environmentName,
        value: f.pipelineId
      }));
      u(C);
    } catch (x) {
      ve(x);
    } finally {
      p(!1);
    }
  }, m = (x) => x.displayName, _ = (x) => x.id, g = async () => {
    i.length === 0 && await d();
  };
  return (
    // Ideally this should be handled using the container
    /* @__PURE__ */ e.jsx("div", { className: "w-200", children: /* @__PURE__ */ e.jsx(
      te,
      {
        inputId: "map-environment",
        options: i,
        isLoading: c,
        onMenuOpen: g,
        placeholder: "Map environment",
        onChange: s,
        value: o.displayName === void 0 ? o.displayName : o,
        getOptionLabel: m,
        getOptionValue: _,
        isSearchable: !0
      }
    ) })
  );
};
function Zr({
  id: s,
  name: t,
  isCurrentApp: a = !1,
  dependencyIndex: n,
  dependencyData: o,
  mode: r,
  currentAppSelectedEnvironmentIndex: l,
  handleDeleteDependency: i,
  handleEnvironmentChange: u
}) {
  const c = () => {
    i(n);
  }, p = (d) => {
    u(n, d);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: `flexbox dc__align-items-center w-100 h-40 ${a ? "bcy-1 br-4" : ""}`, children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-40 svg-height-100 dc__no-shrink", children: a ? /* @__PURE__ */ e.jsxs("span", { className: "dc__position-rel", children: [
      /* @__PURE__ */ e.jsx("span", { className: "dc__position-abs", style: { left: "8px", bottom: "-2px" }, children: /* @__PURE__ */ e.jsx(Vi, {}) }),
      /* @__PURE__ */ e.jsx(Qa, {})
    ] }) : /* @__PURE__ */ e.jsx(Qa, {}) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center w-100 dc__content-space", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "h-20 flexbox dc__align-items-center fs-13 fw-4 dc__gap-16 ", children: [
        /* @__PURE__ */ e.jsx(um, { className: "icon-dim-24" }),
        /* @__PURE__ */ e.jsx("span", { className: a ? "fw-6" : "", children: t })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-16", children: [
        r === qt.MAP_ENVIRONMENT && /* @__PURE__ */ e.jsx(
          oh,
          {
            applicationId: s,
            dependencyIndex: n,
            handleEnvironmentChange: p,
            selectedEnvironment: o[n]?.environmentDependencyMap[l]?.[0]
          },
          `${s}-${l}`
        ),
        !a && /* @__PURE__ */ e.jsx(Rn, { className: "icon-dim-16 cursor", onClick: c })
      ] })
    ] })
  ] });
}
function rh({
  options: s,
  handleAddDependency: t,
  toggleSelector: a,
  isAppListDataLoading: n
}) {
  const o = (l) => l.label, r = (l) => l.value;
  return /* @__PURE__ */ e.jsx("div", { className: "w-250 pt-12", children: /* @__PURE__ */ e.jsx(
    te,
    {
      inputId: "dependency-selector",
      autoFocus: !0,
      isSearchable: !0,
      isLoading: n,
      menuIsOpen: !0,
      placeholder: "Search Application",
      options: s,
      getOptionLabel: o,
      getOptionValue: r,
      onChange: t,
      onBlur: a,
      variant: We.COMPACT
    }
  ) });
}
const el = ({ title: s, tooltip: t }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-6 dc__border-bottom-n1 pt-8 pb-8", children: [
  /* @__PURE__ */ e.jsx("div", { className: "fw-6 cn-7 fs-12 dc__uppercase", children: s }),
  /* @__PURE__ */ e.jsx(Es, { content: t, className: "default-tt", placement: "auto", arrow: !1, children: /* @__PURE__ */ e.jsx("div", { className: "flex cursor", children: /* @__PURE__ */ e.jsx(cr, { className: "icon-dim-16 cn-6" }) }) })
] });
function lh({
  appList: s,
  dependencyData: t,
  mode: a,
  selectedEnvironmentIndex: n,
  setDependencyData: o,
  setAppList: r,
  trackDependenciesUpdate: l,
  isAppListDataLoading: i
}) {
  const [u, c] = E(!1), { resourceName: p, resourceId: d } = ua(), m = () => {
    c(!u);
  }, _ = (C) => {
    l();
    const f = Object.keys(t || {}).map(Number), h = f.length ? Math.max(...f) + 1 : 0;
    o({
      ...t,
      [h]: { ...C, index: h }
    });
    const b = s.filter((S) => S.id !== C.id);
    r(b), c(!1);
  }, g = (C) => {
    l();
    const f = t[C];
    r([...s, f]);
    const h = { ...t };
    delete h[C], o(h);
  }, x = (C, f) => {
    l(), o({
      ...t,
      [C]: {
        ...t[C],
        environmentDependencyMap: {
          ...t[C].environmentDependencyMap,
          [n]: [f]
        }
      }
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "w-100 flexbox-col w-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col w-100", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox", children: [
        /* @__PURE__ */ e.jsx("div", { className: "w-40 svg-height-100 dc__no-shrink", children: /* @__PURE__ */ e.jsx(Qa, {}) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col w-100", children: [
          /* @__PURE__ */ e.jsx(
            el,
            {
              title: "Upstream Dependency",
              tooltip: `Applications providing data to ${p}`
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "h-48", children: u ? /* @__PURE__ */ e.jsx(
            rh,
            {
              options: s,
              handleAddDependency: _,
              toggleSelector: m,
              isAppListDataLoading: i
            }
          ) : /* @__PURE__ */ e.jsxs(
            "button",
            {
              onClick: m,
              className: "fw-6 flexbox dc__align-items-center pt-12 pl-0 pb-16 bg__primary dc__no-border dc__gap-4",
              type: "button",
              children: [
                /* @__PURE__ */ e.jsx(da, { className: "icon-dim-16 icon-fill-blue-imp" }),
                /* @__PURE__ */ e.jsx("span", { className: "cb-5", children: "Add Dependency" })
              ]
            }
          ) })
        ] })
      ] }),
      Object.keys(t ?? {}).length > 0 && /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: Object.values(t).map(
        (C) => C.typeOfDependency === Mt.UPSTREAM && /* @__PURE__ */ e.jsx(
          Zr,
          {
            id: C.metadata?.appId || C.id,
            dependencyIndex: C.index,
            name: C.metadata?.appName || C.name,
            dependencyData: t,
            mode: a,
            currentAppSelectedEnvironmentIndex: n,
            handleEnvironmentChange: x,
            handleDeleteDependency: g
          },
          C.metadata?.appId || C.id
        )
      ) }),
      /* @__PURE__ */ e.jsx(
        Zr,
        {
          id: d,
          name: p,
          isCurrentApp: !0,
          handleEnvironmentChange: x,
          handleDeleteDependency: g
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox pb-16", children: [
      /* @__PURE__ */ e.jsx("div", { className: "w-40 svg-height-100 dc__no-shrink", children: /* @__PURE__ */ e.jsx(Qa, {}) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx(
          el,
          {
            title: "Downstream Dependency",
            tooltip: `Applications consuming data from ${p}`
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 pt-8", children: [
          "Downstream dependencies are auto-populated if ",
          p,
          " is added as an upstream dependency in applications."
        ] })
      ] })
    ] })
  ] });
}
const ih = ({
  environmentList: s,
  selectedEnvironmentIndex: t,
  setSelectedEnvironmentIndex: a
}) => {
  const { appName: n } = ua();
  return /* @__PURE__ */ e.jsxs("aside", { className: "flexbox-col dc__gap-8 w-200", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "fs-12 lh-20 pl-8 pr-8", children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-9 fw-4", children: n }),
      /* @__PURE__ */ e.jsx("div", { className: "cn-7 fw-6 dc__uppercase", children: "Deployments" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top-n1" }),
    /* @__PURE__ */ e.jsx("div", { className: "fs-13 lh-20 fw-4 cn-9 cursor", children: s.map((o) => /* @__PURE__ */ e.jsx(
      "div",
      {
        onClick: () => a(o.index),
        className: `pt-6 pb-6 pr-8 pl-8 br-4 dc__ellipsis-right dc__word-break ${t === o.index ? "cb-5 bcb-1" : "dc__hover-n50"}`,
        children: o.metadata.environmentName
      },
      `${o.id}-${o.index}`
    )) })
  ] });
}, ch = {
  addDependency: {
    width: "600px"
  },
  mapEnvironment: {
    width: "800px"
  }
}, dh = ({
  mode: s,
  selectedEnvironmentIndexInList: t,
  isListDataLoading: a
}) => {
  const n = Ms(null), {
    appName: o,
    resourceId: r,
    dependencyMapByDependencyIndex: l,
    filteredEnvironmentList: i,
    resourceKindConfig: { devtronResourceId: u, devtronResourceSchemaId: c },
    reloadDependencyList: p,
    toggleUpdateModalOpen: d,
    allEnvironmentList: m
  } = ua(), [_, g] = E(!1), [x, C] = E([]), [f, h] = E(l), [b, S] = E(t), [O, j] = E(!1), [v, A] = E(!1), N = O || a, L = s === qt.ADD_DEPENDENCY && i.length > 0;
  ue(() => {
    l && (h(
      Object.fromEntries(
        Object.entries(l).filter(
          ([, w]) => w.typeOfDependency === Mt.UPSTREAM
        )
      )
    ), g(!0), sh().then(({ result: w }) => {
      const T = Object.values(l).map((y) => ({
        id: y.id,
        typeOfDependency: y.typeOfDependency
      })), I = w.filter(
        (y) => y.id !== r && !T.some(
          (k) => k.id === y.id && k.typeOfDependency === Mt.UPSTREAM
        )
      ).map((y) => ({
        ...y,
        devtronResourceId: u,
        devtronResourceSchemaId: c,
        environmentDependencyMap: {},
        typeOfDependency: Mt.UPSTREAM,
        label: y.name,
        value: y.id
      }));
      C(I);
    }).catch((w) => {
      ve(w);
    }).finally(() => {
      g(!1);
    }));
  }, [l, u]);
  const M = ch[s], W = () => {
    j(!0), nh({
      dependencyMapByDependencyIndex: f,
      appEnvironments: m,
      resourceId: r,
      resourceType: "app",
      version: zn.v1
    }).then(() => {
      Se.showToast({
        variant: Ne.success,
        description: "Dependencies updated successfully"
      }), (s === qt.MAP_ENVIRONMENT || s === qt.ADD_DEPENDENCY && !i.length) && d(), p();
    }).catch((w) => {
      ve(w);
    }).finally(() => {
      j(!1);
    });
  }, $ = () => {
    v || A(!0);
  };
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", width: M.width, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "h-100 bg__primary dc__position-rel flexbox-col dc__content-space dc__overflow-hidden",
      ref: n,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom", children: [
            /* @__PURE__ */ e.jsxs("h2", { className: "fs-16 cn-9 fw-6 m-0", children: [
              "Manage application dependencies for ",
              o
            ] }),
            /* @__PURE__ */ e.jsx(Rn, { className: "icon-dim-20 cursor", onClick: d })
          ] }),
          a ? /* @__PURE__ */ e.jsx(cs, {}) : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto p-16", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox", children: [
            s === qt.MAP_ENVIRONMENT && /* @__PURE__ */ e.jsx(
              ih,
              {
                environmentList: i,
                selectedEnvironmentIndex: b,
                setSelectedEnvironmentIndex: S
              }
            ),
            f && /* @__PURE__ */ e.jsx(
              lh,
              {
                appList: x,
                dependencyData: f,
                mode: s,
                selectedEnvironmentIndex: b,
                setDependencyData: h,
                setAppList: C,
                trackDependenciesUpdate: $,
                isAppListDataLoading: _
              }
            )
          ] }) })
        ] }),
        !a && /* @__PURE__ */ e.jsxs("div", { className: "dc__border-top flex right dc__gap-12 bg__primary py-16 px-20 w-100 dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            B,
            {
              text: "Cancel",
              variant: U.secondary,
              style: q.neutral,
              onClick: d,
              disabled: N,
              dataTestId: "dependency-modal-cancel-button"
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              isLoading: N,
              disabled: !v,
              onClick: W,
              text: "Save",
              ...L && {
                endIcon: /* @__PURE__ */ e.jsx(Lo, {}),
                text: "Map Environments"
              },
              dataTestId: "dependency-modal-save-button"
            }
          )
        ] })
      ]
    }
  ) });
}, uh = () => {
  const { selectedEnvironmentIndex: s, handleEnvironmentChange: t, filteredEnvironmentList: a, resourceId: n } = ua(), o = a.map((i) => ({ label: i.metadata.environmentName, value: i.index })), r = o.find((i) => i.value === s), l = (i) => {
    t(i.value);
  };
  return a.length ? /* @__PURE__ */ e.jsx(
    te,
    {
      inputId: Bi,
      options: o,
      placeholder: "Select environment",
      hideSelectedOptions: !0,
      onChange: l,
      value: r,
      variant: We.COMPACT
    }
  ) : /* @__PURE__ */ e.jsx(as, { to: `${R.APPLICATION_MANAGEMENT_APP}/${n}/edit`, className: "anchor cursor", children: /* @__PURE__ */ e.jsx(
    Es,
    {
      content: "Configure environments for the application",
      className: "default-tt",
      placement: "auto",
      arrow: !1,
      children: /* @__PURE__ */ e.jsx("span", { children: "Configure" })
    }
  ) });
}, sl = ({ dependency: s, isCurrentApp: t }) => {
  const {
    lastDeployedClassName: a,
    isLastDeployedExpanded: n,
    showAppStatus: o,
    filteredEnvironmentList: r,
    toggleUpdateModalOpen: l
  } = ua(), i = t ? "dependencies-row__current-app" : "", u = () => `${R.APPLICATION_MANAGEMENT_APP}/${s.metadata.appId}/cd-details/${s.metadata.environmentId}/${s.metadata.pipelineId}/${s.metadata.latestCdWorkflowRunnerId ?? ""}`, c = () => r.length ? s.metadata.environmentName ? s.metadata.environmentName : s.typeOfDependency === Mt.UPSTREAM ? /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 fw-4 cb-5 cursor", onClick: l, children: "Map Environment" }) : /* @__PURE__ */ e.jsxs(
    as,
    {
      to: `${R.APPLICATION_MANAGEMENT_APP}/${s.metadata.appId}/overview?tab=dependencies`,
      className: "anchor cursor flexbox flex-align-center dc__gap-4",
      children: [
        "Map Environment",
        /* @__PURE__ */ e.jsx(Zn, { className: "icon-dim-14 mw-14 scb-5" })
      ]
    }
  ) : "-", p = () => s.metadata.lastDeployedImage ? /* @__PURE__ */ e.jsx("div", { className: "cn-7 fs-14 flexbox", children: /* @__PURE__ */ e.jsx(
    Es,
    {
      content: s.metadata.lastDeployedImage,
      className: "default-tt",
      placement: "auto",
      arrow: !1,
      children: /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: `dependencies-row__last-deployed-cell bcn-1 br-6 pl-6 pr-6 ${a}`,
          children: [
            /* @__PURE__ */ e.jsx(pm, { className: "icon-dim-16" }),
            n ? /* @__PURE__ */ e.jsx("div", { className: "mono dc__ellipsis-left direction-left", children: s.metadata.lastDeployedImage }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx("div", { children: "..." }),
              /* @__PURE__ */ e.jsx("div", { className: "mono dc__ellipsis-left direction-left text-overflow-clip", children: s.metadata.lastDeployedImage.split(":").at(-1) })
            ] })
          ]
        }
      )
    }
  ) }) : s.metadata.lastDeployedImage !== void 0 ? /* @__PURE__ */ e.jsx(Wr, { status: Ht.NOT_DEPLOYED }) : "";
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `dependencies-row ${a} ${i}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "dc__position-rel flexbox", children: [
          /* @__PURE__ */ e.jsx(Qa, {}),
          t && /* @__PURE__ */ e.jsx("div", { className: "dc__align-reload-center flexbox", children: /* @__PURE__ */ e.jsx(Vi, {}) })
        ] }),
        o && /* @__PURE__ */ e.jsx(
          Wr,
          {
            status: s.metadata.lastDeployed ? s.metadata.appStatus : Ht.NOT_DEPLOYED,
            isVirtualEnv: s.metadata.isVirtualEnvironment,
            hideMessage: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          as,
          {
            to: `${R.APPLICATION_MANAGEMENT_APP}/${s.metadata.appId}/details/${s.metadata.environmentId === Mi || s.metadata.environmentId === void 0 ? "" : `${s.metadata.environmentId}/`}`,
            className: `anchor fs-13 dc__ellipsis-right ${t ? "cn-9 fw-6" : ""}`,
            children: s.metadata.appName
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "fs-13 dc__ellipsis-right", children: t ? /* @__PURE__ */ e.jsx(uh, {}) : c() }),
        p(),
        s.metadata.lastDeployed && /* @__PURE__ */ e.jsxs("span", { className: "fs-13 fw-4 cn-9 dc__ellipsis-right dc__word-break flex left dc__gap-6", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "flex left dc__gap-8", children: [
            /* @__PURE__ */ e.jsx(
              "span",
              {
                className: "icon-dim-20 mw-20 flex dc__border-radius-50-per dc__uppercase cn-0 fw-4",
                style: {
                  backgroundColor: Uu(s.metadata.lastDeployedBy)
                },
                children: s.metadata.lastDeployedBy[0]
              }
            ),
            /* @__PURE__ */ e.jsx("span", { children: s.metadata.lastDeployedBy })
          ] }),
          /* @__PURE__ */ e.jsx(as, { to: u(), className: "anchor cursor", children: Fu(s.metadata.lastDeployed, o) })
        ] })
      ]
    },
    `dep-row-${s.metadata.appId}-${s.metadata.environmentId}-${s.index}`
  );
}, bo = ({ dependencyList: s, isCurrentApp: t }) => {
  const { selectedEnvironmentIndex: a } = ua();
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: s.map((n) => {
    const o = n.environmentDependencyMap[a] ?? [];
    return o.length ? o.map((r) => /* @__PURE__ */ e.jsx(
      sl,
      {
        dependency: {
          ...r,
          typeOfDependency: n.typeOfDependency,
          metadata: {
            ...r.metadata,
            // Use the dependency data explicitly instead of the pipeline mapping
            ...n.metadata
          }
        },
        isCurrentApp: t
      },
      `${r.index}-${r.id}-${r.metadata.environmentId}`
    )) : /* @__PURE__ */ e.jsx(
      sl,
      {
        dependency: {
          ...n,
          dependentOnParentIndex: -1,
          metadata: {
            // If there is no environment for the app
            environmentId: Mi,
            environmentName: "",
            ...n.metadata
          }
        }
      },
      `${n.index}-${n.metadata.appId}`
    );
  }) });
}, { DEPENDENCIES_TITLE: ph, DEPENDENCIES_SUB_TITLE: mh } = Qm, hh = ({
  resourceId: s,
  isArgoInstalled: t,
  resourceName: a,
  resourceType: n,
  isUpdateModalOpen: o,
  filteredEnvIds: r,
  toggleUpdateModalOpen: l,
  toggleButtonDisabledState: i
}) => {
  const [u, c, p, d] = wn(
    () => eh({ resourceId: s, resourceType: n, version: zn.v1 }),
    [s]
  ), [m, _] = wn(ah), [g, x] = E(!1), [C, f] = E(!1), [h, b] = E(), S = g ? "last-deployed-expanded" : "", { appDependencies: O = [], appEnvironments: j = [], dependencyMapByDependencyIndex: v = {} } = c ?? {}, A = de(() => r?.split(","), [r]), N = de(
    () => r ? j.filter(
      (X) => X.metadata?.environmentId && A?.includes(X.metadata.environmentId.toString())
    ).sort((X, Oe) => X.metadata.environmentName.localeCompare(Oe.metadata.environmentName)) : j,
    [j, A]
  ), L = Ms(A), M = u || C, W = N.find((X) => X.index === h) ?? {}, $ = t && N.length > 0, { upstreamDependencies: w, downstreamDependencies: T } = de(
    () => ({
      upstreamDependencies: O.filter(
        (X) => X.typeOfDependency === Mt.UPSTREAM
      ),
      downstreamDependencies: O.filter(
        (X) => X.typeOfDependency === Mt.DOWNSTREAM
      )
    }),
    [c]
  ), I = N.length && w.length ? qt.MAP_ENVIRONMENT : qt.ADD_DEPENDENCY;
  ue(() => {
    N.length && (b((X) => X === void 0 || A !== L.current ? N[0].index : X), L.current = A);
  }, [N]), ue(() => {
    i(O.length === 0 || M);
  }, [M]);
  const y = () => {
    x(!g);
  }, k = (X) => {
    f(!0), b(X), setTimeout(() => {
      f(!1);
    }, 500);
  }, G = () => {
    Qt.event({
      category: "Application Dependency",
      action: "Add Dependency click",
      label: "Add Dependency click"
    }), l();
  }, K = () => /* @__PURE__ */ e.jsxs(
    "button",
    {
      type: "button",
      className: "flex flex-align-center cta dc__gap-4 dependencies-wrapper__empty-state-button",
      onClick: G,
      children: [
        /* @__PURE__ */ e.jsx(da, { className: "icon-dim-12" }),
        /* @__PURE__ */ e.jsx("span", { children: "Add Dependency" })
      ]
    }
  );
  return p ? /* @__PURE__ */ e.jsx(ya, { reload: d }) : /* @__PURE__ */ e.jsx("div", { className: "flex column left", children: /* @__PURE__ */ e.jsxs(
    Zm,
    {
      value: {
        lastDeployedClassName: S,
        isLastDeployedExpanded: g,
        showAppStatus: $,
        selectedEnvironmentIndex: h,
        handleEnvironmentChange: k,
        filteredEnvironmentList: N,
        allEnvironmentList: j,
        resourceId: s,
        appName: a,
        dependencyMapByDependencyIndex: v,
        toggleUpdateModalOpen: l,
        resourceName: a,
        resourceKindConfig: _ ?? {},
        reloadDependencyList: d
      },
      children: [
        O.length > 0 || M ? /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: `dependencies-wrapper ${$ ? "dependencies-wrapper--show-app-status" : ""} w-100`,
            children: [
              /* @__PURE__ */ e.jsxs(
                "div",
                {
                  className: `dependencies-header display-grid dc__align-items-center dc__border-bottom dc__uppercase fs-12 fw-6 cn-7 pr-16 pl-16 ${S}`,
                  children: [
                    /* @__PURE__ */ e.jsx("span", {}),
                    $ && /* @__PURE__ */ e.jsx(im, { className: "icon-dim-16" }),
                    /* @__PURE__ */ e.jsx("span", { children: "Dependent Applications" }),
                    /* @__PURE__ */ e.jsx("span", { children: "Environment" }),
                    /* @__PURE__ */ e.jsxs("span", { className: `flex left dc__gap-4 ${S}`, children: [
                      "Last deployed",
                      /* @__PURE__ */ e.jsx(
                        "button",
                        {
                          type: "button",
                          className: "dc__outline-none-imp p-0 dc__transparent flex",
                          onClick: y,
                          "aria-label": "Expand last deployment",
                          children: /* @__PURE__ */ e.jsx(
                            cm,
                            {
                              className: "icon-dim-14 scn-5 rotate",
                              style: { "--rotateBy": g ? "90deg" : "-90deg" }
                            }
                          )
                        }
                      )
                    ] }),
                    /* @__PURE__ */ e.jsx("span", { children: "Deployed by" })
                  ]
                }
              ),
              /* @__PURE__ */ e.jsx("div", { className: "dependencies-body show-shimmer-loading", id: Bi, children: M ? (
                // Skeleton loader for the table
                Jm.map((X) => /* @__PURE__ */ e.jsxs(
                  "div",
                  {
                    className: `dependencies-row ${S}`,
                    children: [
                      /* @__PURE__ */ e.jsx("span", { className: "child child-shimmer-loading" }),
                      $ && /* @__PURE__ */ e.jsx("div", { className: "child child-shimmer-loading" }),
                      /* @__PURE__ */ e.jsx("div", { className: "child child-shimmer-loading" }),
                      /* @__PURE__ */ e.jsx("div", { className: "child child-shimmer-loading" }),
                      /* @__PURE__ */ e.jsx("div", { className: "child child-shimmer-loading" }),
                      /* @__PURE__ */ e.jsx("div", { className: "child child-shimmer-loading" })
                    ]
                  },
                  `${X.appId}-${X.environmentId}`
                ))
              ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx(bo, { dependencyList: w }),
                /* @__PURE__ */ e.jsx(
                  bo,
                  {
                    dependencyList: [
                      {
                        ...W,
                        // Adding this for type safety, but this won't be of the type
                        typeOfDependency: W.typeOfDependency,
                        environmentDependencyMap: {
                          [h]: [
                            {
                              index: W.index,
                              name: W.name,
                              id: W.id,
                              devtronResourceId: W.devtronResourceId,
                              typeOfDependency: W.typeOfDependency,
                              metadata: {
                                ...W.metadata,
                                appId: s,
                                appName: a
                              },
                              dependentOnParentIndex: h,
                              label: W.name,
                              value: W.id
                            }
                          ]
                        }
                      }
                    ],
                    isCurrentApp: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(bo, { dependencyList: T }),
                /* @__PURE__ */ e.jsx("div", { className: "dependencies-row dependencies-row__info-bar", children: /* @__PURE__ */ e.jsxs("div", { className: "fs-13 lh-20 fw-4 cn-7", children: [
                  "Downstream dependent applications are populated when ",
                  a,
                  " is added as an upstream dependency in other applications."
                ] }) })
              ] }) })
            ]
          }
        ) : /* @__PURE__ */ e.jsx("div", { className: "w-100 mh-500 bg__primary flex en-2 bw-1 br-4", children: /* @__PURE__ */ e.jsx(
          Xe,
          {
            layout: "row",
            title: ph,
            subTitle: mh,
            contentClassName: "empty-state-content",
            SvgImage: dm,
            isButtonAvailable: !0,
            renderButton: K
          }
        ) }),
        o && /* @__PURE__ */ e.jsx(
          dh,
          {
            mode: I,
            selectedEnvironmentIndexInList: h,
            isListDataLoading: M || m
          },
          `dependency-modal-${h}`
        )
      ]
    }
  ) });
}, vv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hh
}, Symbol.toStringTag, { value: "Module" })), Gi = ({ excludedUserEmails: s, rootClassName: t = "" }) => {
  const a = () => s?.sort((n, o) => n > o ? 1 : -1).map((n) => /* @__PURE__ */ e.jsxs("div", { className: "flex left fs-13 mb-8 lh-20", children: [
    oi(n, "dc__no-shrink"),
    /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: n })
  ] }));
  return /* @__PURE__ */ e.jsx("div", { className: t, children: a() });
}, ko = (s, t) => s?.length ? s.includes(t) ? s.length - 1 : s.length : 0, _h = (s, t) => `/dashboard${R.APPLICATION_MANAGEMENT_APP}/${s}/overview?tab=about&envId=${t}`, fh = ({
  excludedUserEmails: s,
  userActionState: t,
  withoutTippy: a,
  currentUserEmail: n,
  isUserExcludedInProfile: o
}) => {
  const r = ko(s, n) === 0, l = ko(s, n), i = /* @__PURE__ */ e.jsx(
    Gi,
    {
      excludedUserEmails: s,
      userActionState: t,
      rootClassName: "p-12 mxh-350 dc__overflow-auto"
    }
  ), u = () => /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
    /* @__PURE__ */ e.jsx(yi, { className: "icon-dim-20 mr-8 fcv-5" }),
    "Users allowed to take action"
  ] }), c = (d) => /* @__PURE__ */ e.jsx(
    ea,
    {
      theme: sa.white,
      className: "w-300",
      placement: "bottom",
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      heading: u(),
      additionalContent: i,
      children: /* @__PURE__ */ e.jsx("div", { onClick: Rs, children: d })
    }
  ), p = () => {
    let d = "";
    return o ? l >= 1 && (d += ` ${l} other ${l > 1 ? "users" : "user"}`) : l > 0 ? d += `${l} ${l === 1 ? "user" : "users"}` : r && (d = "No user"), d;
  };
  return /* @__PURE__ */ e.jsx(on, { condition: !a && !r, wrap: (d) => c(d), children: /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `${r || a ? "" : "cb-5 cursor"} ${o ? "ml-4" : ""} mr-4`,
      children: p()
    }
  ) });
}, _n = ({
  excludedUserEmails: s,
  hideUserIcon: t,
  windowType: a,
  rootClassName: n = "",
  iconClass: o = "",
  withoutTippy: r
}) => {
  const { email: l } = Vu(), i = s.includes(l), u = ko(s, l), c = () => a === Ge.BLACKOUT ? "fcy-7" : a === Ge.MAINTENANCE ? "fcg-5" : "", p = () => !i && u === 0 ? " is " : " are ", d = () => (
    // isUserExcludedInProfile is true when current user is included in excludedUserEmails
    /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      i ? "You" : "",
      i && u > 0 && " and ",
      /* @__PURE__ */ e.jsx(
        fh,
        {
          excludedUserEmails: s,
          userActionState: zt.ALLOWED,
          currentUserEmail: l,
          isUserExcludedInProfile: i,
          withoutTippy: r
        }
      ),
      p(),
      "allowed to take action"
    ] })
  );
  return /* @__PURE__ */ e.jsxs("div", { className: `flex left ${n}`, children: [
    !t && /* @__PURE__ */ e.jsx(yi, { className: `icon-dim-16 mr-8 ${c()} ${o}` }),
    /* @__PURE__ */ e.jsx("div", { className: "flex left", children: d() })
  ] });
}, Tv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _n
}, Symbol.toStringTag, { value: "Module" })), gh = ({ deploymentWindowProfile: s, key: t, isActive: a }) => {
  const n = s.type === Ge.BLACKOUT, o = () => s.deploymentWindowList.map((u, c) => /* @__PURE__ */ e.jsxs("div", { className: "window-card-wrapper fs-12", "data-testId": `window-${c}`, children: [
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: `br-4 mw-4 fw-6 ${s.type === Ge.BLACKOUT ? "bcy-5" : "bcg-5"}`
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "cn-7 ln-16", children: [
        " ",
        a ? "Active" : "Next",
        " Window "
      ] }),
      /* @__PURE__ */ e.jsx(Ql, { deploymentWindow: u, timeZone: s.timeZone })
    ] })
  ] }, s.id)), r = () => /* @__PURE__ */ e.jsxs("div", { className: `${n ? "cy-7" : "cg-5"} fw-6`, children: [
    a ? "ACTIVE " : "NEXT ",
    n ? Ge.BLACKOUT : Ge.MAINTENANCE,
    " WINDOW"
  ] }), l = () => /* @__PURE__ */ e.jsxs("div", { children: [
    r(),
    /* @__PURE__ */ e.jsx("div", { className: "fw-6 mt-8 fs-13 dc__truncate", "data-testId": "window-name", children: s.name }),
    /* @__PURE__ */ e.jsx("div", { className: "fs-12 dc__truncate", "data-testId": "window-description", children: s.description })
  ] }), i = () => n ? /* @__PURE__ */ e.jsx(to, { className: "dc__align-start icon-dim-40" }) : /* @__PURE__ */ e.jsx(mn, { className: "dc__align-start icon-dim-40" });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `confirmation-window-card-wrapper p-16 cn-9 ${s.type === Ge.BLACKOUT ? " ey-2 confirmation-blackout" : "eg-2 confirmation-maintenance"} br-4 bw-1`,
      "data-testId": "confirmation-window-card",
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space top pb-16 dc__gap-12", children: [
          l(),
          i()
        ] }),
        o()
      ]
    },
    t
  );
}, xh = ({ profiles: s, className: t }) => {
  const [a, n] = E(1), o = (u) => {
    u > s.length ? n(1) : u < 1 ? n(s.length) : n(u);
  }, r = () => {
    o(a + 1);
  }, l = () => {
    o(a - 1);
  }, i = () => s.length > 1 && /* @__PURE__ */ e.jsxs("div", { className: "carousel-slide__action-buttons flex dc__content-space bg__primary", children: [
    /* @__PURE__ */ e.jsxs("span", { className: "fw-6", children: [
      s.length > 1 && s.length,
      " Active"
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex right", children: [
      /* @__PURE__ */ e.jsx(
        Jr,
        {
          className: "icon-dim-20 action-prev__icon carousel-slide__action flex cursor",
          style: { transform: "rotate(90deg)" },
          onClick: l
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "carousel-slide__slide-count ml-4 mr-4" }),
      /* @__PURE__ */ e.jsx(
        Jr,
        {
          className: "icon-dim-20 action-prev__icon carousel-slide__action flex cursor",
          style: { transform: "rotate(-90deg)" },
          onClick: r
        }
      )
    ] })
  ] });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      onClick: Rs,
      className: `deployment-carousel__wrapper deployment-carousel-container ${t || ""}`,
      "data-testId": "deployment-carousel",
      children: [
        s.map((u, c) => /* @__PURE__ */ e.jsx(
          "div",
          {
            className: `carousel-slide pb-12 ${c === a - 1 ? "active-slide" : ""}`,
            children: /* @__PURE__ */ e.jsx(
              gh,
              {
                deploymentWindowProfile: u.deploymentWindowProfile,
                isActive: u.isActive
              },
              u.deploymentWindowProfile.id
            )
          },
          `carousel-slide-${u.deploymentWindowProfile.name}`
        )),
        i()
      ]
    }
  );
}, Ch = ({
  environmentState: s,
  calculatedTimestamp: t,
  environmentProfileDetails: a,
  envId: n,
  isActive: o
}) => {
  const [r, l] = E(!1), i = a[n].blackoutWindows.filter((_) => _.isActive), u = i?.length > 0 ? [] : a[n].maintenanceWindows.filter((_) => !_.isActive), c = [...i, ...u], p = (_) => {
    _.stopPropagation(), l(!r);
  }, d = () => /* @__PURE__ */ e.jsx("div", { className: "flex column mt-16 dc__align-center h-200 bg__secondary br-4", children: /* @__PURE__ */ e.jsx("div", { className: "w-100 flex center", children: /* @__PURE__ */ e.jsx("span", { className: "w-300", children: "No window active" }) }) });
  if (!c?.length) return d();
  const m = () => /* @__PURE__ */ e.jsx(xh, { profiles: c, className: "restriction-window-card dc__overflow-auto pl-12 pr-12" });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `${r ? "restriction-card__expanded" : "restriction-card__wrapper"} ${s.userActionState === zt.BLOCKED && !r ? "h-48" : ""} ${c.length > 1 && r ? "restriction-card__multiple-carousel-cards " : ""} br-4 fs-13 lh-20 cursor`,
      onClick: p,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space top p-12", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
            /* @__PURE__ */ e.jsx(_m, {}),
            /* @__PURE__ */ e.jsxs("div", { className: "ml-12", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "fw-6 flex left", children: [
                "Restriction ",
                /* @__PURE__ */ e.jsx(
                  an,
                  {
                    endTime: t,
                    showClockIcon: !1,
                    reloadAfterTimeEnd: !0,
                    rootClassName: "fs-13 dc__lowercase",
                    isActive: s.appliedProfile.deploymentWindowProfile.type === Ge.MAINTENANCE ? !o : o
                  }
                )
              ] }),
              s.userActionState === zt.PARTIAL && s.excludedUserEmails.length > 0 && // If the user has partial access and there are other excluded users as well, render the ExcludedUsersDescription component
              /* @__PURE__ */ e.jsx(
                _n,
                {
                  excludedUserEmails: s.excludedUserEmails,
                  userActionState: s.userActionState
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(dr, { className: `icon-dim-20 rotate cursor ${r ? "dc__flip-180" : ""}` })
        ] }),
        r && m()
      ]
    }
  );
}, bh = ({ type: s }) => {
  switch (s) {
    case je.HIBERNATE:
      return /* @__PURE__ */ e.jsx(gm, { className: "icon-dim-16  scn-0 mr-8" });
    case je.UNHIBERNATE:
      return /* @__PURE__ */ e.jsx(xm, { className: "icon-dim-16 scn-0 mr-8" });
    case je.RESTART:
      return /* @__PURE__ */ e.jsx(fm, { className: "icon-dim-16 dc__no-svg-fill scn-0 mr-8" });
    case je.DEPLOY:
      return /* @__PURE__ */ e.jsx(ji, { className: "icon-dim-16 dc__no-svg-fill scn-0 mr-8" });
    case je.PIPELINE:
    case je.RESOURCE:
      return /* @__PURE__ */ e.jsx(hn, { className: "icon-dim-16 dc__no-svg-fill mr-8" });
    default:
      return null;
  }
}, Sh = ({
  onClose: s,
  isLoading: t = !1,
  type: a,
  onClickActionButton: n,
  appName: o,
  envName: r,
  strategyName: l,
  appId: i,
  envId: u,
  resourceName: c,
  forceDelete: p,
  apiCallInProgress: d,
  forceDeleteHandler: m
}) => {
  const { environmentProfileDetails: _, environmentStateMap: g, appliedProfile: x, loading: C } = Hn({
    appId: i,
    envId: u
  }), [f, h] = E(!0), [b, S] = E(!1), O = () => {
    S(!b);
  }, j = () => /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom-n1", children: [
    b && /* @__PURE__ */ e.jsx(mm, { className: "icon-dim-20 cursor", onClick: O }),
    /* @__PURE__ */ e.jsxs("h2", { className: "fs-16 cn-9 fw-6 m-0", children: [
      su[a],
      " is blocked"
    ] }),
    /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "close-window-confirmation",
        onClick: s,
        icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
        size: P.xxs,
        ariaLabel: "close deployment window confirmation",
        showAriaLabelInTippy: !1,
        style: q.negativeGrey,
        variant: U.borderLess
      }
    )
  ] }), v = () => {
    let $ = "";
    return a === je.HIBERNATE ? $ = `Pods for application '${o}' will be scaled down to 0 on environment '${r}'.` : a === je.UNHIBERNATE ? $ = `Pods for application '${o}' will be scaled up to its original count on environment '${r}'.` : a === je.RESTART ? $ = `Pods for selected workloads will be restarted. Configured deployment strategy "${l}" will be used to restart selected workloads.` : a === je.RESOURCE ? $ = `Deleting the resource ‘${c}’ may impact the active service.` : a === je.DEPLOY ? $ = `A deployment will be triggered for this application on environment '${r}'.` : a === je.PIPELINE && ($ = `Deleting the deployment pipeline will delete the service and may impact traffic for application ‘${o}’.`), $ ? /* @__PURE__ */ e.jsx(Us, { description: $ }) : null;
  }, A = () => a === je.RESOURCE ? /* @__PURE__ */ e.jsx(
    Ft,
    {
      isChecked: p,
      value: De.CHECKED,
      disabled: d,
      onChange: m,
      dataTestId: "force-delete-checkbox",
      rootClassName: "fs-13",
      children: "Force delete resource"
    }
  ) : null, N = () => /* @__PURE__ */ e.jsxs("div", { className: `flex ${a === je.RESOURCE ? "dc__content-space" : "right"} dc__border-top-n1 p-16`, children: [
    A(),
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        className: `${f ? "dc__disabled" : ""} pl-12 cta flex fw-6 fs-13 cn-9 ${a === je.PIPELINE || a === je.RESOURCE ? "delete" : ""}`,
        onClick: !f && n,
        "data-testid": "deployment-window-confirmation-dialog-action-button",
        children: [
          /* @__PURE__ */ e.jsx(bh, { type: a }),
          a === je.PIPELINE || a === je.RESOURCE ? "Delete" : "",
          " ",
          ta(a),
          a === je.RESTART ? " workloads" : ""
        ]
      }
    )
  ] }), L = () => /* @__PURE__ */ e.jsxs("div", { className: "flex column mt-16 dc__align-center h-200 bg__secondary br-4 fs-13", children: [
    /* @__PURE__ */ e.jsx(hm, { className: "icon-dim-24 mb-4" }),
    /* @__PURE__ */ e.jsx("div", { className: "fw-6 cn-9 mb-8", children: "No users are allowed to take action" }),
    /* @__PURE__ */ e.jsx("div", { className: "w-100 flex center", children: /* @__PURE__ */ e.jsx("span", { className: "w-300", children: "No users are allowed to take action during the restricted period" }) })
  ] }), M = () => g[u].userActionState === zt.BLOCKED ? g[u].excludedUserEmails.length ? /* @__PURE__ */ e.jsx(
    Gi,
    {
      excludedUserEmails: g[u].excludedUserEmails || [],
      userActionState: g[u].userActionState
    }
  ) : L() : (
    // handling user with partial action state
    /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        Bu,
        {
          type: a,
          setActionButtonDisabled: h,
          rootClassName: "mt-16 mb-16"
        }
      ),
      v()
    ] })
  ), W = () => t || C ? /* @__PURE__ */ e.jsx("div", { className: "flex mh-250", children: /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) }) : !g[u] || g[u].userActionState === zt.ALLOWED ? /* @__PURE__ */ e.jsx(hs, { reload: () => window.location.reload() }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "deployment-window__confirmation-body p-16 dc__overflow-auto mxh-350 mh-250", children: [
      /* @__PURE__ */ e.jsx(
        Ch,
        {
          environmentState: g[u],
          calculatedTimestamp: x.calculatedTimestamp,
          environmentProfileDetails: _,
          envId: u,
          isActive: x.isActive
        }
      ),
      g[u].userActionState === zt.BLOCKED && /* @__PURE__ */ e.jsx(
        _n,
        {
          excludedUserEmails: g[u].excludedUserEmails,
          rootClassName: "fs-13 fw-6 mt-16 mb-12",
          iconClass: "icon-dim-20",
          withoutTippy: !0
        }
      ),
      M()
    ] }),
    g[u].userActionState === zt.PARTIAL && N()
  ] });
  return /* @__PURE__ */ e.jsx(Gu, { className: "app-status__material-modal", children: /* @__PURE__ */ e.jsxs("div", { className: "deployment-window-confirmation modal__body br-8 bg__primary p-0 mt-40 w-500", children: [
    j(),
    W()
  ] }) });
}, Av = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sh
}, Symbol.toStringTag, { value: "Module" })), Nh = ({
  excludedUserEmails: s,
  userActionState: t,
  warningMessage: a
}) => {
  const n = () => /* @__PURE__ */ e.jsxs("span", { className: "fs-13 cn-9 flex", children: [
    a,
    ". ",
    /* @__PURE__ */ e.jsx(
      _n,
      {
        excludedUserEmails: s,
        userActionState: t,
        hideUserIcon: !0
      }
    )
  ] });
  return /* @__PURE__ */ e.jsx(
    Us,
    {
      description: n(),
      variant: "warning",
      borderConfig: { top: !1, left: !1, right: !1 },
      borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 }
    }
  );
}, yv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nh
}, Symbol.toStringTag, { value: "Module" }));
function Wi() {
  return xe(z.ENVIRONMENT_LIST_MIN);
}
function Eh() {
  return xe(z.DIGEST_POLICY);
}
function vh(s) {
  return _s(z.DIGEST_POLICY, s);
}
const So = () => {
  const s = (t) => /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 pt-8 pb-8", style: { width: t } });
  return /* @__PURE__ */ e.jsxs("div", { className: "overview-window-card-row overview-window-card--shimmer-row pt-8 pb-8", children: [
    s("100%"),
    s("100%")
  ] });
}, Do = ({
  deploymentWindowProfile: s,
  type: t,
  isActive: a,
  calculatedTimestamp: n,
  excludedUserEmails: o,
  rootClassName: r,
  windowType: l,
  userActionState: i,
  key: u
}) => {
  const c = s.type === Ge.BLACKOUT, p = (f) => s.deploymentWindowList.map((h) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flexbox fs-12 mb-4 dc__gap-8 ${t === je.APP_DETAILS_STATUS || t === je.OVERVIEW ? "" : "mr-32"}`,
      "data-testId": "window-card__timestamp",
      children: [
        /* @__PURE__ */ e.jsx("span", { className: "flex", children: tu(h.frequency, c, t) }),
        /* @__PURE__ */ e.jsx(
          Ql,
          {
            deploymentWindow: h,
            timeZone: s.timeZone,
            rootClassName: f || ""
          }
        )
      ]
    },
    s.id
  )), d = () => c ? /* @__PURE__ */ e.jsx(to, { className: "icon-dim-32" }) : /* @__PURE__ */ e.jsx(mn, { className: "icon-dim-32" }), m = () => /* @__PURE__ */ e.jsxs("div", { className: "w-90", "data-testId": "window-card__meta-data", children: [
    /* @__PURE__ */ e.jsx("div", { className: "fw-6 fs-13 lh-20", children: s.name }),
    /* @__PURE__ */ e.jsx("div", { className: "fs-12", children: s.description })
  ] }), _ = () => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flex right dc__align-items-center fw-6 min-w-200 ${a ? "cg-5" : "cn-9"}`,
      "data-testId": "window-care__timer",
      children: [
        a ? /* @__PURE__ */ e.jsx("div", { className: "dc__bullet icon-dim-8-imp mr-6 bcg-5" }) : /* @__PURE__ */ e.jsx(Cm, { className: "mr-6" }),
        /* @__PURE__ */ e.jsx(an, { endTime: n, showClockIcon: !1, reloadAfterTimeEnd: !0, isActive: a })
      ]
    }
  ), g = () => /* @__PURE__ */ e.jsxs("div", { className: "window-card__modal-status lh-18", "data-testId": "window-card__modal-status", children: [
    d(),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex top dc__content-space", children: [
        m(),
        /* @__PURE__ */ e.jsx("div", { children: t === je.APP_DETAILS_STATUS && _() })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "h-1 bg__primary mt-12 mb-12" }),
      /* @__PURE__ */ e.jsxs("div", { className: `${r} dc__gap-4`, children: [
        p("fs-13-imp"),
        /* @__PURE__ */ e.jsx(
          _n,
          {
            excludedUserEmails: o,
            windowType: l,
            userActionState: i,
            rootClassName: "fs-13-imp"
          }
        )
      ] })
    ] })
  ] }), x = () => /* @__PURE__ */ e.jsxs("div", { "data-testId": "window-card__overview", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex top dc__content-space pb-12", children: [
      m(),
      d()
    ] }),
    p()
  ] }), C = () => t === je.OVERVIEW ? x() : g();
  return /* @__PURE__ */ e.jsxs("div", { className: "window-card-wrapper cn-9 mb-8", "data-testId": "window-info-card-wrapper", children: [
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: `br-4 mw-4 fw-6 ${s.type === Ge.BLACKOUT ? "bcy-5" : "bcg-5"}`
      }
    ),
    /* @__PURE__ */ e.jsx(
      "div",
      {
        "data-testId": "window-card__info",
        className: `window-card__info br-4 p-12 bw-1 w-100 ${s.type === Ge.BLACKOUT ? "bcy-1 ey-2" : "bcg-1 eg-2 "} `,
        children: C()
      }
    )
  ] }, u);
}, Th = ({ appId: s, filteredEnvIds: t }) => {
  const { loading: a, environmentProfileDetails: n, reloadData: o } = Hn({
    appId: s,
    modalType: je.OVERVIEW,
    filteredEnvIds: t
  }), [r, l] = E(!0), [i, u] = E({}), { searchParams: c } = Re(), p = ae(), d = !Object.keys(n).length, m = () => {
    Wi().then((N) => {
      const L = {};
      N.result.forEach((M) => {
        L[M.id] = M.environment_name;
      }), u(L);
    }).catch((N) => {
      ve(N);
    }).finally(() => {
      l(!1);
    });
  };
  ue(() => {
    m();
  }, []);
  const _ = (N) => {
    const L = {
      ...c,
      envId: N
    };
    N === c.envId && delete L.envId, p.push({
      search: new URLSearchParams(L).toString()
    });
  }, g = () => /* @__PURE__ */ e.jsxs("div", { className: "p-12 fs-13 fw-4 lh-20", children: [
    /* @__PURE__ */ e.jsx("span", { children: "Deployment windows enforce durations during which deployments are:" }),
    /* @__PURE__ */ e.jsxs("ol", { className: "dc__list-style-disc m-0 pl-20", children: [
      /* @__PURE__ */ e.jsx("li", { children: "Blocked (Blackout window)" }),
      /* @__PURE__ */ e.jsx("li", { children: "Allowed (Maintenance window)" })
    ] })
  ] }), x = () => /* @__PURE__ */ e.jsx(
    ea,
    {
      theme: sa.white,
      className: "w-300",
      placement: "bottom",
      Icon: ur,
      iconClass: "fcv-5",
      heading: "Deployment Window",
      additionalContent: g(),
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      children: /* @__PURE__ */ e.jsx("div", { "data-testid": "deployment-window-help-tippy", className: "flex ml-8", children: /* @__PURE__ */ e.jsx(cr, { className: "icon-dim-20 cursor" }) })
    }
  ), C = () => /* @__PURE__ */ e.jsxs("div", { className: "overview-window-card-row dc__border-bottom-n1 pt-8 pb-8 cn-7", children: [
    /* @__PURE__ */ e.jsx("div", { className: "fs-12 fw-6 w-200", children: "ENVIRONMENT" }),
    /* @__PURE__ */ e.jsx("div", { className: "fs-12 fw-6", children: "DEPLOYMENT WINDOWS" }),
    /* @__PURE__ */ e.jsx("div", {})
  ] }), f = (N) => N.map((L) => /* @__PURE__ */ e.jsx("div", { className: "window-card-column", children: /* @__PURE__ */ e.jsx(
    Do,
    {
      deploymentWindowProfile: L.deploymentWindowProfile,
      type: je.OVERVIEW,
      reloadData: o
    }
  ) }, L.deploymentWindowProfile.id)), h = (N) => /* @__PURE__ */ e.jsx("div", { className: "dc__border-dashed lh-20 cursor bc-b50 flex column center dc__align-center p-20 br-4 cn-7 fs-12 mh-98", children: /* @__PURE__ */ e.jsxs("span", { className: "w-200 lh-18", children: [
    "No ",
    N,
    " windows are configured for this environment"
  ] }) }), b = (N) => /* @__PURE__ */ e.jsxs("div", { className: "overview-window-card", children: [
    /* @__PURE__ */ e.jsx("div", { className: "ml-12", children: n[N].blackoutWindows.length ? f(n[N].blackoutWindows) : h("blackout") }),
    /* @__PURE__ */ e.jsx("div", { children: n[N].maintenanceWindows.length ? f(n[N].maintenanceWindows) : h("maintenance") })
  ] }), S = (N) => /* @__PURE__ */ e.jsxs("div", { className: "dc__border-left mb-8", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "overview-window-card cn-7 fw-6 mb-12 pt-8", children: [
      /* @__PURE__ */ e.jsx("div", { className: "ml-12", children: "BLACKOUT WINDOW" }),
      /* @__PURE__ */ e.jsx("div", { children: "MAINTENANCE WINDOW" })
    ] }),
    b(N)
  ] }), O = () => Object.keys(n).map((N) => /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "overview-window-card-row overview-window-card-row pt-8 pb-8 lh-20 fw-12 cursor dc__gap-20",
        "data-testid": "deployment-window-overview-row",
        onClick: () => _(N),
        children: [
          /* @__PURE__ */ e.jsx("div", { className: "dc__ellipsis-right w-200 fw-6 dc__align-self-center", children: i[N] }),
          c.envId === N ? /* @__PURE__ */ e.jsx("div", {}) : /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
            /* @__PURE__ */ e.jsxs("span", { children: [
              n[N].blackoutWindows.length,
              " Blackout window "
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "dc__bullet ml-4 dc__bullet--d2 mr-4" }),
            /* @__PURE__ */ e.jsxs("span", { children: [
              n[N].maintenanceWindows.length,
              " Maintenance window"
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(
            dr,
            {
              className: `icon-dim-20 rotate cursor ${c.envId === N ? "dc__flip-180" : ""}`
            }
          )
        ]
      }
    ),
    c.envId === N && S(N)
  ] })), j = () => /* @__PURE__ */ e.jsxs("div", { className: "", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-6 flex left mb-8", children: [
      "Deployment Window",
      x()
    ] }),
    C()
  ] }), v = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(So, {}),
    /* @__PURE__ */ e.jsx(So, {}),
    /* @__PURE__ */ e.jsx(So, {})
  ] }), A = () => a || r ? v() : O();
  return d ? null : /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "deployment-window-overview pt-16 pl-16 pr-16 pb-8 bg__primary en-2 bw-1 br-4 fs-13 mb-12",
      "data-testId": "deployment-window-overview",
      children: [
        j(),
        A()
      ]
    }
  );
}, jv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Th
}, Symbol.toStringTag, { value: "Module" })), Ah = ({ type: s, rootClassName: t, id: a }) => {
  const n = s === Ge.BLACKOUT;
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      "data-testid": "deployment-window-card__shadow",
      className: `app-details-info-card app-details-info__shadow-card pointer deployment-window-card__shadow flex left br-8 mr-6 lh-20 mh-95 ${t} ${n ? "bcy-1" : "bcg-1"}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "app-details-info-card__top-container flex h-60", children: [
          /* @__PURE__ */ e.jsx("div", { className: "app-details-info-card__top-container__content" }),
          n ? /* @__PURE__ */ e.jsx(to, { className: "icon-dim-24" }) : /* @__PURE__ */ e.jsx(mn, { className: "icon-dim-24" })
        ] }),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: `app-details-info-card__bottom-container ${n ? Ge.BLACKOUT.toLowerCase() : Ge.MAINTENANCE.toLowerCase()}`
          }
        )
      ]
    },
    a
  );
}, yh = ({ cardLoading: s, appId: t, envId: a }) => {
  const { appliedProfile: n, loading: o, reloadData: r, statusCardStack: l } = Hn({
    appId: t,
    envId: a
  }), i = !n?.deploymentWindowProfile, u = n?.deploymentWindowProfile.type === Ge.BLACKOUT, c = ae(), p = (m) => {
    m.stopPropagation(), c.push({
      search: au
    });
  };
  if (n === void 0 || i || Object.keys(n).length === 0)
    return null;
  if (o || s)
    return /* @__PURE__ */ e.jsx(Wu, {});
  const d = () => l.length > 0 && /* @__PURE__ */ e.jsx(e.Fragment, { children: l.filter((m) => m.name !== n.deploymentWindowProfile.name).map((m, _) => /* @__PURE__ */ e.jsx(
    Ah,
    {
      type: m.type,
      rootClassName: `indexing-window-${_ + 1}`,
      id: m.id
    }
  )) });
  return /* @__PURE__ */ e.jsxs("div", { className: "deployment-window-card cn-9 flex left", onClick: p, children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        "data-testid": "deployment-window-card",
        className: `app-details-info-card app-details-info-card__first-card pointer flex left br-8 lh-20 dc__zi-10 w-200 mh-95 ${u ? "blackout bcy-1" : "maintenance bcg-1"}`,
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: "app-details-info-card__top-container flex", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "app-details-info-card__top-container__content", children: [
              /* @__PURE__ */ e.jsx("div", { className: "app-details-info-card__top-container__content__title-wrapper", children: /* @__PURE__ */ e.jsxs("div", { className: "fs-12 fw-4 cn-7 mr-5 dc__capitalize", children: [
                u ? Ge.BLACKOUT.toLowerCase() : Ge.MAINTENANCE.toLowerCase(),
                " Window"
              ] }) }),
              /* @__PURE__ */ e.jsx(
                Es,
                {
                  className: "default-tt",
                  content: n.deploymentWindowProfile.name,
                  placement: "top",
                  arrow: !1,
                  children: /* @__PURE__ */ e.jsx("div", { className: "fs-12 fw-4 dc__truncate cn-9 fw-6 fs-13 mw-140", children: n.deploymentWindowProfile.name })
                }
              )
            ] }),
            u ? /* @__PURE__ */ e.jsx(to, { className: "icon-dim-24" }) : /* @__PURE__ */ e.jsx(mn, { className: "icon-dim-24" })
          ] }),
          /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: `app-details-info-card__bottom-container dc__content-space  lh-18 ${u ? "blackout" : "maintenance"}`,
              children: [
                /* @__PURE__ */ e.jsx("span", { className: "app-details-info-card__bottom-container__message fs-12 flex left", children: /* @__PURE__ */ e.jsx("span", { className: "fw-6 fw-6 fs-13", children: /* @__PURE__ */ e.jsx(
                  an,
                  {
                    endTime: n.calculatedTimestamp,
                    showClockIcon: !1,
                    callbackAfterTimeEnd: r,
                    isActive: n.isActive
                  }
                ) }) }),
                /* @__PURE__ */ e.jsx("div", { className: "deployment-window-info-card__bottom-container__details fs-12 fw-6 cb-5", children: "Details" })
              ]
            }
          )
        ]
      }
    ),
    d()
  ] });
}, Ov = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yh
}, Symbol.toStringTag, { value: "Module" })), jh = ({ appId: s, envId: t }) => {
  const a = Ms(null), n = ae(), { environmentProfileDetails: o, loading: r, reloadData: l, environmentStateMap: i } = Hn({
    appId: s,
    envId: t
  }), u = () => {
    n.replace({
      search: ""
    });
  }, c = (g) => {
    g.keyCode === 27 && u();
  };
  ue(() => (document.addEventListener("keydown", c), () => {
    document.removeEventListener("keydown", c);
  }), []);
  const p = () => /* @__PURE__ */ e.jsxs("div", { children: [
    "View all deployment windows configured for this application.",
    /* @__PURE__ */ e.jsx(
      "a",
      {
        className: "anchor ml-6",
        href: _h(s, t),
        rel: "noreferrer noopener",
        "data-testId": "overview-link",
        children: "Go to Overview"
      }
    )
  ] }), d = () => /* @__PURE__ */ e.jsx(
    Us,
    {
      description: p(),
      borderConfig: { top: !1, left: !1, right: !1 },
      borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 }
    }
  ), m = (g) => /* @__PURE__ */ e.jsxs("div", { className: "dc__uppercase fw-6 fs-13 lh-1-5 cn-9", children: [
    g,
    " WINDOW"
  ] }), _ = () => o[t] && /* @__PURE__ */ e.jsxs("div", { className: "pl-20 pr-20", children: [
    o[t].blackoutWindows?.length > 0 && /* @__PURE__ */ e.jsx("div", { className: "window-card-column mb-20", children: /* @__PURE__ */ e.jsxs("div", { children: [
      m(Ge.BLACKOUT),
      /* @__PURE__ */ e.jsx("div", { className: "cn-7", children: "No new deployment related changes can be made to this application during the set period." }),
      /* @__PURE__ */ e.jsx("div", { className: "mt-16", children: o[t].blackoutWindows.map((g) => /* @__PURE__ */ e.jsx(
        Do,
        {
          deploymentWindowProfile: g.deploymentWindowProfile,
          type: je.APP_DETAILS_STATUS,
          excludedUserEmails: g.excludedUserEmails,
          calculatedTimestamp: g.calculatedTimestamp,
          isActive: g.isActive,
          reloadData: l,
          rootClassName: "fs-13 lh-1-5",
          windowType: Ge.BLACKOUT,
          userActionState: i[t].userActionState
        },
        g.deploymentWindowProfile.id
      )) })
    ] }) }),
    o[t].maintenanceWindows?.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "window-card-column mb-20", children: [
      m(Ge.MAINTENANCE),
      /* @__PURE__ */ e.jsx("div", { className: "cn-7", children: "Deployment related changes to this application can be performed only during the set period." }),
      /* @__PURE__ */ e.jsx("div", { className: "mt-16", children: o[t].maintenanceWindows.map((g) => /* @__PURE__ */ e.jsx(
        Do,
        {
          deploymentWindowProfile: g.deploymentWindowProfile,
          type: je.APP_DETAILS_STATUS,
          excludedUserEmails: g.excludedUserEmails ?? [],
          isActive: g.isActive,
          calculatedTimestamp: g.calculatedTimestamp,
          reloadData: l,
          rootClassName: "fs-13 lh-1-5",
          windowType: Ge.MAINTENANCE,
          userActionState: i[t].userActionState
        },
        g.deploymentWindowProfile.id
      )) })
    ] })
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "deployment-window-status-modal bg__primary pt-16 pb-16 pl-20 pr-20 cn-9", children: /* @__PURE__ */ e.jsx(Vs, { position: "right", width: "800px", children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "h-100 flexbox-col bg__primary",
      "data-testid": "deployment-status-drawer",
      ref: a,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "dc__box-shadow pb-12 pt-12 bg__primary", children: /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "title flex dc__content-space pl-20 pr-20 show-shimmer-loading",
            "data-testid": "app-status-cross",
            children: [
              /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx("div", { className: "cn-9 fs-16 fw-6 flexbox flex-align-center", children: "Deployment Window" }) }),
              /* @__PURE__ */ e.jsx(
                B,
                {
                  dataTestId: "deployment-window-modal__close-button",
                  onClick: u,
                  icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
                  size: P.xs,
                  ariaLabel: "close deployment window confirmation",
                  showAriaLabelInTippy: !1,
                  style: q.negativeGrey,
                  variant: U.borderLess
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ e.jsx("div", { className: "bg__primary dc__overflow-auto h-100", children: r ? /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
          d(),
          _()
        ] }) })
      ]
    }
  ) }) });
}, Iv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jh
}, Symbol.toStringTag, { value: "Module" })), Oh = ({ windowName: s, endTime: t }) => {
  const a = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 flexbox dc__content-space", children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("span", { children: "Maintenance window active" }),
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "fw-6 dc__ellipsis-right cn-9", children: s })
    ] }),
    /* @__PURE__ */ e.jsx(an, { endTime: t, reloadAfterTimeEnd: !0, isActive: !0 })
  ] });
  return !t || !s ? null : /* @__PURE__ */ e.jsx(
    Us,
    {
      description: a(),
      variant: "success",
      borderConfig: { top: !1, left: !1, right: !1 },
      borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 },
      customIcon: /* @__PURE__ */ e.jsx(mn, {})
    }
  );
}, wv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Oh
}, Symbol.toStringTag, { value: "Module" }));
var Kt = /* @__PURE__ */ ((s) => (s[s.APPROVED = 0] = "APPROVED", s[s.ALREADY_IMAGE_APPROVED = 1] = "ALREADY_IMAGE_APPROVED", s[s.REQUEST_CANCELLED_DISCARDED = 2] = "REQUEST_CANCELLED_DISCARDED", s[s.ALREADY_CONFIG_APPROVED = 3] = "ALREADY_CONFIG_APPROVED", s))(Kt || {});
const ha = {
  CONFIGURATION_ALREADY_APPROVED: "Configuration change is already approved",
  DEPLOYMENT_APPROVAL_ALREADY_APPROVED: "Image is already approved",
  CONFIGURATION_APPROVED_SUCCESSFULY: "Configuration change approved successfully",
  DEPLOYMENT_APPROVED_SUCCESSFULLY: "Image approved successfully",
  APPROVAL_REQUEST_INVALID: "Approval request is no longer valid",
  REQUEST_CANCELLED_SUBTITLE: "Request might have been cancelled."
}, wt = {
  TAGS: "Tags",
  COMMENT: "Comment",
  IMAGE_TAGS: "Image Tags",
  FILE_NAME: "File Name",
  FILE_TYPE: "File Type"
}, tl = new qo({
  code: 403,
  errors: [{ code: Xo.UNAUTHORIZED, internalMessage: "Unauthorized", userMessage: "Unauthorized" }]
}), Ih = ({ approvalNotificationData: s, approvalType: t }) => {
  const a = s.configApproval.draftState === Kt.ALREADY_CONFIG_APPROVED || s.deploymentApproval.status === Kt.ALREADY_IMAGE_APPROVED || s.imagePromotionApproval.status === Kt.ALREADY_IMAGE_APPROVED, n = s.configApproval.draftState === Kt.REQUEST_CANCELLED_DISCARDED || s.deploymentApproval.status === Kt.REQUEST_CANCELLED_DISCARDED || s.imagePromotionApproval.status === Kt.REQUEST_CANCELLED_DISCARDED, o = () => {
    let g = "";
    return a ? g = t === js.CONFIG ? ha.CONFIGURATION_ALREADY_APPROVED : ha.DEPLOYMENT_APPROVAL_ALREADY_APPROVED : n ? g = ha.APPROVAL_REQUEST_INVALID : g = t === js.CONFIG ? ha.CONFIGURATION_APPROVED_SUCCESSFULY : ha.DEPLOYMENT_APPROVED_SUCCESSFULLY, g;
  }, r = () => a ? /* @__PURE__ */ e.jsx(vm, { className: "icon-dim-72" }) : n ? /* @__PURE__ */ e.jsx(Em, { className: "icon-dim-72" }) : /* @__PURE__ */ e.jsx(Oi, { className: "icon-dim-72" }), l = () => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `${a || n ? "bcy-1" : "bcg-1"} p-20 flex column fs-14 br-8 lh-20 dc__align-center`,
      children: [
        r(),
        /* @__PURE__ */ e.jsx("div", { className: "fw-6 fs-16 pt-16 pb-4 lh-24", children: o() }),
        n ? ha.REQUEST_CANCELLED_SUBTITLE : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "pb-4", children: Ut(s.notificationMetaData.eventTime).format(
            nu.TWELVE_HOURS_FORMAT
          ) }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            "by ",
            s.notificationMetaData.approvedBy
          ] })
        ] })
      ]
    }
  ), i = (g, x, C) => {
    const f = Array.isArray(x) ? x.join(", ") : x;
    return (g === wt.COMMENT || g === wt.TAGS) && !f ? null : /* @__PURE__ */ e.jsxs("div", { className: `mt-12 mb-12 lh-20 ${C ?? ""}`, children: [
      /* @__PURE__ */ e.jsx("div", { className: "cn-7", children: g }),
      /* @__PURE__ */ e.jsx("div", { className: "fs-14 dc__word-break-all", children: f })
    ] });
  }, u = () => /* @__PURE__ */ e.jsxs("div", { className: "approval__row--half", children: [
    i("Application", s.notificationMetaData.appName, "mt-16 mb-16"),
    t !== js.IMAGE_PROMOTION && i(
      t === js.CONFIG ? "Change Impacts" : "Environment",
      s.notificationMetaData.envName ? s.notificationMetaData.envName : "Base configuration",
      "mt-16 mb-16"
    )
  ] }), c = () => t !== js.IMAGE_PROMOTION ? null : /* @__PURE__ */ e.jsxs("div", { className: "approval__row--half", children: [
    i(
      "Source",
      s.imagePromotionApproval.sourceInfo,
      "pt-16 pb-16 m-0-imp"
    ),
    i(
      "Target Environment",
      s.notificationMetaData.envName,
      "pt-16 pb-16 m-0-imp"
    )
  ] }), p = () => {
    const g = t === js.DEPLOYMENT ? s.deploymentApproval : s.imagePromotionApproval, { dockerImageUrl: x, imageComment: C, imageTagNames: f } = g;
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      i(wt.IMAGE_TAGS, x),
      C && i(wt.COMMENT, C, "m-0"),
      i(wt.TAGS, f)
    ] });
  }, d = () => /* @__PURE__ */ e.jsxs("div", { className: "dc__gap-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "approval__row--half", children: [
      i(
        wt.FILE_TYPE,
        s.configApproval.protectConfigFileType
      ),
      i(
        wt.FILE_NAME,
        s.configApproval.protectConfigFileName
      )
    ] }),
    s.configApproval.protectConfigComment && i(
      wt.COMMENT,
      s.configApproval.protectConfigComment,
      "m-0"
    )
  ] }), m = () => /* @__PURE__ */ e.jsxs("div", { className: "dc__border-top-n1", children: [
    /* @__PURE__ */ e.jsx("div", { className: "fw-6 fs-14 mt-16", children: t === js.CONFIG ? "File details" : "Image details" }),
    t === js.CONFIG ? d() : p()
  ] }), _ = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    u(),
    c(),
    m()
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "approval-body p-20", children: [
    l(),
    _()
  ] });
};
async function pr(s, t, a, n, o) {
  const r = {
    method: t,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "api-token": a
    },
    signal: o,
    body: void 0,
    credentials: "include"
  };
  return fetch(`${window.__ORCHESTRATOR_ROOT__}/${s}`, r).then((l) => {
    if (l.headers.get($u.LICENSE_STATUS) === Ku)
      throw Hu(), tl;
    return l.json();
  }).then(async (l) => {
    if (l.code === 403)
      throw tl;
    if (l.code >= 300 && l.code <= 599)
      throw new qo({ code: l.code, errors: l.errors });
    return l;
  });
}
const wh = (s) => pr(z.NOTIFIER_CHANNEL_CONFIG_APPROVE, "POST", s), Ph = (s) => pr(z.NOTIFIER_CHANNEL_DEPLOYMENT_APPROVE, "POST", s), Rh = (s) => pr(z.NOTIFIER_CHANNEL_IMAGE_PROMOTION_APPROVE, "POST", s), Lh = (s) => {
  switch (s) {
    case js.CONFIG:
      return wh;
    case js.DEPLOYMENT:
      return Ph;
    case js.IMAGE_PROMOTION:
      return Rh;
    default:
      throw new Error(`Invalid approval modal type: ${s}`);
  }
}, kh = (s, t) => t === js.CONFIG ? {
  protectConfigFileType: s.protectConfigFileType,
  protectConfigFileName: s.protectConfigFileName,
  protectConfigComment: s.protectConfigComment,
  protectConfigLink: s.protectConfigLink,
  draftState: s.draftState
} : {
  protectConfigFileType: "",
  protectConfigFileName: "",
  protectConfigComment: "",
  protectConfigLink: "",
  draftState: ""
}, Dh = (s, t) => t === js.DEPLOYMENT ? {
  imageTagNames: s.imageTagNames,
  imageComment: s.imageComment,
  imageApprovalLink: s.imageApprovalLink,
  dockerImageUrl: s.dockerImageUrl,
  status: s.status
} : {
  imageTagNames: [],
  imageComment: "",
  imageApprovalLink: "",
  dockerImageUrl: "",
  status: ""
}, Mh = (s, t) => t === js.IMAGE_PROMOTION ? {
  imageTagNames: s.imageTagNames,
  imageComment: s.imageComment,
  dockerImageUrl: s.dockerImageUrl,
  status: s.status,
  sourceInfo: s.sourceInfo
} : {
  imageTagNames: [],
  imageComment: "",
  dockerImageUrl: "",
  status: "",
  sourceInfo: ""
}, Bh = ({ approvalType: s, approvalToken: t }) => {
  const [a, n] = E(!0), [o, r] = E(null), [l, i] = E(0), [u, c] = E(null), p = (C) => ({
    configApproval: kh(C, s),
    deploymentApproval: Dh(C, s),
    imagePromotionApproval: Mh(C, s),
    notificationMetaData: {
      appName: C.notificationMetaData.appName,
      envName: C.notificationMetaData.envName,
      eventTime: C.notificationMetaData.eventTime,
      approvedBy: C.notificationMetaData.approvedBy
    }
  }), d = async () => {
    try {
      n(!0);
      const f = await Lh(s)(t);
      c(p(f.result)), i(f.code);
    } catch (C) {
      C instanceof qo && i(C.code), r(C.errors?.[0]?.userMessage || ma.REQUEST_COULD_NOT_BE_PROCESSED);
    } finally {
      n(!1);
    }
  };
  ue(() => {
    d();
  }, []);
  const m = () => /* @__PURE__ */ e.jsx("div", { className: "approval-header flex p-16 dc__border-bottom-n1", children: /* @__PURE__ */ e.jsx(bm, { className: "devtron-logo" }) }), _ = () => /* @__PURE__ */ e.jsx(Ih, { approvalNotificationData: u, approvalType: s }), g = () => /* @__PURE__ */ e.jsxs("div", { className: "generic-approval__footer flex dc__content-space dc__border-top-n1 p-16", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
      /* @__PURE__ */ e.jsx("a", { href: "https://twitter.com/DevtronL", target: "_blank", className: "cursor pr-12 flex", rel: "noreferrer", children: /* @__PURE__ */ e.jsx(
        "img",
        {
          src: "https://cdn.devtron.ai/images/twitter-new.png",
          className: "icon-dim-20",
          alt: "devtron-twitter"
        }
      ) }),
      /* @__PURE__ */ e.jsx(
        "a",
        {
          href: "https://www.linkedin.com/company/devtron-labs/mycompany/",
          target: "_blank",
          className: "cursor pr-12 flex",
          rel: "noreferrer",
          children: /* @__PURE__ */ e.jsx(
            "img",
            {
              src: "https://cdn.devtron.ai/images/linkedin_social_dark.png",
              className: "icon-dim-20",
              alt: "devtron-linkedin"
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx("a", { href: "https://devtron.ai/blog/", target: "_blank", className: "cursor pr-12 flex", rel: "noreferrer", children: "Blog" }),
      /* @__PURE__ */ e.jsx("a", { href: "https://devtron.ai/", target: "_blank", className: "cursor pr-12 flex", rel: "noreferrer", children: "Website" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "generic-approval__copyright cn-5", children: /* @__PURE__ */ e.jsx(Yu, {}) })
  ] }), x = () => a ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      SvgImage: Sm,
      title: ma.HOLD_ON,
      subTitle: ma.FETCHING_NOTIFICATION_DETAILS,
      imageType: Io.Large,
      classname: "mh-440"
    }
  ) : o ? l === 403 ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      image: Nm,
      title: ma.UNAUTHORIZED,
      subTitle: ma.UNAUTHORIZED_MESSAGE,
      classname: "mh-440"
    }
  ) : /* @__PURE__ */ e.jsx(
    Xe,
    {
      title: ma.UNABLE_TO_PROCESS,
      subTitle: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate--clamp-6", children: o }),
      classname: "mh-440",
      imageType: Io.Large
    }
  ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    _(),
    g()
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "bg__tertiary flex top w-100 h-100vh", children: /* @__PURE__ */ e.jsxs("div", { className: "bg__primary w-600 m-20 fs-13", children: [
    m(),
    x()
  ] }) });
}, Pv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bh
}, Symbol.toStringTag, { value: "Module" }));
function Uh({
  x: s,
  y: t,
  width: a,
  height: n,
  configDiffView: o,
  title: r,
  redirectTo: l,
  blockAddNewPipeline: i,
  toggleCDMenu: u,
  history: c,
  readOnly: p,
  handleSelectedNodeChange: d,
  selectedNode: m,
  id: _,
  isLastNode: g,
  deploymentAppDeleteRequest: x,
  appId: C,
  workflowId: f,
  getWorkflows: h,
  isTemplateView: b
}) {
  const S = (N) => {
    if (zu(N), Rs(N), !i) {
      if (x) {
        Se.showToast({
          variant: Ne.error,
          description: "Deployment pipeline cannot be attached to a pipeline being deleted."
        });
        return;
      }
      g ? u() : d({
        nodeType: $r.CI,
        id: _
      });
    }
  }, O = (N) => {
    N.stopPropagation(), !p && l && c && c.push(l);
  }, j = `${m?.nodeType}-${m?.id}`, v = `${$r.CI}-${_ ?? ""}`, A = () => {
    const N = {
      appId: C,
      appWorkflowId: Number(f),
      pipelineId: Number(_),
      pipelineName: r
    };
    return /* @__PURE__ */ e.jsx(
      ri,
      {
        testId: `sync-cd-deployment-pipeline-button-${r}-delete`,
        deletePayloadConfig: N,
        title: r,
        getWorkflows: h,
        isTemplateView: b
      }
    );
  };
  return /* @__PURE__ */ e.jsx(
    "foreignObject",
    {
      className: "data-hj-whitelist",
      x: s,
      y: t,
      width: a,
      height: n,
      style: { overflow: "visible" },
      children: o ? /* @__PURE__ */ e.jsx("div", { className: "workflow-node", children: /* @__PURE__ */ e.jsxs("div", { className: "workflow-node__title flex", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "workflow-node__full-width-minus-Icon", children: [
          /* @__PURE__ */ e.jsx("span", { className: "workflow-node__text-light", children: "Build" }),
          /* @__PURE__ */ e.jsx("div", { className: "dc__ellipsis-left", children: r })
        ] }),
        /* @__PURE__ */ e.jsx(Ka, { className: "icon-dim-20" })
      ] }) }) : /* @__PURE__ */ e.jsxs(
        "div",
        {
          "data-testid": `workflow-editor-link-cd-${r}`,
          className: `dc__border br-8 bg__primary pl-12 flexbox dc__align-items-center h-100 flexbox dc__content-space ${p ? "" : "cursor node-hover-shadow"}`,
          role: p ? null : "button",
          onClick: O,
          tabIndex: -1,
          children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-items-center pt-12 pb-12", children: [
              /* @__PURE__ */ e.jsx(Ka, { className: "icon-dim-18 dc__no-shrink" }),
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__ellipsis-right", children: [
                /* @__PURE__ */ e.jsx("span", { className: "cn-7 m-0 fs-10 fw-4 lh-14", "data-testid": "linked-indication-name", children: "Sync with..." }),
                /* @__PURE__ */ e.jsx(Es, { className: "default-tt dc__word-break-all", arrow: !0, placement: "bottom", content: r, children: /* @__PURE__ */ e.jsx("p", { className: "dc__ellipsis-right m-0 cn-9 fs-12 fw-6 lh-16", children: r }) })
              ] })
            ] }),
            !p && j !== v && /* @__PURE__ */ e.jsxs("div", { className: "h-100 dc__border-left-n1 w-24 dc__align-items-center dc__grid-rows-2 ci-node__action-button dc__right-radius-8", children: [
              /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1", children: /* @__PURE__ */ e.jsx(
                B,
                {
                  ariaLabel: i ? ct.CANT_ADD_DEPLOYMENT_PIPELINE : ct.ADD_NEW_DEPLOYMENT_PIPELINE,
                  variant: U.borderLess,
                  dataTestId: `sync-cd-add-deployment-pipeline-button-${r}`,
                  onClick: S,
                  icon: /* @__PURE__ */ e.jsx(D, { size: 12, name: "ic-add", color: null }),
                  size: P.xxs_small_icon,
                  style: q.neutral,
                  fullWidth: !0,
                  showTooltip: !0,
                  tooltipProps: {
                    placement: "right",
                    content: i ? ct.CANT_ADD_DEPLOYMENT_PIPELINE : ct.ADD_NEW_DEPLOYMENT_PIPELINE
                  }
                }
              ) }),
              A()
            ] })
          ]
        }
      )
    }
  );
}
const Rv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uh
}, Symbol.toStringTag, { value: "Module" })), Fh = (s, t) => {
  const a = t ? qu({
    type: Xu.CI_PIPELINE,
    queryParams: {
      id: s.appId
    }
  }) : Qe.CI_PIPELINE_PATCH;
  return _s(a, s);
};
var Jt = /* @__PURE__ */ ((s) => (s.CREATE_NO_DEPLOY = "CREATE_NO_DEPLOY", s.CREATE_DEPLOY = "CREATE_DEPLOY", s.UPDATE = "UPDATE", s))(Jt || {}), Ys = /* @__PURE__ */ ((s) => (s.ALLOWED = "ALLOWED", s.CYCLIC = "CYCLIC", s.SELECTED = "SELECTED", s.PRESENT = "PRESENT", s))(Ys || {}), $i = /* @__PURE__ */ ((s) => (s[s.CREATE = 0] = "CREATE", s[s.DELETE = 2] = "DELETE", s))($i || {});
function Vh({
  view: s,
  setShowDeploymentModal: t,
  disableDeploy: a
}) {
  const n = (r) => {
    r.stopPropagation(), t(!0);
  }, o = (r) => /* @__PURE__ */ e.jsx(Es, { content: ct.SELECT_SOURCE, placement: "top", className: "default-tt", arrow: !1, children: r });
  return s === Jt.UPDATE ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox pt-12 pb-12 pl-20 pr-20 dc__gap-12 dc__border-right", children: [
    /* @__PURE__ */ e.jsx(Ka, { className: "icon-dim-20" }),
    /* @__PURE__ */ e.jsx("p", { className: "fs-12 cn-7 fw-6 lh-20 m-0", children: Sn[0] })
  ] }) : s === Jt.CREATE_DEPLOY ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-100", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex pt-12 pb-12 pl-16 pr-16 dc__gap-8", style: { width: "387px" }, children: [
      /* @__PURE__ */ e.jsx(Ka, { className: "icon-dim-20" }),
      /* @__PURE__ */ e.jsx("p", { className: "fs-12 cn-7 fw-6 lh-20 m-0", children: Sn[0] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsx("div", { style: { width: "13px" }, className: "dc__border-right h-10" }),
      /* @__PURE__ */ e.jsx("div", { className: "flex p-4 br-4 dc__border-n1 bg__secondary", children: /* @__PURE__ */ e.jsx(Lo, { className: "icon-dim-16 scn-6" }) }),
      /* @__PURE__ */ e.jsx("div", { style: { width: "13px" }, className: "dc__border-right h-10" })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex pt-12 pb-12 pl-16 pr-16 dc__gap-8", style: { width: "387px" }, children: [
      /* @__PURE__ */ e.jsx(Ii, { className: "icon-dim-20 flip-rocket" }),
      /* @__PURE__ */ e.jsx("p", { className: "fs-12 cn-7 fw-6 lh-20 m-0", children: Sn[1] })
    ] })
  ] }) : s === Jt.CREATE_NO_DEPLOY ? /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox pt-12 pb-12 pl-16 pr-16 dc__gap-8 flex-grow-1", children: [
      /* @__PURE__ */ e.jsx(Ka, { className: "icon-dim-20" }),
      /* @__PURE__ */ e.jsx("p", { className: "fs-12 cn-7 fw-6 lh-20 m-0", children: Sn[0] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsx("div", { style: { width: "13px" }, className: "dc__border-right h-10" }),
      /* @__PURE__ */ e.jsx("div", { className: "flex p-4 br-4 dc__border-n1 bg__secondary", children: /* @__PURE__ */ e.jsx(Lo, { className: "icon-dim-16 scn-6" }) }),
      /* @__PURE__ */ e.jsx("div", { style: { width: "13px" }, className: "dc__border-right h-10" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox pt-8 pb-8 pl-16 pr-16 dc__gap-8", children: /* @__PURE__ */ e.jsx(on, { condition: a, wrap: o, children: /* @__PURE__ */ e.jsx("div", { className: "flexbox", children: /* @__PURE__ */ e.jsx(
      "button",
      {
        className: "cta secondary pl-12 pr-12 pt-5 pb-5 h-28 flex",
        type: "button",
        onClick: n,
        disabled: a,
        "data-testid": "sync-env-deploy-to-btn",
        children: jo.DEPLOY_TO
      }
    ) }) }) })
  ] }) : null;
}
const Gh = (s, t, a) => {
  const n = a?.nodes?.reduce(
    (r, l) => (l.environmentId && (r[l.environmentId] = !0), r),
    {}
  ) ?? {};
  return t.map((r) => n[r.environmentId] ? {
    pipeline: r,
    environmentStatus: Ys.SELECTED
  } : s[r.ciPipelineId] ? {
    pipeline: r,
    environmentStatus: Ys.CYCLIC
  } : {
    pipeline: r,
    environmentStatus: Ys.ALLOWED
  });
}, al = (s, t, a) => s ? a.result.map((n) => ({
  environmentId: n.id,
  environmentStatus: t.some(
    (o) => o.pipeline.environmentId === n.id
  ) ? Ys.PRESENT : Ys.ALLOWED,
  isProd: n.default,
  envName: n.environment_name
  // No need of pipelineId here
})) : t.map((n) => ({
  environmentId: n.pipeline.environmentId,
  environmentStatus: n.environmentStatus,
  isProd: n.pipeline.isProdEnv,
  envName: n.pipeline.environmentName,
  pipelineId: n.pipeline.parentPipelineId
})), Wh = (s) => s === Ys.SELECTED ? ct.DISABLED_RADIO.SELECTED : s === Ys.CYCLIC ? ct.DISABLED_RADIO.CYCLIC : s === Ys.PRESENT ? ct.DISABLED_RADIO.PRESENT : null;
function $h({
  selectedId: s,
  environmentStatus: t,
  handleSelect: a,
  isProd: n,
  envName: o,
  envId: r,
  groupName: l,
  setSelectedDeploymentIdEnvName: i
}) {
  const [u, c] = E(!1), p = t !== Ys.ALLOWED ? "dc__disabled" : "", d = () => {
    c(!0);
  }, m = () => {
    c(!1);
  }, _ = (x) => {
    a(Number(x.target.value)), i?.(o);
  }, g = (x) => {
    const C = Wh(t);
    return /* @__PURE__ */ e.jsx(Es, { content: C, placement: "left", className: "default-tt w-200", arrow: !1, children: x });
  };
  return /* @__PURE__ */ e.jsx(on, { wrap: g, condition: t !== Ys.ALLOWED, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flexbox dc__align-items-center dc__gap-12 dc__hover-n50 w-100 ${u ? "bg__secondary" : ""}`,
      children: [
        /* @__PURE__ */ e.jsx(
          "input",
          {
            type: "radio",
            id: `${l}-${r}`,
            name: l,
            value: r,
            checked: s === r,
            onChange: _,
            disabled: t !== Ys.ALLOWED,
            className: `h-20 cursor dc__hover-border-n300 m-0 dc__outline-none-imp ${p}`,
            onFocus: d,
            onBlur: m,
            "data-testid": `${l}-${r}`
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "label",
          {
            htmlFor: `${l}-${r}`,
            className: `m-0 w-100 pt-8 pb-8 flexbox dc__align-items-center dc__gap-6 cursor cn-9 fs-13 fw-4 lh-20 ${p}`,
            children: [
              o,
              n && /* @__PURE__ */ e.jsx("span", { className: "fs-10 fw-6 cn-7 lh-12 p-4 flex br-4 dc__border bg__secondary h-20", children: "Prod" })
            ]
          }
        )
      ]
    }
  ) });
}
function nl({
  sourceCandidatePipelines: s,
  selectedId: t,
  setSelectedId: a,
  fetchAllEnvironments: n,
  setSelectedDeploymentIdEnvName: o
}) {
  const [r, l, i, u] = wn(
    Zl,
    [n],
    n
  ), [c, p] = E([]), [d, m] = E([]);
  ue(() => {
    if (n) {
      if (!r && l?.result) {
        const C = al(
          n,
          s,
          l
        );
        p(C), m(C);
      }
    } else {
      const C = al(
        n,
        s
      );
      p(C), m(C);
    }
  }, [l, r, n, s]);
  const _ = Wt(
    (C) => {
      const f = C.toLowerCase().trim(), h = c.filter(
        (b) => b.envName.toLowerCase().includes(f)
      );
      m(h);
    },
    [c]
  ), g = (C) => {
    a(C);
  }, x = (C) => /* @__PURE__ */ e.jsx(e.Fragment, { children: Array.from(Array(C).keys()).map((f) => /* @__PURE__ */ e.jsx("div", { className: "pt-8 pb-8 h-36", children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-20 w-50" }) }, f)) });
  return r ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pl-16 pr-16 w-100", children: [
    /* @__PURE__ */ e.jsx("div", { className: "pt-8 pb-8", children: /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-32 pt-8 pb-8 w-100" }) }),
    x(3)
  ] }) : i ? (ve(i), /* @__PURE__ */ e.jsx("div", { className: "flexbox pl-16 pr-16 w-100", children: /* @__PURE__ */ e.jsx(ya, { reload: u, className: "dc__overflow-auto" }) })) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pl-16 pr-16 w-100 dc__border-right", children: [
    /* @__PURE__ */ e.jsx("div", { className: "pt-8 pb-8", children: /* @__PURE__ */ e.jsx(
      li,
      {
        onSearch: _,
        placeholder: ei,
        containerClass: "w-100 h-32 flexbox pl-6 pr-6 pt-10 pb-10 dc__gap-8 dc__align-self-stretch dc__align-items-center bg__secondary dc__border dc__border-radius-4-imp focus-within-border-b5 dc__hover-border-n300",
        inputClass: "flex-grow-1 dc__no-border dc__outline-none-imp bg__secondary lh-20 fs-13 cn-9 fw-4 p-0 placeholder-cn5",
        Icon: wi,
        iconClass: "icon-dim-16 icon-n2",
        autoFocus: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto h-100", children: d.length > 0 ? d.map((C) => /* @__PURE__ */ e.jsx(
      $h,
      {
        selectedId: t,
        environmentStatus: C.environmentStatus,
        handleSelect: g,
        isProd: C.isProd,
        envName: C.envName,
        envId: C.environmentId,
        groupName: n ? Pr.DEPLOY_TO : Pr.IMAGE_SOURCE,
        setSelectedDeploymentIdEnvName: o
      },
      C.environmentId
    )) : /* @__PURE__ */ e.jsx(
      Xe,
      {
        title: Rr.NO_SEARCH_ENV.TITLE,
        subTitle: Rr.NO_SEARCH_ENV.SUBTITLE
      }
    ) })
  ] });
}
const Kh = ({ closeModal: s }) => /* @__PURE__ */ e.jsxs("div", { className: "w-100 flexbox dc__content-space dc__align-items-center dc__border-bottom pt-12 pb-12 pr-16 pl-16", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-24", children: ou }),
    /* @__PURE__ */ e.jsx(
      Tt,
      {
        infoText: ru,
        heading: lu,
        iconClassName: "icon-dim-20"
      }
    )
  ] }),
  /* @__PURE__ */ e.jsx(
    "button",
    {
      className: "h-20 dc__no-background dc__no-border dc__outline-none-imp p-0",
      type: "button",
      "aria-label": "close-modal",
      onClick: s,
      children: /* @__PURE__ */ e.jsx(ja, { className: "icon-dim-20 fcn-6" })
    }
  )
] });
function Hh({
  closeModal: s,
  cdPipelines: t,
  blackListedIds: a,
  getWorkflows: n,
  workflows: o,
  isTemplateView: r
}) {
  const l = () => {
    s();
  }, i = Ms(null);
  Ju(i, l);
  const { appId: u, workflowId: c } = ce(), p = he(), [d, m] = E(null), [_, g] = E(null), [x, C] = E(null), [f, h] = E(!1), [b, S] = E([]), [O, j] = E(!1), [v, A, N] = de(() => {
    const k = new URLSearchParams(p.search), G = k.get("changeCi") ?? bt, K = k.get("switchFromCiPipelineId") ?? bt, X = k.get("switchFromExternalCiPipelineId") ?? bt;
    return [G, K, X];
  }, [p.search]), L = v === bt && c !== bt && A !== bt, M = O ? ct.LOADING_REQUEST : d ? null : ct.SELECT_SOURCE;
  ue(() => {
    const k = Number(A), G = o.find((X) => X.id === c), K = Gh(a, t, G);
    if (S(K), k && a[k]) {
      const X = a[k].parentCiPipeline, Oe = K.find((J) => J.pipeline.id === X);
      m(Oe?.pipeline.environmentId ?? null);
    }
  }, [a, A, N, t]);
  const W = (k) => {
    k.preventDefault();
    const G = Number(A), K = Number(N), X = Number(c), Oe = t.find((_e) => _e.environmentId === d);
    if (!Oe) {
      Se.showToast({
        variant: Ne.error,
        description: Lr.NO_SOURCE_SELECTED
      });
      return;
    }
    j(!0);
    const J = {
      appId: Number(u),
      action: $i.CREATE,
      parentCDPipeline: Oe.id
    };
    _ && (J.deployEnvId = _), X > 0 && (J.appWorkflowId = X), G > 0 ? J.switchFromCiPipelineId = G : K > 0 && (J.switchFromExternalCiPipelineId = K), Fh(J, r).then(() => {
      j(!1), Se.showToast({
        variant: Ne.success,
        description: Lr.CREATION
      }), J.deployEnvId ? s(!0, J.deployEnvId, x, iu, !1) : s(), n();
    }).catch((_e) => {
      j(!1), ve(_e);
    });
  }, $ = (k) => {
    const G = k.key === "Enter", K = k.target instanceof HTMLInputElement && k.target.placeholder === ei;
    G && K && k.preventDefault();
  }, w = () => f ? Jt.CREATE_DEPLOY : Number(c) !== 0 ? Jt.UPDATE : Jt.CREATE_NO_DEPLOY, T = () => v !== bt || A !== bt || N !== bt ? jo.UPDATE_PIPELINE : jo.CREATE_PIPELINE, I = () => {
    const k = {
      appId: u,
      appWorkflowId: Number(c),
      pipelineId: Number(A),
      pipelineName: a[Number(A)]?.name
    };
    return /* @__PURE__ */ e.jsx(
      ri,
      {
        testId: "delete-linked-pipeline",
        disabled: O,
        deletePayloadConfig: k,
        title: "sync with environment",
        getWorkflows: n,
        showIconOnly: !1,
        onDelete: s,
        isTemplateView: r
      }
    );
  }, y = (k) => /* @__PURE__ */ e.jsx(Es, { content: M, placement: "top", className: "default-tt", arrow: !1, children: k });
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", onEscape: l, children: /* @__PURE__ */ e.jsxs(
    "form",
    {
      className: `flexbox-col dc__content-space sync-environment-drawer flex-grow-1 bg__primary ${f ? "drawer-open" : ""}`,
      ref: i,
      onClick: Rs,
      onSubmit: W,
      onKeyPress: $,
      children: [
        /* @__PURE__ */ e.jsx(Kh, { closeModal: l }),
        /* @__PURE__ */ e.jsx(
          Vh,
          {
            view: w(),
            setShowDeploymentModal: h,
            disableDeploy: !d
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox h-100 dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsx(
            nl,
            {
              sourceCandidatePipelines: b,
              selectedId: d,
              setSelectedId: m,
              fetchAllEnvironments: !1
            }
          ),
          f && /* @__PURE__ */ e.jsx(
            nl,
            {
              sourceCandidatePipelines: b,
              selectedId: _,
              setSelectedId: g,
              fetchAllEnvironments: !0,
              setSelectedDeploymentIdEnvName: C
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: `flexbox pt-16 pb-16 pl-20 pr-20 dc__gap-12 dc__align-items-center dc__border-top ${L ? "dc__content-space" : "dc__content-end"}`,
            children: [
              L && I(),
              /* @__PURE__ */ e.jsx(on, { condition: !!M, wrap: y, children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(
                "button",
                {
                  className: "cta flex pt-6 pb-6 pl-12 pr-12 fs-13 fw-6 lh-20 h-32",
                  type: "submit",
                  disabled: !!M,
                  "data-testid": "linked-cd-create-pipeline-button",
                  children: O ? /* @__PURE__ */ e.jsx(cs, { size: 16 }) : T()
                }
              ) }) })
            ]
          }
        )
      ]
    }
  ) });
}
const Lv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hh
}, Symbol.toStringTag, { value: "Module" })), ol = () => /* @__PURE__ */ e.jsx("i", { className: "cn-6", children: " (at the time image was available)" });
function Yh({
  children: s,
  commitTimestamp: t,
  appliedFiltersTimestamp: a,
  envName: n,
  showConfiguredFilters: o,
  filterState: r,
  dataSource: l,
  deploymentWindowArtifactMetadata: i,
  isFilterApplied: u,
  triggerBlockedInfo: c
}) {
  const p = () => u ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 dc__align-self-stretch", children: [
    /* @__PURE__ */ e.jsx(Im, { className: "icon-dim-16" }),
    /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 fw-4 lh-20 cn-9", children: [
      /* @__PURE__ */ e.jsxs("span", { className: `m-0 ${r === Hr.ALLOWED ? "cg-5" : "cr-5"}`, children: [
        r === Hr.ALLOWED ? "Image was eligible" : "Image was not eligible",
        " "
      ] }),
      /* @__PURE__ */ e.jsx("span", { className: "m-0", children: "for deployment due to " }),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          className: "cb-5 dc__underline-onhover cursor bg__primary dc__outline-none-imp p-0 dc__no-border",
          type: "button",
          onClick: o,
          children: "configured filter"
        }
      ),
      ol()
    ] })
  ] }) : null, d = () => c?.isBlocked && c?.blockedBy ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-start dc__gap-8 dc__align-self-stretch fs-13 fw-4 lh-20", children: [
    /* @__PURE__ */ e.jsx(jm, { className: "icon-dim-16 dc__no-shrink" }),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("span", { className: "cr-5", children: "Auto trigger failed" }),
      " ",
      /* @__PURE__ */ e.jsxs("span", { className: "cn-9", children: [
        "because ",
        c.reason
      ] }),
      ol()
    ] })
  ] }) : null, m = () => i?.type ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 dc__align-self-stretch", children: [
    /* @__PURE__ */ e.jsx(Tm, { className: "icon-dim-16" }),
    /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 fw-4 lh-20 cn-9", children: [
      /* @__PURE__ */ e.jsx("span", { className: "m-0 cr-5", children: "Deployment was blocked " }),
      /* @__PURE__ */ e.jsx("span", { className: "m-0", children: i.type === Ge.MAINTENANCE ? "as it was initiated outside maintenance window" : `as it was initiated during blackout window '${i.name}'` })
    ] })
  ] }) : null, _ = () => /* @__PURE__ */ e.jsxs("div", { className: `flexbox-col dc_gap-8 ${s ? "pt-24" : "pt-16"}`, children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox h-20 dc__align-items-center dc__gap-6", children: /* @__PURE__ */ e.jsxs("p", { className: "fs-13 fw-6 lh-16 cn-6 m-0 pb-4", children: [
      "Image available at ",
      n,
      a !== Qu && /* @__PURE__ */ e.jsx("span", { className: "cn-6 fs-12 fw-4 lh-16 m-0", children: a })
    ] }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pt-8 pb-8 pl-12 pr-12 dc__gap-8 br-4 dc__border bg__primary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 dc__align-self-stretch", children: [
        /* @__PURE__ */ e.jsx(Om, { className: "icon-dim-16 scn-6" }),
        /* @__PURE__ */ e.jsxs("p", { className: "m-0 fs-13 fw-4 lh-20 cn-9", children: [
          "Trigger mode was ",
          /* @__PURE__ */ e.jsx("span", { className: "m-0 fw-6", children: "automatic" })
        ] })
      ] }),
      p(),
      d(),
      m()
    ] })
  ] }), g = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("p", { className: "fs-13 fw-6 lh-16 cn-6 m-0 pb-4", children: [
      l === Kr.EXTERNAL ? kr.EXTERNAL : kr.COMMIT,
      /* @__PURE__ */ e.jsxs("span", { className: "cn-6 fs-12 fw-4 lh-16 m-0", children: [
        " ",
        t,
        " "
      ] })
    ] }),
    s && /* @__PURE__ */ e.jsx("div", { className: "bg__primary en-2 bw-1 br-4", children: s })
  ] }), x = () => /* @__PURE__ */ e.jsxs("div", { className: `${s ? "h-250" : "h-48"}`, children: [
    /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-radius-50-per dc__border flex w-20", children: l === Kr.EXTERNAL ? /* @__PURE__ */ e.jsx(wm, { className: "icon-dim-12" }) : /* @__PURE__ */ e.jsx(ym, { className: "icon-dim-12" }) }),
    /* @__PURE__ */ e.jsx("div", { className: "flex w-100", children: /* @__PURE__ */ e.jsx("div", { style: { width: "1px", height: s ? "205px" : "16px" }, className: "bcn-2 flex" }) }),
    /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-radius-50-per dc__border flex w-20", children: /* @__PURE__ */ e.jsx(Am, { className: "icon-dim-12" }) })
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox p-12 dc__gap-8", children: [
    x(),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
      g(),
      _()
    ] })
  ] });
}
const kv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yh
}, Symbol.toStringTag, { value: "Module" }));
function An({ onSearch: s }) {
  const t = ae(), a = () => {
    t.push(Qe.FILTER_CONDITIONS_ADD);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox pt-16 pb-8 pl-20 pr-20 dc__align-items-center dc__content-space", children: [
    /* @__PURE__ */ e.jsx(
      Jo,
      {
        title: $a.FILTER_CONDITION.title,
        renderDescriptionContent: () => si,
        showInfoIconTippy: !0,
        docLink: "GLOBAL_CONFIG_FILTER_CONDITION"
      }
    ),
    !!s && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-start dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(
        li,
        {
          onSearch: s,
          placeholder: cu,
          containerClass: "w-240 h-32 flexbox pl-6 pr-6 pt-10 pb-10 dc__gap-8 dc__align-self-stretch dc__align-items-center bg__secondary dc__border dc__border-radius-4-imp focus-within-border-b5 dc__hover-border-n300",
          inputClass: "flex-grow-1 dc__no-border dc__outline-none-imp bg__secondary lh-20 fs-13 cn-9 fw-4 p-0 placeholder-cn5",
          Icon: wi,
          iconClass: "icon-dim-16 icon-n2"
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-left" }),
      /* @__PURE__ */ e.jsxs("button", { className: "cta flex h-32 pl-8-imp", type: "button", onClick: a, children: [
        /* @__PURE__ */ e.jsx(da, { className: "icon-dim-14 mr-6" }),
        "Add"
      ] })
    ] })
  ] });
}
const rl = (s, t) => {
  if (!/^.{3,50}$/.test(s)) {
    t((a) => ({
      ...a,
      name: "Minimum 3 and maximum 50 characters allowed"
    }));
    return;
  }
  if (!/^[a-z0-9-._]+$/.test(s)) {
    t((a) => ({
      ...a,
      name: "Only lowercase alphanumeric characters, -, _ or . allowed"
    }));
    return;
  }
  if (!/^(?![-._]).*[^-._]$/.test(s)) {
    t((a) => ({
      ...a,
      name: "Cannot start/end with -, _ or ."
    }));
    return;
  }
  t((a) => ({
    ...a,
    name: null
  }));
}, ll = (s, t) => {
  s.conditions?.length || t((a) => ({
    ...a,
    minConditions: "At least one condition is required."
  })), t((a) => ({
    ...a,
    minConditions: null
  }));
}, zh = (s, t) => {
  (s.qualifierSelector.applicationSelectors.length === 0 || s.qualifierSelector.environmentSelectors.length === 0) && t((a) => ({
    ...a,
    minScopes: "Both application and environment scopes are required."
  })), t((a) => ({
    ...a,
    minScopes: null
  }));
}, il = (s, t, a) => {
  switch (s) {
    case In.NAME:
      rl(t.name, a);
      break;
    case In.MIN_CONDITIONS:
      ll(t, a);
      break;
    // In case user submits the form
    default:
      rl(t.name, a), ll(t, a), zh(t, a);
      break;
  }
}, cl = (s) => /* @__PURE__ */ e.jsx(Zu, { ...s, children: /* @__PURE__ */ e.jsx(Pi, { className: "icon-dim-16 icon-fill-n4" }) }), dl = ({ selectProps: s, children: t, ...a }) => {
  const n = s.value?.filter(
    (l) => !l.value.startsWith(re.AllFuture) && !l.value.startsWith(re.AllExisting) && !l.value.startsWith(re.AllProd) && !l.value.startsWith(re.AllNonProd)
  ).length ?? 0, o = {
    selectProps: s,
    children: t,
    ...a
  }, r = () => {
    const l = s.value?.length === 0;
    return !s.menuIsOpen || !s.inputValue ? l ? /* @__PURE__ */ e.jsx("span", { className: "cn-4 pl-4 dc__position-abs", children: s.placeholder }) : /* @__PURE__ */ e.jsxs("span", { className: "cn-9 pl-4", children: [
      s.name,
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "bcb-5 cn-0 fw-6 fs-12 br-8 pr-5 pl-5", children: n })
    ] }) : null;
  };
  return /* @__PURE__ */ e.jsxs(lm.ValueContainer, { ...o, children: [
    r(),
    Xp.cloneElement(t[1])
  ] });
};
function ul({ label: s, isProd: t, value: a, ...n }) {
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(
      "p",
      {
        className: `flex m-0 ${a.startsWith(re.AllFuture) || a.startsWith(re.AllExisting) || a.startsWith(re.AllProd) || a.startsWith(re.AllNonProd) ? "fw-6" : "fw-4"}`,
        children: s
      }
    ),
    !!t && !a.startsWith(re.AllProd) && /* @__PURE__ */ e.jsx("div", { className: "dc__border flex pt-0 pb-0 pl-8 pr-8 br-4 flex h-20 dc__no-shrink", children: /* @__PURE__ */ e.jsx("i", { className: "m-0 cn-6 fs-12 fw-4 lh-20", children: "Prod" }) })
  ] });
}
const qh = (s) => {
  const [t, a] = E({
    application: [],
    environment: []
  }), [n, o] = E([]), [r, l] = E([]), [i, u] = E(!0), [c, p] = E(null), d = t.environment.flatMap(
    (f) => f.options.filter((h) => h.isProd)
  ), m = t.environment.flatMap(
    (f) => f.options.filter((h) => !h.isProd && h.isProd !== null)
  ), _ = () => {
    const f = [];
    if (n.findIndex((v) => v.value === `${re.AllFuture}`) !== -1)
      f.push({
        projectName: fe.AllFutureProject,
        applications: []
      });
    else {
      const v = n.filter(
        (N) => N.value.startsWith(re.AllFuture)
      ), A = [];
      v.length > 0 && v.forEach((N) => {
        f.push({
          projectName: N.projectName,
          applications: []
        }), A.push(N.projectName);
      }), n.forEach((N) => {
        if (!N.value.startsWith(re.AllExisting)) {
          const L = f.findIndex((W) => W.projectName === N.projectName) !== -1, M = A.includes(N.projectName);
          if (!L && !M)
            f.push({
              projectName: N.projectName,
              applications: [N.value]
            });
          else if (!M) {
            const W = f.findIndex(($) => $.projectName === N.projectName);
            f[W].applications.push(N.value);
          }
        }
      });
    }
    const b = [], S = r.findIndex((v) => v.value === `${re.AllProd}`) !== -1, O = r.findIndex((v) => v.value === `${re.AllNonProd}`) !== -1;
    let j = r;
    if (S && O)
      b.push(
        {
          clusterName: fe.AllFutureProdCluster,
          environments: []
        },
        {
          clusterName: fe.AllFutureNonProdCluster,
          environments: []
        }
      );
    else if (S) {
      b.push({
        clusterName: fe.AllFutureProdCluster,
        environments: []
      });
      const v = [], A = j.filter(
        (N) => N.value.startsWith(re.AllFuture)
      );
      A.length > 0 && A.forEach((N) => {
        b.push({
          clusterName: N.clusterName,
          environments: []
        }), v.push(N.clusterName);
      }), j = j.filter(
        (N) => !N.isProd && N.isProd !== null && !v.includes(N.clusterName)
      ), j.forEach((N) => {
        if (N.clusterName !== fe.AllFutureNonProdCluster)
          if (!(b.findIndex((M) => M.clusterName === N.clusterName) !== -1))
            b.push({
              clusterName: N.clusterName,
              environments: [N.value]
            });
          else {
            const M = b.findIndex((W) => W.clusterName === N.clusterName);
            b[M].environments.push(N.value);
          }
      });
    } else if (O) {
      b.push({
        clusterName: fe.AllFutureNonProdCluster,
        environments: []
      });
      const v = [], A = j.filter(
        (N) => N.value.startsWith(re.AllFuture)
      );
      A.length > 0 && A.forEach((N) => {
        b.push({
          clusterName: N.clusterName,
          environments: []
        }), v.push(N.clusterName);
      }), j = j.filter(
        (N) => N.isProd && N.isProd !== null && !v.includes(N.clusterName)
      ), j.forEach((N) => {
        if (N.clusterName !== fe.AllFutureProdCluster)
          if (!(b.findIndex((M) => M.clusterName === N.clusterName) !== -1))
            b.push({
              clusterName: N.clusterName,
              environments: [N.value]
            });
          else {
            const M = b.findIndex((W) => W.clusterName === N.clusterName);
            b[M].environments.push(N.value);
          }
      });
    } else {
      const v = r.filter(
        (N) => N.value.startsWith(re.AllFuture)
      ), A = [];
      v.length > 0 && v.forEach((N) => {
        b.push({
          clusterName: N.clusterName,
          environments: []
        }), A.push(N.clusterName);
      }), j.forEach((N) => {
        if (!N.value.startsWith(re.AllExisting)) {
          const L = b.findIndex((W) => W.clusterName === N.clusterName) !== -1, M = A.includes(N.clusterName);
          if (!L && !M)
            b.push({
              clusterName: N.clusterName,
              environments: [N.value]
            });
          else if (!M) {
            const W = b.findIndex(($) => $.clusterName === N.clusterName);
            b[W].environments.push(N.value);
          }
        }
      });
    }
    return {
      applicationSelectors: f,
      environmentSelectors: b
    };
  }, g = () => {
    u(!0), p(null), Promise.all([pu(), Zl()]).then((f) => {
      const [h, b] = f.map((S) => S.result);
      if (h.length > 0 && b.length > 0) {
        const S = [], O = h.map((v) => ({
          label: `Project: ${v.projectName}`,
          options: [
            {
              label: `All existing + future applications in ‘${v.projectName}’`,
              value: `${re.AllFuture}_${v.projectName}`,
              projectName: v.projectName
            },
            {
              label: `All existing applications in ‘${v.projectName}’`,
              value: `${re.AllExisting}_${v.projectName}`,
              projectName: v.projectName
            },
            ...v.appList.map((A) => ({
              label: A.name,
              value: A.name,
              projectName: v.projectName
            })).sort((A, N) => A.label.localeCompare(N.label))
          ],
          projectName: v.projectName
        })), j = b.reduce((v, A) => {
          const N = v;
          return N[A.cluster_name] = N[A.cluster_name] || [], N[A.cluster_name].push({
            label: A.environment_name,
            value: A.environment_name,
            clusterName: A.cluster_name,
            isProd: !!A.default
          }), N;
        }, {});
        if (Object.keys(j).forEach((v) => {
          const A = j[v];
          S.push({
            label: `Cluster: ${v}`,
            options: [
              {
                label: `All existing + future environments in ‘${v}’`,
                value: `${re.AllFuture}_${v}`,
                clusterName: v,
                isProd: null
              },
              {
                label: `All existing environments in ‘${v}’`,
                value: `${re.AllExisting}_${v}`,
                clusterName: v,
                isProd: null
              },
              ...A.sort((N, L) => N.label.localeCompare(L.label))
            ],
            clusterName: v
          });
        }), O.sort((v, A) => v.projectName.localeCompare(A.projectName)), S.sort((v, A) => v.clusterName.localeCompare(A.clusterName)), O.unshift({
          label: "All Applications",
          options: [
            {
              label: "All existing + future applications",
              value: `${re.AllFuture}`,
              projectName: fe.AllFutureProject
            },
            {
              label: "All existing applications",
              value: `${re.AllExisting}`,
              projectName: ""
            }
          ],
          // Its defining GLOBAL LABEL
          projectName: fe.ProjectGlobalLabel
        }), S.unshift({
          label: "All Environments",
          options: [
            {
              label: "All existing + future prod environments",
              value: `${re.AllProd}`,
              clusterName: fe.AllFutureProdCluster,
              isProd: !0
            },
            {
              label: "All existing + future non-prod environments",
              value: `${re.AllNonProd}`,
              clusterName: fe.AllFutureNonProdCluster,
              isProd: !1
            }
          ],
          // Its Defining GLOBAL LABEL
          clusterName: fe.ClusterGlobalLabel
        }), s) {
          const v = [], A = [], N = s.qualifierSelector.applicationSelectors, L = s.qualifierSelector.environmentSelectors;
          N.forEach((T) => {
            if (T.projectName === fe.AllFutureProject)
              O.forEach((I) => {
                I.options.forEach((y) => {
                  v.push(y);
                });
              });
            else if (T.applications.length === 0)
              O.find(
                (y) => y.projectName === T.projectName
              ).options.forEach((y) => {
                v.push(y);
              });
            else {
              const I = O.find(
                (y) => y.projectName === T.projectName
              ).options;
              T.applications.length === I.length - 2 ? I.forEach((y) => {
                y.value !== `${re.AllFuture}_${T.projectName}` && v.push(y);
              }) : T.applications.length === 0 ? I.forEach((y) => {
                v.push(y);
              }) : I.forEach((y) => {
                T.applications.includes(y.value) && v.push(y);
              });
            }
          });
          let M = !0;
          const W = [...new Set(v)];
          for (let T = 1; T < O.length; T += 1) {
            const I = O[T], y = W.filter(
              (G) => G.projectName === I.projectName
            );
            if (!(!!y && y?.findIndex(
              (G) => G.value === `${re.AllExisting}_${I.projectName}`
            ) !== -1)) {
              M = !1;
              break;
            }
          }
          if (M) {
            const T = O[0].options[1];
            v.push(T);
          }
          o([...new Set(v)]);
          const $ = L.findIndex(
            (T) => T.clusterName === fe.AllFutureProdCluster
          ) !== -1;
          L.findIndex(
            (T) => T.clusterName === fe.AllFutureNonProdCluster
          ) !== -1 && $ ? S.forEach((T) => {
            T.options.forEach((I) => {
              A.push(I);
            });
          }) : L.forEach((T) => {
            if (T.clusterName === fe.AllFutureProdCluster)
              S.forEach((I) => {
                let y = 0;
                I.options.forEach((k) => {
                  k.isProd && (A.push(k), y += 1);
                }), y === I.options.length - 2 && A.push(I.options[1]);
              });
            else if (T.clusterName === fe.AllFutureNonProdCluster)
              S.forEach((I) => {
                let y = 0;
                I.options.forEach((k) => {
                  !k.isProd && k.isProd !== null && (A.push(k), y += 1);
                }), y === I.options.length - 2 && A.push(I.options[1]);
              });
            else {
              const I = S.find(
                (y) => y.clusterName === T.clusterName
              ).options;
              T.environments.length === I.length - 2 ? I.forEach((y) => {
                y.value !== `${re.AllFuture}_${T.clusterName}` && A.push(y);
              }) : T.environments.length === 0 ? I.forEach((y) => {
                A.push(y);
              }) : I.forEach((y) => {
                T.environments.includes(y.value) && A.push(y);
              });
            }
          }), l([...new Set(A)]);
        }
        a({
          application: O,
          environment: S
        });
      }
    }).catch((f) => {
      p(f);
    }).finally(() => {
      u(!1);
    });
  };
  return ue(g, [s]), {
    conditionSelectOptions: t,
    selectedApplications: n,
    selectedEnvironments: r,
    handleApplicationConditionChange: (f) => {
      let h = f;
      const b = h.findIndex((w) => w.projectName === fe.AllFutureProject) !== -1, S = n.findIndex((w) => w.projectName === fe.AllFutureProject) !== -1;
      if (b && !S) {
        o(t.application.flatMap((w) => w.options));
        return;
      }
      if (!b && S) {
        o([]);
        return;
      }
      h = h.filter(
        (w) => w.projectName !== fe.AllFutureProject
      );
      const j = h.findIndex((w) => w.value === `${re.AllExisting}`) !== -1, v = n.findIndex((w) => w.value === re.AllExisting) !== -1;
      j && !v ? (h = h.filter((I) => !I.value.startsWith(re.AllExisting)), h = [...t.application.flatMap((I) => I.options).filter((I) => I.value.startsWith(re.AllExisting)), ...h]) : !j && v && (h = h.filter((T) => !T.value.startsWith(re.AllExisting))), h = h.filter(
        (w) => w.value !== re.AllExisting
      ), h = [...new Set(h)];
      const N = h.reduce((w, T) => {
        const I = w;
        return I[T.projectName] = I[T.projectName] || [], I[T.projectName].push(T), I;
      }, {}), L = {}, M = [];
      Object.keys(N).forEach((w) => {
        const T = N[w], I = `${re.AllFuture}_${w}`, y = `${re.AllExisting}_${w}`, k = n.findIndex((ee) => ee.projectName === w && ee.value === I) !== -1, G = n.findIndex(
          (ee) => ee.projectName === w && ee.value === y
        ) !== -1, K = T.findIndex((ee) => ee.value === I) !== -1, X = T.findIndex((ee) => ee.value === y) !== -1, Oe = T.filter(
          (ee) => ee.value !== I && ee.value !== y
        ), J = t.application.find(
          (ee) => ee.projectName === w
        ).options, _e = Oe.length === J.length - 2;
        if (k && (!K || !X) || G && !X)
          L[w] = [];
        else if (G && !k && K)
          L[w] = J, M.push({
            projectName: w,
            appNames: []
          });
        else if (!_e && (k || G))
          L[w] = Oe, M.push({
            projectName: w,
            appNames: Oe.map((ee) => ee.value)
          });
        else if (K)
          L[w] = J, M.push({
            projectName: w,
            appNames: []
          });
        else if (X || _e) {
          const ee = J.filter((H) => H.value !== I);
          L[w] = ee, M.push({
            projectName: w,
            appNames: ee.map((H) => H.value).filter((H) => H !== y)
          });
        } else
          L[w] = T, M.push({
            projectName: w,
            appNames: Oe.map((ee) => ee.value)
          });
      });
      let W = !0;
      for (let w = 1; w < t.application.length; w += 1) {
        const T = t.application[w], I = L?.[T.projectName];
        if (!(!!I && I?.findIndex(
          (k) => k.value === `${re.AllExisting}_${T.projectName}`
        ) !== -1)) {
          W = !1;
          break;
        }
      }
      if (W) {
        const w = t.application[0].options[1];
        L[""] = [w];
      }
      let $ = !0;
      for (let w = 1; w < t.application.length; w += 1) {
        const T = t.application[w], I = L[T.projectName];
        if (!(!!I && I?.findIndex(
          (k) => k.value === `${re.AllFuture}_${T.projectName}`
        ) !== -1)) {
          $ = !1;
          break;
        }
      }
      if ($ && b) {
        const w = t.application[0].options[0];
        L[fe.AllFutureProject] = [w];
      }
      o(Object.values(L).flatMap((w) => w));
    },
    handleEnvironmentConditionChange: (f) => {
      let h = f;
      const b = h.findIndex((T) => T.clusterName === fe.AllFutureProdCluster) !== -1, S = r.findIndex(
        (T) => T.clusterName === fe.AllFutureProdCluster
      ) !== -1;
      b && !S ? (h = h.filter((y) => y.clusterName !== fe.AllFutureProdCluster), h = [...t.environment.flatMap((y) => y.options).filter((y) => y.isProd), ...h]) : !b && S && (h = h.filter((I) => !I.isProd || I.isProd === null)), h = h.filter(
        (T) => T.clusterName !== fe.AllFutureProdCluster
      );
      const j = h.findIndex((T) => T.clusterName === fe.AllFutureNonProdCluster) !== -1, v = r.findIndex(
        (T) => T.clusterName === fe.AllFutureNonProdCluster
      ) !== -1;
      if (j && !v ? (h = h.filter(
        (y) => y.clusterName !== fe.AllFutureNonProdCluster
      ), h = [...t.environment.flatMap((y) => y.options).filter((y) => !y.isProd && y.isProd !== null), ...h]) : !j && v && (h = h.filter((I) => I.isProd || I.isProd === null)), h = h.filter(
        (T) => T.clusterName !== fe.AllFutureNonProdCluster
      ), b && j && !(b && j && v && S)) {
        l(t.environment.flatMap((T) => T.options));
        return;
      }
      h = [...new Set(h)];
      const L = h.reduce((T, I) => {
        const y = T;
        return y[I.clusterName] = y[I.clusterName] || [], y[I.clusterName].push(I), y;
      }, {}), M = {}, W = [];
      Object.keys(L).forEach((T) => {
        const I = L[T], y = `${re.AllFuture}_${T}`, k = `${re.AllExisting}_${T}`, G = r.findIndex((H) => H.clusterName === T && H.value === y) !== -1, K = r.findIndex(
          (H) => H.clusterName === T && H.value === k
        ) !== -1, X = I.findIndex((H) => H.value === y) !== -1, Oe = I.findIndex((H) => H.value === k) !== -1, J = t.environment.find(
          (H) => H.clusterName === T
        ).options, _e = I.filter(
          (H) => H.value !== y && H.value !== k
        ), ee = _e.length === J.length - 2;
        if (G && (!X || !Oe) || K && !Oe)
          M[T] = [];
        else if (K && !G && X)
          M[T] = J, W.push({
            clusterName: T,
            envNames: []
          });
        else if (!ee && (G || K))
          M[T] = _e, W.push({
            clusterName: T,
            envNames: _e.map((H) => H.value)
          });
        else if (X)
          M[T] = J, W.push({
            clusterName: T,
            envNames: []
          });
        else if (Oe || ee) {
          const H = J.filter((Je) => Je.value !== y);
          M[T] = H, W.push({
            clusterName: T,
            envNames: H.map((Je) => Je.value).filter((Je) => Je !== k)
          });
        } else
          M[T] = I, W.push({
            clusterName: T,
            envNames: _e.map((H) => H.value)
          });
      });
      let $ = !0, w = !0;
      if (d.forEach((T) => {
        T.clusterName !== fe.AllFutureProdCluster && (M?.[T.clusterName] && M[T.clusterName]?.findIndex((y) => y.value === T.value) !== -1 || ($ = !1));
      }), m.forEach((T) => {
        T.clusterName !== fe.AllFutureNonProdCluster && (M?.[T.clusterName] && M[T.clusterName]?.findIndex((y) => y.value === T.value) !== -1 || (w = !1));
      }), b && $) {
        const T = t.environment[0].options[0];
        M[fe.AllFutureProdCluster] = [T];
      }
      if (j && w) {
        const T = t.environment[0].options[1];
        M[fe.AllFutureNonProdCluster] = [T];
      }
      l(Object.values(M).flatMap((T) => T));
    },
    scopeError: c,
    scopeLoading: i,
    fetchConditionSelectOptions: g,
    getSanitizedData: _
  };
}, Xh = () => {
  const [s, t] = E([]), [a, n] = E(!0), [o, r] = E(null), l = () => {
    n(!0), r(null), mu().then((i) => {
      i.code === 200 && t(i.result ?? []);
    }).catch((i) => {
      r(i);
    }).finally(() => {
      n(!1);
    });
  };
  return ue(() => {
    l();
  }, []), {
    filterConditions: s,
    isLoading: a,
    error: o,
    fetchConditions: l
  };
}, Jh = (s) => {
  const [t, a] = E(null), [n, o] = E(!0), [r, l] = E(null), i = Wt(() => {
    o(!0), l(null), du(s).then((u) => {
      u.code === 200 && a(u.result);
    }).catch((u) => {
      l(u);
    }).finally(() => {
      o(!1);
    });
  }, [s]);
  return ue(() => {
    i();
  }, [i]), {
    filterDetails: t,
    isLoading: n,
    error: r,
    fetchFilterDetails: i
  };
}, pl = [
  {
    value: uu.DEPLOYMENT,
    label: "Deployment pipeline",
    startIcon: /* @__PURE__ */ e.jsx(Ii, {})
  }
];
function Qh({
  filterId: s,
  handleFilterSubmit: t,
  handleStepperUpdate: a,
  filterDetails: n,
  handleNameChange: o,
  filterDetailsValidationErrors: r,
  handleDescriptionChange: l,
  conditionType: i,
  handleEnablePassCondition: u,
  renderConditionStatus: c,
  handleEnableFailCondition: p,
  renderInfoBar: d,
  renderButtonStatus: m,
  handleExpressionChange: _,
  handleListNavigation: g,
  disableSave: x,
  isLoading: C
}) {
  const f = () => {
    const h = n.conditions.find(
      (b) => b.conditionType === i
    );
    return h ? h.expression : "";
  };
  return /* @__PURE__ */ e.jsxs(
    "form",
    {
      className: "flexbox-col pt-0 dc__align-start dc__align-self-stretch flex-grow-1 dc__overflow-auto dc__content-space",
      onSubmit: s ? t : a,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col pr-20 pl-20 dc__align-start dc__align-self-stretch flex-grow-1 dc__overflow-auto pb-16", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "w-885 flexbox-col pt-16 pb-16 pl-0 pr-0 dc__gap-16", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-885 dc__gap-16", children: [
              /* @__PURE__ */ e.jsx("div", { className: "flexbox-col w-50", children: /* @__PURE__ */ e.jsx(
                te,
                {
                  label: "Filter For",
                  required: !0,
                  options: pl,
                  value: pl[0],
                  isSearchable: !1,
                  inputId: "filter-conditions-type-select",
                  size: P.large
                }
              ) }),
              /* @__PURE__ */ e.jsx("div", { className: "flexbox-col w-50", children: /* @__PURE__ */ e.jsx(
                ke,
                {
                  required: !0,
                  label: "Filter Name",
                  name: "filterName",
                  placeholder: "Suggest a filter name",
                  value: n.name,
                  onChange: o,
                  error: r.name
                }
              ) })
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "w-885", children: /* @__PURE__ */ e.jsx(
              At,
              {
                label: "Description",
                placeholder: "Enter here",
                value: n.description,
                onChange: l,
                name: "filter-conditions-description"
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsx("p", { className: "dc__required-field fs-13 fw-4 lh-20 cn-7 m-0 pt-8 pb-8", children: "Filter Condition" }),
          /* @__PURE__ */ e.jsxs("div", { className: "w-885 flex dc__gap-8 pb-16", children: [
            /* @__PURE__ */ e.jsx(
              Es,
              {
                content: /* @__PURE__ */ e.jsx("div", { className: "dc__mxw-400 word-break-none", children: hu }),
                placement: "top",
                className: "default-tt",
                arrow: !1,
                children: /* @__PURE__ */ e.jsxs(
                  "button",
                  {
                    className: `flex flex-grow-1 pt-10 pb-10 pl-12 pr-12 br-4 dc__border dc__content-space dc__outline-none-imp ${i === As.PASS ? "active-filter-condition-btn bcb-1" : "dc__no-background"}`,
                    type: "button",
                    onClick: u,
                    children: [
                      /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
                        /* @__PURE__ */ e.jsx(
                          Qr,
                          {
                            className: `icon-dim-20 mr-10 ${i === As.PASS ? "" : "scb-5"}`
                          }
                        ),
                        /* @__PURE__ */ e.jsx(
                          "div",
                          {
                            className: `fs-13 fw-6 lh-20 ${i === As.PASS ? "cn-9" : "cb-5"}`,
                            children: "Pass Condition"
                          }
                        )
                      ] }),
                      c(As.PASS)
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__border-left" }),
            /* @__PURE__ */ e.jsx(
              Es,
              {
                content: /* @__PURE__ */ e.jsx("div", { className: "dc__mxw-400 word-break-none", children: _u }),
                placement: "top",
                className: "default-tt",
                arrow: !1,
                children: /* @__PURE__ */ e.jsxs(
                  "button",
                  {
                    className: `flex flex-grow-1 pt-10 pb-10 pl-12 pr-12 br-4 dc__border dc__content-space dc__outline-none-imp ${i === As.FAIL ? "active-filter-condition-btn bcb-1" : "dc__no-background"}`,
                    type: "button",
                    onClick: p,
                    children: [
                      /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
                        /* @__PURE__ */ e.jsx(
                          Qr,
                          {
                            className: `icon-dim-20 dc__flip-y mr-10 ${i === As.FAIL ? "" : "scb-5"}`
                          }
                        ),
                        /* @__PURE__ */ e.jsx(
                          "div",
                          {
                            className: `fs-13 fw-6 lh-20 ${i === As.FAIL ? "cn-9" : "cb-5"}`,
                            children: "Fail Condition"
                          }
                        )
                      ] }),
                      c(As.FAIL)
                    ]
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "w-885 flexbox-col", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox p-12 dc__gap-4 dc__align-self-stretch dc__top-radius-4 border__primary dc__no-bottom-border", children: [
              /* @__PURE__ */ e.jsx("p", { className: "m-0 flex-grow-1 flexbox fs-13 fw-4 lh-20", children: i === As.PASS ? Dr.PASS_CONDITION : Dr.FAIL_CONDITION }),
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
                /* @__PURE__ */ e.jsx(
                  ea,
                  {
                    theme: sa.white,
                    className: "w-236 h-100 dc__align-left",
                    placement: "bottom",
                    Icon: ur,
                    iconClass: "fcv-5",
                    heading: "Filter criteria",
                    showCloseButton: !0,
                    trigger: "click",
                    interactive: !0,
                    additionalContent: /* @__PURE__ */ e.jsx(fu, {}),
                    children: /* @__PURE__ */ e.jsx(
                      "button",
                      {
                        className: "h-20 fs-13 fw-4 lh-20 p-0 cb-5 dc__no-background dc__no-border dc__outline-none-imp",
                        type: "button",
                        children: "View filter criteria"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "h-12 dc__border-left bcn-2" }),
                /* @__PURE__ */ e.jsx(
                  Tt,
                  {
                    infoText: gu,
                    heading: "CEL Expression",
                    documentationLink: "CEL",
                    children: /* @__PURE__ */ e.jsxs(
                      "button",
                      {
                        className: "flex dc__gap-8 dc__outline-none-imp p-0 dc__no-border dc__no-background",
                        type: "button",
                        children: [
                          /* @__PURE__ */ e.jsx("p", { className: "m-0 cb-5 fs-13 fw-4 lh-20", children: "CEL expression" }),
                          /* @__PURE__ */ e.jsx(cr, { className: "icon-dim-16" })
                        ]
                      }
                    )
                  }
                )
              ] })
            ] }),
            d(),
            /* @__PURE__ */ e.jsx(
              At,
              {
                name: "filter-conditions-expression",
                placeholder: xu,
                value: f(),
                onChange: _,
                borderRadiusConfig: {
                  top: !1
                }
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__border-top pt-16 pb-16 pl-20 pr-20 w-100", children: /* @__PURE__ */ e.jsxs("div", { className: "w-885 dc__gap-16 flexbox dc__content-end", children: [
          /* @__PURE__ */ e.jsx(
            "button",
            {
              className: "cta cancel h-36 lh-36",
              type: "button",
              onClick: g,
              disabled: C,
              children: "Cancel"
            }
          ),
          x && !C ? /* @__PURE__ */ e.jsx(
            Es,
            {
              content: "Input is required for all mandatory fields.",
              placement: "top",
              className: "default-tt",
              arrow: !1,
              children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx("button", { className: "cta h-36 lh-36", type: "submit", disabled: !0, children: s ? "Update" : "Next" }) })
            }
          ) : /* @__PURE__ */ e.jsx("button", { className: "cta h-36 lh-36", type: "submit", disabled: C, children: m() })
        ] }) })
      ]
    }
  );
}
const Zh = {
  group: (s) => ({
    ...s,
    paddingTop: 0,
    paddingBottom: 0
  }),
  groupHeading: (s) => ({
    ...s,
    fontWeight: 600,
    fontSize: "12px",
    color: "var(--N900)",
    backgroundColor: "var(--N100)",
    marginBottom: 0,
    padding: "4px 8px",
    textTransform: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  })
}, ml = {
  container: (s) => ({
    ...s,
    height: "36px",
    width: "100%"
  }),
  control: (s) => ({
    ...s,
    boxShadow: "none",
    minHeight: "36px",
    backgroundColor: "var(--bg-secondary)",
    cursor: "pointer"
  }),
  menu: (s) => ({
    ...s,
    backgroundColor: "var(--bg-primary)",
    top: "38px"
  }),
  singleValue: (s) => ({
    ...s,
    fontWeight: 500,
    color: "var(--N900)"
  }),
  option: (s, t) => ({
    ...s,
    padding: "4px 12px",
    backgroundColor: t.isFocused ? "var(--N100)" : "var(--bg-primary)",
    color: "var(--N900)",
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  valueContainer: (s) => ({
    ...s,
    padding: "2px 0px 2px 8px",
    display: "flex",
    height: "36px"
  }),
  dropdownIndicator: (s, t) => ({
    ...s,
    transition: "all .2s ease",
    transform: t.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
  }),
  ...Zh
}, e_ = {
  [ka.PRE_CI]: ze.PRE_STAGE,
  [ka.POST_CI]: ze.POST_STAGE,
  [ka.PRE_OR_POST_CI]: ze.PRE_OR_POST_STAGE,
  [ka.PRE_CD]: ze.PRE_STAGE,
  [ka.POST_CD]: ze.POST_STAGE
};
function s_({
  isLoading: s,
  filterId: t,
  handleFilterSubmit: a,
  handleListNavigation: n,
  renderButtonStatus: o,
  disableSave: r,
  conditionSelectOptions: l,
  selectedApplications: i,
  handleApplicationConditionChange: u,
  selectedEnvironments: c,
  handleEnvironmentConditionChange: p
}) {
  return /* @__PURE__ */ e.jsxs(
    "form",
    {
      className: "flexbox-col pt-0 dc__align-start dc__align-self-stretch flex-grow-1 dc__overflow-auto dc__content-space",
      onSubmit: a,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "w-885 pt-20 pl-20 flexbox-col dc__gap-12", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: /* @__PURE__ */ e.jsx("p", { className: "cn-9 fs-13 fw-6 lh-20 m-0", children: "Apply filter condition to" }) }),
          /* @__PURE__ */ e.jsxs("div", { className: "w-885 flexbox-col", children: [
            /* @__PURE__ */ e.jsx("label", { className: "fs-13 fw-4 lh-20 cn-7", htmlFor: "filter-conditions-application-select", children: "Application" }),
            /* @__PURE__ */ e.jsx(
              Ro,
              {
                name: "Applications",
                placeholder: "Search by project or application name",
                options: l.application,
                value: i,
                onChange: u,
                isMulti: !0,
                closeMenuOnSelect: !1,
                hideSelectedOptions: !1,
                components: {
                  IndicatorSeparator: null,
                  ClearIndicator: cl,
                  Option: Yr,
                  ValueContainer: dl
                },
                formatOptionLabel: ul,
                styles: ml,
                id: "filter-conditions-application-select"
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "w-885 flexbox-col", children: [
            /* @__PURE__ */ e.jsx("label", { className: "fs-13 fw-4 lh-20 cn-7", htmlFor: "filter-conditions-env-select", children: "Environment" }),
            /* @__PURE__ */ e.jsx(
              Ro,
              {
                name: "Environments",
                placeholder: "Search by cluster or environment name",
                options: l.environment,
                value: c,
                onChange: p,
                isMulti: !0,
                closeMenuOnSelect: !1,
                hideSelectedOptions: !1,
                formatOptionLabel: ul,
                components: {
                  IndicatorSeparator: null,
                  ClearIndicator: cl,
                  Option: Yr,
                  ValueContainer: dl
                },
                styles: ml,
                id: "filter-conditions-env-select"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__border-top pt-16 pb-16 pl-20 pr-20 w-100", children: /* @__PURE__ */ e.jsxs("div", { className: "w-885 dc__gap-16 flexbox dc__content-end", children: [
          /* @__PURE__ */ e.jsx(
            "button",
            {
              className: "cta cancel h-36 lh-36",
              type: "button",
              onClick: n,
              disabled: s,
              children: "Cancel"
            }
          ),
          r && !s ? /* @__PURE__ */ e.jsx(
            Es,
            {
              content: "Input is required for all mandatory fields.",
              placement: "top",
              className: "default-tt",
              arrow: !1,
              children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx("button", { className: "cta h-36 lh-36", type: "submit", disabled: !0, children: t ? "Update" : "Save" }) })
            }
          ) : /* @__PURE__ */ e.jsx("button", { className: "cta h-36 lh-36", type: "submit", disabled: s, children: o() })
        ] }) })
      ]
    }
  );
}
function Ki({
  activeStep: s,
  existingFilterDetails: t,
  setActiveStep: a,
  setEnableToggle: n,
  filterId: o
}) {
  const [r, l] = E(
    t ?? Cu
  ), [i, u] = E(
    t ? bu : Su
  ), [c, p] = E(As.PASS), [d, m] = E([]), [_, g] = E(!1), {
    conditionSelectOptions: x,
    selectedApplications: C,
    selectedEnvironments: f,
    scopeLoading: h,
    scopeError: b,
    handleApplicationConditionChange: S,
    handleEnvironmentConditionChange: O,
    fetchConditionSelectOptions: j,
    getSanitizedData: v
  } = qh(t), A = de(
    () => Object.values(i).some((J) => J !== null),
    [i]
  ), N = ae(), L = () => {
    N.push(Qe.FILTER_CONDITIONS);
  }, M = (J) => {
    l({ ...r, name: J.currentTarget.value }), il(
      In.NAME,
      { ...r, name: J.currentTarget.value },
      u
    );
  }, W = (J) => {
    l({ ...r, description: J.currentTarget.value });
  }, $ = (J) => {
    const _e = J.currentTarget.value, H = [
      ...r.conditions.filter((Je) => Je.conditionType !== c),
      { conditionType: c, expression: _e }
    ].filter((Je) => !!Je.expression);
    il(
      In.MIN_CONDITIONS,
      { ...r, conditions: H },
      u
    ), l({
      ...r,
      conditions: H
    });
  }, w = (J) => {
    J.preventDefault(), g(!0), Nu({
      conditions: r.conditions
    }).then((_e) => {
      _e.code === 200 && (m(_e.result?.conditions ?? []), (_e.result?.conditions?.filter((H) => !!H.errorMsg)).length === 0 ? (a(gs.SCOPE), n(!0), m([])) : Se.showToast({
        variant: Ne.error,
        description: "Invalid Expression provided. Please check the expression and try again."
      }));
    }).catch(() => {
      Se.showToast({
        variant: Ne.error,
        description: "Something went wrong while sending request. Please try again."
      });
    }).finally(() => {
      g(!1);
    });
  }, T = () => {
    if (!(C.length === 0 && f.length === 0)) {
      if (C.length === 0)
        return Se.showToast({
          variant: Ne.error,
          description: "Please select at least one application"
        }), !1;
      if (f.length === 0)
        return Se.showToast({
          variant: Ne.error,
          description: "Please select at least one environment"
        }), !1;
    }
    return !0;
  }, I = (J) => {
    if (J.preventDefault(), !T())
      return;
    const _e = {
      ...r,
      qualifierSelector: v()
    };
    g(!0), (o ? Eu(o, _e) : vu(_e)).then((H) => {
      H.code === 200 ? (N.push(Qe.FILTER_CONDITIONS), Se.showToast({
        variant: Ne.success,
        description: o ? Mr.UPDATED : Mr.SAVED
      })) : H.code === 209 ? (m(H.result?.conditions ?? []), Se.showToast({
        variant: Ne.error,
        description: "Invalid Expression provided. Please check the expression and try again."
      }), g(!1)) : (Se.showToast({
        variant: Ne.error,
        description: "Something went wrong"
      }), g(!1));
    }).catch((H) => {
      H.code === 500 ? Se.showToast({
        variant: Ne.error,
        description: "Internal server error. Please try again."
      }) : Se.showToast({
        variant: Ne.error,
        description: "Something went wrong. Please ensure all fields are valid and try again."
      }), g(!1);
    });
  }, y = () => {
    p(As.PASS);
  }, k = () => {
    p(As.FAIL);
  }, G = () => {
    const J = d.find(
      (_e) => _e.conditionType === c
    );
    return J?.errorMsg ? /* @__PURE__ */ e.jsx(
      Us,
      {
        description: J.errorMsg,
        borderConfig: { bottom: !1, left: !1, right: !1, top: !1 },
        borderRadiusConfig: { bottom: !1, left: !1, right: !1, top: !1 },
        variant: "error"
      }
    ) : null;
  }, K = (J) => {
    const _e = d.find(
      (H) => H.conditionType === J
    ), ee = r.conditions.find(
      (H) => H.conditionType === J
    );
    return _e && _e.errorMsg ? La.ERROR : ee?.expression?.length ? La.SUCCESS : La.HOLD;
  }, X = (J) => {
    switch (K(J)) {
      case La.SUCCESS:
        return /* @__PURE__ */ e.jsx("div", { className: "icon-dim-20 flex", children: /* @__PURE__ */ e.jsx(
          Pm,
          {
            className: `icon-dim-20 ${c === J ? "scn-6" : "scb-5"}`
          }
        ) });
      case La.ERROR:
        return /* @__PURE__ */ e.jsx("div", { className: "icon-dim-20 flex", children: /* @__PURE__ */ e.jsx(Ja, { className: "icon-dim-20 cn-5 alert-icon-r5-imp" }) });
      default:
        return null;
    }
  }, Oe = () => _ ? /* @__PURE__ */ e.jsx(cs, { size: 16 }) : o ? "Update" : s === gs.SCOPE ? "Save" : "Next";
  return s === gs.SCOPE ? h ? /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) : b ? /* @__PURE__ */ e.jsx(ya, { reload: j }) : /* @__PURE__ */ e.jsx(
    s_,
    {
      isLoading: _,
      filterId: o,
      disableSave: A,
      conditionSelectOptions: x,
      selectedApplications: C,
      selectedEnvironments: f,
      handleFilterSubmit: I,
      handleListNavigation: L,
      handleApplicationConditionChange: S,
      handleEnvironmentConditionChange: O,
      renderButtonStatus: Oe
    }
  ) : /* @__PURE__ */ e.jsx(
    Qh,
    {
      filterId: o,
      filterDetails: r,
      filterDetailsValidationErrors: i,
      conditionType: c,
      disableSave: A,
      isLoading: _,
      handleFilterSubmit: I,
      handleStepperUpdate: w,
      handleNameChange: M,
      handleDescriptionChange: W,
      handleEnablePassCondition: y,
      handleEnableFailCondition: k,
      handleExpressionChange: $,
      handleListNavigation: L,
      renderConditionStatus: X,
      renderInfoBar: G,
      renderButtonStatus: Oe
    }
  );
}
function Hi({ activeStep: s, setStep: t, isToggleEnabled: a, editMode: n = !1 }) {
  const o = () => {
    a && t(gs.DEFINE);
  }, r = () => {
    a && t(gs.SCOPE);
  }, l = () => [
    {
      id: "define-filter-condition-tab",
      label: n ? gs.REVIEW : `1. ${gs.DEFINE}`,
      tabType: "button",
      active: s === gs.DEFINE,
      props: {
        onClick: o
      },
      disabled: !a && s !== gs.DEFINE
    },
    ...n ? [] : [
      {
        id: "edit-stepper-gap",
        label: ">",
        tabType: "button",
        active: !1,
        props: {
          onClick: ks
        }
      }
    ],
    {
      id: "apply-to-tab",
      label: n ? gs.SCOPE : `2. ${gs.SCOPE}`,
      tabType: "button",
      active: s === gs.SCOPE,
      props: {
        onClick: r
      },
      disabled: !a && s !== gs.SCOPE
    }
  ];
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-start pt-0 pb-0 pl-20 pr-20 dc__align-self-stretch bg__primary dc__border-bottom", children: /* @__PURE__ */ e.jsx(ep, { hideTopPadding: !0, tabs: l() }) });
}
function t_() {
  const [s, t] = E(gs.DEFINE), [a, n] = E(!1);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(An, { path: "Add" }),
    /* @__PURE__ */ e.jsx(Hi, { activeStep: s, setStep: t, isToggleEnabled: a }),
    /* @__PURE__ */ e.jsx(
      Ki,
      {
        activeStep: s,
        setActiveStep: t,
        setEnableToggle: n,
        filterId: null
      }
    )
  ] });
}
function a_() {
  const [s, t] = E(gs.DEFINE), { filterId: a } = ce(), { filterDetails: n, isLoading: o, error: r, fetchFilterDetails: l } = Jh(a);
  return o ? /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) : r || !n ? r.code === 404 ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      title: "Filter condition not found",
      subTitle: "The filter condition you are looking for does not exist."
    }
  ) : /* @__PURE__ */ e.jsx("div", { className: "flex column dc__align-items-center dc__justify-content-center h-100", children: /* @__PURE__ */ e.jsx(ya, { reload: l }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex px-20 pt-16 pb-24", children: /* @__PURE__ */ e.jsx(
      sp,
      {
        redirectUrl: Qe.FILTER_CONDITIONS,
        linkText: "Filter Conditions",
        profileName: n.name
      }
    ) }),
    /* @__PURE__ */ e.jsx(Hi, { activeStep: s, setStep: t, isToggleEnabled: !0, editMode: !0 }),
    /* @__PURE__ */ e.jsx(
      Ki,
      {
        activeStep: s,
        setActiveStep: t,
        existingFilterDetails: n,
        filterId: +a
      }
    )
  ] });
}
const n_ = ({ name: s, description: t, conditions: a, fetchConditions: n, id: o }) => {
  const [r, l] = E(!1), [i, u] = E(!1), c = ae(), p = () => l(!0), d = () => l(!1), m = () => u(!0), _ = () => u(!1), g = () => {
    c.push(`${Qe.FILTER_CONDITIONS_EDIT}/${o}`);
  }, x = async () => {
    await Tu(o), n();
  }, C = () => {
    const f = a.map((b) => b.conditionType), h = [];
    return f.includes(As.PASS) && h.push("Pass"), f.includes(As.FAIL) && h.push("Fail"), /* @__PURE__ */ e.jsx("p", { className: "dc__ellipsis-right m-0 cn-9 fs-13 fw-4 pr-16", children: h.join(", ") });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "flexbox flex-wrap w-100 dc__overflow-hidden dc__hover-n50 pt-12 pb-12 pl-20 pr-20",
        onMouseEnter: p,
        onMouseLeave: d,
        children: [
          /* @__PURE__ */ e.jsx(it, { item: !0, xs: 0.5, itemClass: "dc__ellipsis-right flex dc__content-start", children: /* @__PURE__ */ e.jsx(ji, { className: "icon-dim-20" }) }),
          /* @__PURE__ */ e.jsx(it, { item: !0, xs: 2, itemClass: "dc__ellipsis-right flex dc__content-start", children: /* @__PURE__ */ e.jsx(Es, { content: s, placement: "top", className: "default-tt dc__word-break-all", children: /* @__PURE__ */ e.jsx(
            as,
            {
              to: `${Qe.FILTER_CONDITIONS_EDIT}/${o}`,
              className: "dc__ellipsis-right cb-5 fw-4 fs-13 m-0 pr-16",
              children: s
            }
          ) }) }),
          /* @__PURE__ */ e.jsx(it, { item: !0, xs: 7.5, itemClass: "dc__ellipsis-right flex dc__content-start", children: /* @__PURE__ */ e.jsx(Es, { content: t, placement: "top", className: "default-tt dc__word-break-all", children: /* @__PURE__ */ e.jsx("p", { className: "dc__ellipsis-right m-0 cn-9 fs-13 fw-4 pr-16", children: t }) }) }),
          /* @__PURE__ */ e.jsxs(it, { item: !0, xs: 2, itemClass: "dc__ellipsis-right flex dc__content-space", children: [
            C(),
            r && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-16", children: [
              /* @__PURE__ */ e.jsx(
                "button",
                {
                  type: "button",
                  className: "dc__outline-none-imp dc__no-border p-0 h-20 dc__no-background",
                  onClick: g,
                  "aria-label": "Edit",
                  children: /* @__PURE__ */ e.jsx(Ri, { className: "icon-dim-20 scn-6" })
                }
              ),
              /* @__PURE__ */ e.jsx(
                "button",
                {
                  type: "button",
                  className: "dc__outline-none-imp dc__no-border p-0 h-20 dc__no-background",
                  onClick: m,
                  "aria-label": "Delete",
                  children: /* @__PURE__ */ e.jsx(hn, { className: "icon-dim-20 scn-6" })
                }
              )
            ] })
          ] })
        ]
      }
    ),
    i && /* @__PURE__ */ e.jsx(
      Xa,
      {
        title: s,
        component: "filter",
        subtitle: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("p", { className: "fs-13 cn-8 lh-20 m-0", children: "Deleting will remove the enforced filter conditions" }),
          /* @__PURE__ */ e.jsx("p", { className: "fs-13 cn-8 lh-20 m-0", children: "Do you want to delete?" })
        ] }),
        onDelete: x,
        closeConfirmationModal: _,
        successToastMessage: `Successfully deleted ${s}`
      }
    )
  ] });
};
function o_() {
  const [s, t] = E(""), { filterConditions: a, isLoading: n, error: o, fetchConditions: r } = Xh(), l = ae(), i = de(() => s ? a.filter((d) => {
    const { name: m, description: _ } = d;
    return m.toLowerCase().includes(s) || _.toLowerCase().includes(s);
  }) : a, [a, s]), u = (d) => {
    t(d.toLowerCase().trim());
  }, c = () => {
    l.push(Qe.FILTER_CONDITIONS_ADD);
  }, p = () => /* @__PURE__ */ e.jsxs("button", { className: "cta flex h-36", onClick: c, type: "button", children: [
    /* @__PURE__ */ e.jsx(da, { className: "mr-4" }),
    "Add filter condition"
  ] });
  return n ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(An, { onSearch: u }),
    /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 })
  ] }) : o ? /* @__PURE__ */ e.jsxs("div", { className: "flex column dc__align-items-center dc__justify-content-center h-100", children: [
    /* @__PURE__ */ e.jsx(An, { onSearch: u }),
    /* @__PURE__ */ e.jsx(ya, {})
  ] }) : a.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(An, { onSearch: u }),
    i.length ? /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto flex column dc__content-start dc__align-start bg__primary dc__align-self-stretch flex-grow-1 dc__no-shrink", children: /* @__PURE__ */ e.jsxs(it, { container: !0, containerClass: "w-100 flex dc__align-self-stretch dc__align-items-center", children: [
      /* @__PURE__ */ e.jsxs(
        it,
        {
          container: !0,
          containerClass: "w-100 dc__overflow-hidden dc__border-bottom-n1 pt-8 pb-8 pl-20 pr-20",
          children: [
            /* @__PURE__ */ e.jsx(it, { item: !0, xs: 0.5 }),
            /* @__PURE__ */ e.jsx(it, { item: !0, xs: 2, itemClass: "dc__ellipsis-right flex dc__content-start", children: /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-6 lh-20 dc__uppercase dc__ellipsis-right pr-16", children: ho[0] }) }),
            /* @__PURE__ */ e.jsx(it, { item: !0, xs: 7.5, itemClass: "dc__ellipsis-right flex dc__content-start", children: /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-6 lh-20 dc__uppercase dc__ellipsis-right pr-16", children: ho[1] }) }),
            /* @__PURE__ */ e.jsx(it, { item: !0, xs: 2, itemClass: "dc__ellipsis-right flex dc__content-start", children: /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-6 lh-20 dc__uppercase dc__ellipsis-right", children: ho[2] }) })
          ]
        }
      ),
      i.map((d) => /* @__PURE__ */ e.jsx(
        n_,
        {
          name: d.name,
          conditions: d.conditions,
          description: d.description?.length ? d.description : "No defined description",
          fetchConditions: r,
          id: d.id
        },
        d.id
      ))
    ] }) }) : /* @__PURE__ */ e.jsx(
      Xe,
      {
        image: Ln,
        title: "No results found",
        subTitle: "Try adjusting your search to find what you are looking for."
      }
    )
  ] }) : /* @__PURE__ */ e.jsx(
    Xe,
    {
      image: Ln,
      title: "No condition is defined",
      subTitle: si,
      isButtonAvailable: !0,
      renderButton: p
    }
  );
}
const mr = ({ isSuperAdmin: s }) => s ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col bg__primary h-100", children: /* @__PURE__ */ e.jsxs(rt, { children: [
  /* @__PURE__ */ e.jsx(le, { path: Qe.FILTER_CONDITIONS, exact: !0, children: /* @__PURE__ */ e.jsx(o_, {}) }),
  /* @__PURE__ */ e.jsx(le, { path: `${Qe.FILTER_CONDITIONS_EDIT}/:filterId`, children: /* @__PURE__ */ e.jsx(a_, {}) }),
  /* @__PURE__ */ e.jsx(le, { path: `${Qe.FILTER_CONDITIONS_ADD}`, children: /* @__PURE__ */ e.jsx(t_, {}) })
] }) }) : /* @__PURE__ */ e.jsx(rn, {}), r_ = Jp(mr), Dv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FilterConditions: mr,
  default: r_
}, Symbol.toStringTag, { value: "Module" })), l_ = ({
  appName: s,
  envName: t,
  ciPipelineId: a,
  branchName: n
}) => {
  const o = [
    `${Is.devtronApplication}|identifier|${s}`
  ];
  return t ? o.push(`${Is.environment}|identifier|${t}`) : a && (o.push(`${Is.ciPipeline}|id|${a}`), n && o.push(
    `${Is.ciPipeline}|${Au.branchFixed}|${n}`
  )), { resourceIdentifier: o };
}, Yi = (s, t) => {
  const a = s === Is.ciPipeline ? "build" : "deployment";
  switch (t) {
    case ze.POST_STAGE:
      return `post-${a} stage`;
    case ze.PRE_STAGE:
      return `pre-${a} stage`;
    default:
      return "any stage";
  }
}, hl = (s, t, a) => t?.filter((n) => {
  if (n.stepType !== ii.PLUGIN_REF || !n.pluginRefStepDetail)
    return !1;
  const { pluginId: o } = n.pluginRefStepDetail, { parentPluginId: r } = a.pluginVersionStore[o] || {};
  return r === s;
}).length || 0, i_ = (s, t) => s?.reduce((a, n) => (n.parentPluginId === t && !a.includes(n.requiredIn) && a.push(n.requiredIn), a), []) || [], Mv = ({
  mandatoryPluginList: s,
  formData: t,
  targetPluginId: a,
  activeStageName: n,
  pluginDataStore: o,
  isFromMoveTask: r = !1
}) => {
  const l = o.pluginVersionStore[a]?.parentPluginId;
  if (!l)
    return {
      isValid: !0
    };
  const i = i_(s, l);
  if (!i.length)
    return {
      isValid: !0
    };
  const u = t[ze.PRE_STAGE]?.steps || [], c = t[ze.POST_STAGE]?.steps || [], p = hl(
    l,
    u,
    o
  ), d = hl(
    l,
    c,
    o
  );
  return i.includes(ze.PRE_OR_POST_STAGE) && !r && !(p + d > 1) ? {
    isValid: !1
  } : n === ze.PRE_STAGE && i.includes(ze.PRE_STAGE) ? {
    isValid: p > 1
  } : n === ze.POST_STAGE && i.includes(ze.POST_STAGE) ? {
    isValid: d > 1
  } : {
    isValid: !0
  };
}, hr = (s, t, a) => {
  switch (s) {
    case "CI":
      return a ? "Job" : "Build";
    case "PRECD":
      return "Pre-deployment";
    case "POSTCD":
      return "Post-deployment";
    case "CD":
      return "Deployment";
    default:
      return t ?? "Event";
  }
}, c_ = (s) => {
  switch (s) {
    case "CI":
      return "Start Build";
    case "PRECD":
    case "POSTCD":
      return "Trigger stage";
    default:
      return "Trigger";
  }
}, d_ = (s, t) => {
  const a = "Apply and configure mandatory plugins", o = `Go to Workflow editor > Edit ${s === "CI" ? t ? "job" : "build" : "deployment"} pipeline`;
  switch (s) {
    case "CI":
      return [
        o,
        t ? "Look for mandatory plugins in 'Tasks to be executed'" : "Look for mandatory plugins at pre-build or post-build stage",
        a
      ];
    case "PRECD":
      return [o, "Look for mandatory plugins at pre-deployment stage", a];
    case "POSTCD":
      return [o, "Look for mandatory plugins at post-deployment stage", a];
    default:
      return [
        "Go to Workflow editor > Edit pipeline",
        "Look for mandatory plugins at pre-build or post-build stage",
        a
      ];
  }
}, u_ = (s, t) => {
  switch (s) {
    case "PRECD":
      return qp;
    case "POSTCD":
      return zp;
    default:
      return t ? Yp : Hp;
  }
}, Dn = ({
  parentPluginId: s,
  stage: t
}) => `${s}-${t}`, p_ = (s) => s?.definitions?.length ? structuredClone(s.definitions).reduce((a, n) => {
  const o = Dn({
    parentPluginId: n.parentPluginId,
    stage: n.applyToStage
  }), r = a[o]?.definitionSources || {
    policyNames: {},
    linkedCIPipelineNames: {}
  }, l = {
    pluginId: 0,
    parentPluginId: n.parentPluginId,
    applyToStage: n.applyToStage
  };
  return n.linkedPipelines?.forEach((i) => {
    const u = i.identifierDetails?.name;
    i.type === "CI" && u && (r.linkedCIPipelineNames[u] = !0);
  }), n.policyIdentifiers?.forEach((i) => {
    r.policyNames[i] = !0;
  }), {
    ...a,
    [o]: {
      data: l,
      definitionSources: r
    }
  };
}, {}) || {} : {}, m_ = (s) => Object.values(s).map(({ data: t, definitionSources: a }) => ({
  data: t,
  definitionSources: {
    policyNames: Object.keys(a.policyNames),
    linkedCIPipelineNames: Object.keys(a.linkedCIPipelineNames)
  }
})), zi = ({
  consequence: s,
  configurePluginURL: t,
  onTrigger: a,
  showTriggerButton: n,
  children: o,
  nodeType: r,
  visible: l,
  onClose: i,
  trigger: u
}) => {
  const [c, p] = E(!1), d = wo.ALLOW_FOREVER === s.action, m = () => {
    p(!0);
  }, _ = () => /* @__PURE__ */ e.jsxs("div", { className: "flex column left px-16 pb-16 dc__gap-20", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("div", { className: "fs-14 cn-9 fw-6 lh-20 dc__word-break flexbox flex-wrap", children: d ? /* @__PURE__ */ e.jsx("span", { children: "Some enforced plugins are not configured" }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsxs("span", { children: [
          hr(r),
          " ",
          c ? "is blocked" : "will be blocked on",
          " "
        ] }),
        s.metadataField && /* @__PURE__ */ e.jsx(
          an,
          {
            endTime: s.metadataField,
            callbackAfterTimeEnd: m,
            rootClassName: "cy-7 fs-14 fw-6 lh-20"
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 lh-20 fw-4", children: d ? "Please configure required plugins to comply with enforced policy." : "Some mandatory plugins are not configured. Configure the plugins to avoid blocking." })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "configure-plugin-with-warning",
          startIcon: /* @__PURE__ */ e.jsx(Rm, {}),
          text: "Configure plugin",
          component: me.link,
          linkProps: {
            to: t,
            target: "_blank"
          },
          size: P.medium,
          variant: U.secondary
        }
      ),
      n && /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "trigger-with-warning",
          startIcon: /* @__PURE__ */ e.jsx(km, {}),
          text: c_(r),
          onClick: a,
          style: q.neutral,
          size: P.medium,
          variant: U.secondary,
          disabled: c
        }
      )
    ] })
  ] });
  return /* @__PURE__ */ e.jsx(
    ea,
    {
      theme: sa.white,
      placement: "bottom-end",
      className: "mb-60--neg",
      Icon: Lm,
      iconSize: 40,
      showCloseButton: !0,
      noHeadingBorder: !0,
      additionalContent: _(),
      interactive: !0,
      ...u ? { trigger: u } : {},
      ...nn(l) ? { trigger: "click" } : { visible: l },
      ...i ? { onClose: i } : {},
      children: /* @__PURE__ */ e.jsx("div", { children: o })
    }
  );
}, Bv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zi
}, Symbol.toStringTag, { value: "Module" })), qi = ({ pluginDetail: s, rootClassName: t }) => {
  const { policyNames: a, linkedCIPipelineNames: n } = s?.definitionSources || {};
  return /* @__PURE__ */ e.jsxs("div", { className: `flexbox-col dc__gap-12 ${t || ""}`, children: [
    a?.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Plugin is mandatory due to plugin policy" }),
        /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-wrap dc__gap-8", children: a.map((o) => /* @__PURE__ */ e.jsx(
          as,
          {
            to: $e(Ce.PLUGIN_POLICY_APPLIED_PROFILE_LIST, {
              [yu.profile]: [o]
            }),
            target: "_blank",
            className: "dc__no-decor dc__hover-n50 cn-9 dc__hover-color-b500 dc__hover-color-b500--stroke",
            children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-4 py-2 px-6 br-4 dc__border", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 dc__truncate dc__mxw-150", children: o }),
              /* @__PURE__ */ e.jsx(Zn, { className: "icon-dim-16 scn-7 dc__no-shrink" })
            ] })
          },
          o
        )) })
      ] }),
      n?.length > 0 && /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100" })
    ] }),
    n?.length > 0 && /* @__PURE__ */ e.jsxs("span", { className: "cn-9 fs-13 lh-20 dc__word-break", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-4", children: "Plugin is mandatory for linked CI" }),
      " ",
      n.map((o, r) => /* @__PURE__ */ e.jsxs("span", { className: "fw-6 dc__word-break", children: [
        r !== 0 ? "," : "",
        " ",
        o
      ] }, o))
    ] })
  ] });
}, h_ = ({
  handleTogglePluginExpansion: s,
  pluginDetail: t,
  isExpanded: a,
  resourceKindType: n
}) => {
  const o = () => {
    s({
      parentPluginId: t.parentPluginId,
      requiredIn: t.requiredIn
    });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        role: "tab",
        className: `dc__transparent dc__hover-n50 px-12 py-10 flexbox dc__gap-8 dc__visible-hover dc__visible-hover--parent ${a ? "bg__secondary" : ""}`,
        "data-testid": `toggle-expansion-for-${Dn({ parentPluginId: t.parentPluginId, stage: t.requiredIn })}`,
        onClick: o,
        children: [
          !a && /* @__PURE__ */ e.jsx(
            tp,
            {
              fallbackImageClassName: "icon-dim-20 dc__visible-hover--hide-child",
              imageProps: {
                src: t.icon,
                alt: t.name,
                height: 20,
                width: 20,
                className: "icon-dim-20 dc__visible-hover--hide-child"
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            dr,
            {
              className: `icon-dim-20 dc__no-shrink dc__transition--transform ${a ? "" : "dc__flip-90--neg dc__visible-hover--child"}`
            }
          ),
          /* @__PURE__ */ e.jsx(we, { content: t.name, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate flex-grow-1 dc__align-left", children: t.name }) }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-6 fs-12 fw-4 lh-20 dc__no-shrink dc__first-letter-capitalize", children: Yi(n, t.requiredIn) })
        ]
      }
    ),
    a && /* @__PURE__ */ e.jsx(qi, { pluginDetail: t, rootClassName: "py-10 pl-40 pr-8" })
  ] });
}, __ = ({
  mandatoryPluginData: s,
  stage: t,
  formData: a,
  setFormData: n,
  formDataErrorObj: o,
  setFormDataErrorObj: r,
  handleApplyPlugin: l,
  resourceKindType: i
}) => {
  const [u, c] = E({}), p = s?.pluginData?.filter((h) => !h.applied) || [], d = () => {
    c({});
  }, m = (h) => (h.refVariableStepIndex = 0, h.refVariableName = "", h.variableType = ap.NEW, h.variableStepIndexInPlugin = h.variableStepIndex, delete h.refVariableStage, delete h.variableStepIndex, h), _ = () => {
    if (p.length) {
      const h = { ...a }, b = { ...o };
      for (let S = 0; S < p.length; S++) {
        const O = p[S], j = O.requiredIn !== ze.PRE_OR_POST_STAGE ? O.requiredIn : t, v = h[j].steps.length - 1;
        h[j].steps.push({
          id: v,
          index: v,
          description: O.description,
          name: O.name,
          stepType: ii.PLUGIN_REF,
          pluginRefStepDetail: {
            id: 0,
            pluginId: O.id,
            conditionDetails: [],
            inputVariables: O.inputVariables?.map(m) || [],
            outputVariables: O.outputVariables?.map(m) || []
          }
        }), b[j].steps.push({
          name: { isValid: !0, message: null },
          isValid: !0,
          pluginRefStepDetail: { inputVariables: [] }
        });
      }
      n(h), r(b), l(h);
    }
  }, g = ({
    parentPluginId: h,
    requiredIn: b
  }) => {
    const S = structuredClone(u), O = Dn({ parentPluginId: h, stage: b });
    S[O] ? delete S[O] : S[O] = !0, c(S);
  }, x = () => /* @__PURE__ */ e.jsxs("div", { className: "h-100 mxh-210 dc__overflow-auto flexbox-col dc__content-space", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col h-100 dc__overflow-auto", children: p.map((h) => {
      const b = Dn({
        parentPluginId: h.parentPluginId,
        stage: h.requiredIn
      });
      return /* @__PURE__ */ e.jsx(
        h_,
        {
          pluginDetail: h,
          handleTogglePluginExpansion: g,
          isExpanded: u[b],
          resourceKindType: i
        },
        b
      );
    }) }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__border-top flex right p-12 dc__no-shrink", children: /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "apply-mandatory-plugin-button",
        text: "Apply",
        onClick: _,
        size: P.small
      }
    ) })
  ] }), C = () => /* @__PURE__ */ e.jsxs("span", { className: "flexbox dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(Ja, { className: "warning-icon-y7-imp icon-dim-20 dc__no-shrink" }),
    /* @__PURE__ */ e.jsx("span", { children: "Apply mandatory plugins" })
  ] }), f = () => /* @__PURE__ */ e.jsx("span", { children: "Apply plugins & configure them. A non-configured plugin may lead to the blocking of pipeline triggers." });
  return p.length ? /* @__PURE__ */ e.jsx("div", { className: "mb-12 dc__border-bottom-n1", children: /* @__PURE__ */ e.jsxs("div", { className: "br-4 p-12 flexbox-col dc__gap-6 en-2 bw-1", children: [
    /* @__PURE__ */ e.jsxs("span", { className: "bcy-1 br-4 ey-2 bw-1 cy-7 flex dc__gap-6 px-8 dc__w-fit-content fw-6 fs-12 h-22", children: [
      /* @__PURE__ */ e.jsx(Ja, { className: "warning-icon-y7-imp icon-dim-14 dc__no-shrink" }),
      "Action required"
    ] }),
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Mandatory plugins are not configured" }),
    /* @__PURE__ */ e.jsx(
      ea,
      {
        theme: sa.white,
        heading: C(),
        headingInfo: f(),
        additionalContent: x(),
        className: "w-436 h-100",
        placement: "bottom",
        showCloseButton: !0,
        trigger: "click",
        interactive: !0,
        onClose: d,
        children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          B,
          {
            text: "View plugins",
            dataTestId: "mandatory-plugin-warning-button",
            variant: U.text
          }
        ) })
      }
    )
  ] }) }) : null;
}, Uv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __
}, Symbol.toStringTag, { value: "Module" })), f_ = (s) => /* @__PURE__ */ e.jsx(
  "span",
  {
    className: "flex fs-12 fw-6 cn-9 lh-20 icon-dim-24 bg__primary dc__border dc__border-radius-50-per",
    style: {
      marginLeft: "-13px"
    },
    children: s
  }
), No = ({ step: s, stepLabel: t, children: a }) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: "display-grid left fs-13 fw-4 lh-20 cn-9 dc__gap-16",
    style: {
      gridTemplateColumns: "24px auto"
    },
    children: [
      f_(s),
      t,
      a
    ]
  }
), Fv = ({ configurePluginURL: s, nodeType: t, isJobView: a = !1 }) => {
  const n = d_(t, a), o = hr(t, null, a);
  return /* @__PURE__ */ e.jsx(
    Xe,
    {
      classname: "left flexbox-col dc__overflow-auto dc__gap-24 dc__skip-align-reload-center dc__align-left w-342 dc__m-auto",
      SvgImage: Kp,
      imageClassName: "w-125px-imp h-100px-imp",
      title: `${o} trigger is blocked!`,
      contentClassName: "dc__align-start w-342",
      children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsxs("span", { className: "fs-13 fw-4 cn-9 lh-20 dc__first-letter-capitalize", children: [
          "Some mandatory plugins are not configured. Configure the plugins to unblock ",
          o,
          " trigger."
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsx("h5", { className: "fs-14 fw-6 lh-20 cn-8", children: "How to unblock" }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex column left top dc__border-left dc__gap-16 ml-12", children: [
            /* @__PURE__ */ e.jsx(No, { step: 1, stepLabel: n[0] }),
            /* @__PURE__ */ e.jsx(No, { step: 2, children: /* @__PURE__ */ e.jsxs("div", { className: "flex column left dc__gap-8", children: [
              n[1],
              /* @__PURE__ */ e.jsx(
                "img",
                {
                  className: "w-100-imp h-100-imp",
                  src: u_(t, a),
                  width: 330,
                  height: 140,
                  alt: "How to unblock"
                }
              )
            ] }) }),
            /* @__PURE__ */ e.jsx(No, { step: 3, stepLabel: n[2] })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "configure-plugins",
            endIcon: /* @__PURE__ */ e.jsx(Zn, {}),
            text: "Configure plugins to unblock",
            size: P.medium,
            component: me.link,
            variant: U.secondary,
            linkProps: {
              to: s
            }
          }
        )
      ] })
    }
  );
}, _l = ({ mandatoryPluginDetails: s }) => {
  const [t, a] = E(!1), n = () => {
    a((o) => !o);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        onClick: n,
        className: `dc__transparent br-4 ev-2 bw-1 flexbox dc__gap-8 p-8 dc__align-items-center bcv-1 w-100 mt-16 ${t ? "dc__no-bottom-radius" : ""}`,
        children: [
          /* @__PURE__ */ e.jsx(Zp, { className: "icon-dim-20 dc__no-shrink" }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-8 fs-13 fw-4 lh-20 flex-grow-1 dc__align-left", children: "Why this plugin is mandatory" }),
          /* @__PURE__ */ e.jsx(
            Qp,
            {
              className: `icon-dim-20 dc__no-shrink dc__transition--transform ${t ? "dc__flip-180--neg" : ""} `
            }
          )
        ]
      }
    ),
    t && /* @__PURE__ */ e.jsx(
      qi,
      {
        pluginDetail: s,
        rootClassName: "en-2 bw-1 p-12 w-100 dc__no-border-top-imp mxh-210 dc__overflow-auto dc__bottom-left-radius dc__bottom-right-radius"
      }
    )
  ] });
}, Vv = ({
  handleClose: s,
  handleDelete: t,
  handleMoveTask: a,
  taskIndex: n,
  type: o,
  pluginId: r,
  activeStageName: l,
  pluginDataStore: i,
  resourceKindType: u,
  mandatoryPluginList: c
}) => {
  const p = () => {
    t(n), s();
  }, d = () => {
    a(n), s();
  }, m = i.pluginVersionStore[r]?.parentPluginId, _ = c.find(
    (x) => x.parentPluginId === m && x.requiredIn === l
  ) || c.find(
    (x) => x.parentPluginId === m && x.requiredIn === ze.PRE_OR_POST_STAGE
  ), g = `Plugin is mandatory for ${Yi(u, l)}`;
  return o === zr.DELETE ? /* @__PURE__ */ e.jsx(
    vt,
    {
      variant: mt.delete,
      title: g,
      subtitle: /* @__PURE__ */ e.jsxs("p", { className: "m-0-imp fs-13 cn-7", children: [
        /* @__PURE__ */ e.jsx("span", { className: "lh-20", children: "Are you sure you want to remove?" }),
        /* @__PURE__ */ e.jsx(_l, { mandatoryPluginDetails: _ })
      ] }),
      buttonConfig: {
        secondaryButtonConfig: {
          onClick: s,
          text: "Cancel"
        },
        primaryButtonConfig: {
          onClick: p,
          text: "Delete"
        }
      },
      handleClose: s
    }
  ) : o === zr.MOVE_PLUGIN ? /* @__PURE__ */ e.jsx(
    vt,
    {
      variant: mt.custom,
      Icon: /* @__PURE__ */ e.jsx(
        em,
        {
          className: `${_.requiredIn === ze.POST_STAGE ? "dc__flip-180" : ""}`
        }
      ),
      title: g,
      subtitle: "Are you sure you want to move?",
      handleClose: s,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: s
        },
        primaryButtonConfig: {
          text: "Move",
          onClick: d
        }
      },
      children: /* @__PURE__ */ e.jsx(_l, { mandatoryPluginDetails: _ })
    }
  ) : null;
}, g_ = (s) => /* @__PURE__ */ e.jsxs("span", { className: "flex left cr-5 fw-4 fs-12 dc__align-items-center", children: [
  /* @__PURE__ */ e.jsx(Li, { className: "icon-dim-12 mr-4 mw-14 dc__no-shrink" }),
  /* @__PURE__ */ e.jsxs("span", { className: "dc__block dc__ellipsis-right", children: [
    s,
    " is blocked"
  ] })
] }), x_ = ({
  consequence: s,
  configurePluginURL: t,
  nodeType: a,
  shouldRenderAdditionalInfo: n,
  isJobView: o
}) => {
  const r = hr(a), l = (u) => /* @__PURE__ */ e.jsx(
    zi,
    {
      trigger: "mouseenter focus",
      consequence: s,
      configurePluginURL: t,
      nodeType: a,
      isJobView: o,
      children: u
    }
  ), i = () => /* @__PURE__ */ e.jsx("div", { className: "flex left dc__align-start dc__gap-4", children: /* @__PURE__ */ e.jsx(on, { condition: n, wrap: l, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-start", children: [
    /* @__PURE__ */ e.jsx(Ja, { className: "icon-dim-12 warning-icon-y7 mw-14 dc__no-shrink mt-4" }),
    /* @__PURE__ */ e.jsx("span", { className: "flex left cy-7 fw-4 fs-12 flex-grow-1 dc__align-left", children: s.action === wo.ALLOW_UNTIL_TIME ? `${o ? "Job" : r} trigger will be blocked in...` : "Plugins not configured" }),
    /* @__PURE__ */ e.jsx(Dm, { className: "icon-dim-12 dc__no-shrink dc__flip-180 scy-7 mt-5" })
  ] }) }) });
  return s.action === wo.BLOCK ? g_(r) : i();
}, Gv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: x_
}, Symbol.toStringTag, { value: "Module" })), Xi = async (s) => {
  const t = `${z.OFFENDING}/${s.resourceKind}`;
  if (s.resourceKind === Is.cdPipeline && !s.envName)
    return {
      definitions: [],
      isOffendingMandatoryPlugin: !1,
      isTriggerBlocked: !1,
      pipelineBlockState: Br()
    };
  const a = np({
    kind: op.plugins,
    version: zn.alpha1,
    suffix: t,
    queryParams: l_(s)
  }), { result: n } = await xe(a);
  return {
    ...n,
    pipelineBlockState: Br(n?.pipelineBlockState)
  };
}, Wv = async (s, t, a, n) => {
  const { isOffendingMandatoryPlugin: o, isTriggerBlocked: r, pipelineBlockState: l } = await Xi({
    appId: +t,
    appName: n,
    resourceKind: Is.ciPipeline,
    ciPipelineId: +s || null,
    branchName: a
  });
  return {
    isOffendingMandatoryPlugin: o,
    isCITriggerBlocked: r,
    ciBlockState: l
  };
}, fl = (s, t) => {
  const a = {};
  for (let n = 0; n < s.length; n++) {
    const o = s[n].pluginRefStepDetail?.pluginId;
    o && (a[t.pluginVersionStore[o].parentPluginId] = !0);
  }
  return a;
}, C_ = (s, t, a) => {
  const n = Object.keys(a.parentPluginStore), o = Object.keys(a.pluginVersionStore);
  if (!t.length || !n.length || !o.length)
    return {
      pluginData: [],
      isValidPre: !0,
      isValidPost: !0
    };
  const r = fl(
    s?.preBuildStage?.steps || [],
    a
  ), l = fl(
    s?.postBuildStage?.steps || [],
    a
  );
  let i = !0, u = !0;
  const c = n.reduce(
    (d, m) => {
      const _ = a.parentPluginStore[m].latestVersionId;
      return d[m] = a.pluginVersionStore[_], d;
    },
    {}
  ), p = [];
  return t.forEach((d) => {
    let m = !1;
    d.requiredIn === ze.PRE_STAGE && !r[d.parentPluginId] ? (m = !0, i = i && !1) : d.requiredIn === ze.POST_STAGE && !l[d.parentPluginId] ? (m = !0, u = u && !1) : d.requiredIn === ze.PRE_OR_POST_STAGE && !r[d.parentPluginId] && !l[d.parentPluginId] && (m = !0, u = u && !1, i = i && !1), m ? d.applied = !1 : d.applied = !0;
    let _ = {};
    c[d.parentPluginId] && (_ = { ...c[d.parentPluginId] }), p.push({ ...d, ..._ });
  }), {
    pluginData: p,
    isValidPre: i,
    isValidPost: u
  };
}, b_ = async (s) => {
  try {
    const t = await Xi(s), a = p_(t);
    return m_(a);
  } catch {
  }
  return null;
}, S_ = async (s, t, a, n) => {
  if (!s.length && !t.length)
    return structuredClone(n);
  const {
    pluginStore: { parentPluginStore: o, pluginVersionStore: r }
  } = await rp({
    appId: a,
    parentPluginIds: t,
    pluginIds: s
  });
  return lp(n, o, r);
}, $v = async ({
  formData: s,
  pluginDataStoreState: t,
  appName: a,
  appId: n,
  ciPipelineId: o,
  branchName: r,
  requiredPluginIds: l = [],
  envName: i,
  resourceKind: u
}) => {
  try {
    const c = await b_(
      u === Is.ciPipeline ? {
        appId: +n,
        appName: a,
        ciPipelineId: o,
        branchName: r,
        resourceKind: u
      } : {
        appId: +n,
        appName: a,
        envName: i,
        resourceKind: u
      }
    ), p = { mandatoryPluginList: [], requiredParentPluginIds: [] }, { mandatoryPluginList: d, requiredParentPluginIds: m } = c?.reduce((g, x) => {
      const { parentPluginId: C } = x.data;
      g.mandatoryPluginList.push({
        id: x.data.pluginId,
        parentPluginId: C,
        requiredIn: e_[x.data.applyToStage],
        definitionSources: x.definitionSources,
        applied: !1
      });
      const f = t.parentPluginStore[C]?.latestVersionId;
      return (!f || !t.pluginVersionStore[f]) && g.requiredParentPluginIds.push(C), g;
    }, p) ?? p, _ = await S_(
      l,
      m,
      n,
      t
    );
    return {
      mandatoryPluginData: C_(s, d, _),
      pluginDataStore: _
    };
  } catch (c) {
    if (l.length)
      throw c;
    return {
      mandatoryPluginData: {
        pluginData: [],
        isValidPre: !0,
        isValidPost: !0
      },
      pluginDataStore: structuredClone(t)
    };
  }
}, N_ = ({ clusterId: s, namespace: t, name: a, rbacPayload: n }) => xe(
  $e(z.K8S_POD, { clusterId: s, name: a, namespace: t, ...n })
), Ji = ({
  close: s,
  clusterId: t,
  namespace: a,
  name: n,
  rbacPayload: o,
  aiWidgetAnalyticsEvent: r
}) => {
  const l = Ms(null), [i, u] = E(""), [c, p] = E(!1), [d, m] = E(""), [_, g] = E(0), x = async () => {
    p(!0), N_({
      clusterId: t,
      namespace: a,
      name: n,
      rbacPayload: o
    }).then((h) => {
      u(h?.result), m(h?.errors);
    }).catch((h) => {
      g(h.code);
    }).finally(() => {
      p(!1);
    });
  };
  ue(() => {
    x();
  }, [n]);
  const C = (h) => {
    Rs(h), h && h.key === "Escape" && (h.preventDefault(), s());
  };
  ue(() => (document.addEventListener("keydown", C), () => {
    document.removeEventListener("keydown", C);
  }), [C]);
  const f = () => c ? /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) : _ === 424 ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      title: "Scoop not configured",
      subTitle: "Please contact Devtron's team to configure scoop on this cluster.",
      SvgImage: Mm,
      imageType: Io.Large,
      children: /* @__PURE__ */ e.jsx(
        "a",
        {
          href: "https://enterprise.devtron.ai/portal/en/newticket",
          target: "_blank",
          rel: "noreferrer noopener",
          className: "cta secondary flex anchor",
          children: "Open ticket"
        }
      )
    }
  ) : _ ? /* @__PURE__ */ e.jsx(_t, { code: _ }) : d ? /* @__PURE__ */ e.jsx(Xe, { title: "Failed to show pod restart", subTitle: d }) : /* @__PURE__ */ e.jsx(
    ip,
    {
      className: "pod-restart-content flexbox-col flex-grow-1 dc__overflow-auto fs-13",
      markdown: i,
      breaks: !0
    }
  );
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", width: "800px", children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col dc__overflow-hidden bg__primary h-100",
      ref: l,
      "data-testId": "pod-restart-modal",
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "dc__no-shrink dc__box-shadow pb-12 pt-12 bg__primary", children: /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: "title flex dc__content-space cn-9 fs-16 fw-6 pl-20 pr-20 ",
            "data-testid": "pods-restart-heading-after-click",
            children: [
              "Pod last restart snapshot",
              /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-12", children: [
                i && /* @__PURE__ */ e.jsx(
                  ju,
                  {
                    intelligenceConfig: {
                      clusterId: t,
                      metadata: { namespace: a, name: n },
                      prompt: i,
                      analyticsCategory: r
                    }
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  B,
                  {
                    dataTestId: "close-button",
                    icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-small", size: 24, color: null }),
                    onClick: s,
                    ariaLabel: "close pod restart modal",
                    showAriaLabelInTippy: !1,
                    variant: U.borderLess,
                    style: q.negativeGrey,
                    size: P.xs
                  }
                )
              ] })
            ]
          }
        ) }),
        f()
      ]
    }
  ) });
}, Kv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PodRestartModal: Ji
}, Symbol.toStringTag, { value: "Module" })), E_ = ({ rbacPayload: s, aiWidgetAnalyticsEvent: t }) => {
  const a = ae(), { searchParams: n } = Re();
  if (!n.podRestartModalParams)
    return null;
  const { clusterId: o, namespace: r, name: l } = JSON.parse(n.podRestartModalParams), i = () => {
    delete n.podRestartModalParams, a.replace({
      search: new URLSearchParams(n).toString()
    });
  };
  return /* @__PURE__ */ e.jsx(
    Ji,
    {
      close: i,
      clusterId: +o,
      namespace: r,
      name: l,
      rbacPayload: s,
      aiWidgetAnalyticsEvent: t
    }
  );
}, Hv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E_
}, Symbol.toStringTag, { value: "Module" })), v_ = (s) => {
  const { searchParams: t } = Re(), a = ae(), n = () => {
    const o = {
      ...t,
      podRestartModalParams: JSON.stringify(s)
    };
    a.push({
      search: new URLSearchParams(o).toString()
    });
  };
  return /* @__PURE__ */ e.jsx(Bm, { className: "restart-icon cursor ml-4 flex", onClick: n });
}, Yv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v_
}, Symbol.toStringTag, { value: "Module" }));
var Mo = /* @__PURE__ */ ((s) => (s.ENVIRONMENT = "ENVIRONMENT", s.NAMESPACE = "NAMESPACE", s))(Mo || {}), Pt = /* @__PURE__ */ ((s) => (s.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS = "all_existing_and_future_environments", s.SPECIFIC_ENVIRONMENTS = "specific_environments", s))(Pt || {});
const T_ = ({ isSuperAdmin: s }) => {
  const [t, a] = E({}), [n, o] = E(!1), [r, l] = E(!0), [i, u] = E(""), [c, p] = E(!1), [d, m] = E({}), [_, g] = E(!1), x = (T) => {
    if (!T?.length) return null;
    let I;
    return T.every((y) => y.isSelected) ? I = De.CHECKED : T.some((y) => y.isSelected) ? I = De.INTERMEDIATE : I = null, I;
  };
  async function C() {
    try {
      l(!0), await Promise.all([Wi(), Eh()]).then(([T, I]) => {
        const y = {}, k = {}, G = {};
        I.result.enableDigestForAllClusters && o(!0), I.result.clusterDetails.forEach((K) => {
          k[K.clusterId] = {
            clusterId: K.clusterId,
            policyType: K.policyType,
            environmentIds: K.environmentIds ?? [],
            // Empty array in case of all policy type
            envDetails: [],
            clusterName: "",
            isClusterSelected: null
          }, K.environmentIds.forEach((X) => {
            y[X] = !0;
          });
        }), T.result.forEach((K) => {
          k[K.cluster_id] || (k[K.cluster_id] = {
            clusterId: K.cluster_id,
            isClusterSelected: null,
            policyType: null,
            clusterName: K.cluster_name,
            environmentIds: [],
            envDetails: []
          }), k[K.cluster_id].clusterName || (k[K.cluster_id].clusterName = K.cluster_name), G[K.cluster_id] || (G[K.cluster_id] = []), G[K.cluster_id].push({
            environmentId: K.id,
            environmentName: K.environment_name,
            namespace: K.namespace,
            isSelected: k[K.cluster_id].policyType === Pt.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS || y[K.id],
            id: K.id,
            isDigestEnforcedForEnv: K.isDigestEnforcedForEnv,
            clusterId: K.cluster_id,
            clusterName: K.cluster_name
          });
        }), Object.keys(k).forEach((K) => {
          k[K].envDetails = G[K], k[K].isClusterSelected = x(
            k[K].envDetails
          );
        }), a(k), m(k), o(I.result.enableDigestForAllClusters), l(!1);
      });
    } catch (T) {
      l(!1), ve(T);
    }
  }
  ue(() => {
    s && C();
  }, []);
  const f = () => {
    o(!n);
  }, h = () => /* @__PURE__ */ e.jsxs("div", { className: "en-2 bw-1 px-16 py-12 flex dc__content-space br-4", children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("div", { className: "fw-6", children: "Pull image digest for all existing & future environments" }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        "When enabled, image will be pulled with image digest to ensure uniqueness of image. ",
        /* @__PURE__ */ e.jsx(ln, { dataTestId: "pull-image-digest-learn-more", docLinkKey: "GLOBAL_CONFIG_PULL_IMAGE_DIGEST" })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      ft,
      {
        name: "toggle-pull-image-digest-global",
        ariaLabel: "Toggle pull image digest for all existing & future environments",
        isChecked: n,
        onChange: f
      }
    )
  ] }), b = (T) => {
    let I;
    return T === De.CHECKED ? I = Pt.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS : T === De.INTERMEDIATE && (I = Pt.SPECIFIC_ENVIRONMENTS), I;
  }, S = (T) => {
    const I = (y) => {
      const k = y[T].isClusterSelected === De.CHECKED ? null : De.CHECKED;
      return {
        ...y,
        [T]: {
          ...y[T],
          isClusterSelected: k,
          policyType: b(k),
          // On click of cluster checkbox, all the env checkbox will be selected
          envDetails: y[T].envDetails.map((G) => ({
            ...G,
            isSelected: y[T].isClusterSelected !== De.CHECKED
          }))
        }
      };
    };
    a(I), m(I);
  }, O = (T, I) => {
    const y = (k) => {
      const G = k[I].envDetails.map((X) => X.environmentId === T ? { ...X, isSelected: !X.isSelected } : X), K = x(G);
      return {
        ...k,
        [I]: {
          ...k[I],
          envDetails: G,
          isClusterSelected: K,
          policyType: b(K)
        }
      };
    };
    a(y), m(y);
  }, j = (T) => T?.length === 0 ? null : T.map((I) => /* @__PURE__ */ e.jsxs("div", { className: "image-digest-env-namespace pl-16 pr-16 pt-6 pb-6 dc__border-bottom-n1 fs-13 lh-20", children: [
    /* @__PURE__ */ e.jsx(
      Ft,
      {
        rootClassName: "mt-3 mb-3",
        dataTestId: "enforce-policy",
        isChecked: I.isSelected,
        value: I.isSelected && De.CHECKED,
        onChange: () => O(I.environmentId, I.clusterId),
        onClick: Rs
      }
    ),
    /* @__PURE__ */ e.jsx("div", { children: I.environmentName }),
    /* @__PURE__ */ e.jsx("div", { children: I.namespace })
  ] })), v = (T, I, y) => /* @__PURE__ */ e.jsx("div", { className: "bg__secondary pl-16 pr-16 pt-10 pb-10 dc__border-bottom", children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flex left top cursor",
      onClick: () => S(I),
      "data-testId": "enforce-cluster-checkbox",
      children: [
        /* @__PURE__ */ e.jsx(
          Ft,
          {
            rootClassName: "mt-3",
            dataTestId: "enforce-policy",
            isChecked: y === De.CHECKED || y === De.INTERMEDIATE,
            value: y,
            onChange: () => S(I),
            onClick: Rs
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "fs-13", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "fw-6 mr-12", children: [
            T,
            " "
          ] }),
          y === De.CHECKED && "All existing & future environments"
        ] })
      ]
    }
  ) }), A = () => n ? /* @__PURE__ */ e.jsx("div", { className: "en-2 bw-1 br-4 flex flex-grow-1", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__mxw-300 flex column dc__text-center", children: [
    /* @__PURE__ */ e.jsx(am, { className: "mr-8 w-100px h-100px-imp mb-4" }),
    /* @__PURE__ */ e.jsx("div", { className: "fs-11 fw-5 mb-16 cb-4 pl-6 pr-6 eb-2 bw-1 br-4 mono bcb-1", children: "sha256:2f14a…" }),
    /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 lh-20 cn-9", children: "Image digest will be pulled from registry for deployment to all environments" })
  ] }) }) : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__gap-12", children: Object.values(d).map((T) => T.envDetails?.length ? /* @__PURE__ */ e.jsxs("div", { className: "en-2 bw-1 br-4", children: [
    v(
      T.clusterName,
      T.clusterId,
      T.isClusterSelected
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "image-digest-env-namespace pl-16 pr-16 pt-6 pb-6 dc__border-bottom-n1 fw-6", children: [
      /* @__PURE__ */ e.jsx("div", {}),
      /* @__PURE__ */ e.jsx("div", { children: Mo.ENVIRONMENT }),
      /* @__PURE__ */ e.jsx("div", { children: Mo.NAMESPACE })
    ] }),
    j(d[T.clusterId].envDetails)
  ] }) : null) }), N = async () => {
    const T = [];
    n || Object.values(t).forEach((y) => {
      if (y.policyType === Pt.SPECIFIC_ENVIRONMENTS) {
        const k = y?.envDetails.filter((G) => G.isSelected).map((G) => G.environmentId);
        T.push({
          clusterId: y.clusterId,
          environmentIds: n ? [] : k,
          policyType: Pt.SPECIFIC_ENVIRONMENTS
        });
      } else y.policyType === Pt.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS && T.push({
        clusterId: y.clusterId,
        environmentIds: [],
        policyType: Pt.ALL_EXISTING_AND_FUTURE_ENVIRONMENTS
      });
    });
    const I = {
      enableDigestForAllClusters: n,
      clusterDetails: T
    };
    try {
      l(!0), await vh(I), await C(), Se.showToast({
        variant: Ne.success,
        description: "Saved Changes"
      });
    } catch (y) {
      ve(y);
    } finally {
      l(!1);
    }
  }, L = () => /* @__PURE__ */ e.jsx("div", { className: "py-16 px-20 dc__border-top-n1 dc__no-shrink", children: /* @__PURE__ */ e.jsx(
    B,
    {
      size: P.medium,
      onClick: N,
      disabled: _,
      dataTestId: "save-changes",
      isLoading: r,
      text: "Save Changes"
    }
  ) }), M = (T) => {
    p(!0), u(T);
    let I = !0;
    const y = {};
    Object.keys(t).forEach((k) => {
      const G = t[k].envDetails.filter(
        (K) => K.environmentName.toLowerCase().includes(T.toLowerCase()) || K.namespace.toLowerCase().includes(T.toLowerCase())
      );
      G.length && (I = !1, y[k] = {
        ...t[k],
        envDetails: G
      }), I = I && G.length === 0;
    }), m(y), g(I);
  }, W = () => r ? /* @__PURE__ */ e.jsx("div", { className: "dc__align-reload-center bg__primary", children: /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) }) : _ && c ? /* @__PURE__ */ e.jsx("div", { className: "dc__align-reload-center", children: /* @__PURE__ */ e.jsx(cp, {}) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    h(),
    A()
  ] }), $ = () => {
    p(!0);
  }, w = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space dc__no-shrink pt-16 px-16", children: [
      /* @__PURE__ */ e.jsx(
        Jo,
        {
          title: $a.PULL_IMAGE_DIGEST.title,
          renderDescriptionContent: () => $a.PULL_IMAGE_DIGEST.description,
          docLink: $a.PULL_IMAGE_DIGEST.docLink,
          showInfoIconTippy: !0
        }
      ),
      /* @__PURE__ */ e.jsx(
        aa,
        {
          initialSearchText: i,
          handleSearchChange: M,
          handleEnter: $,
          containerClassName: "w-250-imp",
          inputProps: {
            placeholder: "Search environment or namespa...",
            autoFocus: !0
          }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto py-16 px-16 dc__gap-12", children: W() })
  ] });
  return s ? /* @__PURE__ */ e.jsxs("div", { className: "bg__primary flexbox-col dc__overflow-hidden dc__content-space h-100", children: [
    w(),
    L()
  ] }) : /* @__PURE__ */ e.jsx(rn, {});
};
var Cs = /* @__PURE__ */ ((s) => (s.Password = "PASSWORD", s.SSH_Private_Key = "SSH_PRIVATE_KEY", s.Password_And_SSH_Private_Key = "PASSWORD_AND_SSH_PRIVATE_KEY", s))(Cs || {});
const Eo = {
  Password: "Password",
  SSHAuthKey: "SSH Private Key",
  PasswordAndSSHAuthKey: "Password & SSH Private Key"
}, zv = (s, t, a) => {
  if (!s)
    return {
      connectionMethod: "",
      proxyConfig: { proxyUrl: "" },
      sshConfig: {
        sshServerAddress: "",
        sshUsername: "",
        sshPassword: "",
        sshAuthKey: ""
      }
    };
  let n = es.Direct, o = null;
  s.proxyConfig ? (n = s.connectionMethod.value, n === es.Proxy && (o = s.proxyConfig.proxyUrl.value)) : t ? (n = t, n === es.Proxy && (o = s.proxyUrl?.value)) : s.isConnectedViaProxy && (n = es.Proxy, o = s.proxyUrl?.value);
  let r = null;
  return n === es.SSHTunnel && (r = {
    sshServerAddress: s.sshServerAddress?.value || s.sshConfig?.sshServerAddress?.value || "",
    sshUsername: s.sshUsername?.value || s.sshConfig?.sshUsername?.value || "",
    sshPassword: (a === Cs.Password || a === Cs.Password_And_SSH_Private_Key) && (s.sshPassword?.value || s.sshConfig?.sshPassword?.value) || "",
    sshAuthKey: (a === Cs.SSH_Private_Key || a === Cs.Password_And_SSH_Private_Key) && (s.sshAuthKey?.value || s.sshConfig?.sshAuthKey?.value) || ""
  }), {
    connectionMethod: n,
    proxyConfig: o ? { proxyUrl: o } : null,
    sshConfig: r
  };
}, qv = (s) => ({
  sshUsername: s?.user,
  sshPassword: s?.password,
  sshAuthKey: s?.authKey,
  sshServerAddress: s?.sshServerAddress
}), Ca = ({ dataTestId: s, value: t, text: a, infoCardText: n = "" }) => /* @__PURE__ */ e.jsx(Be, { dataTestId: s, value: t, children: /* @__PURE__ */ e.jsx(we, { content: n, alwaysShowTippyOnHover: !!n, children: /* @__PURE__ */ e.jsx("span", { className: `flex left fs-13 cn-9 ${n ? "dc__underline-dotted" : ""} m-0`, children: a }) }) }), A_ = ({
  remoteConnectionType: s,
  handleConnectionTypeChange: t
}) => /* @__PURE__ */ e.jsxs(
  zs,
  {
    className: "radio-group-no-border",
    value: s,
    name: "cluster-connection-type",
    onChange: t,
    children: [
      /* @__PURE__ */ e.jsx(
        Ca,
        {
          dataTestId: "direct",
          value: es.Direct,
          text: _o[es.Direct],
          infoCardText: "Use this to directly connect to Remote API Server."
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ca,
        {
          dataTestId: "proxy",
          value: es.Proxy,
          text: _o[es.Proxy],
          infoCardText: "Use this to connect to remote server sitting behind a Proxy. Connections to this server will be routed via the configured Proxy URL."
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ca,
        {
          dataTestId: "ssh-tunnel",
          value: es.SSHTunnel,
          text: _o[es.SSHTunnel],
          infoCardText: "Use SSH Tunnel to connect with remote locations over an encrypted SSH connection."
        }
      )
    ]
  }
), y_ = ({
  authenticationType: s,
  handleAuthenticationTypeChange: t
}) => /* @__PURE__ */ e.jsxs(
  zs,
  {
    className: "radio-group-no-border",
    value: s,
    name: "authentication-type",
    onChange: t,
    children: [
      /* @__PURE__ */ e.jsx(
        Ca,
        {
          dataTestId: "authenticate_via_password",
          value: Cs.Password,
          text: Eo.Password
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ca,
        {
          dataTestId: "authenticate_via_ssh_private_key",
          value: Cs.SSH_Private_Key,
          text: Eo.SSHAuthKey
        }
      ),
      /* @__PURE__ */ e.jsx(
        Ca,
        {
          dataTestId: "authentication_via_password_and_ssh_private_key",
          value: Cs.Password_And_SSH_Private_Key,
          text: Eo.PasswordAndSSHAuthKey
        }
      )
    ]
  }
), j_ = ({ handleOnChange: s, proxyConfig: t }) => /* @__PURE__ */ e.jsx("div", { className: "form__row mt-12", children: /* @__PURE__ */ e.jsx(
  ke,
  {
    required: !0,
    label: "Proxy URL with port number for Registry",
    name: "proxyUrl",
    value: t.proxyUrl.value,
    onChange: s,
    error: t.proxyUrl.error,
    placeholder: "eg. http://proxy.example.org:3128"
  }
) }), O_ = ({ handleOnChange: s, sshConfig: t }) => /* @__PURE__ */ e.jsxs("div", { children: [
  /* @__PURE__ */ e.jsx("div", { className: "form__row mt-12", children: /* @__PURE__ */ e.jsx(
    ke,
    {
      label: "SSH Server URL",
      name: "sshServerAddress",
      value: t.sshServerAddress.value,
      onChange: s,
      error: t.sshServerAddress.error,
      placeholder: "eg. http://proxy.example.org",
      helperText: "Devtron will connect to Port 22 of the SSH Server",
      required: !0
    }
  ) }),
  /* @__PURE__ */ e.jsx("div", { className: "form__row mt-12", children: /* @__PURE__ */ e.jsx(
    ke,
    {
      label: "Username",
      name: "sshUsername",
      value: t.sshUsername.value,
      onChange: s,
      error: t.sshUsername.error,
      placeholder: "Username or User Identifier",
      required: !0
    }
  ) })
] }), I_ = ({
  handleOnChange: s,
  handleOnBlur: t,
  handleOnFocus: a,
  sshConfig: n
}) => /* @__PURE__ */ e.jsx("div", { className: "flex column left top mt-12", children: /* @__PURE__ */ e.jsx(
  At,
  {
    name: "sshPassword",
    value: n.sshPassword.value,
    onChange: s,
    onBlur: t,
    onFocus: a,
    placeholder: "Enter Password",
    required: !0,
    label: "Password",
    error: n.sshPassword.error,
    shouldTrim: !1,
    fullWidth: !0
  }
) }), w_ = ({
  handleOnChange: s,
  handleOnBlur: t,
  handleOnFocus: a,
  sshConfig: n
}) => /* @__PURE__ */ e.jsx("div", { className: "flex column left top mt-12", children: /* @__PURE__ */ e.jsx(
  At,
  {
    name: "sshAuthKey",
    value: n.sshAuthKey.value,
    onChange: s,
    onBlur: t,
    onFocus: a,
    placeholder: "Enter SSH Private Key",
    label: "SSH Private Key",
    required: !0,
    error: n.sshAuthKey.error,
    shouldTrim: !1,
    fullWidth: !0
  }
) }), Xv = ({
  resourceType: s,
  connectionMethod: t,
  proxyConfig: a,
  sshConfig: n,
  changeRemoteConnectionType: o,
  changeSSHAuthenticationType: r,
  handleOnChange: l
}) => {
  let i;
  t.value === es.Proxy ? i = es.Proxy : t.value === es.SSHTunnel ? i = es.SSHTunnel : i = es.Direct;
  let u;
  n?.sshPassword?.value && n?.sshAuthKey?.value ? u = Cs.Password_And_SSH_Private_Key : n?.sshAuthKey?.value ? u = Cs.SSH_Private_Key : u = Cs.Password;
  const [c, p] = E(i), [d, m] = E(u), _ = (h) => {
    const b = h.target.value;
    p(b), o(b);
  }, g = (h) => {
    const b = h.target.value;
    m(b), r(b);
  }, x = (h) => {
    h.target.value === qr && (h.target.value = "");
  }, C = (h) => {
    !h.target.value && (n.sshPassword.value || n.sshAuthKey.value) && (h.target.value = qr);
  }, f = (h) => /* @__PURE__ */ e.jsx("div", { className: "form__row mt-12", children: /* @__PURE__ */ e.jsx(Us, { description: h }) });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      A_,
      {
        remoteConnectionType: c,
        handleConnectionTypeChange: _
      }
    ),
    c === es.Proxy && /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx(j_, { handleOnChange: l, proxyConfig: a }),
      s === "cluster" && f(
        "For clusters connected via Proxy, deployments should NOT be done via GitOps(ArgoCD)"
      )
    ] }),
    c === es.SSHTunnel && /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx(O_, { handleOnChange: l, sshConfig: n }),
      /* @__PURE__ */ e.jsxs("div", { className: "form__row mt-12", children: [
        /* @__PURE__ */ e.jsx("span", { className: "form__input-header mr-20", children: "Authenticate using" }),
        /* @__PURE__ */ e.jsx(
          y_,
          {
            authenticationType: d,
            handleAuthenticationTypeChange: g
          }
        ),
        d === Cs.Password || d === Cs.Password_And_SSH_Private_Key ? /* @__PURE__ */ e.jsx(
          I_,
          {
            sshConfig: n,
            handleOnChange: l,
            handleOnBlur: C,
            handleOnFocus: x
          }
        ) : null,
        d === Cs.SSH_Private_Key || d === Cs.Password_And_SSH_Private_Key ? /* @__PURE__ */ e.jsx(
          w_,
          {
            sshConfig: n,
            handleOnChange: l,
            handleOnBlur: C,
            handleOnFocus: x
          }
        ) : null
      ] }),
      s === "cluster" && f(
        "For clusters connected via SSH Tunnel, deployments should NOT be done via GitOps(ArgoCD)"
      )
    ] })
  ] });
};
var Xs = /* @__PURE__ */ ((s) => (s.LABEL_SELECTOR = "labelSelector", s.FIELD_SELECTOR = "fieldSelector", s.FILTER = "filter", s))(Xs || {});
const Bo = eo(null), ao = () => so(Bo), Qi = ({
  nonRepeatableChild: s,
  repeatableChildrenWrapperClassName: t,
  repeatableChild: a,
  startingCount: n = 1
}) => {
  const [o, r] = E([...Array(n || 1).keys()].reverse()), l = (d) => () => String(d), i = (d) => () => r((m) => m.filter((_) => _ !== d)), u = () => {
    const d = (o[0] || 0) + 1;
    return r([d, ...o]), d;
  }, c = de(() => ({ addComponent: u, count: o.length }), [o]), p = Wt(
    (d) => ({
      getComponentKey: l(d),
      deleteComponent: i(d)
    }),
    []
  );
  return /* @__PURE__ */ e.jsxs(Bo.Provider, { value: c, children: [
    s,
    o.length ? /* @__PURE__ */ e.jsx("div", { className: t, children: o.map((d) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(Bo.Provider, { value: p(d), children: a }) }, d)) }) : null
  ] });
}, Zi = (s) => ({
  ...s.has(Xs.LABEL_SELECTOR) ? {
    [Xs.LABEL_SELECTOR]: JSON.parse(
      s.get(Xs.LABEL_SELECTOR) || "[]"
    )
  } : {},
  ...s.has(Xs.FIELD_SELECTOR) ? {
    [Xs.FIELD_SELECTOR]: JSON.parse(
      s.get(Xs.FIELD_SELECTOR) || "[]"
    )
  } : {},
  ...s.has(Xs.FILTER) ? { [Xs.FILTER]: s.get(Xs.FILTER) } : {}
}), P_ = (s) => {
  if (!s)
    return null;
  const a = s.includes("==") ? "==" : "!=", n = s.split(a);
  return {
    key: n[0],
    value: n[1],
    operator: a
  };
}, gl = (s) => Object.values(s.current).filter((t) => !!t), ec = (s) => /* @__PURE__ */ e.jsxs("button", { type: "button", className: "flex dc__gap-4 dc__unset-button-styles fcb-5", onClick: s, children: [
  /* @__PURE__ */ e.jsx(da, { className: "icon-dim-16" }),
  /* @__PURE__ */ e.jsx("span", { className: "lh-20 fw-6 fs-13 cb-5", children: "Add" })
] }), R_ = ({ addToSelectorRef: s, getRefData: t, deleteRefData: a }) => {
  const { getComponentKey: n, deleteComponent: o } = ao(), [r, l] = E(t(n()));
  ue(() => {
    s(n(), r);
  }, [r]);
  const i = (c) => {
    l(c.target.value);
  }, u = () => {
    a(n()), o();
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-100", children: [
    /* @__PURE__ */ e.jsx(
      ke,
      {
        name: "QuerySelector",
        value: r,
        borderRadiusConfig: {
          right: !1
        },
        fullWidth: !0,
        onChange: i,
        placeholder: "Enter query",
        autoFocus: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__unset-button-styles",
        onClick: u,
        "aria-label": "Delete Selector Field",
        children: /* @__PURE__ */ e.jsx("div", { className: "dc__border-top dc__border-right dc__border-bottom w-100 h-100 dc__right-radius-4 p-8 flex", children: /* @__PURE__ */ e.jsx(ja, { className: "icon-dim-16" }) })
      }
    )
  ] });
}, L_ = () => {
  const { addComponent: s } = ao();
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
    /* @__PURE__ */ e.jsx("span", { className: "lh-20 fw-6 fs-13", children: "Filter by Labels" }),
    ec(s)
  ] });
}, k_ = ({ updateRef: s, getRefData: t, getRefDataCount: a, deleteRefData: n }) => /* @__PURE__ */ e.jsx(
  Qi,
  {
    nonRepeatableChild: /* @__PURE__ */ e.jsx(L_, {}),
    repeatableChildrenWrapperClassName: "flexbox-col dc__gap-8",
    repeatableChild: /* @__PURE__ */ e.jsx(R_, { addToSelectorRef: s, getRefData: t, deleteRefData: n }),
    startingCount: a()
  }
), D_ = (s, t) => {
  const a = t.context === "menu";
  return /* @__PURE__ */ e.jsxs("div", { className: `flexbox dc__content-space ${a ? "w-200" : ""}`, children: [
    s.label,
    a && /* @__PURE__ */ e.jsx("span", { className: "mono", children: s.value })
  ] });
}, M_ = ({ addToSelectorRef: s, getRefData: t, deleteRefData: a }) => {
  const { getComponentKey: n, deleteComponent: o } = ao(), r = P_(t(n())), [l, i] = E(r?.key || ""), [u, c] = E(r?.value || ""), p = de(
    () => [
      { label: "==", value: "Equal to" },
      { label: "!=", value: "Not equal to" }
    ],
    []
  ), [d, m] = E(
    p.find((f) => f.label === (r?.operator || "=="))
  );
  ue(() => {
    if (!l || !u) {
      a(n());
      return;
    }
    s(n(), `${l}${d.label}${u}`);
  }, [l, u, d]);
  const _ = (f) => {
    i(f.target.value);
  }, g = (f) => {
    c(f.target.value);
  }, x = (f) => {
    f !== d && m(f);
  }, C = () => {
    a(n()), o();
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-100", children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-200 dc__no-shrink", children: /* @__PURE__ */ e.jsx(
      ke,
      {
        name: "key",
        value: l,
        borderRadiusConfig: {
          right: !1
        },
        fullWidth: !0,
        onChange: _,
        placeholder: "Enter key"
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Ro,
      {
        options: p,
        components: { IndicatorSeparator: null },
        onChange: x,
        formatOptionLabel: D_,
        className: "dc__no-border dc__no-border-radius dc__no-shrink",
        value: d,
        styles: {
          ...fo,
          menu: (f, h) => ({
            ...fo.menu(f, h),
            width: "max-content",
            minWidth: "100%"
          }),
          control: (f, h) => ({
            ...fo.control(f, h),
            borderBlock: "1px solid var(--border-primary)",
            borderRadius: 0,
            borderLeft: 0,
            borderRight: 0,
            minHeight: "36px",
            height: "36px"
          }),
          singleValue: (f) => ({
            ...f,
            color: "var(--N900)"
          }),
          input: (f) => ({
            ...f,
            color: "var(--N900)"
          })
        }
      }
    ),
    /* @__PURE__ */ e.jsx(
      ke,
      {
        name: "value",
        value: u,
        fullWidth: !0,
        borderRadiusConfig: {
          left: !1,
          right: !1
        },
        onChange: g,
        placeholder: "Enter value"
      }
    ),
    /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__unset-button-styles",
        onClick: C,
        "aria-label": "Delete Selector Field",
        children: /* @__PURE__ */ e.jsx("div", { className: "dc__border-top dc__border-right dc__border-bottom w-100 h-100 dc__right-radius-4 p-8 flex", children: /* @__PURE__ */ e.jsx(ja, { className: "icon-dim-16" }) })
      }
    )
  ] });
}, B_ = () => {
  const { addComponent: s } = ao();
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
    /* @__PURE__ */ e.jsx("span", { className: "lh-20 fw-6 fs-13", children: "Filter by Field Selectors" }),
    ec(s)
  ] });
}, U_ = ({ updateRef: s, getRefData: t, getRefDataCount: a, deleteRefData: n }) => /* @__PURE__ */ e.jsx(
  Qi,
  {
    nonRepeatableChild: /* @__PURE__ */ e.jsx(B_, {}),
    repeatableChildrenWrapperClassName: "flexbox-col dc__gap-8",
    repeatableChild: /* @__PURE__ */ e.jsx(M_, { addToSelectorRef: s, getRefData: t, deleteRefData: n }),
    startingCount: a()
  }
), F_ = ({ updateRef: s, getRefData: t }) => {
  const [a, n] = E(t), o = (r) => n(r.target.value);
  return ci(() => s(a), [a]), /* @__PURE__ */ e.jsx(
    At,
    {
      label: "Query with CEL Expression",
      value: a,
      onChange: o,
      placeholder: "Write CEL Expression",
      name: "cel-expression"
    }
  );
}, V_ = ({ clusterName: s, handleClose: t }) => {
  const { setDisableShortcuts: a } = dp(), { replace: n } = ae(), o = he(), r = Zi(new URLSearchParams(o.search)), l = Ms({ ...r.fieldSelector }), i = Ms({ ...r.labelSelector }), u = Ms(r.filter || "");
  ue(() => (a(!0), () => {
    a(!1);
  }), []);
  const c = (f) => (h, b) => {
    f.current[h] = b;
  }, p = (f) => (h) => f.current[h], d = (f) => () => Object.keys(f.current).length, m = (f) => (h) => (
    // eslint-disable-next-line no-param-reassign
    delete f.current[h]
  ), _ = (f) => {
    u.current = f;
  }, g = () => u.current, x = () => {
    const f = gl(l), h = gl(i), b = u.current, S = {
      ...f.length ? { fieldSelector: JSON.stringify(f) } : { fieldSelector: null },
      ...h.length ? { labelSelector: JSON.stringify(h) } : { labelSelector: null },
      ...b ? { filter: b } : { filter: null }
    }, O = new URLSearchParams(o.search);
    Object.entries(S).forEach(([v, A]) => {
      if (A === null) {
        O.delete(v);
        return;
      }
      O.set(v, A);
    });
    const j = new URLSearchParams(O).toString();
    n({ search: j }), t();
  }, C = () => {
    const f = new URLSearchParams(o.search);
    Object.values(Xs).forEach((h) => {
      f.delete(h);
    }), n({ search: f.toString() }), t();
  };
  return /* @__PURE__ */ e.jsx(Vs, { width: "800px", position: "right", onEscape: t, children: /* @__PURE__ */ e.jsxs("main", { className: "flexbox-col bg__primary h-100 dc__content-space", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsxs("section", { className: "flexbox w-100 dc__border-bottom-n1 pt-12 pb-12 pl-20 pr-20 dc__content-space dc__align-items-center", children: [
        /* @__PURE__ */ e.jsxs("span", { className: "form__section", children: [
          "Filter resources in '",
          s,
          "'"
        ] }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "button",
            onClick: t,
            className: "dc__transparent dc__no-shrink flexbox",
            "aria-label": "Close Modal",
            children: /* @__PURE__ */ e.jsx(ja, { className: "icon-fill-n6" })
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("section", { className: "p-20 flexbox-col dc__gap-16 flex-grow-1 dc__overflow-auto", children: [
        /* @__PURE__ */ e.jsx(
          k_,
          {
            updateRef: c(i),
            getRefData: p(i),
            getRefDataCount: d(i),
            deleteRefData: m(i)
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100 h-1" }),
        /* @__PURE__ */ e.jsx(
          U_,
          {
            updateRef: c(l),
            getRefData: p(l),
            getRefDataCount: d(l),
            deleteRefData: m(l)
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__border-bottom-n1 w-100 h-1" }),
        /* @__PURE__ */ e.jsx(F_, { updateRef: _, getRefData: g })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("section", { className: "dc__border-top-n1 pt-12 pb-12 pl-20 pr-20 flexbox dc__content-space dc__items-align-center dc__no-shrink", children: [
      /* @__PURE__ */ e.jsxs("button", { type: "button", className: "cta-with-img secondary", onClick: C, children: [
        /* @__PURE__ */ e.jsx(rm, { className: "icon-dim-16 mr-8" }),
        "Clear all filters"
      ] }),
      /* @__PURE__ */ e.jsx("button", { type: "submit", className: "cta primary", onClick: x, children: "Apply" })
    ] })
  ] }) });
}, Jv = ({ clusterName: s, showModal: t, handleShowFilterModal: a, handleCloseFilterModal: n }) => {
  const o = he(), r = Zi(new URLSearchParams(o.search));
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("button", { type: "button", className: "dc__unset-button-styles", onClick: a, children: /* @__PURE__ */ e.jsxs("div", { className: "flex bg__secondary dc__gap-6 en-2 bw-1 br-4 h-32 pl-8 pr-8 pt-6 pb-6", children: [
      Object.keys(r).length ? /* @__PURE__ */ e.jsx(nm, { className: "icon-dim-16" }) : /* @__PURE__ */ e.jsx(om, { className: "icon-dim-16" }),
      "Filter",
      /* @__PURE__ */ e.jsx("div", { className: "flex fs-12 lh-20 icon-dim-20 bg__primary cn-7 fw-6 dc__border br-2", children: "f" })
    ] }) }),
    t && /* @__PURE__ */ e.jsx(V_, { clusterName: s, handleClose: n })
  ] });
};
function G_() {
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-12 dc__align-self-stretch dc__align-start", children: [
    /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20", children: Ur.DESCRIPTION }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20", children: "It can be scoped for" }),
    /* @__PURE__ */ e.jsx("ul", { className: "m-0 cn-9 fs-13 fw-4 lh-20 pl-20", children: Ur.SCOPES.map((s) => /* @__PURE__ */ e.jsx("li", { children: s }, s)) })
  ] });
}
const Qv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G_
}, Symbol.toStringTag, { value: "Module" })), W_ = {
  DEVTRON_MANAGED: "devtron-system-managed",
  GROUP_CLAIMS: "group-claims"
}, $_ = "authorisation/global-config", K_ = async () => {
  try {
    const { result: s } = await xe($_);
    return (s ?? []).reduce((t, { configType: a, active: n }) => (t[a] = n, t), {});
  } catch (s) {
    throw ve(s), s;
  }
}, H_ = ({
  children: s,
  setIsAutoAssignFlowEnabled: t
}) => {
  const [a, n, o, r] = wn(K_);
  return ue(() => {
    n && t(n[W_.GROUP_CLAIMS]);
  }, [n]), a ? /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) : o || !n ? o && (o.code === 403 || o.code === 401) ? /* @__PURE__ */ e.jsx(
    rn,
    {
      subtitle: up.REQUIRED_MANAGER_ACCESS,
      title: pp.TITLE
    }
  ) : /* @__PURE__ */ e.jsx(ya, { reload: r }) : s;
}, Zv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H_
}, Symbol.toStringTag, { value: "Module" })), Y_ = ({
  documentationText: s,
  documentationLink: t,
  devtronDocLink: a
}) => /* @__PURE__ */ e.jsxs("div", { className: "pl-12 pb-12", children: [
  t && s && /* @__PURE__ */ e.jsxs(
    "a",
    {
      href: t,
      target: "_blank",
      rel: "noreferrer noreferrer",
      className: "anchor flexbox flex-align-center fs-13 dc__gap-4 mb-8",
      children: [
        s,
        /* @__PURE__ */ e.jsx(Zn, { className: "icon-dim-14 scb-5" })
      ]
    }
  ),
  /* @__PURE__ */ e.jsx(
    ln,
    {
      docLinkKey: a,
      text: "View documentation",
      dataTestId: "learn-more-about-view-documentation-link",
      showExternalIcon: !0,
      openInNewTab: !0
    }
  )
] });
function sc({
  heading: s,
  infoText: t,
  documentationText: a,
  documentationLink: n,
  devtronDocLink: o
}) {
  return /* @__PURE__ */ e.jsx(
    ea,
    {
      theme: sa.white,
      className: "w-300 h-100 dc__align-left",
      placement: "right",
      Icon: ur,
      iconClass: "fcv-5",
      infoText: t,
      additionalContent: /* @__PURE__ */ e.jsx(
        Y_,
        {
          documentationText: a,
          documentationLink: n,
          devtronDocLink: o
        }
      ),
      heading: s,
      showCloseButton: !0,
      trigger: "click",
      interactive: !0,
      children: /* @__PURE__ */ e.jsx("div", { className: "anchor cursor dc__inline-block", children: "Learn more" })
    }
  );
}
const Uo = {
  microsoft: {
    permissionGroupName: "Azure Active Directory",
    tippyConfig: {
      heading: "Groups on Azure Active Directory",
      infoText: "Upon user login, Devtron will check for Azure Active Directory Groups associated with the user and assign them to Permission Groups with the same name in Devtron."
    },
    documentationLink: "https://learn.microsoft.com/en-us/entra/fundamentals/groups-view-azure-portal/",
    devtronDocLink: "GLOBAL_CONFIG_SSO_LOGIN_MICROSOFT"
  },
  ldap: {
    permissionGroupName: "LDAP User Groups",
    tippyConfig: {
      heading: "LDAP User Groups",
      infoText: "Upon user login, Devtron will check for LDAP User Groups associated with the user and assign them to Permission Groups with the same name in Devtron."
    },
    documentationLink: "https://www.ldap.com/",
    devtronDocLink: "GLOBAL_CONFIG_SSO_LOGIN_LDAP"
  },
  oidc: {
    permissionGroupName: "OpenID Connect",
    tippyConfig: {
      heading: "OpenID Connect",
      infoText: "Upon user login, Devtron will check for OpenID Connect Groups associated with the user and assign them to Permission Groups with the same name in Devtron."
    },
    documentationLink: "https://openid.net/connect/",
    devtronDocLink: "GLOBAL_CONFIG_SSO_LOGIN_OIDC"
  }
};
function z_({ isSelected: s, onChange: t, ssoType: a }) {
  const n = Uo[a];
  if (!n)
    return null;
  const { permissionGroupName: o, tippyConfig: r, documentationLink: l, devtronDocLink: i } = n, u = () => {
    t(!s);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space p-12 br-4 dc__border dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8 flex-grow-1", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-2 fs-13 lh-20", children: [
        /* @__PURE__ */ e.jsx("p", { className: "mb-0 fw-6 cn-9", children: "Auto-assign permission to users on SSO login" }),
        /* @__PURE__ */ e.jsxs("p", { className: "mb-0 fw-4 cn-7", children: [
          'When enabled, users will be auto-assigned a Permission Group mapped with Groups on "',
          o,
          '". ',
          /* @__PURE__ */ e.jsx(
            sc,
            {
              ...r,
              documentationLink: l,
              documentationText: o,
              devtronDocLink: i
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(Qo, { expand: s, children: /* @__PURE__ */ e.jsx(
        Us,
        {
          description: /* @__PURE__ */ e.jsxs("div", { className: "flexbox", children: [
            /* @__PURE__ */ e.jsx("span", { children: "Please ensure " }),
            /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: "permission-groups-link",
                component: me.link,
                linkProps: {
                  to: R.PERMISSION_GROUPS,
                  target: "_blank",
                  rel: "noreferrer noopener"
                },
                text: "Permission Groups",
                endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-square-out", color: null }),
                size: P.xxs,
                variant: U.text
              }
            ),
            /* @__PURE__ */ e.jsxs("span", { children: [
              ' are created on Devtron with same names as Groups on "',
              o,
              '".'
            ] })
          ] })
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(
      ft,
      {
        name: "sso-permissions-auto-assign",
        ariaLabel: "Auto assign permission toggle",
        isChecked: s,
        onChange: u
      }
    )
  ] });
}
const eT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z_
}, Symbol.toStringTag, { value: "Module" })), tc = () => /* @__PURE__ */ e.jsx(
  sc,
  {
    heading: "Auto-assign permissions",
    infoText: "Upon user login, Devtron will check for Groups on SSO service provider associated with the user and assign them to Permission Groups with the same name in Devtron."
  }
), sT = () => /* @__PURE__ */ e.jsx(
  Us,
  {
    description: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      "Users are auto-assigned a permission group upon SSO login. Ensure matching Permission Groups are created on Devtron and SSO service provider. ",
      /* @__PURE__ */ e.jsx(tc, {})
    ] })
  }
), q_ = () => /* @__PURE__ */ e.jsx(
  Us,
  {
    description: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      "User permissions are being managed via SSO service provider. Direct permissions cannot be assigned to users. ",
      /* @__PURE__ */ e.jsx(tc, {})
    ] })
  }
), X_ = ({ roleGroups: s }) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  /* @__PURE__ */ e.jsx(q_, {}),
  s?.length ? /* @__PURE__ */ e.jsx(mp, { roleGroups: s, showStatus: !1, handleDelete: null }) : /* @__PURE__ */ e.jsx(
    Xe,
    {
      image: Um,
      title: "No permissions found",
      subTitle: "User permissions are being managed via SSO service provider. Direct permissions cannot be assigned to users.",
      classname: "flex-grow-1"
    }
  )
] }), tT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: X_
}, Symbol.toStringTag, { value: "Module" })), J_ = ({
  handleCancel: s,
  handleSave: t,
  isLoading: a,
  ssoType: n
}) => Uo[n] ? /* @__PURE__ */ e.jsx(
  vt,
  {
    variant: mt.warning,
    title: "Existing user permissions (if any) will be removed",
    subtitle: `After saving, user permissions will be managed via Permission Groups mapped with Groups on ${Uo[n].permissionGroupName}.`,
    buttonConfig: {
      secondaryButtonConfig: {
        text: "Cancel",
        onClick: s,
        disabled: a
      },
      primaryButtonConfig: {
        text: "Save changes",
        onClick: t,
        isLoading: a
      }
    },
    handleClose: s,
    children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-21 cn-7 fw-4", children: "Are you sure you want to save the changes?" })
  }
) : null, aT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J_
}, Symbol.toStringTag, { value: "Module" })), Q_ = ({
  labelTags: s,
  showOnlyIcon: t,
  handleAddTag: a,
  selectedProjectId: n,
  reloadProjectTags: o
}) => {
  const [r, l] = E(!1), [i, u] = E([]), c = async () => {
    try {
      const { result: m } = await Ou(n);
      u(m);
    } catch (m) {
      ve(m);
    }
  };
  ue(() => {
    n && c();
  }, [n, o]), ue(() => {
    if (s && i) {
      const m = Array.isArray(s) ? s.reduce(
        (x, C) => (x[C.key] = C, x),
        {}
      ) : {}, _ = (x, C) => x?.blockCustomValue ? x.choices.includes(C) : !0, g = i.some((x) => !!(x.isMandatory && (!m[x.key] || !m[x.key].value || !_(x.valueConstraint, m[x.key]?.value))));
      l(g);
    }
  }, [i, s]);
  const p = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-13 fw-4 flexbox-col", children: [
    /* @__PURE__ */ e.jsx("span", { className: "lh-20 cn-9", children: "Some mandatory tags are not configured for this application." }),
    /* @__PURE__ */ e.jsx(
      B,
      {
        text: "Add tags",
        onClick: a,
        dataTestId: "mandatory-add-tag-warning-button",
        variant: U.text
      }
    )
  ] });
  return r ? t ? /* @__PURE__ */ e.jsx(Ja, { className: "warning-icon-y7-imp icon-dim-16 ml-5" }) : /* @__PURE__ */ e.jsx("div", { className: "mt-12", children: /* @__PURE__ */ e.jsx(
    Us,
    {
      description: p(),
      variant: "warning",
      borderConfig: { top: !1, left: !1, right: !1 },
      borderRadiusConfig: { top: !1, left: !1, right: !1, bottom: !1 }
    }
  ) }) : null;
}, nT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Q_
}, Symbol.toStringTag, { value: "Module" })), Z_ = () => {
  const s = () => /* @__PURE__ */ e.jsxs("div", { className: "p-12 fs-13 fw-4 flexbox-col", children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      "If mandatory tags are not configured, you can either allow or block deployment stages for",
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: " production and non-production " }),
      "environments."
    ] }),
    /* @__PURE__ */ e.jsx("br", {}),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "If deployments are blocked: " }),
      "All deployment stages—",
      /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "pre-deploy, deploy, and post-deploy" }),
      " will be restricted."
    ] })
  ] });
  return /* @__PURE__ */ e.jsx(Tt, { heading: "Allow/block deployments", additionalContent: s() });
}, Fa = (s, t = 16) => s === Ye.ALLOW ? /* @__PURE__ */ e.jsx(Oi, { className: `icon-dim-${t}` }) : /* @__PURE__ */ e.jsx(Li, { className: `icon-dim-${t}` }), Va = (s) => {
  switch (s) {
    case Ye.ALLOW:
      return "Allow deployments";
    case Ye.BLOCK_PROD:
      return "Prod environments";
    case Ye.BLOCK_NON_PROD:
      return "Non-prod environments";
    case Ye.BLOCK:
      return "All environments";
    default:
      return "Allow deployments";
  }
}, ef = (s, t) => [
  {
    label: "TAG KEY",
    key: "tagKey",
    width: "240px"
  },
  {
    label: "VALUE CHOICES",
    key: "choices",
    width: "122px"
  },
  {
    label: "DESCRIPTION",
    key: "description",
    width: "1fr"
  },
  {
    label: "ALLOW/BLOCK DEPLOYMENTS",
    key: "deploymentPolicy",
    width: `${t ? "233px" : "220px"}`,
    isHidden: !s,
    renderAdditionalContent: () => /* @__PURE__ */ e.jsx(Z_, {})
  }
], sf = (s) => s.filter((t) => t.data.tagKey.value).map((t) => di(t.data.tagKey.value)), xl = (s) => s.filter((t) => !!t.choice).length, tf = (s, t) => s.find(
  (a) => a.value === t || a.options?.some((n) => n.value === t)
), af = (s) => {
  if (!s)
    return ba[0].value;
  const t = tf(ba, s);
  return t?.value === s ? t.value : t?.options?.find((a) => a.value === s)?.value || ba[0].value;
}, ba = [
  {
    label: Va(Ye.ALLOW),
    value: Ye.ALLOW,
    startIcon: Fa(Ye.ALLOW)
  },
  {
    label: "Block all deployment stages",
    options: [
      {
        label: Va(Ye.BLOCK_PROD),
        value: Ye.BLOCK_PROD,
        startIcon: Fa(Ye.BLOCK_PROD)
      },
      {
        label: Va(Ye.BLOCK_NON_PROD),
        value: Ye.BLOCK_NON_PROD,
        startIcon: Fa(Ye.BLOCK_NON_PROD)
      },
      {
        label: Va(Ye.BLOCK),
        value: Ye.BLOCK,
        startIcon: Fa(Ye.BLOCK)
      }
    ]
  }
], ac = () => Math.floor(Math.random() * 9e15) + 1e15, nf = {
  key: "",
  value: "",
  propagate: !1,
  isInvalidKey: !1,
  isInvalidValue: !1,
  id: 0,
  description: "",
  valueConstraint: { choices: [], blockCustomValue: !1 },
  deploymentPolicy: Ye.ALLOW
};
var Ds = /* @__PURE__ */ ((s) => (s.GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED = "GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED", s.GLOBAL_TAG_POLICY_KNOW_MORE_BUTTON_CLICKED = "GLOBAL_TAG_POLICY_KNOW_MORE_BUTTON_CLICKED", s.GLOBAL_TAG_POLICY_ENFORCEMENT_SELECT_CLICKED = "GLOBAL_TAG_POLICY_ENFORCEMENT_SELECT_CLICKED", s.GLOBAL_TAG_PROPAGATE_BUTTON_CLICKED = "GLOBAL_TAG_PROPAGATE_BUTTON_CLICKED", s.GLOBAL_TAG_KEY_SETTING_CLICKED = "GLOBAL_TAG_KEY_SETTING_CLICKED", s.GLOBAL_TAG_SAVE_BUTTON_CLICKED = "GLOBAL_TAG_SAVE_BUTTON_CLICKED", s.GLOBAL_TAG_ADD_ROW_CLICKED = "GLOBAL_TAG_ADD_ROW_CLICKED", s))(Ds || {});
const nc = ({
  isEditView: s,
  isMultiDelete: t,
  tagIDList: a,
  tagName: n,
  reload: o,
  closeModal: r
}) => {
  const l = ae(), i = Ts(), u = async () => {
    await Iu(a), s && l.push(i.path.split("edit")[0]), typeof o == "function" && o();
  }, c = () => a.length > 1 ? "tags" : "tag", p = () => {
    let m = "";
    return t ? m += `${a.length} ${c()}?` : m += `${n}`, m;
  }, d = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("p", { className: "fs-14 cn-7 lh-20", children: [
      "Are you sure you want to delete",
      t ? ` the selected ${c()}` : " this tag",
      " ?"
    ] }),
    /* @__PURE__ */ e.jsx("p", { className: "fs-14 cn-7 lh-20", children: "NOTE: Deleting this tag will not remove the applied tag from existing applications." })
  ] });
  return /* @__PURE__ */ e.jsx(
    Xa,
    {
      title: p(),
      component: "tag",
      onDelete: u,
      closeConfirmationModal: r,
      subtitle: d()
    }
  );
};
function of({ closePopup: s }) {
  return /* @__PURE__ */ e.jsx(hp, { className: "", children: /* @__PURE__ */ e.jsxs("div", { className: "modal__body w-600 p-20 mt-40 flex column", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex left w-100 fs-16 fw-6", children: _a.injectTagInfoModal.title }),
    /* @__PURE__ */ e.jsx("img", { src: Fm, className: "w-100 mt-16 mb-12", alt: "Inject Tag Info" }),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx("p", { className: "fs-14 fw-4", children: _a.injectTagInfoModal.description.para1 }),
      /* @__PURE__ */ e.jsx("p", { className: "fs-14 fw-4", children: _a.injectTagInfoModal.description.para2 }),
      /* @__PURE__ */ e.jsx("p", { className: "fs-14 fw-4", children: _a.injectTagInfoModal.description.para3 })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flex right w-100 dc__align-right mt-24", children: /* @__PURE__ */ e.jsx("button", { className: "cta flex h-36", type: "submit", onClick: s, children: _a.injectTagInfoModal.buttonText }) })
  ] }) });
}
function rf() {
  const s = () => /* @__PURE__ */ e.jsxs("div", { className: "p-12 fs-13 fw-4", children: [
    /* @__PURE__ */ e.jsx("div", { children: Yt.description.para1 }),
    /* @__PURE__ */ e.jsx("div", { children: Yt.description.para2 }),
    /* @__PURE__ */ e.jsx("div", { children: Yt.description.para3 })
  ] });
  return /* @__PURE__ */ e.jsx(
    Tt,
    {
      heading: Yt.title,
      additionalContent: s(),
      documentationLink: "TAGS_POLICY",
      documentationLinkText: "View Documentation",
      iconClassName: "icon-dim-20 ml-4 cursor"
    }
  );
}
var Ls = /* @__PURE__ */ ((s) => (s.AND = "AND", s.OR = "OR", s))(Ls || {}), $s = /* @__PURE__ */ ((s) => (s.SUGGESTED = "suggested", s.MANDATORY = "mandatory", s))($s || {}), lt = /* @__PURE__ */ ((s) => (s.ASC = "ASC", s.DESC = "DESC", s))(lt || {}), St = /* @__PURE__ */ ((s) => (s.UPDATE_ROW = "UPDATE_ROW", s.UPDATE_CHOICES = "UPDATE_CHOICES", s.UPDATE_ALLOW_CUSTOM_INPUT = "UPDATE_ALLOW_CUSTOM_INPUT", s.UPDATE_PROPAGATE = "UPDATE_PROPAGATE", s.ADD_CHOICES_TO_VALUE_COLUMN_OPTIONS = "ADD_CHOICES_TO_VALUE_COLUMN_OPTIONS", s))(St || {});
const Cl = ({ text: s, onClickAddButton: t }) => /* @__PURE__ */ e.jsx(
  B,
  {
    text: s,
    onClick: t,
    dataTestId: "add-choice-button",
    startIcon: /* @__PURE__ */ e.jsx(da, {}),
    variant: U.borderLess,
    size: P.small
  }
), lf = ({
  tagChoices: s,
  rowId: t,
  handleRowUpdateAction: a,
  blockCustomValue: n
}) => {
  const o = () => /* @__PURE__ */ e.jsxs("div", { className: "fs-12", children: [
    /* @__PURE__ */ e.jsx("p", { className: "m-0 fw-6", children: "Allow Custom input" }),
    /* @__PURE__ */ e.jsx("p", { className: "m-0", children: "Allow entering any value other than provided choices" })
  ] }), r = () => {
    a({
      actionType: St.UPDATE_ALLOW_CUSTOM_INPUT,
      rowId: t,
      headerKey: null,
      actionValue: !n
    });
  }, l = () => /* @__PURE__ */ e.jsx("div", { className: "flex left w-100 h-100 p-12 dc__border-top dc__gap-8", children: /* @__PURE__ */ e.jsx(
    Ft,
    {
      isChecked: !n,
      rootClassName: "mb-0 flex top dc_max-width__max-content",
      value: De.CHECKED,
      onChange: r,
      "data-testid": "set-clone-directory",
      children: /* @__PURE__ */ e.jsx(
        we,
        {
          alwaysShowTippyOnHover: !0,
          className: "w-200",
          placement: "bottom-start",
          content: o(),
          children: /* @__PURE__ */ e.jsx("div", { className: "dc__border-dashed--n3-bottom fs-13 cn-9 lh-20", children: "Allow Custom input" })
        }
      )
    }
  ) }), i = () => {
    a({
      actionType: St.UPDATE_CHOICES,
      rowId: t,
      headerKey: null,
      actionValue: (m) => [{ choice: "", id: m.length, error: [] }, ...m]
    });
  }, u = () => /* @__PURE__ */ e.jsx("div", { className: "p-12", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__border-dashed fs-12 br-6 dc__gap-12 flex column w-100 dc__align-center p-16", children: [
    /* @__PURE__ */ e.jsx(Gm, {}),
    /* @__PURE__ */ e.jsxs("div", { className: "w-100", children: [
      /* @__PURE__ */ e.jsx("div", { className: "fw-6 lh-18", children: "Set value choices" }),
      /* @__PURE__ */ e.jsx("div", { className: "lh-18 dc__align-center ", children: "Allow users to select a value from a pre-defined set of choices" })
    ] }),
    /* @__PURE__ */ e.jsx(Cl, { text: "Add choices", onClickAddButton: i })
  ] }) }), c = (m) => (_) => {
    const g = _.target.value, x = _p(g, "").errorMessages;
    a({
      actionType: St.UPDATE_CHOICES,
      rowId: t,
      headerKey: null,
      actionValue: (C) => C.map(
        (f) => f.id === m ? { id: m, choice: g, error: x } : f
      )
    });
  }, p = (m) => {
    a({
      rowId: t,
      headerKey: null,
      actionType: St.UPDATE_CHOICES,
      actionValue: (_) => _.filter((g) => g.id !== m)
    });
  }, d = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6 p-12 dc__overflow-auto mxh-220", children: [
      /* @__PURE__ */ e.jsx(Cl, { text: "Add choices", onClickAddButton: i }),
      s.map((m, _) => /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4 w-100 top", children: [
        /* @__PURE__ */ e.jsx(
          ke,
          {
            placeholder: "Enter choice",
            name: `tag-choice-${_}`,
            value: m.choice,
            onChange: c(m.id),
            fullWidth: !0,
            error: m.error?.length ? m.error : null,
            autoFocus: !0
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "pt-4", children: /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "delete-tag-choice",
            ariaLabel: "Delete tag choice",
            showAriaLabelInTippy: !1,
            icon: /* @__PURE__ */ e.jsx(ja, {}),
            variant: U.borderLess,
            size: P.small,
            onClick: () => p(m.id),
            style: q.negativeGrey
          }
        ) })
      ] }, `tag-choice-${m.id}`))
    ] }),
    l()
  ] });
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col w-100", children: s.length ? d() : u() });
}, cf = ({
  title: s,
  handleRowUpdateAction: t,
  tagChoices: a,
  rowId: n,
  blockCustomValue: o
}) => {
  const [r, l] = E(!1), i = de(() => a.some((p) => p?.error?.length > 0), [a]), u = () => {
    l(!0), Qt.event({
      category: Ds.GLOBAL_TAG_KEY_SETTING_CLICKED,
      action: Ds.GLOBAL_TAG_KEY_SETTING_CLICKED
    });
  }, c = () => l(!1);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: `${r ? "dc__transparent-div cursor-not-allowed" : ""}` }),
    /* @__PURE__ */ e.jsx(
      ea,
      {
        theme: sa.white,
        className: "flexbox-col w-300 h-100 p-0",
        placement: "bottom",
        heading: s,
        showCloseButton: !0,
        additionalContent: /* @__PURE__ */ e.jsx(
          lf,
          {
            tagChoices: a,
            rowId: n,
            handleRowUpdateAction: t,
            blockCustomValue: o
          }
        ),
        interactive: !0,
        ...i ? { visible: !0 } : { trigger: "click" },
        disableClose: i,
        onClose: c,
        children: /* @__PURE__ */ e.jsx(
          "button",
          {
            className: "dc__transparent h-100 flex top p-8 dc__hover-n50 w-100 left fs-13",
            type: "button",
            "aria-label": "row-config-button",
            onClick: u,
            children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-4 ", children: [
              xl(a) ? /* @__PURE__ */ e.jsx(ki, { className: "blue-circle-position" }) : null,
              /* @__PURE__ */ e.jsx(kn, { className: "icon-dim-16 pos-relative" }),
              /* @__PURE__ */ e.jsxs("div", { className: "lh-20", children: [
                xl(a) || "Add",
                " choices"
              ] })
            ] })
          }
        )
      }
    )
  ] });
}, df = (s, t) => t?.map((a) => {
  const n = a.id || ac(), o = a?.valueConstraint?.choices?.length || 0;
  return {
    data: {
      deploymentPolicy: {
        value: af(a.deploymentPolicy),
        type: ws.DROPDOWN,
        props: {
          options: ba,
          hideSelectedOptions: !s
        }
      },
      tagKey: {
        value: a.key || null,
        type: ws.TEXT,
        props: {
          placeholder: "Eg. owner-name"
        }
      },
      description: {
        value: a.description || "",
        type: ws.TEXT,
        props: {
          placeholder: "Enter description"
        }
      },
      choices: {
        value: null,
        type: ws.BUTTON,
        props: {
          text: o ? `${o} choices` : "Add Choices",
          icon: o ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(ki, { className: "blue-circle-position" }),
            /* @__PURE__ */ e.jsx(kn, { className: "icon-dim-16 pos-relative" })
          ] }) : /* @__PURE__ */ e.jsx(kn, { className: "icon-dim-16" })
        }
      }
    },
    id: n,
    customState: {
      tagChoices: (a?.valueConstraint?.choices || []).map((r, l) => ({
        id: l,
        choice: r
      })),
      propagate: a?.propagate || !1,
      blockCustomValue: a?.valueConstraint?.blockCustomValue || !1
    }
  };
}), bl = (s) => {
  const t = ac();
  return {
    data: {
      deploymentPolicy: {
        value: ba[0].value,
        type: ws.DROPDOWN,
        props: {
          options: ba,
          hideSelectedOptions: !s
        }
      },
      tagKey: {
        value: null,
        type: ws.TEXT,
        props: {
          placeholder: "Eg. owner-name"
        }
      },
      description: {
        value: "",
        type: ws.TEXT,
        props: {
          placeholder: "Enter description"
        }
      },
      choices: {
        value: "",
        type: ws.BUTTON,
        props: {
          text: "Add Choices",
          icon: /* @__PURE__ */ e.jsx(kn, { className: "icon-dim-16 pos-relative" })
        }
      }
    },
    id: t,
    customState: {
      tagChoices: [],
      propagate: !1,
      blockCustomValue: !1
    }
  };
}, uf = ({
  labelTags: s,
  setLabelTags: t,
  isMandatoryTags: a,
  isEditView: n,
  rows: o,
  setRows: r
}) => {
  const [l, i] = E({}), u = ({ actionType: x, actionValue: C, rowId: f, headerKey: h }) => {
    let b = [...o];
    switch (x) {
      case St.UPDATE_CHOICES:
        b = b.map(
          (S) => S.id === f ? {
            ...S,
            customState: {
              ...S.customState,
              tagChoices: C(S.customState.tagChoices)
            }
          } : S
        );
        break;
      case St.UPDATE_ALLOW_CUSTOM_INPUT:
        b = b.map(
          (S) => S.id === f ? { ...S, customState: { ...S.customState, blockCustomValue: C } } : S
        );
        break;
      case St.UPDATE_ROW:
        b = o.map(
          (S) => S.id === f ? {
            ...S,
            data: {
              ...S.data,
              [h]: {
                ...S.data[h],
                value: C
              }
            }
          } : S
        );
        break;
    }
    r(b);
  };
  ue(() => {
    const x = df(a, s);
    i({}), r(x);
  }, []), ue(() => {
    if (o.length) {
      const x = o.map((C) => ({
        key: C.data.tagKey.value,
        description: C.data.description.value,
        propagate: C.customState.propagate,
        valueConstraint: {
          choices: C.customState.tagChoices.map((f) => f.choice).filter((f) => f !== null && f !== ""),
          blockCustomValue: C.customState.blockCustomValue
        },
        deploymentPolicy: C.data.deploymentPolicy.value,
        id: s[0].id
      }));
      t(x);
    }
  }, [o]);
  const c = (x) => {
    Qt.event({
      category: Ds.GLOBAL_TAG_PROPAGATE_BUTTON_CLICKED,
      action: Ds.GLOBAL_TAG_PROPAGATE_BUTTON_CLICKED
    });
    let C;
    const f = o.map((b) => b.id === x ? (C = b.data.tagKey.value, {
      ...b,
      customState: {
        ...b.customState,
        propagate: !b.customState.propagate
      }
    }) : b);
    r(f);
    const h = s.map((b) => b.key === C ? {
      ...b,
      propagate: !b.propagate
    } : b);
    t(h);
  }, p = (x) => {
    const C = x.customState.propagate;
    return /* @__PURE__ */ e.jsx(we, { content: _a.propagateTippy.title, placement: "left", alwaysShowTippyOnHover: !0, children: /* @__PURE__ */ e.jsx(
      "div",
      {
        onClick: () => c(x.id),
        className: `pointer flex h-100 w-100 top py-8 h-36 dc__bottom-left-radius ${C ? "bcn-7" : ""} ${x.data.tagKey.value?.startsWith("devtron.ai/") ? "cursor-not-allowed bcn-1" : ""}`,
        children: /* @__PURE__ */ e.jsx(Vm, { className: `icon-dim-20 ${C ? "scn-0" : ""}` })
      }
    ) });
  }, d = () => {
    const C = [bl(a), ...o];
    r(C), Qt.event({
      category: Ds.GLOBAL_TAG_ADD_ROW_CLICKED,
      action: Ds.GLOBAL_TAG_ADD_ROW_CLICKED
    });
  }, m = (x, C, f) => {
    const h = structuredClone(l);
    h[x.id] || (h[x.id] = {
      tagKey: { isValid: !0, errorMessages: [] }
    }), u({
      actionType: St.UPDATE_ROW,
      actionValue: f,
      headerKey: C,
      rowId: x.id
    }), C === "tagKey" && (h[x.id].tagKey = di(f), i(h));
  }, _ = (x) => {
    const C = o.filter(({ id: f }) => f !== x.id);
    if (C.length === 0) {
      const f = bl(a);
      r([f]);
      return;
    }
    r(C);
  }, g = (x) => /* @__PURE__ */ e.jsx(
    cf,
    {
      tagChoices: x.customState.tagChoices,
      title: "Set value choices",
      handleRowUpdateAction: u,
      rowId: +x.id,
      blockCustomValue: x.customState.blockCustomValue
    }
  );
  return /* @__PURE__ */ e.jsx(
    Zo,
    {
      headers: ef(a, n),
      rows: o,
      isDeletionNotAllowed: n,
      onRowEdit: m,
      onRowDelete: _,
      onRowAdd: d,
      cellError: l,
      actionButtonConfig: {
        renderer: p,
        key: "tagKey",
        width: "32px",
        position: "start"
      },
      isAdditionNotAllowed: n,
      buttonCellWrapComponent: (x) => g(x)
    }
  );
}, Sl = ({ pageType: s }) => {
  const { tagId: t } = ce(), { replace: a } = ae(), [n, o] = E(!1), [r, l] = E(!1), [i, u] = E([]), [c, p] = E([]), [d, m] = E($s.SUGGESTED), [_, g] = E([nf]), [x, C] = E(!1), [f, h] = E(!1), [b, S] = E([]), [O, j] = E({ isValid: !0, message: "" }), v = async () => {
    o(!0);
    try {
      const [{ result: ee }, { result: H }] = await Promise.all([
        er(),
        s === Lt.edit ? ti(+t) : { result: null }
      ]), Je = [], Ct = [], fs = H?.mandatoryProjectIdsCsv ? H.mandatoryProjectIdsCsv.split(",") : [];
      ee.forEach((He) => {
        const It = { label: He.name, value: `${He.id}` };
        Je.push(It), s === Lt.edit && fs.indexOf(`${He.id}`) >= 0 && Ct.push(It);
      }), p(Je), u(Ct), m(Ct.length ? $s.MANDATORY : $s.SUGGESTED), H && g([H]);
    } catch (ee) {
      ve(ee);
    } finally {
      o(!1);
    }
  };
  ue(() => {
    v();
  }, []);
  const A = () => {
    a(Qe.TAG_LIST);
  }, N = async (ee) => {
    if (ee.preventDefault(), !i.length && d === $s.MANDATORY) {
      j({ isValid: !1, message: "This is required field" });
      return;
    }
    const H = [];
    let Je = !1;
    const Ct = i.map((fs) => fs.value).join(",");
    for (let fs = 0; fs < _.length; fs++) {
      const He = _[fs];
      if (He.isInvalidKey || He.isInvalidValue) {
        Je = !0;
        break;
      } else if (He.key) {
        const It = d === $s.MANDATORY ? Ct : null;
        H.push({
          id: He.id || null,
          key: He.key,
          value: He.value,
          propagate: He.propagate,
          mandatoryProjectIdsCsv: It,
          description: He.description,
          valueConstraint: {
            choices: He.valueConstraint.choices || [],
            blockCustomValue: He.valueConstraint.choices?.length ? He.valueConstraint.blockCustomValue ?? !1 : !1
          },
          deploymentPolicy: d === $s.MANDATORY ? He.deploymentPolicy ?? Ye.ALLOW : Ye.ALLOW
        });
      }
    }
    if (Je) {
      Se.showToast({
        variant: Ne.error,
        description: "Some required fields are missing or invalid"
      });
      return;
    }
    l(!0);
    try {
      Qt.event({
        category: Ds.GLOBAL_TAG_SAVE_BUTTON_CLICKED,
        action: Ds.GLOBAL_TAG_SAVE_BUTTON_CLICKED
      }), await ai(H, s === Lt.edit), Se.showToast({
        variant: Ne.success,
        description: "Successfully saved"
      }), A();
    } catch (fs) {
      ve(fs);
    } finally {
      l(!1);
    }
  }, L = (ee) => {
    m(ee.target.value);
  }, M = (ee) => {
    ee.length ? j({ isValid: !0, message: "" }) : j({ isValid: !1, message: "This is required field" }), u(ee);
  }, W = () => {
    h(!0);
  }, $ = () => {
    h(!1);
  }, w = () => /* @__PURE__ */ e.jsx(
    nc,
    {
      isEditView: !0,
      isMultiDelete: !1,
      tagIDList: [_[0].id],
      tagName: _[0].key,
      closeModal: $
    }
  ), T = () => /* @__PURE__ */ e.jsxs("div", { className: "cn-9 fs-13", children: [
    /* @__PURE__ */ e.jsx("p", { className: "fw-6 m-0", children: "Mandatory tags" }),
    /* @__PURE__ */ e.jsxs("ul", { className: "mb-0 ml-20 pl-4", children: [
      /* @__PURE__ */ e.jsx("li", { children: "Values for mandatory tags are required for applications in selected projects. You can block deployments if tags are missing." }),
      /* @__PURE__ */ e.jsx("li", { children: "Mandatory tags will appear as suggestion for other projects." })
    ] })
  ] }), I = () => /* @__PURE__ */ e.jsx("div", { className: "flex left", children: /* @__PURE__ */ e.jsxs(
    zs,
    {
      className: "radio-group-no-border create-tag__radio-group",
      value: d,
      name: "tagType",
      onChange: L,
      children: [
        /* @__PURE__ */ e.jsx(Be, { value: $s.SUGGESTED, children: "Suggested tags" }),
        /* @__PURE__ */ e.jsx(Be, { value: $s.MANDATORY, children: "Mandatory tags" })
      ]
    }
  ) }), y = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 dc__border-bottom-n1", children: [
    I(),
    d === $s.MANDATORY ? /* @__PURE__ */ e.jsxs("div", { className: "dc__gap-12 flexbox-col", children: [
      /* @__PURE__ */ e.jsx(Us, { description: T() }),
      /* @__PURE__ */ e.jsx(
        te,
        {
          isMulti: !0,
          inputId: "mandatory-project-selector",
          options: c,
          size: P.large,
          placeholder: "Type to select projects",
          label: "Select project(s)",
          onChange: M,
          value: i,
          name: "Resource name",
          error: O.message
        }
      )
    ] }) : /* @__PURE__ */ e.jsx(Us, { description: "Tags will appear as suggestions when adding them to the application." })
  ] }), k = () => {
    Qt.event({
      category: Ds.GLOBAL_TAG_POLICY_KNOW_MORE_BUTTON_CLICKED,
      action: Ds.GLOBAL_TAG_POLICY_KNOW_MORE_BUTTON_CLICKED
    }), C(!0);
  }, G = () => {
    C(!1);
  }, K = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 pt-16", children: [
    /* @__PURE__ */ e.jsx(
      uf,
      {
        labelTags: _,
        setLabelTags: g,
        isMandatoryTags: d === $s.MANDATORY,
        isEditView: s === Lt.edit,
        rows: b,
        setRows: S
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "fs-12 fw-4", children: [
      /* @__PURE__ */ e.jsxs("span", { children: [
        /* @__PURE__ */ e.jsx("span", { className: "fw-6", children: "Propagate tags to Kubernetes resources:" }),
        " Propagate desired tags to Kubernetes resources as labels."
      ] }),
      " ",
      /* @__PURE__ */ e.jsx("span", { className: "cb-5 fs-12 fw-4 cursor", onClick: k, children: "Learn more" })
    ] })
  ] }), X = () => /* @__PURE__ */ e.jsxs("div", { className: "dc__border-top-n1 py-16 flex left dc__gap-12 px-20", children: [
    /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "tag-save-button",
        onClick: N,
        disabled: r || sf(b).some((ee) => !ee.isValid) || d === $s.MANDATORY && !O.isValid,
        text: s === Lt.edit ? "Update" : "Save",
        size: P.medium
      }
    ),
    /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "tag-cancel-button",
        onClick: A,
        disabled: r,
        text: "cancel",
        variant: U.secondary,
        size: P.medium
      }
    )
  ] }), Oe = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto px-20 py-16", children: [
    y(),
    K()
  ] }), { breadcrumbs: J } = nt(
    {
      alias: {
        "application-management": null,
        policies: null,
        tags: {
          component: "Tags",
          linked: !0
        },
        "tag-policy": {
          component: /* @__PURE__ */ e.jsx(tt, { heading: "Tag Policy" }),
          linked: !0
        },
        create: {
          component: "Add tag",
          linked: !1
        },
        edit: {
          component: "Edit tag",
          linked: !1
        },
        ":tagId": null
      }
    },
    []
  ), _e = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: J });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "bg__primary flexbox-col flex-grow-1 h-100 dc__overflow-hidden", children: /* @__PURE__ */ e.jsxs("div", { className: "create-tag-container dc__height-inherit flexbox-col flex-grow-1", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex flex-justify px-20 pt-16", children: [
        /* @__PURE__ */ e.jsxs("h2", { className: "flex left fs-16 cn-9 fw-6 m-0 mb-8 h-32 w-100", children: [
          _e(),
          /* @__PURE__ */ e.jsx(rf, {})
        ] }),
        s === Lt.edit && /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: "cta delete override-button flex h-32 dc__min-width-fit-content",
            type: "button",
            disabled: r,
            onClick: W,
            children: [
              /* @__PURE__ */ e.jsx(hn, { className: "mr-8 icon-dim-16" }),
              "Delete"
            ]
          }
        )
      ] }),
      n ? /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        Oe(),
        X()
      ] }),
      x && /* @__PURE__ */ e.jsx(of, { closePopup: G })
    ] }) }),
    f && w()
  ] });
}, pf = ({
  projectOptions: s,
  projectMap: t,
  uniqueProject: a,
  tagList: n,
  reload: o,
  closeModal: r
}) => {
  const l = Ms(null), [i, u] = E(!1), [c, p] = E([]), [d, m] = E({}), _ = async (j) => {
    if (j.preventDefault(), !c.length && !Object.keys(d).length) {
      r();
      return;
    }
    const v = [];
    let A = "";
    const N = {};
    Object.values(c).forEach((L) => {
      A += `,${L.value}`, N[+L.value] = !0;
    }), n.forEach((L) => {
      let M = A;
      if (L.mandatoryProjectIdsCsv) {
        if (!d[-1]) {
          const W = L.mandatoryProjectIdsCsv.split(",");
          for (let $ = 0; $ < W.length; ) {
            const w = +W[$];
            d[+w] || N[+w] ? W.splice($, 1) : $ += 1;
          }
          W.length && (M += `,${W.join(",")}`);
        }
      } else if (!A)
        return;
      v.push({
        id: L.id,
        key: L.key,
        value: L.value,
        propagate: L.propagate,
        mandatoryProjectIdsCsv: M ? M.substring(1) : null,
        description: L.description,
        valueConstraint: L.valueConstraint,
        deploymentPolicy: L.deploymentPolicy
      });
    }), u(!0);
    try {
      await ai(v, !0), Se.showToast({
        variant: Ne.success,
        description: "Successfully updated"
      }), r(), o();
    } catch (L) {
      ve(L);
    } finally {
      u(!1);
    }
  }, g = (j) => {
    p(j);
  }, x = (j) => {
    const v = { ...d };
    v[j.currentTarget.dataset.id] = !0, m(v);
  }, C = (j) => {
    const v = { ...d };
    delete v[j.currentTarget.dataset.id], m(v);
  }, f = (j, v) => /* @__PURE__ */ e.jsx("span", { className: `fs-12 mr-8 mb-6 pl-8 pr-8 br-4 dc__border dc__ellipsis-right ${j}`, children: v }), h = (j) => {
    const v = j.mandatoryProjectIdsCsv.split(",");
    if (!j.mandatoryProjectIdsCsv && !c.length)
      return /* @__PURE__ */ e.jsx("div", { children: "none" });
    const A = {};
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      v.map((N) => {
        const L = t.get(+N);
        return A[+N] = !0, L ? f(
          d?.[L.id] ? "bcr-1 er-2" : "bg__primary",
          L.name
        ) : null;
      }),
      c.map(
        (N) => A[+N.value] ? null : f("bcg-1 eg-2", N.label)
      )
    ] });
  }, b = () => /* @__PURE__ */ e.jsxs("div", { className: "dc__border br-4 mt-20", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex left bg__secondary dc__top-radius dc__border-bottom pt-8 pr-16 pb-8 pl-16", children: [
      /* @__PURE__ */ e.jsx(Hm, { className: "icon-dim-16 mr-4 mw-18 scn-7 dc__no-shrink" }),
      "Preview Changes"
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "bulk-edit-tag-row pt-8 pr-16 pb-8 pl-16 dc__border-bottom fs-12 fw-6", children: [
      /* @__PURE__ */ e.jsx("span", {}),
      /* @__PURE__ */ e.jsx("span", { children: "Tag name" }),
      /* @__PURE__ */ e.jsx("span", { children: "Mandatory for projects" })
    ] }),
    /* @__PURE__ */ e.jsx("div", { children: n.map((j) => /* @__PURE__ */ e.jsxs("div", { className: "bulk-edit-tag-row pt-6 pr-16 pl-16 fs-13 fw-4", children: [
      /* @__PURE__ */ e.jsx(Di, { className: "icon-dim-14 mr-6 mw-18 mt-3" }),
      /* @__PURE__ */ e.jsx("span", { className: "mr-8 dc__ellipsis-right", children: j.key }),
      /* @__PURE__ */ e.jsx("span", { className: "flex left flex-wrap dc__ellipsis-right", children: h(j) })
    ] })) })
  ] }), S = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    a.length > 0 && /* @__PURE__ */ e.jsx("div", { className: "flex left flex-wrap bg__secondary px-8 py-5 br-4 dc__border dc__no-bottom-radius dc__no-bottom-border", children: a.map((j) => /* @__PURE__ */ e.jsxs("div", { className: "flex fs-12 mr-8 mt-4 pl-8 pr-8 br-4 dc__border bg__primary dc__ellipsis-right", children: [
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: `dc__ellipsis-right ${d?.[j.id] ? "dc__strike-through" : ""}`,
          children: j.name
        }
      ),
      d?.[j.id] ? /* @__PURE__ */ e.jsx(
        Km,
        {
          className: "ml-4 icon-dim-12 cursor scn-6 dc__min-width-fit-content",
          "data-id": j.id,
          onClick: C
        }
      ) : /* @__PURE__ */ e.jsx(
        Rn,
        {
          className: "ml-4 icon-dim-12 cursor scn-6 dc__min-width-fit-content",
          "data-id": j.id,
          onClick: x
        }
      )
    ] })) }),
    /* @__PURE__ */ e.jsx(
      te,
      {
        isMulti: !0,
        inputId: "mandatory-project-selector",
        options: s,
        size: P.large,
        placeholder: "Type to select projects",
        onChange: g,
        value: c,
        name: "Resource name"
      }
    )
  ] }), O = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 cn-7 p-20 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "fs-13 fw-6 mb-8", children: "Remove/Add Projects" }),
      S(),
      b()
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "form__buttons dc__border-top pt-16 pb-16 pl-20 pr-20 dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "tag-cancel-button",
          onClick: r,
          disabled: i,
          text: "Cancel",
          variant: U.secondary,
          style: q.neutral
        }
      ),
      /* @__PURE__ */ e.jsx(B, { dataTestId: "tag-save-button", onClick: _, disabled: i, text: "Save" })
    ] })
  ] });
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", width: "720px", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col mh-0 h-100 flex-grow-1 bg__primary bulk-edit-tag-container", ref: l, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "fs-16 cn-9 fw-6 m-0", children: "Manage mandatory projects for selected tags" }),
      /* @__PURE__ */ e.jsx(Rn, { className: "icon-dim-20 cursor", onClick: r })
    ] }),
    i ? /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) : O()
  ] }) });
}, Nl = ({
  parentRef: s,
  openBulkEditModal: t,
  showMultiTagDeleteModal: a,
  selectedIdentifiersCount: n,
  handleClearAllSelectedTags: o
}) => /* @__PURE__ */ e.jsx(
  fp,
  {
    dragSelector: ".drag-selector",
    positionVariant: gp.PARENT_BOTTOM_CENTER,
    parentRef: s,
    zIndex: "calc(var(--modal-index) - 1)",
    children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8 pt-12 pb-12 pr-12 pl-8 bulk-selection-widget br-8", children: [
      /* @__PURE__ */ e.jsx(xp, { dragClassName: "drag-selector" }),
      /* @__PURE__ */ e.jsxs("div", { className: "fs-13 lh-20 fw-6 flex dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("span", { className: "flex dc__gap-2 bcb-5 cn-0 br-4 pr-6 pl-6", children: n }),
        /* @__PURE__ */ e.jsx("span", { className: "cn-9", children: "Selected" })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__divider h-16" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4", children: [
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "manage-project",
            onClick: t,
            variant: U.secondary,
            style: q.neutral,
            text: "Manage Project(s)",
            size: P.small,
            startIcon: /* @__PURE__ */ e.jsx(Ym, {})
          }
        ),
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "delete-selected-applied-profiles",
            ariaLabel: "Delete selected tags",
            onClick: a,
            "aria-label": "Delete selected tags",
            variant: U.borderLess,
            style: q.negativeGrey,
            size: P.xs,
            icon: /* @__PURE__ */ e.jsx(hn, { className: "icon-dim-16 dc__no-shrink" })
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__divider h-16" }),
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "clear-selected-applied-profiles",
          ariaLabel: "Clear bulk selection",
          onClick: o,
          variant: U.borderLess,
          style: q.negativeGrey,
          size: P.xs,
          icon: /* @__PURE__ */ e.jsx(ja, { className: "icon-dim-16 dc__no-shrink" })
        }
      )
    ] })
  }
), mf = () => {
  const s = Ms(null), t = he(), { push: a } = ae(), [n, o] = E(!1), [r, l] = E(0), [i, u] = E([]), [c, p] = E([]), [d, m] = E([]), [_, g] = E(!1), [x, C] = E(De.CHECKED), [f, h] = E(!1), [b, S] = E(!1), [O, j] = E(!1), [v, A] = E(""), [N, L] = E(null), [M, W] = E([]), [$, w] = E(/* @__PURE__ */ new Map()), [T, I] = E(null), [y, k] = E([]), [G, K] = E(""), [X, Oe] = E(Ls.AND), [J, _e] = E(lt.ASC), ee = (F) => {
    const ye = F.some((Le) => Le.isSelected), pe = F.some((Le) => !Le.isSelected);
    g(ye), C(ye && pe ? De.INTERMEDIATE : De.CHECKED), p(F);
  }, H = (F, ye, pe, Le, Gs) => {
    let ns = (Gs ?? i).map((os) => ({ ...os, isSelected: !1 }));
    m([]), (F || pe.length) && (ns = ns.filter((os) => {
      let ds = !1;
      if (F && (ds = os.key.indexOf(F) >= 0 || os.description.indexOf(F) >= 0 || os.mandatoryProjectsText.indexOf(F) >= 0), (!F || ds) && pe.length) {
        ds = !1;
        const Pa = Object.fromEntries(
          os.mandatoryProjectList.map((Ra) => [Ra, !0])
        );
        ye === Ls.AND ? ds = pe.every((Ra) => Pa[Ra.label]) : ds = pe.some((Ra) => Pa[Ra.label]);
      }
      return ds;
    })), ns.sort((os, ds) => Le === lt.ASC ? os.key.localeCompare(ds.key) : ds.key.localeCompare(os.key)), ee(ns);
    const qs = {};
    F && (qs.search = F), pe.length && (qs.projects = pe.map((os) => os.value)), i || (F || pe.length ? (qs.condition = ye, qs.sort = Le, a({ search: `${new URLSearchParams(qs).toString()}` })) : a({ search: `${new URLSearchParams({ sort: Le }).toString()}` }));
  }, Je = (F, ye) => {
    const pe = new URLSearchParams(t.search), Le = pe.get("projects");
    let Gs = [];
    const ns = pe.get("sort") ? lt[pe.get("sort")] : lt.ASC, qs = pe.get("condition") ? Ls[pe.get("condition")] : Ls.AND, os = pe.get("search") || "";
    Le && ye.size && (Gs = Le.split(",").map((Pa) => ({ label: ye.get(+Pa).name, value: Pa }))), os && K(os), _e(ns), Oe(qs), k(Gs), H(os, qs, Gs, ns, F);
  }, Ct = (F) => F.length === 0 ? Nn : F.join(","), fs = async (F) => {
    try {
      o(!0);
      const [{ result: ye }, { result: pe }] = await Promise.all([
        er(),
        ti()
      ]), Le = /* @__PURE__ */ new Map(), Gs = [];
      ye.forEach((ns) => {
        Le.set(ns.id, ns), Gs.push({ label: ns.name, value: `${ns.id}` });
      }), pe.forEach((ns) => {
        const qs = ns.mandatoryProjectIdsCsv ? ns.mandatoryProjectIdsCsv.split(",").map((ds) => Le.get(+ds)).filter((ds) => !!ds).map((ds) => ds.name) : [], os = {
          ...ns,
          mandatoryProjectsText: Ct(qs),
          mandatoryProjectList: qs
        };
        Object.assign(ns, os);
      }), u(pe), w(Le), W(Gs), m([]), l(0), F ? Je(pe, Le) : H(G, X, y, J, pe);
    } catch (ye) {
      l(ye.code);
    } finally {
      o(!1);
    }
  };
  ue(() => {
    fs(!0);
  }, []);
  const He = () => {
    Qt.event({
      category: Ds.GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED,
      action: Ds.GLOBAL_TAG_POLICY_ADD_TAG_BUTTON_CLICKED
    }), a(Qe.TAG_CREATE);
  }, It = (F) => {
    a(`${Qe.TAG_EDIT}/${F.currentTarget.dataset.tagId}`);
  }, oe = () => {
    const F = [], ye = c.map((pe) => ({
      ...pe,
      isSelected: !_
    }));
    _ || ye.forEach((pe) => {
      F.push(pe);
    }), g(!_), C(De.CHECKED), p(ye), m(F);
  }, Fe = (F) => {
    const ye = c.map((Le) => ({
      ...Le,
      isSelected: Le.id === F ? !Le.isSelected : Le.isSelected
    })), pe = ye.filter((Le) => Le.isSelected);
    g(pe.length > 0), C(
      c.length === pe.length ? De.CHECKED : De.INTERMEDIATE
    ), p(ye), m(pe);
  }, wa = () => {
    h(!1);
  }, wd = (F) => {
    A(F.currentTarget.dataset.tagKey), L([+F.currentTarget.dataset.tagId]), j(!1), h(!0);
  }, jr = () => {
    A(""), L(d.map((F) => +F.id)), j(!0), h(!0);
  }, Or = () => {
    const F = /* @__PURE__ */ new Map(), ye = [];
    d.forEach((pe) => {
      pe.mandatoryProjectIdsCsv && pe.mandatoryProjectsText !== Nn && pe.mandatoryProjectIdsCsv.split(",").forEach((Le) => {
        const Gs = +Le;
        F.get(Gs) || (ye.push($.get(Gs)), F.set(Gs, !0));
      });
    }), I(ye), S(!0);
  }, Pd = () => {
    S(!1);
  }, Rd = () => {
    K(""), Oe(Ls.AND), k([]), H("", Ls.AND, [], lt.ASC);
  }, Ld = (F) => {
    K(F), H(F, X, y, J);
  }, kd = (F) => {
    k(F), H(G, X, F, J);
  }, Ir = (F) => {
    Oe(F.currentTarget.dataset.condition), H(G, F.currentTarget.dataset.condition, y, J);
  }, Dd = () => {
    k([]), H(G, X, [], J);
  }, Md = (F) => {
    const ye = [...y];
    ye.splice(F.currentTarget.dataset.index, 1), k(ye), H(G, X, ye, J);
  }, Bd = () => y?.length ? /* @__PURE__ */ e.jsxs("div", { className: "pt-8 pr-20 pb-2 pl-20 flex left flex-wrap", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex mr-8 fw-6 fs-12 mb-6", children: [
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: `flex en-2 bw-1 pr-6 pl-6 pb-2 pt-2 dc__left-radius-4 ${X === Ls.AND ? "bcn-7 cn-0" : "cn-5 bg__primary cursor"}`,
          "data-condition": Ls.AND,
          onClick: Ir,
          children: Ls.AND
        }
      ),
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: `en-2 bw-1 pr-6 pl-6 pb-2 pt-2 dc__right-radius-4 dc__no-left-border ${X === Ls.OR ? "bcn-7 cn-0" : "cn-5 bg__primary cursor"}`,
          "data-condition": Ls.OR,
          onClick: Ir,
          children: Ls.OR
        }
      )
    ] }, "filter-condition"),
    y.map((F) => /* @__PURE__ */ e.jsxs("div", { className: "flex mr-8 bg__secondary cn-9 fs-12 mb-6", children: [
      /* @__PURE__ */ e.jsx("div", { className: "fw-6 en-2 bw-1 pr-6 pl-6 pb-2 pt-2 dc__left-radius-4", children: "Project" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex fw-4 en-2 bw-1 pr-6 pl-6 pb-2 pt-2 dc__right-radius-4 dc__no-left-border dc__mxw-400 dc__ellipsis-right", children: [
        F.label,
        /* @__PURE__ */ e.jsx(Pi, { className: "icon-dim-16 icon-fill-n4 ml-4", onClick: Md })
      ] })
    ] }, F.value)),
    /* @__PURE__ */ e.jsx("span", { className: "lh-24 mb-6 cb-5 fs-13 fw-6 cursor", onClick: Dd, children: "Clear" })
  ] }) : null, Ud = () => /* @__PURE__ */ e.jsx("div", { className: "w-200", children: /* @__PURE__ */ e.jsx(
    te,
    {
      placeholder: "Project",
      inputId: "project-select",
      value: y,
      options: M,
      onChange: kd,
      controlShouldRenderValue: !1,
      isMulti: !0,
      closeMenuOnSelect: !1,
      hideSelectedOptions: !1,
      isSearchable: !1
    }
  ) }), Fd = () => /* @__PURE__ */ e.jsx(
    aa,
    {
      initialSearchText: G,
      containerClassName: "w-250 br-4",
      handleEnter: Ld,
      inputProps: {
        placeholder: "Search by tags",
        autoFocus: !0
      },
      dataTestId: "tag-search"
    }
  ), Vd = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { children: Yt.description.para1 }),
    /* @__PURE__ */ e.jsx("div", { children: Yt.description.para2 }),
    /* @__PURE__ */ e.jsx("div", { children: Yt.description.para3 })
  ] }), wr = () => /* @__PURE__ */ e.jsx(
    B,
    {
      dataTestId: "add-tag-list",
      onClick: He,
      startIcon: /* @__PURE__ */ e.jsx(da, { className: "icon-dim-20" }),
      text: "Add tag",
      size: P.medium
    }
  ), Gd = () => /* @__PURE__ */ e.jsxs("div", { className: "pt-16 pr-20 pb-8 pl-20 flex flex-justify", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex cn-9 fw-6 fs-16 lh-18", children: /* @__PURE__ */ e.jsx(
      Jo,
      {
        title: $a.TAGS.title,
        renderDescriptionContent: () => Vd?.(),
        docLink: "GLOBAL_CONFIG_TAGS",
        showInfoIconTippy: !0
      }
    ) }),
    i.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
      Fd(),
      Ud(),
      /* @__PURE__ */ e.jsx("div", { className: "dc__border-right h-20" }),
      wr()
    ] })
  ] }), Wd = (F) => /* @__PURE__ */ e.jsx("div", { children: F.map((ye, pe) => pe === 0 ? null : /* @__PURE__ */ e.jsx("div", { children: ye })) }), $d = (F) => F.mandatoryProjectsText === Nn ? /* @__PURE__ */ e.jsx("span", { children: Nn }) : /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
    /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right", children: F.mandatoryProjectList[0] }),
    F.mandatoryProjectList.length > 1 && /* @__PURE__ */ e.jsx(
      Es,
      {
        className: "default-tt",
        arrow: !1,
        placement: "right",
        content: Wd(F.mandatoryProjectList),
        interactive: !0,
        children: /* @__PURE__ */ e.jsxs("span", { className: "dc_width-max-content fs-12 fw-4 pl-4 cursor dc__ellipsis-right cb-5", children: [
          "+",
          F.mandatoryProjectList.length - 1,
          " more"
        ] })
      }
    )
  ] }), Kd = (F) => /* @__PURE__ */ e.jsx(
    we,
    {
      content: F,
      placement: "bottom",
      showOnTruncate: !!F,
      className: "mxh-210 dc__overflow-auto",
      interactive: !0,
      children: /* @__PURE__ */ e.jsx("div", { className: "lh-20 dc__ellipsis-right lh-24", children: F || "-" })
    }
  ), Hd = (F) => /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
    Fa(F),
    /* @__PURE__ */ e.jsx("span", { className: "dc__ellipsis-right", children: Va(F) })
  ] }), Yd = () => /* @__PURE__ */ e.jsx("div", { children: c.map((F) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `tag-list-row fw-4 cn-7 fs-13 pt-6 pb-6 pr-20 pl-20 dc__hover-n50 ${_ ? "show-checkbox" : ""}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
          /* @__PURE__ */ e.jsx(
            Ft,
            {
              "data-tag-id": F.id,
              isChecked: F.isSelected,
              rootClassName: "mb-0-imp tag-checkbox pt-2",
              value: De.CHECKED,
              onChange: () => Fe(F.id)
            }
          ),
          /* @__PURE__ */ e.jsx(Di, { className: "tag-icon icon-dim-20" })
        ] }),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "cb-5 pointer lh-24 dc__truncate",
            "data-tag-id": F.id,
            onClick: It,
            children: F.key
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "lh-20 dc__ellipsis-right lh-24", children: $d(F) }),
        Kd(F.description),
        /* @__PURE__ */ e.jsx("div", { className: "h-20 dc__ellipsis-right lh-24", children: Hd(F.deploymentPolicy) }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex action-container dc__gap-4", children: [
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "edit-tag",
              component: me.link,
              linkProps: { to: `${Qe.TAG_EDIT}/${F.id}` },
              icon: /* @__PURE__ */ e.jsx(Ri, { className: "icon-dim-20 cursor" }),
              ariaLabel: "Edit tag",
              variant: U.borderLess,
              style: q.neutral,
              size: P.xs
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "delete-tag",
              "data-tag-id": F.id,
              "data-tag-key": F.key,
              onClick: wd,
              icon: /* @__PURE__ */ e.jsx(hn, { className: "icon-dim-20 cursor" }),
              ariaLabel: "Delete tag",
              variant: U.borderLess,
              style: q.negativeGrey,
              size: P.xs
            }
          )
        ] })
      ]
    }
  )) }), zd = () => {
    const F = J === lt.DESC ? lt.ASC : lt.DESC;
    _e(F), H(G, X, y, F);
  }, qd = () => /* @__PURE__ */ e.jsxs("div", { className: "tag-list-row fw-6 cn-7 fs-12 dc__border-bottom pt-10 pb-10 pr-20 pl-20 dc__uppercase h-36", children: [
    /* @__PURE__ */ e.jsx(
      Ft,
      {
        isChecked: _,
        rootClassName: "mb-0-imp",
        value: x,
        onChange: oe
      }
    ),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `tag-name flex left dc_max-width__max-content cursor ${J === lt.DESC ? "desc" : ""}`,
        onClick: zd,
        children: [
          "Name ",
          /* @__PURE__ */ e.jsx($m, { className: "cursor icon-dim-12 ml-4 dc__position-rel sort-icon" })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex left", children: [
      "Mandatory for projects ",
      /* @__PURE__ */ e.jsx(Wm, { className: "icon-dim-16 fcn-6 ml-4" }),
      " "
    ] }),
    /* @__PURE__ */ e.jsx("div", { children: "Description" }),
    /* @__PURE__ */ e.jsx("div", { children: "Allow/Block Deployments" }),
    /* @__PURE__ */ e.jsx("div", {})
  ] }), Xd = () => /* @__PURE__ */ e.jsxs("div", { children: [
    qd(),
    Yd(),
    d.length > 0 && /* @__PURE__ */ e.jsx(
      Nl,
      {
        parentRef: s,
        openBulkEditModal: Or,
        showMultiTagDeleteModal: jr,
        selectedIdentifiersCount: d.length,
        handleClearAllSelectedTags: oe
      }
    )
  ] }), Jd = () => /* @__PURE__ */ e.jsx(
    nc,
    {
      isEditView: !1,
      isMultiDelete: O,
      tagIDList: N,
      tagName: v,
      reload: fs,
      closeModal: wa
    }
  ), Qd = () => b ? /* @__PURE__ */ e.jsx(
    pf,
    {
      projectOptions: M,
      projectMap: $,
      uniqueProject: T,
      tagList: d,
      reload: fs,
      closeModal: Pd
    }
  ) : null, Zd = () => /* @__PURE__ */ e.jsx("button", { onClick: Rd, className: "cta h-36 lh-36", type: "button", children: "Clear filter" }), eu = () => i.length === 0 ? /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 mt-8", children: /* @__PURE__ */ e.jsx(
    Xe,
    {
      image: Ln,
      title: "Manage tags for applications",
      subTitle: /* @__PURE__ */ e.jsxs("div", { children: [
        "Add tags here and make them available to be used when creating an application. You can set tags as mandatory for applications in specific projects. ",
        /* @__PURE__ */ e.jsx(ln, { docLinkKey: "TAGS", dataTestId: "learn-more-about-tags-link", fullWidth: !0 })
      ] }),
      isButtonAvailable: !0,
      renderButton: wr
    }
  ) }) : /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx(
    Xe,
    {
      image: Ln,
      title: "No tags found",
      subTitle: "No tags found for applied filters",
      isButtonAvailable: !0,
      renderButton: Zd
    }
  ) });
  return n ? /* @__PURE__ */ e.jsx("div", { className: "bg__primary h-100", children: /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 }) }) : r > 0 ? /* @__PURE__ */ e.jsx("div", { className: "error-screen-wrapper flex column h-100", children: /* @__PURE__ */ e.jsx(_t, { code: r }) }) : /* @__PURE__ */ e.jsxs("div", { className: "tag-list flexbox-col h-100 bg__primary", ref: s, children: [
    i.length > 0 && d.length > 0 && /* @__PURE__ */ e.jsx(
      Nl,
      {
        parentRef: s,
        openBulkEditModal: Or,
        showMultiTagDeleteModal: jr,
        selectedIdentifiersCount: d.length,
        handleClearAllSelectedTags: oe
      }
    ),
    Gd(),
    i.length > 0 && Bd(),
    c.length ? Xd() : eu(),
    f && Jd(),
    Qd()
  ] });
};
function oc() {
  return /* @__PURE__ */ e.jsx(Cp, { children: /* @__PURE__ */ e.jsxs(rt, { children: [
    /* @__PURE__ */ e.jsx(le, { path: Qe.TAG_LIST, exact: !0, children: /* @__PURE__ */ e.jsx(mf, {}) }),
    /* @__PURE__ */ e.jsx(le, { path: Qe.TAG_CREATE, children: /* @__PURE__ */ e.jsx(Sl, { pageType: Lt.create }) }),
    /* @__PURE__ */ e.jsx(le, { path: `${Qe.TAG_EDIT}/:tagId`, children: /* @__PURE__ */ e.jsx(Sl, { pageType: Lt.edit }) }),
    /* @__PURE__ */ e.jsx(pn, { to: Qe.TAG_LIST })
  ] }) });
}
const oT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: oc
}, Symbol.toStringTag, { value: "Module" })), hf = ({
  OfflinePipelineModalAppView: s
}) => {
  const { isSuperAdmin: t, serverMode: a } = Ot(), { pathname: n } = he(), o = [
    {
      title: "Deployment Window",
      dataTestId: "click-on-policies-deployment-window",
      id: "application-management-policies-deployment-window",
      href: Ce.APPLICATION_MANAGEMENT_POLICIES_DEPLOYMENT_WINDOW
    },
    {
      title: "Approval Policy",
      dataTestId: "click-on-policies-approval-policy",
      id: "application-management-policies-approval-policy",
      href: Ce.APPLICATION_MANAGEMENT_POLICIES_APPROVAL_POLICY
    },
    {
      title: "Plugin Policy",
      dataTestId: "click-on-policies-plugin-policy",
      id: "application-management-policies-plugin-policy",
      href: Ce.APPLICATION_MANAGEMENT_POLICIES_PLUGIN_POLICY
    },
    {
      title: "Pull Image Digest",
      dataTestId: "click-on-policies-pull-image-digest",
      id: "application-management-policies-pull-image-digest",
      href: Ce.APPLICATION_MANAGEMENT_POLICIES_PULL_IMAGE_DIGEST
    },
    {
      title: "Tag Policy",
      dataTestId: "click-on-policies-tag-policy",
      id: "application-management-policies-tag-policy",
      href: Ce.APPLICATION_MANAGEMENT_POLICIES_TAG_POLICY
    },
    {
      title: "Filter Conditions",
      dataTestId: "click-on-policies-filter-conditions",
      id: "application-management-policies-filter-conditions",
      href: Ce.APPLICATION_MANAGEMENT_POLICIES_FILTER_CONDITIONS
    },
    ...window._env_?.FEATURE_IMAGE_PROMOTION_ENABLE ? [
      {
        title: "Image Promotion",
        dataTestId: "click-on-policies-image-promotion",
        id: "application-management-policies-image-promotion",
        href: Ce.APPLICATION_MANAGEMENT_POLICIES_IMAGE_PROMOTION
      }
    ] : [],
    {
      title: "Lock Deployment Configuration",
      dataTestId: "click-on-policies-lock-deployment-configuration",
      id: "application-management-policies-lock-deployment-configuration",
      href: Ce.APPLICATION_MANAGEMENT_POLICIES_LOCK_DEPLOYMENT_CONFIGURATION
    }
  ], { breadcrumbs: r } = nt(
    {
      alias: {
        ...bp(),
        policies: {
          component: /* @__PURE__ */ e.jsx(tt, { heading: "Policies", isActive: !0 })
        }
      }
    },
    [n]
  ), l = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: r });
  return a !== Vt.EA_ONLY && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(xt, { isBreadcrumbs: !0, breadCrumbs: l, docPath: sr.APP_MANAGEMENT }),
    /* @__PURE__ */ e.jsxs("div", { className: "application-management-policies dc__grid flex-grow-1 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "py-12 pl-8 pr-7 border__primary--right", children: /* @__PURE__ */ e.jsx(Sp, { list: o }) }),
      /* @__PURE__ */ e.jsx("div", { className: "bg__secondary dc__overflow-auto", children: /* @__PURE__ */ e.jsxs(rt, { children: [
        /* @__PURE__ */ e.jsx(
          le,
          {
            path: Ce.APPLICATION_MANAGEMENT_POLICIES_DEPLOYMENT_WINDOW,
            children: /* @__PURE__ */ e.jsx(wu, { isSuperAdmin: t })
          },
          Ce.APPLICATION_MANAGEMENT_POLICIES_DEPLOYMENT_WINDOW
        ),
        /* @__PURE__ */ e.jsx(
          le,
          {
            path: Ce.APPLICATION_MANAGEMENT_POLICIES_APPROVAL_POLICY,
            children: /* @__PURE__ */ e.jsx(Pu, {})
          },
          Ce.APPLICATION_MANAGEMENT_POLICIES_APPROVAL_POLICY
        ),
        window._env_.FEATURE_IMAGE_PROMOTION_ENABLE && /* @__PURE__ */ e.jsx(
          le,
          {
            path: Ce.APPLICATION_MANAGEMENT_POLICIES_IMAGE_PROMOTION,
            children: /* @__PURE__ */ e.jsx(Ru, {})
          },
          Ce.APPLICATION_MANAGEMENT_POLICIES_IMAGE_PROMOTION
        ),
        /* @__PURE__ */ e.jsx(le, { path: Ce.APPLICATION_MANAGEMENT_POLICIES_PLUGIN_POLICY, children: /* @__PURE__ */ e.jsx(Lu, { OfflinePipelineModalAppView: s }) }),
        /* @__PURE__ */ e.jsx(le, { path: Ce.APPLICATION_MANAGEMENT_POLICIES_PULL_IMAGE_DIGEST, children: /* @__PURE__ */ e.jsx(T_, { isSuperAdmin: t }) }),
        /* @__PURE__ */ e.jsx(le, { path: Ce.APPLICATION_MANAGEMENT_POLICIES_TAG_POLICY, children: /* @__PURE__ */ e.jsx(oc, {}) }),
        /* @__PURE__ */ e.jsx(le, { path: Ce.APPLICATION_MANAGEMENT_POLICIES_FILTER_CONDITIONS, children: /* @__PURE__ */ e.jsx(mr, { isSuperAdmin: t }) }),
        /* @__PURE__ */ e.jsx(le, { path: Ce.APPLICATION_MANAGEMENT_POLICIES_LOCK_DEPLOYMENT_CONFIGURATION, children: /* @__PURE__ */ e.jsx(ku, {}) }),
        /* @__PURE__ */ e.jsx(pn, { to: R.APPLICATION_MANAGEMENT_APP })
      ] }) })
    ] })
  ] });
}, _f = ({
  AppConfig: s,
  OfflinePipelineModalAppView: t
}) => /* @__PURE__ */ e.jsxs(rt, { children: [
  window._env_.FEATURE_APPLICATION_TEMPLATES_ENABLE && Fr && /* @__PURE__ */ e.jsx(le, { path: R.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP, children: /* @__PURE__ */ e.jsx(Fr, { AppConfig: s }) }),
  /* @__PURE__ */ e.jsx(le, { path: Ce.APPLICATION_MANAGEMENT_POLICIES, children: /* @__PURE__ */ e.jsx(hf, { OfflinePipelineModalAppView: t }) }),
  /* @__PURE__ */ e.jsx(pn, { to: R.APPLICATION_MANAGEMENT_APP })
] });
var Y = /* @__PURE__ */ ((s) => (s.MEMORY = "memory", s.CPU = "cpu", s.STORAGE = "storage", s.GPU = "gpu", s.NETWORK = "network", s))(Y || {}), ts = /* @__PURE__ */ ((s) => (s.LAST_24_HOURS = "last24Hours", s.LAST_7_DAYS = "last7Days", s.LAST_30_DAYS = "last30Days", s.LAST_90_DAYS = "last90Days", s))(ts || {}), qe = /* @__PURE__ */ ((s) => (s.CURRENCY = "currency", s.TIME_RANGE = "timeRange", s))(qe || {}), Z = /* @__PURE__ */ ((s) => (s.OVERVIEW = "cost-overview", s.APPLICATIONS = "applications", s.DEPLOYMENT_COST = "deployment-cost", s.CUSTOM_VIEWS = "custom-views", s.AGGREGATIONS = "aggregations", s.RESOURCE_KINDS = "resource-kinds", s))(Z || {}), Za = /* @__PURE__ */ ((s) => (s.typeFilter = "typeFilter", s))(Za || {}), rs = /* @__PURE__ */ ((s) => (s.NODE_GROUPS = "node-groups", s.NAMESPACES = "namespaces", s.APPLICATIONS = "applications", s))(rs || {}), ne = /* @__PURE__ */ ((s) => (s.CLUSTER = "cluster", s.ENVIRONMENT = "environment", s.PROJECT = "project", s.APPLICATION = "application", s.K8S_RESOURCE = "K8sResource", s))(ne || {});
const no = {
  [ts.LAST_24_HOURS]: "last24Hours",
  [ts.LAST_7_DAYS]: "last7Days",
  [ts.LAST_90_DAYS]: "last90Days",
  [ts.LAST_30_DAYS]: "last30Days"
}, ff = {
  [rs.APPLICATIONS]: "application",
  [rs.NAMESPACES]: "namespace",
  [rs.NODE_GROUPS]: "node"
}, gf = {
  [Os.Pod]: "pod",
  [Os.Deployment]: "deployment",
  [Os.DaemonSet]: "daemonSet",
  [Os.Job]: "job",
  [Os.Rollout]: "rollout",
  [Os.StatefulSet]: "statefulSet",
  [Os.Containers]: "container"
}, Oa = async ({
  payload: s,
  resource: t,
  signal: a
}) => {
  const n = t ? `/${t}` : "";
  return xe($e(`${z.COST_SUMMARY}${n}`, s), { signal: a });
}, pa = async ({
  payload: s,
  resource: t,
  signal: a
}) => {
  const n = t ? `/${t}` : "";
  return xe($e(`${z.COST_BREAKDOWN}${n}`, s), {
    signal: a
  });
}, rT = async (s) => {
  try {
    const { result: t } = await _s(
      z.K8S_CAPACITY_CLUSTER_IDENTIFY,
      {
        id: s
      }
    ), a = JSON.parse(t?.costModuleSchema);
    return {
      clusterProvider: t?.provider || "Unknown",
      costModuleSchema: a
    };
  } catch (t) {
    throw ve(t), t;
  }
};
var Qs = /* @__PURE__ */ ((s) => (s.CLUSTERS = "cluster", s.ENVIRONMENTS = "environment", s.APPLICATIONS = "application", s.CI_PIPELINES = "ciPipeline", s.PROJECTS = "project", s.CLUSTER_PROVIDERS = "clusterProvider", s.CUSTOM_VIEWS = "customView", s))(Qs || {});
const kt = {
  [Y.CPU]: "CPU Cost",
  [Y.MEMORY]: "Memory Cost",
  [Y.GPU]: "GPU Cost",
  [Y.STORAGE]: "Storage Cost",
  [Y.NETWORK]: "Network Cost"
}, fa = {
  [Y.CPU]: "LimeGreen500",
  [Y.MEMORY]: "SkyBlue500",
  [Y.GPU]: "Lavender500",
  [Y.STORAGE]: "AquaTeal500",
  [Y.NETWORK]: "GoldenYellow500"
}, rc = {
  increase: "CoralRed400",
  decrease: "LimeGreen300",
  no_change: "SkyBlue300"
}, _r = [
  {
    label: "Cost: High to Low",
    value: {
      sortBy: "totalCost",
      sortOrder: Ss.DESC
    }
  },
  {
    label: "Cost: Low to High",
    value: {
      sortBy: "totalCost",
      sortOrder: Ss.ASC
    }
  },
  {
    label: "A to Z",
    value: {
      sortBy: "name",
      sortOrder: Ss.ASC
    }
  },
  {
    label: "Z to A",
    value: {
      sortBy: "name",
      sortOrder: Ss.DESC
    }
  }
], Fs = ts.LAST_30_DAYS, oo = [
  {
    group: "",
    version: "v1",
    kind: Os.Pod
  },
  {
    group: "apps",
    version: "v1",
    kind: Os.Deployment
  },
  {
    group: "apps",
    version: "v1",
    kind: Os.DaemonSet
  },
  {
    group: "batch",
    version: "v1",
    kind: Os.Job
  },
  {
    group: "argoproj.io",
    version: "v1alpha1",
    kind: Os.Rollout
  },
  {
    group: "apps",
    version: "v1",
    kind: Os.StatefulSet
  },
  {
    group: "",
    version: "v1",
    kind: Os.Containers
  }
], Ea = [
  {
    label: "Cluster",
    value: V.CLUSTERS
  },
  {
    label: "Application",
    value: V.APPLICATIONS
  },
  {
    label: "Environment",
    value: V.ENVIRONMENTS
  },
  {
    label: "Project",
    value: V.PROJECTS
  }
];
var Ie = /* @__PURE__ */ ((s) => (s.TOTAL_COST = "totalCost", s.CPU_COST = "cpuCost", s.MEMORY_COST = "memoryCost", s.GPU_COST = "gpuCost", s.STORAGE_COST = "storageCost", s.NETWORK_COST = "networkCost", s.POTENTIAL_SAVINGS = "potentialSavings", s.NAME = "name", s.NAMESPACE = "namespace", s.ENVIRONMENT = "environment", s))(Ie || {});
const fr = {
  [ne.CLUSTER]: "clusterDetails",
  [ne.ENVIRONMENT]: "envDetails",
  [ne.PROJECT]: "projectDetails",
  [ne.APPLICATION]: "appDetails",
  [ne.K8S_RESOURCE]: "resourceDetails"
}, xf = {
  [ne.CLUSTER]: V.CLUSTERS,
  [ne.ENVIRONMENT]: V.ENVIRONMENTS,
  [ne.PROJECT]: V.PROJECTS,
  [ne.APPLICATION]: V.APPLICATIONS
}, lc = {
  [Y.CPU]: Ie.CPU_COST,
  [Y.MEMORY]: Ie.MEMORY_COST,
  [Y.GPU]: Ie.GPU_COST,
  [Y.STORAGE]: Ie.STORAGE_COST,
  [Y.NETWORK]: Ie.NETWORK_COST
}, Cf = ({
  row: s,
  field: t
}) => {
  const { data: a } = s, n = Object.entries(lc).find(
    ([, r]) => r === t
  )?.[0];
  if (!n)
    return null;
  const o = a[n];
  return /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: o.value });
}, bf = ({ row: s }) => {
  const { data: t } = s, a = t.totalCost;
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-8", children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: a.value }) });
}, Sf = ({ row: s }) => {
  const { data: t } = s, a = t.potentialSavings;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cg-5 ", children: a.value }),
    /* @__PURE__ */ e.jsxs("span", { className: "cn-9 fs-13 fw-4 lh-20", children: [
      "Save ",
      a.savingsPercentage,
      "%"
    ] })
  ] });
}, Ma = [
  ...Object.values(Y).map((s) => ({
    field: lc[s],
    label: kt[s],
    size: {
      range: {
        startWidth: 120,
        maxWidth: 250,
        minWidth: 80
      }
    },
    CellComponent: Cf,
    isSortable: !0
  })),
  {
    field: Ie.TOTAL_COST,
    label: "Total Cost",
    size: {
      range: {
        startWidth: 100,
        maxWidth: 250,
        minWidth: 80
      }
    },
    CellComponent: bf,
    isSortable: !0
  },
  {
    field: Ie.POTENTIAL_SAVINGS,
    label: "Potential Savings",
    size: {
      range: {
        startWidth: 180,
        maxWidth: 400,
        minWidth: 80
      }
    },
    CellComponent: Sf,
    isSortable: !0
  }
], Nf = {
  [Ie.CPU_COST]: "cpuCost",
  [Ie.GPU_COST]: "gpuCost",
  [Ie.MEMORY_COST]: "memoryCost",
  [Ie.NETWORK_COST]: "networkCost",
  [Ie.NAME]: "name",
  [Ie.POTENTIAL_SAVINGS]: "potentialSavings",
  [Ie.STORAGE_COST]: "storageCost",
  [Ie.TOTAL_COST]: "totalCost",
  [Ie.NAMESPACE]: "namespace",
  [Ie.ENVIRONMENT]: "env"
}, Mn = "namespace", Bn = "environment", ic = (s) => typeof s != "string" || s === "0" ? "no_change" : s.startsWith("+") ? "increase" : "decrease", ro = (s) => `${s.kind}-${s.group || Np}-${s.version}`, Fo = (s, t) => {
  if (s === Z.DEPLOYMENT_COST)
    return "Deployment environments";
  if (s === Z.APPLICATIONS)
    return "Applications";
  if (!t)
    return "";
  if (s === Z.AGGREGATIONS)
    switch (t) {
      case rs.NAMESPACES:
        return "Namespace";
      case rs.NODE_GROUPS:
        return "Node Group";
      case rs.APPLICATIONS:
        return "Application";
      default:
        return "";
    }
  if (s === Z.RESOURCE_KINDS) {
    const a = oo.find((n) => ro(n) === t);
    return a ? a.kind : "";
  }
  return t;
}, cc = (s) => {
  switch (s) {
    case V.APPLICATIONS:
      return R.COST_BREAKDOWN_APPLICATIONS;
    case V.CLUSTERS:
      return R.COST_BREAKDOWN_CLUSTERS;
    case V.ENVIRONMENTS:
      return R.COST_BREAKDOWN_ENVIRONMENTS;
    case V.PROJECTS:
      return R.COST_BREAKDOWN_PROJECTS;
    default:
      return R.COST_BREAKDOWN_CLUSTERS;
  }
}, us = (s, t, a) => {
  const n = {};
  if (t !== Fs && (n[qe.TIME_RANGE] = t), a && (n[qe.CURRENCY] = a), Object.keys(n).length === 0)
    return s;
  const o = $e("", n).slice(1), r = s.includes("?") ? "&" : "?";
  return `${s}${r}${o}`;
}, Ef = (s) => (t, a) => {
  let n = null, o = "";
  switch (s) {
    case ts.LAST_24_HOURS:
      return n = Pe(t, ls.WEEKDAY_DATE_MONTH_YEAR_AND_HOUR, !0), a === 0 || n.format("hh") === "12" ? [n.format("hh"), n.format("A")] : n.format("hh");
    case ts.LAST_7_DAYS:
      return n = Pe(t, ls.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, !0), n.format(ls.ABBREVIATED_WEEKDAY);
    case ts.LAST_30_DAYS:
      return n = Pe(t, ls.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, !0), o = n.format(ls.DAY_OF_MONTH), a === 0 || o === "01" ? [o, n.format(ls.ABBREVIATED_MONTH)] : o;
    case ts.LAST_90_DAYS:
      return t.split(" to ").map(
        (r) => Pe(r, ls.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, !0).format(
          ls.DATE_WITH_ABBREVIATED_MONTH
        )
      ).join(" - ");
    default:
      return t;
  }
}, gr = (s, t) => {
  if (t === V.CLUSTERS) {
    if (s === Ns.PRODUCTION)
      return "cluster|type|prod";
    if (s === Ns.NON_PRODUCTION)
      return "cluster|type|non-prod";
  }
  if (t === V.ENVIRONMENTS) {
    if (s === Ns.PRODUCTION)
      return "environment|type|prod";
    if (s === Ns.NON_PRODUCTION)
      return "environment|type|non-prod";
  }
  return null;
}, xr = (s, t) => t ? Qs.CUSTOM_VIEWS : {
  [V.APPLICATIONS]: Qs.APPLICATIONS,
  [V.CLUSTERS]: Qs.CLUSTERS,
  [V.ENVIRONMENTS]: Qs.ENVIRONMENTS,
  [V.PROJECTS]: Qs.PROJECTS
}[s] || null, dc = (s, t) => {
  if (!s)
    return null;
  switch (s) {
    case Z.CUSTOM_VIEWS:
      return null;
    case Z.AGGREGATIONS:
      return t ? [ff[t]] : null;
    case Z.RESOURCE_KINDS: {
      if (!t) return null;
      const a = oo.find((n) => ro(n) === t);
      return a ? [gf[a.kind]] : (Se.showToast({
        variant: Ne.error,
        description: "Invalid resource kind"
      }), null);
    }
    case Z.APPLICATIONS:
      return ["application"];
    case Z.DEPLOYMENT_COST:
      return ["environment"];
    default:
      return null;
  }
}, vf = (s, t) => s ? `namespace|name|${s}` : t ? `environment|name|${t}` : null, Tf = ({
  view: s,
  breakdownViewType: t,
  itemName: a,
  detail: n,
  currency: o,
  timeRange: r,
  sortBy: l,
  sortOrder: i,
  pageSize: u,
  offset: c,
  searchKey: p,
  typeFilter: d,
  namespace: m,
  environment: _
}) => {
  const g = {
    timeWindow: no[r || Fs],
    sortBy: Nf[l],
    sortOrder: i,
    searchByName: p || "",
    size: u,
    offset: c
  }, x = xr(t, s === Z.CUSTOM_VIEWS), C = Object.values(Ns).includes(d) ? d : Ns.ALL, f = dc(s, n);
  if (!s) {
    const b = {
      ...g,
      resourceName: null,
      subResource: null,
      currencyCode: o,
      filter: gr(C, t)
    };
    return {
      resource: x,
      payload: b
    };
  }
  const h = {
    currencyCode: o,
    subResource: f,
    filter: vf(m, _),
    resourceName: s === Z.CUSTOM_VIEWS ? n : a
  };
  return {
    resource: x,
    payload: {
      ...g,
      ...h
    }
  };
}, lo = (s) => !s || s.length === 0 ? null : [...s].sort((a, n) => Pe(n.date).valueOf() - Pe(a.date).valueOf())[0]?.date || null, Af = (s) => Array.from({ length: 24 }, (t, a) => {
  const n = 23 - a;
  return (s ? Pe(s) : Pe()).subtract(n, "hours").toISOString();
}), yf = (s) => Array.from({ length: 7 }, (t, a) => {
  const n = 6 - a;
  return (s ? Pe(s) : Pe()).subtract(n, "days").startOf("day").toISOString();
}), jf = (s) => Array.from({ length: 30 }, (t, a) => {
  const n = 29 - a;
  return (s ? Pe(s) : Pe()).subtract(n, "days").startOf("day").toISOString();
}), Of = (s) => Array.from({ length: 13 }, (t, a) => {
  const n = 12 - a;
  return (s ? Pe(s) : Pe()).subtract(n, "weeks").startOf("week").toISOString();
}), If = (s) => {
  const t = /* @__PURE__ */ new Map();
  return s.forEach((a) => {
    const n = Pe(a.date), o = n.hour(), r = n.format("DD"), l = `${o}-${r}`;
    t.set(l, a.cost);
  }), t;
}, wf = (s) => {
  const t = /* @__PURE__ */ new Map();
  return s.forEach((a) => {
    const o = Pe(a.date).format("ddd");
    t.set(o, (t.get(o) || 0) + a.cost);
  }), t;
}, Pf = (s) => {
  const t = /* @__PURE__ */ new Map();
  return s.forEach((a) => {
    const n = Pe(a.date), o = n.format("DD"), r = n.format("MM"), l = `${o}-${r}`;
    t.set(l, (t.get(l) || 0) + a.cost);
  }), t;
}, Rf = (s) => {
  const t = ls.WEEKDAY_DATE_MONTH_YEAR_AND_HOUR, a = lo(s), n = Af(a), o = If(s);
  return n.map((r) => {
    const l = Pe(r), i = l.hour(), u = l.format("DD"), c = `${i}-${u}`;
    return {
      label: l.format(t),
      value: o.get(c) ?? NaN
    };
  });
}, Lf = (s) => {
  const t = ls.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, a = lo(s), n = yf(a), o = wf(s);
  return n.map((r) => ({
    label: Pe(r).format(t),
    value: o.get(Pe(r).format("ddd")) ?? NaN
  }));
}, kf = (s) => {
  const t = ls.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, a = lo(s), n = jf(a), o = Pf(s);
  return n.map((r) => {
    const l = Pe(r), i = l.format("DD"), u = l.format("MM"), c = `${i}-${u}`;
    return {
      label: l.format(t),
      value: o.get(c) ?? NaN
    };
  });
}, Df = (s) => {
  const t = ls.WEEKDAY_WITH_DATE_MONTH_AND_YEAR, a = lo(s);
  return Of(a).map((o) => {
    const r = Pe(o), l = Pe(r).endOf("week");
    let i = 0, u = !1;
    return s.forEach((c) => {
      Pe(c.date).isBetween(r, l, null, "[]") && (i += c.cost, u = !0);
    }), {
      label: `${r.format(t)} to ${l.format(t)}`,
      value: u ? i : NaN
    };
  });
}, Mf = (s, t) => {
  if (!s || s.length === 0)
    return [];
  switch (t) {
    case "last24Hours":
      return Rf(s);
    case "last7Days":
      return Lf(s);
    case "last30Days":
      return kf(s);
    case "last90Days":
      return Df(s);
    default:
      return [];
  }
}, Ws = ({
  totalCost: s = 0,
  potentialSavings: t = 0,
  potentialSavingsPercentage: a = 0,
  recommendedCost: n = 0,
  trend: o = null,
  trendPercent: r = 0
}, l) => ({
  totalCost: Number(s.toFixed(2)),
  recommendedCost: Number(n?.toFixed(2) ?? (s - t).toFixed(2)),
  potentialSavings: Number(t.toFixed(2)),
  potentialSavingsPercentage: Number(a.toFixed(2)),
  trend: r === 0 ? "0" : `${r > 0 ? "+" : "-"}${Math.abs(r)}`,
  plotPoints: Mf(o, l)
}), fn = (s, t) => {
  const a = no[t];
  if (s?.subResourceSummary && Object.keys(s.subResourceSummary).length) {
    const c = {};
    return Object.entries(s.subResourceSummary).forEach(([p, d]) => {
      const m = d.summary, { cpu: _, memory: g, gpu: x, storage: C, network: f, ...h } = m ?? {};
      c[p] = {
        overall: Ws(h, a),
        cpu: Ws(_ ?? {}, a),
        memory: Ws(g ?? {}, a),
        gpu: Ws(x ?? {}, a),
        storage: Ws(C ?? {}, a),
        network: Ws(f ?? {}, a)
      };
    }), {
      subResourceSummary: c
    };
  }
  const { cpu: n, memory: o, gpu: r, storage: l, network: i, ...u } = s?.summary ?? {};
  return {
    summary: {
      overall: Ws(u, a),
      cpu: Ws(n ?? {}, a),
      memory: Ws(o ?? {}, a),
      gpu: Ws(r ?? {}, a),
      storage: Ws(l ?? {}, a),
      network: Ws(i ?? {}, a)
    }
  };
}, Ia = ({
  subResource: s,
  breakdownViewType: t,
  timeRange: a,
  typeFilter: n,
  resourceName: o,
  isCustomView: r,
  trendDetailType: l,
  currency: i
}) => {
  const u = {
    timeWindow: no[a || Fs]
  }, c = xr(t, r), p = {
    ...u,
    resourceName: o,
    subResource: s,
    filter: gr(n, t),
    includeTrendForAdditionalCostTypes: l === "all",
    includeTrendForSubResources: l === "include-sub-resource-total",
    currencyCode: i
  };
  return {
    resource: c,
    payload: p
  };
}, gn = ({
  breakdownViewType: s,
  resourceName: t,
  currency: a,
  timeRange: n,
  sortBy: o,
  sortOrder: r,
  pageSize: l,
  offset: i,
  searchKey: u,
  typeFilter: c,
  subResource: p,
  isCustomView: d
}) => {
  const m = xr(s, d), _ = {
    timeWindow: no[n || Fs],
    sortBy: o,
    sortOrder: r,
    searchByName: u || "",
    size: l,
    offset: i,
    resourceName: t,
    subResource: p ?? null,
    filter: gr(c, s),
    currencyCode: a
  };
  return {
    resource: m,
    payload: _
  };
}, Cr = (s, { variant: t }, a, n) => {
  const o = s.subResourceSummary ? Object.values(s.subResourceSummary)[0] : s.summary;
  if (!o)
    throw new Error("Invalid CostSummaryType: Neither summary nor subResourceSummary found");
  const r = o.overall, l = r.trend, i = r.plotPoints || [], u = i.map((_) => _.label), c = {
    datasetName: "Cost Trend",
    yAxisValues: i.map((_) => _.value),
    color: "blue"
  }, p = {
    totalCost: Te(r.totalCost, n),
    delta: l,
    datasets: c,
    xAxisLabels: u,
    isLoading: !1
  };
  let d, m;
  if (t === "expanded") {
    const { potentialSavingsPercentage: _, potentialSavings: g } = r;
    d = {
      variant: "expanded",
      props: {
        potentialSavingsPercentage: _,
        potentialSavings: Te(g, n),
        recommendedCost: Te(r.recommendedCost, n)
      }
    };
  } else
    m = Object.values(Y).map((_) => {
      const g = o[_], { potentialSavings: x, trend: C, totalCost: f, potentialSavingsPercentage: h } = g;
      return {
        isLoading: !1,
        variant: "mini",
        props: {
          category: _.toUpperCase(),
          delta: C,
          variant: "plain",
          categoryPotentialSavingsPercentage: h,
          categoryPotentialSavings: Te(x, n),
          totalCategoryCost: Te(f, n)
        }
      };
    }), m.sort(
      ({ props: { categoryPotentialSavings: _ } }, { props: { categoryPotentialSavings: g } }) => Number(g.slice(1)) - Number(_.slice(1))
    );
  return {
    costTrendProps: p,
    potentialSavingsCardProps: d,
    potentialSavingsMiniCardProps: m
  };
}, El = "cost-visibility-user-currency", uc = eo({
  isCostVisibilityEnabled: !1,
  refetchCostVisibilityMetadata: ks,
  isLoadingMetadata: !1,
  metadataError: null,
  currencyData: {
    currencies: [],
    defaultCurrency: "",
    globalDefaultCurrency: "",
    isLoading: !1,
    error: null,
    refetch: ks
  },
  handleCurrencyChangeForUser: ks,
  breakdownDetailsData: {
    selectedCluster: {
      id: null,
      handleChange: ks
    }
  }
}), $t = () => {
  const s = so(uc);
  if (!s)
    throw new Error("useCostVisibilityContext must be used within a CostVisibilityProvider");
  return s;
}, pc = "cost-opportunities", mc = "costBreakdown", Bf = "costVisibilityMetadata-global-provider", hc = "currencyData-global-provider", _c = (s) => s ? s.enabled && s.installationStatus === "Success" : !1, Uf = () => se({
  queryKey: [Bf],
  queryFn: ({ signal: s }) => tr(s),
  select: ({ result: s }) => (s || []).filter((t) => _c(t.costModuleConfig))
}), fc = () => se({
  queryKey: [hc],
  queryFn: () => xe(z.CURRENCY),
  select: (s) => {
    const { defaultCurrency: t, supportedCurrencies: a } = s?.result || {
      defaultCurrency: "",
      supportedCurrencies: []
    };
    return {
      currencies: (a || []).filter((n) => !!n.code).map((n) => n.code).sort(Ae),
      defaultCurrency: t
    };
  }
}), gc = async (s, t) => {
  const { result: a } = await xe(`${z.CLUSTER_NAMESPACES}/${s}`, { signal: t });
  return (a || []).sort(Ae).map((o) => ({
    label: o,
    value: o
  }));
}, yn = ({ children: s }) => {
  const {
    isFetching: t,
    data: a,
    error: n,
    refetch: o
  } = Uf(), [r, l] = E(null), {
    isFetching: i,
    data: u,
    error: c,
    refetch: p
  } = fc(), d = () => localStorage.getItem(El), m = (h) => {
    localStorage.setItem(El, h);
  }, [_, g] = E(d), x = (h) => {
    m(h), g(h);
  }, C = (h) => {
    l(h);
  };
  ue(() => {
    !d() && u?.defaultCurrency && x(u.defaultCurrency);
  }, [u?.defaultCurrency]);
  const f = de(
    () => ({
      isCostVisibilityEnabled: (a || []).length > 0,
      refetchCostVisibilityMetadata: o,
      isLoadingMetadata: t,
      metadataError: n,
      currencyData: {
        currencies: u?.currencies || [],
        defaultCurrency: _ || "",
        globalDefaultCurrency: u?.defaultCurrency || "",
        isLoading: i,
        error: c,
        refetch: p
      },
      handleCurrencyChangeForUser: x,
      breakdownDetailsData: {
        selectedCluster: {
          id: r,
          handleChange: C
        }
      }
    }),
    [
      a,
      t,
      n,
      u,
      i,
      c,
      r
    ]
  );
  return /* @__PURE__ */ e.jsx(uc.Provider, { value: f, children: s });
}, Ke = () => {
  const { searchParams: s } = Re(), { currencyData: t } = $t(), a = s[qe.TIME_RANGE], n = Object.values(ts).includes(a) ? a : Fs, o = s[Za.typeFilter], r = Object.values(Ns).includes(o) ? o : Ns.ALL, l = s[qe.CURRENCY] || t.defaultCurrency;
  return {
    timeRange: n,
    typeFilter: r,
    currency: l
  };
}, Un = [
  { value: 8, selected: !0 },
  { value: 12, selected: !1 },
  { value: 16, selected: !1 }
], Ff = [
  "pod",
  "deployment",
  "daemonSet",
  "job",
  "rollout",
  "statefulSet",
  "container"
], Vf = ({ datasets: s, xAxisLabels: t, orientation: a }) => {
  const { currency: n } = Ke(), o = de(
    () => ({
      id: "stacked-bar-chart",
      type: a === "horizontal" ? "stackedBarHorizontal" : "stackedBar",
      datasets: Object.entries(s).map(([r, l]) => ({
        datasetName: kt[r],
        color: fa[r],
        yAxisValues: l
      })),
      xAxisLabels: t
    }),
    [s, t, a]
  );
  return /* @__PURE__ */ e.jsx(
    na,
    {
      ...o,
      yScaleTickFormat: (r) => Te(Number(r), n),
      tooltipConfig: {
        datasetValueFormatter: (r) => Te(r, n)
      }
    }
  );
}, Zt = {
  [ts.LAST_24_HOURS]: "Last 24 Hours",
  [ts.LAST_7_DAYS]: "Last 7 Days",
  [ts.LAST_30_DAYS]: "Last 30 Days",
  [ts.LAST_90_DAYS]: "Last 90 Days"
}, Fn = Object.values(
  ts
).map((s) => ({
  label: Zt[s],
  value: s
})), jt = ({ shouldMenuAlignRight: s = !0, stateConfig: t, variant: a, size: n, analyticsAction: o }) => {
  const { searchParams: r } = Re(), l = ae(), i = r[qe.TIME_RANGE], u = Fn.find(
    (p) => p.value === (t?.timeRange ?? i)
  ) ?? {
    label: Zt[Fs],
    value: Fs
  }, c = (p) => {
    if (o && is({
      category: "cost_visibility_timeframe",
      action: o
    }), t) {
      t.setTimeRange(p.value);
      return;
    }
    const d = structuredClone(r);
    l.push({
      search: new URLSearchParams({
        ...d,
        [qe.TIME_RANGE]: p.value
      }).toString()
    });
  };
  return /* @__PURE__ */ e.jsx(
    te,
    {
      inputId: "cost-visibility-time-range-select",
      value: u,
      options: Fn,
      onChange: c,
      shouldMenuAlignRight: s,
      variant: a,
      size: n
    }
  );
}, br = ({
  paginationProps: s,
  chartProps: t,
  isLoading: a,
  hideFilters: n,
  hideCategoryFilter: o,
  selectedCategoryOption: r,
  setSelectedCategoryOption: l,
  setSortOrderOption: i,
  sortOrderOption: u,
  categoryLabel: c = "",
  orientation: p = "horizontal",
  errorConfig: d,
  timeSelectStateConfig: m,
  cardVariant: _,
  timeframeAnalyticsAction: g
}) => {
  const { timeRange: x } = Ke(), C = Zt[x ?? Fs], f = () => {
    const h = "456px";
    if (a)
      return /* @__PURE__ */ e.jsx("div", { style: { height: h }, className: "p-16", children: /* @__PURE__ */ e.jsx("div", { className: "shimmer w-100 h-100" }) });
    if (d)
      return /* @__PURE__ */ e.jsx("div", { style: { height: h }, className: "flex p-16", children: /* @__PURE__ */ e.jsx(hs, { reload: d.refetch }) });
    const { size: b } = s ?? {};
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { style: { height: h }, className: "p-16", children: /* @__PURE__ */ e.jsx(Vf, { orientation: p, ...t }) }),
      s && b > Un[0].value && /* @__PURE__ */ e.jsx(
        ui,
        {
          rootClassName: "flex dc__content-space px-20",
          ...s,
          pageSizeOptions: Un
        }
      )
    ] });
  };
  return /* @__PURE__ */ e.jsxs(Ze, { variant: _, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space px-16 py-12 dc__gap-16 border__secondary--bottom", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-4 lh-1-5 fs-13", children: m ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fw-6", children: "Cost breakdown for" }),
        /* @__PURE__ */ e.jsx(
          jt,
          {
            stateConfig: m,
            variant: We.COMPACT,
            size: P.small,
            analyticsAction: g
          }
        )
      ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsxs("span", { className: "cn-9 fw-6", children: [
          "Cost breakdown ",
          c && `by ${ta(c)}`
        ] }),
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fw-4", children: "·" }),
        /* @__PURE__ */ e.jsx("span", { className: "cn-7 fw-4", children: C })
      ] }) }),
      !n && /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox", children: [
        !o && /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "overview-cost-breakdown-select",
            value: r,
            onChange: l,
            options: Ea,
            variant: We.COMPACT,
            size: P.small,
            shouldMenuAlignRight: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "overview-cost-breakdown-sort-select",
            value: u,
            onChange: i,
            options: _r,
            variant: We.COMPACT,
            size: P.small,
            shouldMenuAlignRight: !0
          }
        )
      ] })
    ] }),
    f()
  ] });
}, Gf = (s) => {
  const t = s.summary || s.subResourceSummary && Object.values(s.subResourceSummary)[0]?.summary;
  if (!t)
    return {
      datasets: {
        [Y.CPU]: [],
        [Y.MEMORY]: [],
        [Y.GPU]: [],
        [Y.STORAGE]: [],
        [Y.NETWORK]: []
      },
      xAxisLabels: []
    };
  if (s.subResourceSummary) {
    const a = Object.keys(s.subResourceSummary), n = a;
    return {
      datasets: {
        [Y.CPU]: a.map(
          (r) => s.subResourceSummary[r].summary.cpu.totalCost
        ),
        [Y.MEMORY]: a.map(
          (r) => s.subResourceSummary[r].summary.memory.totalCost
        ),
        [Y.GPU]: a.map(
          (r) => s.subResourceSummary[r].summary.gpu.totalCost
        ),
        [Y.STORAGE]: a.map(
          (r) => s.subResourceSummary[r].summary.storage.totalCost
        ),
        [Y.NETWORK]: a.map(
          (r) => s.subResourceSummary[r].summary.network.totalCost
        )
      },
      xAxisLabels: n
    };
  }
  return {
    datasets: {
      [Y.CPU]: [t.cpu.totalCost],
      [Y.MEMORY]: [t.memory.totalCost],
      [Y.GPU]: [t.gpu.totalCost],
      [Y.STORAGE]: [t.storage.totalCost],
      [Y.NETWORK]: [t.network.totalCost]
    },
    xAxisLabels: ["Total"]
  };
}, xc = ({
  items: s,
  totalCount: t
}) => {
  const a = s.map((o) => o.name);
  return {
    chartProps: {
      datasets: {
        [Y.CPU]: s.map((o) => o.cpuCost),
        [Y.MEMORY]: s.map((o) => o.memoryCost),
        [Y.GPU]: s.map((o) => o.gpuCost),
        [Y.STORAGE]: s.map((o) => o.storageCost),
        [Y.NETWORK]: s.map((o) => o.networkCost)
      },
      xAxisLabels: a
    },
    totalItems: t
  };
}, Wf = ({ breakdownViewType: s, itemName: t }) => {
  const { view: a } = ce(), { timeRange: n, currency: o, typeFilter: r } = Ke(), { isLoading: l, data: i, error: u, refetch: c } = se({
    queryKey: ["costBreakdown", "resourceKind", s, o, n, r, t, a],
    queryFn: ({ signal: d }) => Oa({
      ...Ia({
        breakdownViewType: s,
        currency: o,
        timeRange: n,
        // No need to handle custom view since its in cost-overview page
        resourceName: t,
        isCustomView: a === Z.CUSTOM_VIEWS,
        typeFilter: r,
        subResource: Ff,
        trendDetailType: "total_only"
      }),
      signal: d
    }),
    select: (d) => Gf(d.result)
  }), p = de(() => i ?? {}, [i]);
  return /* @__PURE__ */ e.jsx(
    br,
    {
      ...l ? { isLoading: !0 } : {
        chartProps: p,
        hideFilters: !0,
        categoryLabel: "Resource Kind",
        orientation: "vertical",
        errorConfig: u ? { refetch: c } : null
      }
    }
  );
}, $f = ({ breakdownViewType: s, itemName: t, subResource: a }) => {
  const { view: n } = ce(), [o, r] = E(
    _r[0]
  ), { pageSize: l, changePage: i, changePageSize: u, offset: c } = qn({
    defaultPageSize: Un[0].value
  }), { timeRange: p, currency: d, typeFilter: m } = Ke(), { isLoading: _, data: g, error: x, refetch: C } = se({
    queryKey: [
      "costBreakdown",
      l,
      t,
      s,
      c,
      o,
      m,
      p,
      d,
      JSON.stringify(a),
      n
    ],
    queryFn: ({ signal: b }) => pa({
      ...gn({
        breakdownViewType: s,
        currency: d,
        pageSize: l,
        offset: c,
        sortOrder: o.value.sortOrder,
        timeRange: p,
        typeFilter: m,
        // No need to handle custom view since its in cost-overview page
        resourceName: t,
        isCustomView: n === Z.CUSTOM_VIEWS,
        searchKey: "",
        sortBy: o.value.sortBy,
        subResource: a
      }),
      signal: b
    }),
    select: (b) => xc(b.result.breakdownsBySubResource[a[0]])
  }), { chartProps: f, totalItems: h } = de(() => g ?? {}, [g]);
  return /* @__PURE__ */ e.jsx(
    br,
    {
      ..._ ? { isLoading: !0 } : {
        chartProps: f,
        paginationProps: { changePage: i, offset: c, pageSize: l, size: h, changePageSize: u },
        categoryLabel: a[0],
        setSortOrderOption: r,
        sortOrderOption: o,
        hideCategoryFilter: !0,
        orientation: "horizontal",
        errorConfig: x ? { refetch: C } : null
      }
    }
  );
}, Kf = ({ type: s, props: t }) => s === "resourceKind" ? /* @__PURE__ */ e.jsx(Wf, { ...t }) : /* @__PURE__ */ e.jsx($f, { ...t }), Cc = ({
  hideCategoryFilter: s = !1,
  timeframeAnalyticsAction: t,
  breakdownCategoryAnalyticsAction: a
}) => {
  const { pageSize: n, changePage: o, offset: r, changePageSize: l } = qn({
    defaultPageSize: Un[0].value
  }), [i, u] = E(
    _r[0]
  ), [c, p] = E(
    Ea[0]
  ), [d, m] = E(Fs), { currency: _, typeFilter: g } = Ke(), { data: x, isFetching: C, error: f, refetch: h } = se({
    queryKey: [
      mc,
      { pageSize: n, offset: r, sortOrder: i, selectedCategoryOption: c, currency: _, timeRange: d, typeFilter: g }
    ],
    queryFn: ({ signal: j }) => pa({
      ...gn({
        breakdownViewType: c.value,
        currency: _,
        pageSize: n,
        offset: r,
        sortOrder: i.value.sortOrder,
        timeRange: d,
        typeFilter: g,
        resourceName: null,
        isCustomView: !1,
        searchKey: "",
        sortBy: i.value.sortBy,
        subResource: null
      }),
      signal: j
    }),
    select: (j) => xc(j?.result?.overallBreakdown ?? { items: [], totalCount: 0 })
  }), { chartProps: b, totalItems: S } = de(() => x ?? {}, [x]), O = (j) => {
    a && is({
      category: "cost_visibility_breakdown",
      action: `${a}_BY_${j.value.toUpperCase()}`
    }), p(j);
  };
  return /* @__PURE__ */ e.jsx(
    br,
    {
      ...C ? { isLoading: !0 } : {
        chartProps: b,
        paginationProps: {
          changePage: o,
          offset: r,
          pageSize: n,
          size: S,
          changePageSize: l
        },
        isLoading: !1,
        sortOrderOption: i,
        setSortOrderOption: u,
        orientation: "horizontal",
        errorConfig: f ? { refetch: h } : null,
        ...s ? { hideCategoryFilter: !0 } : {
          selectedCategoryOption: c,
          setSelectedCategoryOption: O
        },
        timeSelectStateConfig: { timeRange: d, setTimeRange: m },
        // All cards in Overview should have outlined secondary variant
        cardVariant: "secondary--outlined",
        timeframeAnalyticsAction: t
      }
    }
  );
}, jn = (s) => {
  const { serverMode: t } = Ot(), { variant: a } = s;
  return a === "overview" ? /* @__PURE__ */ e.jsx(
    Cc,
    {
      hideCategoryFilter: t === Vt.EA_ONLY,
      timeframeAnalyticsAction: "COST_OVERVIEW_COST_BREAKDOWN_TIMEFRAME",
      breakdownCategoryAnalyticsAction: "COST_OVERVIEW_COST_BREAKDOWN"
    }
  ) : /* @__PURE__ */ e.jsx(Kf, { ...s });
}, Hf = async (s) => {
  try {
    return await Aa(z.CURRENCY, { defaultCurrency: s }), !0;
  } catch (t) {
    return ve(t), !1;
  }
}, va = ({
  variant: s = We.DEFAULT,
  useDefaultValue: t = !1,
  analyticsAction: a
}) => {
  const { searchParams: n } = Re(), o = ae(), {
    currencyData: { isLoading: r, error: l, refetch: i, currencies: u, globalDefaultCurrency: c, defaultCurrency: p },
    handleCurrencyChangeForUser: d
  } = $t(), [m, _] = E(!1), g = n[qe.CURRENCY], x = () => r ? null : !t && g ? { label: g, value: g } : t ? { label: c, value: c } : p ? { label: p, value: p } : null, C = (u || []).map((b) => ({
    label: b === c ? `${b} (Default)` : b,
    value: b
  })), f = x(), h = async (b) => {
    if (a && is({
      category: "cost-configurations",
      action: a
    }), t) {
      _(!0);
      const O = await Hf(b.value);
      _(!1), O && (d(""), i());
      return;
    }
    d(b.value);
    const S = structuredClone(n);
    o.push({
      search: new URLSearchParams({
        ...S,
        [qe.CURRENCY]: b.value
      }).toString()
    });
  };
  return /* @__PURE__ */ e.jsx(
    te,
    {
      inputId: "cost-visibility-currency-select",
      value: f,
      options: C,
      variant: s,
      onChange: h,
      isLoading: r || m,
      optionListError: l,
      reloadOptionList: i,
      isClearable: !1
    }
  );
}, bc = () => /* @__PURE__ */ e.jsxs("div", { className: "enable-cost-visibility-empty-state flex-grow-1 h-100 dc__grid dc__content-center pt-40 px-20 dc__overflow-hidden bg__primary", children: [
  /* @__PURE__ */ e.jsx("div", { className: "enable-cost-visibility-empty-state__illustration flex", children: /* @__PURE__ */ e.jsx(
    pi,
    {
      name: "no-cluster-cost-enabled",
      imageProps: {
        alt: "",
        role: "presentation",
        width: "100%",
        height: "100%",
        className: "br-8 border__secondary bg__primary dc__blend-luminosity"
      }
    }
  ) }),
  /* @__PURE__ */ e.jsx("div", { className: "enable-cost-visibility-empty-state__content flex dc__zi-1", children: /* @__PURE__ */ e.jsx("div", { className: "w-400 flex", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-24 dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "br-12 border__primary bg__primary flex", children: /* @__PURE__ */ e.jsx(D, { name: "ic-coins-color-animated", color: null, size: 64 }) }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 dc__text-center", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-20 fw-6 lh-1-5", children: "Track your Infra Spend" }),
      /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-8 fs-16 fw-4 lh-1-5", children: "Get insights into your infrastructure spending and cost optimization opportunity for this cluster" })
    ] }),
    /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "enable-cost-visibility-button",
        component: me.link,
        linkProps: { to: R.COST_CONFIGURATIONS },
        text: "Enable Cost Tracking",
        endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-right", color: null }),
        size: P.xl
      }
    )
  ] }) }) })
] }), Yf = () => {
  const { breakdownViewType: s } = ce(), { timeRange: t } = Ke(), { searchParams: a } = Re(), n = a[qe.CURRENCY] || "";
  return /* @__PURE__ */ e.jsx(
    as,
    {
      to: us(
        Q(R.COST_BREAKDOWN_ROUTE, { breakdownViewType: s }),
        t,
        n
      ),
      children: /* @__PURE__ */ e.jsx(tt, { isActive: !1, heading: ta(s) })
    }
  );
}, zf = async (s, t) => {
  switch (s) {
    case V.CLUSTERS: {
      const { result: a } = await tr(t);
      return (a || []).filter((n) => _c(n.costModuleConfig)).map((n) => ({ name: n.cluster_name, id: n.id })).sort((n, o) => Ae(n.name, o.name));
    }
    case V.APPLICATIONS:
      return (await vp() || []).flatMap((o) => o.appList || []).map((o) => ({ name: o.name })).sort((o, r) => Ae(o.name, r.name));
    case V.ENVIRONMENTS:
      return (await Ep() || []).flatMap((o) => o.envList || []).map((o) => ({ name: o.name })).sort((o, r) => Ae(o.name, r.name));
    case V.PROJECTS: {
      const { result: a } = await er();
      return (a || []).map((n) => ({ name: n.name })).sort((n, o) => Ae(n.name, o.name));
    }
    default:
      return [];
  }
}, qf = () => {
  const { itemName: s, breakdownViewType: t } = ce(), { breakdownDetailsData: a } = $t(), n = ae(), o = he(), {
    data: r,
    isLoading: l,
    error: i,
    refetch: u
  } = se({
    queryFn: ({ signal: d }) => zf(t, d),
    queryKey: ["breakdownViewItemSelectorOptions", t]
  }), c = de(
    () => (r || []).map((d) => ({
      label: d.name,
      value: d.name,
      id: d.id
    })).sort((d, m) => Ae(d.label, m.label)),
    [r]
  );
  ue(
    () => () => {
      a.selectedCluster.handleChange(null);
    },
    []
  ), ue(() => {
    if (s && r) {
      const d = (r || []).find((m) => m.name === s) || null;
      a.selectedCluster.handleChange(d?.id);
    } else
      a.selectedCluster.handleChange(null);
  }, [s, r]);
  const p = (d) => {
    const m = o.pathname.split("/"), _ = m.findIndex((g) => g === t);
    _ !== -1 && (m[_ + 1] = d.value, n.push({
      pathname: m.join("/"),
      search: o.search
    }));
  };
  return /* @__PURE__ */ e.jsx(
    te,
    {
      inputId: `breakdown-view-${t}-selector`,
      options: c || [],
      value: {
        label: s,
        value: s
      },
      isLoading: l,
      optionListError: i,
      reloadOptionList: u,
      placeholder: `Select ${t}`,
      onChange: p,
      variant: We.BORDER_LESS,
      size: P.xl
    }
  );
}, Xf = [
  {
    key: "overview",
    route: R.COST_VISIBILITY_OVERVIEW,
    heading: "Overview"
  },
  {
    key: "configurations",
    route: R.COST_CONFIGURATIONS,
    heading: "Configurations"
  },
  {
    key: "breakdown",
    route: R.COST_BREAKDOWN_ROUTE,
    heading: "Cost Breakdown"
  }
], Jf = (s, t, a) => {
  const n = s.split("?")[0].split("#")[0], o = {
    "cost-visibility": {
      component: /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "redirect-to-overview-btn",
          component: me.link,
          size: P.xs,
          icon: /* @__PURE__ */ e.jsx(D, { name: "ic-cost-visibility", color: null }),
          variant: U.borderLess,
          linkProps: {
            to: us(R.COST_VISIBILITY_OVERVIEW, t, a)
          },
          ariaLabel: "Cost Visibility",
          showAriaLabelInTippy: !1
        }
      ),
      linked: !0
    }
  };
  return Xf.forEach(({ key: r, route: l, heading: i }) => {
    const u = !!Po(n, { path: l, exact: !0 });
    if (r === "breakdown" && !u) {
      o[r] = {
        component: /* @__PURE__ */ e.jsx(
          as,
          {
            to: us(
              Q(l, { breakdownViewType: V.CLUSTERS }),
              t,
              a
            ),
            children: /* @__PURE__ */ e.jsx(tt, { isActive: u, heading: i })
          }
        ),
        linked: !1
      };
      return;
    }
    o[r] = {
      component: /* @__PURE__ */ e.jsx(tt, { isActive: u, heading: i }),
      linked: !u
    };
  }), o[":breakdownViewType"] = Po(n, { path: R.COST_BREAKDOWN_ROUTE, exact: !0 }) ? null : {
    component: /* @__PURE__ */ e.jsx(Yf, {}),
    linked: !1
  }, Object.values(Tn).forEach((r) => {
    const l = r !== Tn.DETAIL ? `:${r}` : `:${r}?`;
    o[l] = {
      component: null,
      linked: !1
    };
  }), o[`:${Tn.ITEM_NAME}`] = {
    component: /* @__PURE__ */ e.jsx(qf, {}),
    linked: !1
  }, { alias: o };
}, Sr = () => {
  const { pathname: s } = he(), { timeRange: t } = Ke(), { searchParams: a } = Re(), n = a[qe.CURRENCY] || "", { path: o } = Ts(), { breadcrumbs: r } = nt(Jf(s, t, n), [
    s,
    t,
    n
  ]), l = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: r });
  return /* @__PURE__ */ e.jsx(
    xt,
    {
      isBreadcrumbs: !0,
      breadCrumbs: l,
      tippyProps: {
        isTippyCustomized: !0,
        tippyHeader: "How is cost being calculated?",
        tippyMessage: "Costs are displayed only for clusters with cost module enabled. For multi-cluster projects or applications, data reflects only for the enabled clusters.",
        additionalContent: o !== R.COST_CONFIGURATIONS ? /* @__PURE__ */ e.jsx("div", { className: "flex left pb-12 px-12", children: /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "go-to-config-page-header-info-tippy",
            component: me.link,
            variant: U.text,
            text: "Go to Configurations",
            endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-right", color: null }),
            linkProps: { to: R.COST_CONFIGURATIONS }
          }
        ) }) : null,
        tippyRedirectLink: "COST_CALCULATION"
      },
      docPath: sr.COST_BREAKDOWN
    }
  );
}, Vo = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
    /* @__PURE__ */ e.jsx("span", { className: "shimmer h-20 w-40" }),
    /* @__PURE__ */ e.jsx("span", { className: "shimmer h-20 w-40" })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "shimmer h-8 br-4" })
] }), Sc = ({ title: s, value: t, coveragePercent: a, backgroundColor: n = "LimeGreen500" }) => {
  const { appTheme: o } = Tp(), r = Ap[o][n];
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 cn-9", children: s }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-14 lh-1-5 fw-6 cn-9", children: t })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "h-8 br-4 bcb-1", children: /* @__PURE__ */ e.jsx("div", { className: "h-100 br-4", style: { width: `${a}%`, backgroundColor: r } }) })
  ] });
}, Qf = ({ resourceType: s, resourceName: t, cost: a }) => {
  const n = s === Qs.APPLICATIONS ? "App" : "Pipeline";
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col px-10 py-6 fs-12 fw-4 lh-18", children: [
    /* @__PURE__ */ e.jsxs("span", { children: [
      n,
      ": ",
      t
    ] }),
    /* @__PURE__ */ e.jsxs("span", { children: [
      "Cost: ",
      a
    ] })
  ] });
}, Zf = () => se({
  queryKey: ["approvalConfig"],
  queryFn: ({ signal: s }) => xe(z.APPROVAL_POLICY, { signal: s }),
  select: ({ result: s }) => s
}), eg = ({
  resourceType: s,
  timeWindow: t,
  currency: a
}) => se({
  queryKey: ["appOverviewCostBreakdown", s, t, a],
  queryFn: ({ signal: n }) => pa({
    payload: {
      currencyCode: a,
      offset: 0,
      size: 10,
      sortBy: "totalCost",
      sortOrder: Ss.DESC,
      timeWindow: t,
      searchByName: ""
    },
    resource: s,
    signal: n
  }),
  select: ({ result: n }) => {
    const o = n?.overallBreakdown?.items?.[0]?.totalCost;
    return o ? (n?.overallBreakdown?.items || []).map((r) => ({
      name: r.name,
      totalCost: Te(r.totalCost, a, 5),
      formattedCost: Te(r.totalCost, a),
      percentage: r.totalCost / o * 100
    })) : [];
  },
  enabled: !!a
}), vl = ({ title: s, coveredCount: t, totalCount: a }) => {
  const n = a ? (t / a * 100).toFixed(2) : 0;
  return /* @__PURE__ */ e.jsx("div", { className: "p-16", children: /* @__PURE__ */ e.jsx(Sc, { title: s, value: `${n}%`, coveragePercent: Number(n) }) });
}, lT = () => {
  const { isFetching: s, data: t, isError: a, refetch: n } = Zf(), { totalProdPipelineCount: o, pipelineCountWithConfigApproval: r, pipelineCountWithDeploymentApproval: l } = t ?? {
    totalPipelineCount: 0,
    pipelineCountWithConfigApproval: 0,
    pipelineCountWithDeploymentApproval: 0
  }, i = () => s ? /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half", children: [
    /* @__PURE__ */ e.jsx("div", { className: "p-16", children: /* @__PURE__ */ e.jsx(Vo, {}) }),
    /* @__PURE__ */ e.jsx("div", { className: "p-16", children: /* @__PURE__ */ e.jsx(Vo, {}) })
  ] }) : a ? /* @__PURE__ */ e.jsx(hs, { subTitle: "", reload: n }) : /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half", children: [
    /* @__PURE__ */ e.jsx(
      vl,
      {
        title: "Config change approval",
        totalCount: o,
        coveredCount: r
      }
    ),
    /* @__PURE__ */ e.jsx(
      vl,
      {
        title: "Deployment approval",
        totalCount: o,
        coveredCount: l
      }
    )
  ] });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-20 lh-1-5 fw-4 cn-9", children: "Best Practices" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col br-8 bg__primary border__secondary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-16 flexbox-col border__secondary--bottom", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: "Approval Coverage" }),
        /* @__PURE__ */ e.jsx("span", { children: "Production pipelines with active approval policies" })
      ] }),
      i()
    ] })
  ] });
}, Tl = ({ isMetadataFetching: s, resourceType: t, timeWindow: a, currency: n }) => {
  const {
    isFetching: o,
    isError: r,
    data: l,
    refetch: i
  } = eg({ resourceType: t, timeWindow: a, currency: n }), u = t === Qs.APPLICATIONS ? "applications" : "build pipelines", c = () => o || s ? Array.from({ length: 5 }).map((p, d) => /* @__PURE__ */ e.jsx(Vo, {}, d)) : r ? /* @__PURE__ */ e.jsx(hs, { subTitle: "", reload: i }) : !l || l.length === 0 ? /* @__PURE__ */ e.jsx(
    cn,
    {
      iconName: "ic-info-outline",
      title: `No ${u} cost data available`,
      subtitle: `${ta(u)} costs are not available for the selected duration`
    }
  ) : l.map((p, d) => /* @__PURE__ */ e.jsx(
    we,
    {
      content: /* @__PURE__ */ e.jsx(
        Qf,
        {
          resourceType: t,
          resourceName: p.name,
          cost: p.totalCost
        }
      ),
      alwaysShowTippyOnHover: !0,
      followCursor: !0,
      children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
        Sc,
        {
          title: p.name,
          value: p.formattedCost,
          coveragePercent: p.percentage,
          backgroundColor: "SkyBlue400"
        }
      ) })
    },
    `${d}-${p.name}`
  ));
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col bg__primary border__secondary br-8", children: [
    /* @__PURE__ */ e.jsx("div", { className: "px-16 py-12 border__secondary--bottom", children: /* @__PURE__ */ e.jsxs("span", { className: "fs-14 fw-6 lh-1-5 cn-9", children: [
      "Top 10 costly ",
      t === Qs.APPLICATIONS ? "applications" : "build pipelines"
    ] }) }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12 px-16 pt-12 pb-16", children: c() })
  ] });
}, sg = () => {
  const { isCostVisibilityEnabled: s, isLoadingMetadata: t, currencyData: a } = $t(), [n, o] = E(ts.LAST_30_DAYS), r = (i) => {
    o(i.value);
  }, l = a?.defaultCurrency;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
        /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-20 lh-1-5 fw-4 cn-9", children: "Cost Visibility" }),
        s && /* @__PURE__ */ e.jsx(
          Tt,
          {
            heading: "How costs are calculated?",
            infoText: "Costs are displayed only for clusters with cost module enabled. For multi-cluster projects or applications, data reflects only for the enabled clusters.",
            additionalContent: /* @__PURE__ */ e.jsx("div", { className: "flex left pb-12 px-12", children: /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: "go-to-config-page-header-info-tippy",
                component: me.link,
                variant: U.text,
                text: "Go to Configurations",
                endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-right", color: null }),
                linkProps: { to: R.COST_CONFIGURATIONS }
              }
            ) }),
            buttonPadding: "p-6"
          }
        )
      ] }),
      s && /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-12", children: [
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "select-cost-time-range",
            options: Fn,
            onChange: r,
            shouldMenuAlignRight: !0,
            variant: We.COMPACT,
            value: Xt(Fn, n)
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__divider" }),
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "cost-visibility-details",
            text: "Details",
            size: P.medium,
            variant: U.text,
            component: me.link,
            linkProps: {
              to: R.COST_VISIBILITY_OVERVIEW
            },
            endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-caret-right", color: null })
          }
        )
      ] })
    ] }),
    t || s ? /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-half dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(
        Tl,
        {
          timeWindow: n,
          resourceType: Qs.APPLICATIONS,
          isMetadataFetching: t,
          currency: l
        }
      ),
      /* @__PURE__ */ e.jsx(
        Tl,
        {
          timeWindow: n,
          resourceType: Qs.CI_PIPELINES,
          isMetadataFetching: t,
          currency: l
        }
      )
    ] }) : /* @__PURE__ */ e.jsx("div", { className: "border__secondary bg__primary br-8 flex column dc__gap-12 h-200", children: /* @__PURE__ */ e.jsx(
      cn,
      {
        iconName: "ic-cost-visibility",
        title: "Cost visibility is not enabled",
        subtitle: "Get insights into your infrastructure spending and cost optimization opportunities",
        buttonConfig: {
          dataTestId: "redirect-to-cost-visibility",
          text: "Go to configurations",
          endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-right", color: null }),
          size: P.small,
          variant: U.borderLess,
          component: me.link,
          linkProps: { to: R.COST_CONFIGURATIONS }
        }
      }
    ) })
  ] });
}, iT = () => /* @__PURE__ */ e.jsx(yn, { children: /* @__PURE__ */ e.jsx(sg, {}) }), Nc = eo(null), cT = ({ children: s, renderClusterForm: t }) => {
  const a = de(() => ({ renderClusterForm: t }), [t]);
  return /* @__PURE__ */ e.jsx(Nc.Provider, { value: a, children: s });
}, tg = () => {
  const s = so(Nc);
  if (!s)
    throw new Error("CostVisibilityRenderContext cannot be used outside CostVisibilityRender scope");
  return s;
}, Ga = ({ children: s }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__overflow-auto bg__primary flex-grow-1 w-100", children: [
  /* @__PURE__ */ e.jsx(Sr, {}),
  s
] }), Ba = ({ row: s, signals: t }) => {
  const { timeRange: a } = Ke(), { searchParams: n } = Re(), o = n[qe.CURRENCY] || "", { name: r } = s.data[fr[s.data.variant]], { itemName: l, breakdownViewType: i } = ce(), u = !!l, c = Ms(null), p = s.data.variant !== ne.K8S_RESOURCE, d = () => {
    u && is({
      category: "cost-breakdown-item",
      action: `COST_BREAKDOWN_BY_${i.toUpperCase()}_LIST_ITEM`
    });
  };
  return ue(() => {
    const m = ({ detail: { activeRowData: _ } }) => {
      p && _.id === s.id && c.current?.click();
    };
    return t.addEventListener(Sa.ENTER_PRESSED, m), () => {
      t.removeEventListener(Sa.ENTER_PRESSED, m);
    };
  }, []), p ? /* @__PURE__ */ e.jsx(
    as,
    {
      to: us(
        Q(`${R.COST_BREAKDOWN_ROUTE}/${R.COST_BREAKDOWN_DETAIL}`, {
          breakdownViewType: xf[s.data.variant],
          itemName: r,
          view: Z.OVERVIEW
        }),
        a,
        o
      ),
      className: "dc__link dc__truncate",
      ref: c,
      onClick: d,
      children: r
    }
  ) : /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: r });
}, Al = ({ row: s }) => s.data.variant !== ne.CLUSTER && s.data.variant !== ne.ENVIRONMENT ? null : /* @__PURE__ */ e.jsx(yt, { label: s.data[fr[s.data.variant]].type, size: P.xxs }), ag = () => /* @__PURE__ */ e.jsx(D, { name: "ic-bg-cluster", color: null, size: 24 }), ng = () => /* @__PURE__ */ e.jsx(D, { name: "ic-bg-environment", color: null, size: 24 }), og = () => /* @__PURE__ */ e.jsx(D, { name: "ic-folder-color", color: null, size: 24 }), rg = () => /* @__PURE__ */ e.jsx(D, { name: "ic-devtron-app", color: null, size: 24 }), lg = ({ row: s }) => /* @__PURE__ */ e.jsxs("span", { children: [
  s.data.appDetails.envCount || 0,
  " ",
  s.data.appDetails.envCount === 1 ? "Environment" : "Environments"
] }), yl = ({ row: s }) => {
  if (s.data.variant !== ne.ENVIRONMENT && s.data.variant !== ne.PROJECT)
    return null;
  const t = s.data[fr[s.data.variant]].appCount || 0;
  return /* @__PURE__ */ e.jsxs("span", { className: "cn-9 fs-13 fw-4 lh-20", children: [
    t,
    " ",
    t === 1 ? "Application" : "Applications"
  ] });
}, ig = ({ row: s }) => {
  if (s.data.variant !== ne.CLUSTER)
    return null;
  const t = s.data.clusterDetails.clusterProvider, a = yp[t];
  return /* @__PURE__ */ e.jsx(
    yt,
    {
      startIconProps: a ? {
        name: a
      } : null,
      label: jp[t] || t,
      variant: "neutral",
      size: P.xxs
    }
  );
}, cg = ({ row: s }) => s.data.variant !== ne.K8S_RESOURCE ? null : /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: s.data.resourceDetails.kind || "--" }), dg = ({ row: s }) => s.data.variant !== ne.K8S_RESOURCE ? null : /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: s.data.resourceDetails.namespace || "--" }), Ec = (s, t) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-2", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-2", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20", children: "Cluster:" }),
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20", children: s || "--" })
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-2", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-20", children: "Namespace:" }),
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20", children: t || "--" })
  ] })
] }), ug = ({ row: s }) => s.data.variant !== ne.K8S_RESOURCE ? null : /* @__PURE__ */ e.jsx(
  we,
  {
    content: Ec(s.data.resourceDetails.clusterName, s.data.resourceDetails.namespace),
    alwaysShowTippyOnHover: !0,
    children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: s.data.resourceDetails.environmentName || "--" })
  }
), pg = ({
  variant: s,
  detailViewItemName: t,
  isDetailView: a,
  isCustomView: n,
  breakdownViewType: o,
  view: r
}) => {
  switch (s) {
    case ne.CLUSTER:
      return [
        {
          field: "clusterIcon",
          label: "",
          size: { fixed: 24 },
          CellComponent: ag,
          horizontallySticky: !0
        },
        {
          field: Ie.NAME,
          label: "Cluster",
          size: {
            range: {
              startWidth: t ? 336 : 390,
              maxWidth: 500,
              minWidth: 100
            }
          },
          CellComponent: Ba,
          isSortable: !0,
          horizontallySticky: !0
        },
        {
          field: "clusterProvider",
          label: "Provider",
          size: {
            range: {
              startWidth: 150,
              maxWidth: 250,
              minWidth: 120
            }
          },
          CellComponent: ig
        },
        {
          field: "type",
          label: "Type",
          size: {
            range: {
              startWidth: 120,
              maxWidth: 250,
              minWidth: 80
            }
          },
          CellComponent: Al
        },
        ...Ma
      ];
    case ne.ENVIRONMENT:
      return [
        {
          field: "envIcon",
          label: "",
          size: { fixed: 24 },
          CellComponent: ng,
          horizontallySticky: !0
        },
        {
          field: Ie.NAME,
          label: "Environment",
          size: {
            range: {
              startWidth: t ? 336 : 390,
              maxWidth: 500,
              minWidth: 100
            }
          },
          CellComponent: Ba,
          isSortable: !0,
          horizontallySticky: !0
        },
        {
          field: "type",
          label: "Type",
          size: {
            range: {
              startWidth: 120,
              maxWidth: 250,
              minWidth: 80
            }
          },
          CellComponent: Al
        },
        ...a ? [] : [
          {
            field: "appCount",
            label: "Applications Count",
            size: {
              range: {
                startWidth: 150,
                maxWidth: 250,
                minWidth: 80
              }
            },
            CellComponent: yl
          }
        ],
        ...Ma
      ];
    case ne.APPLICATION:
      return [
        {
          field: "appIcon",
          label: "",
          size: { fixed: 24 },
          CellComponent: rg,
          horizontallySticky: !0
        },
        {
          field: Ie.NAME,
          label: "App Name",
          size: {
            range: {
              startWidth: t ? 336 : 390,
              maxWidth: 500,
              minWidth: 100
            }
          },
          CellComponent: Ba,
          isSortable: !0,
          horizontallySticky: !0
        },
        ...a ? [] : [
          {
            field: "envCount",
            label: "Environments",
            size: {
              range: {
                startWidth: 150,
                maxWidth: 250,
                minWidth: 80
              }
            },
            CellComponent: lg
          }
        ],
        ...Ma
      ];
    case ne.PROJECT:
      return [
        {
          field: "projectIcon",
          label: "",
          size: { fixed: 24 },
          CellComponent: og,
          horizontallySticky: !0
        },
        {
          field: Ie.NAME,
          label: "Project Name",
          size: {
            range: {
              startWidth: t ? 336 : 390,
              maxWidth: 500,
              minWidth: 100
            }
          },
          CellComponent: Ba,
          isSortable: !0,
          horizontallySticky: !0
        },
        ...a ? [] : [
          {
            field: "appCount",
            label: "Applications Count",
            size: {
              range: {
                startWidth: 150,
                maxWidth: 250,
                minWidth: 80
              }
            },
            CellComponent: yl
          }
        ],
        ...Ma
      ];
    case ne.K8S_RESOURCE:
      return [
        {
          field: Ie.NAME,
          label: n || !t ? "Resource Name" : t,
          size: {
            range: {
              startWidth: 300,
              maxWidth: 450,
              minWidth: 100
            }
          },
          CellComponent: Ba,
          isSortable: !0,
          horizontallySticky: !0
        },
        ...n || o === V.CLUSTERS && r === Z.RESOURCE_KINDS ? [
          {
            field: Ie.NAMESPACE,
            label: "Namespace",
            size: {
              range: {
                startWidth: 120,
                maxWidth: 250,
                minWidth: 80
              }
            },
            isSortable: !0,
            CellComponent: dg
          }
        ] : [],
        ...r === Z.RESOURCE_KINDS && (o === V.APPLICATIONS || o === V.PROJECTS) ? [
          {
            field: Ie.ENVIRONMENT,
            label: "Environment",
            size: {
              range: {
                startWidth: 120,
                maxWidth: 250,
                minWidth: 80
              }
            },
            isSortable: !0,
            CellComponent: ug
          }
        ] : [],
        ...n ? [
          {
            field: "kind",
            label: "Kind",
            size: {
              range: {
                startWidth: 120,
                maxWidth: 250,
                minWidth: 80
              }
            },
            CellComponent: cg
          }
        ] : [],
        ...Ma
      ];
    default:
      return null;
  }
}, mg = (s) => {
  const t = s.get(Za.typeFilter);
  return {
    currency: s.get(qe.CURRENCY),
    timeRange: s.get(qe.TIME_RANGE),
    typeFilter: t,
    [Mn]: s.get(Mn),
    [Bn]: s.get(Bn)
  };
}, Ua = (s) => {
  const t = s.metadata?.clusterType === "prod" ? "Production" : "Non-Production", a = s.metadata ? t : null, n = s.metadata?.envType === "prod" ? "Production" : "Non-Production", o = s.metadata ? n : null, r = s.name || "-";
  return {
    clusterDetails: {
      name: r,
      type: a,
      clusterProvider: s.metadata?.clusterProvider || "Unknown"
    },
    appDetails: {
      name: r,
      envCount: s.metadata?.envCount || null
    },
    resourceDetails: {
      name: r,
      namespace: s.metadata?.namespace || "",
      kind: s.metadata?.kind || "",
      environmentName: s.metadata?.envName || "",
      clusterName: s.metadata?.clusterName || ""
    },
    envDetails: {
      name: r,
      type: o,
      appCount: s.metadata?.applicationCount || null
    },
    projectDetails: {
      name: r,
      appCount: s.metadata?.applicationCount || null
    }
  };
}, vc = (s, t, a) => s.map((n) => {
  const o = {
    variant: t,
    id: vs(),
    [Y.CPU]: {
      value: Te(n.cpuCost, a)
    },
    [Y.MEMORY]: {
      value: Te(n.memoryCost, a)
    },
    [Y.GPU]: {
      value: Te(n.gpuCost, a)
    },
    [Y.STORAGE]: {
      value: Te(n.storageCost, a)
    },
    [Y.NETWORK]: {
      value: Te(n.networkCost, a)
    },
    totalCost: {
      value: Te(n.totalCost, a)
    },
    potentialSavings: {
      value: Te(n.potentialSavings, a),
      savingsPercentage: n.savingsPercent.toFixed(2)
    }
  };
  switch (t) {
    case ne.CLUSTER:
      return {
        ...o,
        variant: ne.CLUSTER,
        clusterDetails: Ua(n).clusterDetails
      };
    case ne.ENVIRONMENT:
      return {
        ...o,
        variant: ne.ENVIRONMENT,
        envDetails: Ua(n).envDetails
      };
    case ne.APPLICATION:
      return {
        ...o,
        variant: ne.APPLICATION,
        appDetails: Ua(n).appDetails
      };
    case ne.PROJECT:
      return {
        ...o,
        variant: ne.PROJECT,
        projectDetails: Ua(n).projectDetails
      };
    case ne.K8S_RESOURCE:
      return {
        ...o,
        variant: ne.K8S_RESOURCE,
        resourceDetails: Ua(n).resourceDetails
      };
    default:
      throw new Error(
        `Encountered unsupported ${t} variant type while parsing breakdown list data`
      );
  }
}), hg = (s, t, a) => {
  if (!s?.overallBreakdown)
    return { data: [], totalCount: 0 };
  const n = vc(
    s.overallBreakdown.items || [],
    t,
    a
  );
  return {
    totalCount: s.overallBreakdown.totalCount || 0,
    data: n
  };
}, _g = (s, t, a, n) => {
  if (!s?.breakdownsBySubResource?.[a])
    return { data: [], totalCount: 0 };
  const o = s.breakdownsBySubResource[a], r = vc(o.items || [], t, n);
  return {
    totalCount: o.totalCount || 0,
    data: r
  };
}, fg = async ({
  view: s,
  breakdownViewType: t,
  itemName: a,
  detail: n,
  currency: o,
  timeRange: r,
  sortBy: l,
  sortOrder: i,
  pageSize: u,
  offset: c,
  signal: p,
  searchKey: d,
  typeFilter: m,
  tableVariant: _,
  namespace: g,
  environment: x
}) => {
  const { payload: C, resource: f } = Tf({
    view: s,
    breakdownViewType: t,
    itemName: a,
    detail: n,
    currency: o,
    timeRange: r,
    sortBy: l,
    sortOrder: i,
    pageSize: u,
    offset: c,
    searchKey: d,
    typeFilter: m,
    namespace: g,
    environment: x
  }), { result: h } = await pa({ payload: C, resource: f, signal: p });
  return C.subResource?.[0] ? _g(h, _, C.subResource?.[0], o) : hg(h, _, o);
}, gg = async ({
  resource: s,
  resourceName: t,
  signal: a
}) => {
  const { result: n } = await xe(
    $e(z.ENV_LIST_BY_RESOURCE, {
      resource: s,
      resourceName: t
    }),
    { signal: a }
  );
  return (n || []).filter((o) => !!o.envName).sort((o, r) => Ae(o.envName, r.envName)).map(({ envId: o, envName: r, clusterId: l, clusterName: i, namespace: u }) => ({
    envName: r,
    envId: o || 0,
    clusterName: i || "",
    clusterId: l || 0,
    namespace: u || ""
  }));
}, xg = async ({
  showEnvironmentFilter: s,
  showNamespaceFilter: t,
  clusterId: a,
  resourceName: n,
  viewType: o,
  signal: r
}) => {
  if (t) {
    const l = await gc(a, r);
    return [
      {
        label: "All Namespaces",
        value: ""
      },
      ...l
    ];
  }
  if (s) {
    const i = (await gg({
      resource: o === V.APPLICATIONS ? "application" : "project",
      resourceName: n || "",
      signal: r
    })).map(({ envName: u, clusterName: c, namespace: p }) => ({
      label: u,
      value: u,
      tooltipProps: {
        content: Ec(c, p)
      }
    }));
    return [
      {
        label: "All Environments",
        value: ""
      },
      ...i
    ];
  }
  return [];
}, Cg = ({
  children: s,
  searchKey: t,
  handleSearch: a,
  areNoResourcesAvailableGlobally: n
}) => {
  const { view: o, breakdownViewType: r, itemName: l } = ce(), { breakdownDetailsData: i } = $t(), { searchParams: u } = Re(), c = he(), p = ae(), d = u[Mn], m = u[Bn], _ = i.selectedCluster.id, g = o === Z.CUSTOM_VIEWS || o === Z.RESOURCE_KINDS, x = !n && g && !!_, C = !n && g && (r === V.APPLICATIONS || r === V.PROJECTS) && !!l, {
    data: f,
    isFetching: h,
    error: b,
    refetch: S
  } = se({
    queryKey: [
      "filter-options",
      _,
      l,
      r,
      x,
      C
    ],
    queryFn: ({ signal: v }) => xg(
      x ? {
        showNamespaceFilter: !0,
        clusterId: _,
        signal: v
      } : {
        showEnvironmentFilter: !0,
        resourceName: l,
        viewType: r === V.APPLICATIONS || r === V.PROJECTS ? r : null,
        signal: v
      }
    ),
    enabled: x || C
  }), O = (v) => {
    const A = new URLSearchParams(c.search), N = x ? Mn : Bn;
    v.value ? A.set(N, v.value) : A.delete(N), p.push({
      pathname: c.pathname,
      search: A.toString()
    });
  }, j = x ? {
    label: d || "All Namespaces",
    value: d || ""
  } : {
    label: m || "All Environments",
    value: m || ""
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-hidden flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__content-space p-16", children: [
      n ? /* @__PURE__ */ e.jsx("div", {}) : /* @__PURE__ */ e.jsx(
        aa,
        {
          containerClassName: "w-250",
          initialSearchText: t,
          handleEnter: a,
          keyboardShortcut: "/"
        }
      ),
      (x || C) && /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "cost-breakdown-table-resource-filter",
          classNamePrefix: "cost-breakdown-table-resource-filter",
          value: j,
          options: f,
          placeholder: `Select ${x ? "Namespace" : "Environment"}`,
          onChange: O,
          isLoading: h,
          optionListError: b,
          reloadOptionList: S,
          shouldMenuAlignRight: !0
        }
      )
    ] }),
    s
  ] });
}, Tc = ({ variant: s, globalResourceCountConfig: t }) => {
  const { view: a, breakdownViewType: n, itemName: o, detail: r } = ce(), l = Fo(a, r), { areNoResourcesAvailable: i, setAreNoResourcesAvailable: u } = t || {
    setAreNoResourcesAvailable: ks,
    areNoResourcesAvailable: !1
  }, {
    currencyData: { defaultCurrency: c }
  } = $t(), p = de(
    () => pg({
      variant: s,
      detailViewItemName: l,
      isDetailView: !!o,
      isCustomView: a === Z.CUSTOM_VIEWS,
      breakdownViewType: n,
      view: a
    }),
    [s, l]
  ), d = Wt(
    async ({
      sortBy: m,
      sortOrder: _,
      searchKey: g,
      offset: x,
      pageSize: C,
      currency: f,
      timeRange: h,
      typeFilter: b,
      namespace: S,
      environment: O
    }, j) => {
      u?.(!1);
      const v = await fg({
        view: a,
        breakdownViewType: n,
        itemName: o,
        detail: r,
        currency: f || c,
        timeRange: h,
        sortBy: m,
        sortOrder: _,
        pageSize: C,
        offset: x,
        signal: j,
        searchKey: g,
        typeFilter: b,
        tableVariant: s,
        namespace: S,
        environment: O
      }), A = !!g || x > 0 || !!S || !!O;
      return u?.(!A && !v.data?.length), {
        rows: (v.data || []).map((N) => ({
          id: N.id,
          data: N
        })),
        totalRows: v.totalCount || 0
      };
    },
    // Custom view won't have same name as detailViewItemName in case of resources because resources name are kept in pascal case in util
    [s, l]
  );
  return /* @__PURE__ */ e.jsx(
    oa,
    {
      id: `table__cost-breakdown-${s}-${l}`,
      columns: p,
      emptyStateConfig: {
        noRowsConfig: {
          image: zm,
          title: "No results found",
          subTitle: "We couldn't find any matching results"
        },
        noRowsForFilterConfig: {
          title: "No results",
          subTitle: "We couldn't find any matching results"
        }
      },
      paginationVariant: ra.PAGINATED,
      additionalFilterProps: {
        initialSortKey: Ie.NAME,
        parseSearchParams: mg
      },
      getRows: d,
      filtersVariant: la.URL,
      ViewWrapper: Cg,
      additionalProps: {
        areNoResourcesAvailableGlobally: i
      },
      filter: ks
    }
  );
};
var Js = /* @__PURE__ */ ((s) => (s.Equality = "Equality", s.Inequality = "Inequality", s.Contains = "Contains", s.NotContains = "NotContains", s.ContainsPrefix = "ContainsPrefix", s.NotContainsPrefix = "NotContainsPrefix", s.ContainsSuffix = "ContainsSuffix", s.NotContainsSuffix = "NotContainsSuffix", s))(Js || {}), Bt = /* @__PURE__ */ ((s) => (s.SHOW_CUSTOM_VIEW_MODAL = "showCustomViewModal", s.CUSTOM_VIEW_NAME = "customViewName", s))(Bt || {}), Ve = /* @__PURE__ */ ((s) => (s.KEY = "KEY", s.OPERATOR = "OPERATOR", s.VALUE = "VALUE", s))(Ve || {});
const bg = [
  {
    label: "KEY",
    key: Ve.KEY,
    width: "300px"
  },
  {
    label: "OPERATOR",
    key: Ve.OPERATOR,
    width: "160px"
  },
  {
    label: "VALUE",
    key: Ve.VALUE,
    width: "1fr"
  }
], Ac = {
  [Js.Equality]: "equals",
  [Js.Inequality]: "does not equal",
  [Js.Contains]: "contains",
  [Js.NotContains]: "does not contain",
  [Js.ContainsPrefix]: "starts with",
  [Js.NotContainsPrefix]: "does not start with",
  [Js.ContainsSuffix]: "ends with",
  [Js.NotContainsSuffix]: "does not end with"
}, Sg = Object.values(
  Js
).map((s) => ({
  label: Ac[s],
  value: s
})), Wa = {
  label: "Cost Overview",
  id: Z.OVERVIEW,
  iconName: "ic-world-globe"
}, jl = {
  label: "Applications",
  id: Z.APPLICATIONS,
  iconName: "ic-grid-view"
}, Ng = {
  label: "Deployment Cost",
  id: Z.DEPLOYMENT_COST,
  iconName: "ic-env"
}, Eg = {
  [V.APPLICATIONS]: [Wa, Ng],
  [V.CLUSTERS]: [Wa],
  [V.ENVIRONMENTS]: [Wa, jl],
  [V.PROJECTS]: [Wa, jl]
}, vg = {
  // Aggregations also has applications table as exception
  [Z.AGGREGATIONS]: ne.K8S_RESOURCE,
  [Z.APPLICATIONS]: ne.APPLICATION,
  [Z.CUSTOM_VIEWS]: ne.K8S_RESOURCE,
  [Z.DEPLOYMENT_COST]: ne.ENVIRONMENT,
  [Z.OVERVIEW]: null,
  [Z.RESOURCE_KINDS]: ne.K8S_RESOURCE
}, yc = Js.Equality, Tg = {
  [V.CLUSTERS]: ["namespace"],
  [V.ENVIRONMENTS]: ["application"],
  [V.PROJECTS]: ["application"],
  [V.APPLICATIONS]: ["deployment"]
};
var Go = /* @__PURE__ */ ((s) => (s.EDIT_CUSTOM_VIEW = "edit-custom-view", s.DELETE_CUSTOM_VIEW = "delete-custom-view", s))(Go || {});
const Ag = [
  {
    items: [
      {
        id: "edit-custom-view",
        label: "Edit",
        startIcon: {
          name: "ic-pencil",
          color: "N700"
        }
      },
      {
        id: "delete-custom-view",
        label: "Delete",
        type: "negative",
        startIcon: {
          name: "ic-delete",
          color: "R500"
        }
      }
    ]
  }
], vn = (s, t = !1) => ({
  data: {
    [Ve.KEY]: {
      value: s?.key || "",
      type: ws.TEXT,
      props: {
        placeholder: "Key",
        autoFocus: t
      }
    },
    [Ve.OPERATOR]: {
      type: ws.DROPDOWN,
      value: s?.operator || yc,
      props: {
        options: Sg
      }
    },
    [Ve.VALUE]: {
      value: s?.value || "",
      type: ws.TEXT,
      props: {
        placeholder: "Enter value or variable"
      }
    }
  },
  id: s?.id || vs()
}), yg = (s, t) => ({
  id: s.id || void 0,
  name: s.name,
  description: s.description,
  clusterName: t,
  filters: s.labelRows.map((a) => ({
    key: a.data[Ve.KEY].value.trim(),
    operator: a.data[Ve.OPERATOR].value,
    value: a.data[Ve.VALUE].value.trim()
  })).filter((a) => a.key && a.value)
}), jc = (s) => dn(s), Oc = (s) => ar(s), jg = (s, t) => {
  const a = s[t].data, n = a[Ve.KEY].value.trim(), o = a[Ve.OPERATOR].value, r = a[Ve.VALUE].value.trim();
  if (!(n !== "" && r !== ""))
    return s.length === 1 ? {
      isValid: !1,
      message: "At-least one label with key and value is required"
    } : {
      // Since will filter out empty labels on save
      isValid: !0
    };
  const i = {};
  s.forEach((p) => {
    const d = p.data[Ve.KEY].value.trim(), m = p.data[Ve.OPERATOR].value, _ = p.data[Ve.VALUE].value.trim(), g = `${d}-${m}-${_}`;
    i[g] = (i[g] || 0) + 1;
  });
  const u = `${n}-${o}-${r}`, c = i[u] === 1;
  return {
    isValid: c,
    message: c ? "" : "Combination of key, operator, and value must be unique"
  };
}, Ic = (s) => {
  const t = {};
  return s.labelRows.forEach((a, n) => {
    const o = jg(s.labelRows, n);
    o.isValid || (t[a.id] = {
      [Ve.KEY]: {
        isValid: !1,
        errorMessages: [o.message]
      },
      [Ve.VALUE]: {
        isValid: !1,
        errorMessages: [o.message]
      },
      [Ve.OPERATOR]: {
        isValid: !1,
        errorMessages: [o.message]
      }
    });
  }), t;
}, Og = (s) => {
  const t = jc(s.name), a = Oc(s.description);
  return {
    name: t.message,
    description: a.message,
    labelRows: Ic(s)
  };
}, Ig = (s) => !s.name && !s.description && Object.values(s.labelRows).every(
  (t) => !t[Ve.KEY]?.errorMessages?.length && !t[Ve.VALUE]?.errorMessages?.length && !t[Ve.OPERATOR]?.errorMessages?.length
), wg = async (s, t) => {
  try {
    const a = yg(s, t);
    await _s(z.COST_CUSTOM_VIEW, a);
  } catch (a) {
    throw ve(a), a;
  }
}, Pg = ({
  handleClose: s,
  refetchCustomViews: t,
  customViews: a,
  customViewError: n,
  isLoadingViewData: o
}) => {
  const { itemName: r } = ce(), { searchParams: l } = Re(), i = l[Bt.CUSTOM_VIEW_NAME], u = a.find((v) => v.name === i), [c, p] = E({
    id: u?.id,
    name: "",
    description: "",
    labelRows: [vn()]
  }), [d, m] = E({
    name: "",
    description: "",
    labelRows: {}
  }), [_, g] = E(!1), x = async () => {
    const v = Og(c);
    if (m(v), !Ig(v)) {
      Se.showToast({
        variant: Ne.error,
        description: "Please fix the errors before saving."
      });
      return;
    }
    is({
      category: "cost-breakdown-item-details",
      action: "COST_BREAKDOWN_CLUSTER_SAVE_CUSTOM_VIEW"
    }), g(!0);
    try {
      await wg(c, r), t(c.name), g(!1), s();
    } catch {
      g(!1);
    }
  };
  ue(() => {
    i && u && p({
      id: u.id,
      name: u.name,
      description: u.description,
      labelRows: [
        vn(),
        ...u.labels.map((v) => vn(v, !0))
      ]
    });
  }, [i, a]);
  const C = () => {
    p((v) => ({
      ...v,
      labelRows: [vn(null, !0), ...v.labelRows]
    })), is({
      category: "cost-breakdown-item-details",
      action: "COST_BREAKDOWN_CLUSTER_ADD_CUSTOM_VIEW_ADD_LABEL"
    });
  }, f = (v) => {
    p((A) => ({
      ...A,
      name: v.target.value
    })), m((A) => ({
      ...A,
      name: jc(v.target.value).message || ""
    }));
  }, h = (v) => {
    p((A) => ({
      ...A,
      description: v.target.value
    })), m((A) => ({
      ...A,
      description: Oc(v.target.value).message || ""
    }));
  }, b = (v) => {
    const A = {
      ...c,
      labelRows: [...v]
    };
    p(A), m((N) => ({
      ...N,
      labelRows: Ic(A)
    }));
  }, S = (v, A, N) => {
    const L = c.labelRows.map((M) => M.id === v.id ? {
      ...M,
      data: {
        ...M.data,
        [A]: {
          ...M.data[A],
          value: N
        }
      }
    } : M);
    b(L);
  }, O = (v) => {
    if (c.labelRows.length <= 1)
      return;
    const A = c.labelRows.filter((N) => N.id !== v.id);
    b(A);
  }, j = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-20 dc__overflow-auto dc__gap-16 flex-grow-1", children: [
    /* @__PURE__ */ e.jsx(
      ke,
      {
        name: "view-name",
        label: "Name",
        placeholder: "Logistics EU",
        value: c.name,
        onChange: f,
        error: d.name,
        required: !0,
        fullWidth: !0,
        autoFocus: !!i
      }
    ),
    /* @__PURE__ */ e.jsx(
      At,
      {
        label: "Description",
        name: "custom-view-description",
        placeholder: "Aggregates resources operating logistics services",
        value: c.description,
        onChange: h,
        error: d.description
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8 dc__align-items-center", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 fs-14 fw-6 lh-20 cn-9", children: "Filter resources by labels" }),
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "heading-add-label-button",
          variant: U.secondary,
          size: P.small,
          startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-add", color: null }),
          text: "Add Label",
          onClick: C
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      Zo,
      {
        headers: bg,
        rows: c.labelRows,
        onRowAdd: C,
        onRowEdit: S,
        onRowDelete: O,
        cellError: d.labelRows
      }
    ),
    /* @__PURE__ */ e.jsx(Us, { variant: "neutral", description: "Filter will be applied as AND" })
  ] });
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", width: "800px", onClose: s, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
      onClick: Rs,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom", children: [
            /* @__PURE__ */ e.jsxs("h2", { className: "m-0 fs-16 fw-6 lh-1-5 cn-9 dc__truncate", children: [
              "Custom View ",
              i ? `'${i}'` : ""
            ] }),
            /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: "header-close-button",
                ariaLabel: "Close",
                showAriaLabelInTippy: !1,
                onClick: s,
                variant: U.borderLess,
                style: q.negativeGrey,
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
                size: P.xs
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 dc__overflow-auto w-100", children: /* @__PURE__ */ e.jsx(
            at,
            {
              isLoading: i && o,
              progressingProps: {
                pageLoader: !0
              },
              error: n,
              errorScreenManagerProps: i ? {
                code: n?.code,
                reload: t,
                on404Redirect: s
              } : null,
              children: j()
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "footer-cancel-button",
              variant: U.secondary,
              text: "Cancel",
              style: q.neutral,
              size: P.large,
              onClick: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "footer-apply-button",
              variant: U.primary,
              size: P.large,
              text: "Apply Changes",
              disabled: i ? o || !!n : !1,
              isLoading: _,
              onClick: x
            }
          )
        ] })
      ]
    }
  ) });
}, Rg = ({ datasets: s, isLoading: t, errorConfig: a }) => {
  const { currency: n } = Ke(), o = de(
    () => t ? null : {
      type: "pie",
      xAxisLabels: Object.keys(s).map(
        (r) => kt[r]
      ),
      datasets: {
        datasetName: "Cost Breakdown",
        colors: ["LimeGreen400", "Lavender400", "SkyBlue400", "GoldenYellow600"],
        yAxisValues: Object.values(s)
      },
      id: "cost-breakdown-doughnut"
    },
    [s]
  );
  return /* @__PURE__ */ e.jsxs(Ze, { isLoading: t, shimmerVariant: "C", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox py-12 px-16 border__secondary--bottom", children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-1-5 cn-9", children: "Cost Breakdown" }) }),
    /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 p-16", children: a ? /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 p-16", children: /* @__PURE__ */ e.jsx(hs, { reload: a.refetch }) }) : /* @__PURE__ */ e.jsx(
      na,
      {
        ...o,
        tooltipConfig: {
          datasetValueFormatter: (r) => Te(r, n)
        }
      }
    ) })
  ] });
}, Nr = ({
  isLoading: s,
  totalCost: t,
  delta: a,
  xAxisLabels: n,
  datasets: o,
  errorConfig: r
}) => {
  const { currency: l } = Ke(), i = de(
    () => ({
      ...o,
      color: rc[ic(a)]
    }),
    [o, a]
  ), u = () => r ? /* @__PURE__ */ e.jsx(hs, { reload: r.refetch, rootClassName: "h-100" }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-12 dc__align-start px-16 pt-16", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 cn-9", children: "Total Cost" }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-24 fw-6 cn-9 dc__truncate lh-1-5 font-ibm-plex-sans", children: t })
    ] }) }),
    /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 w-100 dc__overflow-hidden", children: /* @__PURE__ */ e.jsx(
      na,
      {
        id: "cost-trend-chart",
        type: "area",
        xAxisLabels: n,
        datasets: i,
        hideAxis: !0,
        yScaleTickFormat: (c) => Te(Number(c), l),
        tooltipConfig: {
          datasetValueFormatter: (c) => Te(c, l)
        }
      }
    ) })
  ] });
  return /* @__PURE__ */ e.jsx(Ze, { shimmerVariant: "C", isLoading: s, variant: "primary--outlined", children: u() });
}, Lg = ({
  isLoading: s,
  recommendedCost: t,
  potentialSavings: a,
  potentialSavingsPercentage: n,
  cardVariant: o
}) => {
  const r = Math.min(100, Math.ceil(n));
  return /* @__PURE__ */ e.jsx(Ze, { shimmerVariant: "B", isLoading: s, variant: o, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "dc__grid dc__overflow-hidden",
      style: { gridTemplateColumns: "minmax(50%, max-content) 1fr" },
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__gap-16 p-16 border__secondary--right", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space", children: [
            /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 cn-9", children: "Recommended Cost" }),
            /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-24 fw-6 lh-1-5 font-ibm-plex-sans dc__truncate", children: t })
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space", children: [
            /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 cn-9", children: "Potential Savings" }),
            /* @__PURE__ */ e.jsx("span", { className: "cg-5 fs-24 fw-6 lh-1-5 font-ibm-plex-sans dc__truncate", children: a })
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 p-16", children: [
          /* @__PURE__ */ e.jsxs("p", { className: "m-0 p-0 fs-13 fw-4 cn-9", children: [
            "Estimated cost reduction ",
            /* @__PURE__ */ e.jsxs("span", { className: "fw-6", children: [
              n,
              "%"
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(
            mi,
            {
              hideLegend: !0,
              entities: [
                { value: r, color: "var(--G500)" },
                { value: 100 - r, color: "var(--N200)" }
              ],
              showAnimationOnBar: !0,
              size: P.large
            }
          )
        ] })
      ]
    }
  ) });
}, kg = ({
  category: s,
  categoryPotentialSavings: t,
  categoryPotentialSavingsPercentage: a,
  isLoading: n,
  totalCategoryCost: o
}) => {
  if (n)
    return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-16 dc__gap-8 br-8 border__primary bg__primary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__align-start dc__content-space", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
          /* @__PURE__ */ e.jsx("div", { className: "shimmer h-16 w-80" }),
          /* @__PURE__ */ e.jsx("div", { className: "shimmer h-24 w-100" })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "shimmer h-20 w-40 br-4" })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
          /* @__PURE__ */ e.jsx("div", { className: "shimmer h-13 w-90" }),
          /* @__PURE__ */ e.jsx("div", { className: "shimmer h-13 w-60" })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "shimmer h-8 w-100 br-4" })
      ] })
    ] });
  const r = Math.min(100, Math.ceil(a));
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-16 dc__gap-8 br-8 border__primary bg__primary", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-12 dc__align-start dc__content-space", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5", children: s }),
      /* @__PURE__ */ e.jsx("span", { className: "fs-24 fw-6 lh-1-5 font-ibm-plex-sans cn-9", children: o })
    ] }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 font-ibm-plex-sans dc__content-space", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-7", children: "Potential Savings" }),
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: t })
      ] }),
      /* @__PURE__ */ e.jsx(
        mi,
        {
          hideLegend: !0,
          size: P.xs,
          entities: [
            { value: r, color: "var(--G500)" },
            { value: 100 - r, color: "var(--N200)" }
          ]
        }
      )
    ] })
  ] });
}, en = ({ variant: s, props: t }) => {
  switch (s) {
    case "expanded":
      return /* @__PURE__ */ e.jsx(Lg, { ...t });
    case "mini":
      return /* @__PURE__ */ e.jsx(kg, { ...t });
    default:
      return null;
  }
}, Ol = [
  { label: "Total Cost", value: "total" },
  { label: kt.cpu, value: Y.CPU },
  { label: kt.memory, value: Y.MEMORY },
  { label: kt.storage, value: Y.STORAGE },
  { label: kt.gpu, value: Y.GPU },
  { label: kt.network, value: Y.NETWORK }
], Il = {
  [Y.CPU]: "cpuCost",
  [Y.MEMORY]: "memoryCost",
  [Y.GPU]: "gpuCost",
  [Y.STORAGE]: "storageCost",
  [Y.NETWORK]: "networkCost",
  total: "totalCost"
}, Dg = ({
  maxValue: s,
  name: t,
  cost: a,
  scaledValue: n,
  currency: o,
  breakdownViewType: r,
  timeRange: l,
  isNavigationDisabled: i
}) => {
  const { push: u } = ae(), c = () => {
    const p = Q(
      `${cc(r)}/${R.COST_BREAKDOWN_DETAIL}`,
      {
        view: Z.OVERVIEW,
        itemName: t
      }
    );
    u(us(p, l, o));
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      ...i ? {} : { role: "button", tabIndex: 0, onClick: c },
      className: `dc__position-rel w-100 h-40 dc__no-shrink p-4 br-4 ${i ? "" : "dc__hover-n50 top10-card__bar--clickable dc__transition--background"}`,
      children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "h-100 br-4 bcb-1 bar__visual dc__transition--background",
            style: { width: `${n / s * 100}%` }
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-12 dc__position-abs dc__zi-1 w-100 h-100 dc__top-0 dc__left-0 dc__align-items-center px-8", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 cn-9 dc__truncate", children: t }),
          /* @__PURE__ */ e.jsx("span", { className: "fs-16 lh-1-5 fw-6 cn-9 font-ibm-plex-sans dc__no-shrink", children: Te(a, o) })
        ] })
      ]
    }
  );
}, Mg = (s, t) => (
  // Transform items to Top10ResourceType format
  s.map((a) => ({
    name: a.name,
    cost: Number(a[Il[t]].toFixed(2)),
    scaledValue: a[Il[t]] * 100
  }))
), Bg = (s) => {
  switch (s) {
    case Y.CPU:
      return "cpuCost";
    case Y.MEMORY:
      return "memoryCost";
    case Y.STORAGE:
      return "storageCost";
    case Y.GPU:
      return "gpuCost";
    case "total":
    default:
      return "totalCost";
  }
}, Ug = ({
  breakdownViewType: s,
  resourceName: t,
  subComponent: a,
  subResource: n,
  timeRange: o
}) => {
  const { view: r } = ce(), { currency: l, typeFilter: i } = Ke(), {
    isLoading: u,
    data: c,
    error: p,
    refetch: d
  } = se({
    queryKey: [
      "top10Resources",
      a,
      i,
      t,
      JSON.stringify(n),
      s,
      l,
      o,
      r
    ],
    queryFn: ({ signal: g }) => pa({
      ...gn({
        pageSize: 10,
        offset: 0,
        resourceName: t,
        isCustomView: r === Z.CUSTOM_VIEWS,
        breakdownViewType: s,
        subResource: n,
        currency: l,
        searchKey: "",
        sortBy: Bg(a),
        sortOrder: Ss.DESC,
        timeRange: o,
        typeFilter: i
      }),
      signal: g
    }),
    select: ({ result: g }) => Mg(
      n ? g?.breakdownsBySubResource?.[n[0]]?.items ?? [] : g?.overallBreakdown?.items ?? [],
      a
    )
  }), m = de(
    // NOTE: returning 1 instead of 0 to mitigate division by zero errors
    () => c?.reduce((g, x) => Math.max(g, x.scaledValue), 1) ?? 1,
    [c, a]
  ), _ = () => u ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "shimmer br-4 h-20 mb-8 p-4", style: { width: "60%" } }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer br-4 h-20 p-4", style: { width: "40%" } })
  ] }) : c.map((g, x) => /* @__PURE__ */ e.jsx(
    Dg,
    {
      maxValue: m,
      name: g.name,
      cost: g.cost,
      scaledValue: g.scaledValue,
      currency: l,
      breakdownViewType: s,
      isNavigationDisabled: !!t,
      timeRange: o
    },
    x
  ));
  return p ? /* @__PURE__ */ e.jsx(hs, { reload: d, rootClassName: "h-100" }) : /* @__PURE__ */ e.jsx("div", { className: "py-8 px-12 flexbox-col dc__overflow-auto", children: _() });
}, io = ({ variant: s, hideCategoryFilter: t = !1, ...a }) => {
  const { serverMode: n } = Ot(), { subResource: o, breakdownViewType: r } = a, { timeRange: l } = Ke(), [i, u] = E(
    r ?? V.CLUSTERS
  ), [c, p] = E(Fs);
  ci(() => {
    r && u(r);
  }, [r]);
  const [d, m] = E("total"), _ = de(
    () => Ea.find((h) => h.value === i),
    [i]
  ), g = de(
    () => Ol.find((h) => h.value === d),
    [d]
  ), x = (h) => {
    m(h.value);
  }, C = (h) => {
    is({
      category: "cost_visibility_most_expensive",
      action: `COST_OVERVIEW_MOST_EXPENSIVE_${h.value.toUpperCase()}`
    }), u(h.value);
  }, f = o?.[0] ?? i;
  return /* @__PURE__ */ e.jsx(Ze, { variant: s === "overview" ? "secondary--outlined" : "primary--outlined", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-hidden top10-card", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox py-12 px-16 dc__gap-16 dc__content-space border__secondary--bottom", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 fw-6 cn-9", children: s === "overview" ? "Most Expensive" : `Top 10 Costly ${f}` }),
        s === "overview" && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          n === Vt.EA_ONLY ? /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 fw-6 cn-9", children: "Cluster" }) : /* @__PURE__ */ e.jsx(
            te,
            {
              inputId: "top-10-overview-cost-breakdown-select",
              value: _,
              onChange: C,
              options: Ea,
              variant: We.COMPACT,
              size: P.small,
              shouldMenuAlignRight: !0
            }
          ),
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 fw-6 cn-9", children: "in" }),
          /* @__PURE__ */ e.jsx(
            jt,
            {
              stateConfig: { timeRange: c, setTimeRange: p },
              size: P.small,
              variant: We.COMPACT,
              analyticsAction: "COST_OVERVIEW_MOST_EXPENSIVE_TIMEFRAME"
            }
          )
        ] })
      ] }),
      !t && /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: `top-10-${f}-category-filter`,
          value: g,
          onChange: x,
          options: Ol,
          variant: We.COMPACT,
          size: P.small,
          shouldMenuAlignRight: !0
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      Ug,
      {
        ...a,
        breakdownViewType: i,
        subComponent: d,
        timeRange: s === "overview" ? c : l
      }
    )
  ] }) });
}, vo = (s) => () => {
  is({
    category: "cost-breakdown-details-nav",
    action: `COST_BREAKDOWN_CLUSTER_BY_${s.toUpperCase()}`
  });
}, Fg = (s, t, a, n) => [
  {
    title: "Aggregations",
    id: "cost-visibility-aggregations",
    type: "heading",
    items: [
      {
        type: "item",
        id: rs.NODE_GROUPS,
        title: "Node Groups",
        as: "link",
        href: us(
          Q(s, {
            ...t,
            view: Z.AGGREGATIONS,
            detail: rs.NODE_GROUPS
          }),
          a,
          n
        ),
        onClick: vo(rs.NODE_GROUPS)
      },
      {
        type: "item",
        id: rs.NAMESPACES,
        title: "Namespaces",
        as: "link",
        href: us(
          Q(s, {
            ...t,
            view: Z.AGGREGATIONS,
            detail: rs.NAMESPACES
          }),
          a,
          n
        ),
        onClick: vo(rs.NAMESPACES)
      },
      {
        type: "item",
        id: rs.APPLICATIONS,
        title: "Applications",
        as: "link",
        href: us(
          Q(s, {
            ...t,
            view: Z.AGGREGATIONS,
            detail: rs.APPLICATIONS
          }),
          a,
          n
        ),
        onClick: vo(rs.APPLICATIONS)
      }
    ]
  }
], Vg = (s, t) => (a) => {
  const n = fn(a.result, s), o = Cr(
    n,
    {
      variant: "expanded"
    },
    s,
    t
  ), r = n.subResourceSummary ? Object.values(n.subResourceSummary)[0] : n.summary;
  return {
    ...o,
    costBreakdownDoughnutCardProps: {
      datasets: Object.values(Y).reduce(
        (l, i) => ({
          ...l,
          [i]: r[i].totalCost
        }),
        {}
      )
    }
  };
}, Gg = () => {
  const { itemName: s, breakdownViewType: t, view: a, detail: n } = ce(), { timeRange: o, currency: r } = Ke(), l = a === Z.CUSTOM_VIEWS ? n : s, i = de(() => dc(a, n), [a, n]), {
    isLoading: u,
    data: c,
    error: p,
    refetch: d
  } = se({
    queryFn: ({ signal: g }) => Oa({
      signal: g,
      ...Ia({
        breakdownViewType: t,
        resourceName: l,
        subResource: i,
        currency: r,
        timeRange: o,
        typeFilter: Ns.ALL,
        isCustomView: a === Z.CUSTOM_VIEWS,
        trendDetailType: "include-sub-resource-total"
      })
    }),
    queryKey: [
      "breakdownViewDetailsCharts",
      t,
      JSON.stringify(i),
      r,
      o,
      a,
      l
    ],
    select: Vg(o, r)
  }), m = p ? { refetch: d } : null, _ = () => a === Z.CUSTOM_VIEWS || a === Z.DEPLOYMENT_COST || a === Z.APPLICATIONS && t !== V.CLUSTERS ? /* @__PURE__ */ e.jsx(
    Rg,
    {
      ...u ? { isLoading: !0 } : {
        ...c?.costBreakdownDoughnutCardProps,
        errorConfig: m
      }
    }
  ) : /* @__PURE__ */ e.jsx(io, { breakdownViewType: t, resourceName: l, subResource: i });
  return /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__gap-12 p-16", style: { gridTemplateRows: "356px" }, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "dc__grid dc__gap-12", style: { gridTemplateRows: "1fr min-content" }, children: [
      /* @__PURE__ */ e.jsx(
        Nr,
        {
          ...u ? { isLoading: !0 } : { ...c?.costTrendProps, errorConfig: m }
        }
      ),
      /* @__PURE__ */ e.jsx(
        en,
        {
          ...u || m ? { variant: "expanded", props: { isLoading: !0 } } : c.potentialSavingsCardProps
        }
      )
    ] }),
    _()
  ] });
}, Wg = () => {
  const { itemName: s, breakdownViewType: t } = ce(), { timeRange: a, currency: n } = Ke(), {
    isLoading: o,
    data: r,
    error: l,
    refetch: i
  } = se({
    queryKey: ["getCostBreakdownViewDetail", t, s, n, a],
    queryFn: ({ signal: u }) => Oa({
      ...Ia({
        breakdownViewType: t,
        resourceName: s,
        isCustomView: !1,
        currency: n,
        timeRange: a,
        typeFilter: Ns.ALL,
        subResource: null,
        trendDetailType: "total_only"
      }),
      signal: u
    }),
    select: ({ result: u }) => Cr(
      fn(u, a),
      { variant: "mini" },
      a,
      n
    )
  });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-16 dc__gap-16 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsxs("h2", { className: "m-0 p-0 fs-16 lh-1-5 fw-6", children: [
        "Cost Overview `",
        s,
        "`"
      ] }) }),
      /* @__PURE__ */ e.jsx(va, {}),
      /* @__PURE__ */ e.jsx(jt, {})
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__gap-12 breakdown-view-item-details__overview-charts", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "dc__grid dc__gap-12", style: { gridTemplateRows: "168px auto" }, children: [
        /* @__PURE__ */ e.jsx(
          Nr,
          {
            ...o ? { isLoading: !0 } : {
              ...r?.costTrendProps,
              errorConfig: l ? { refetch: i } : null
            }
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "dc__grid-cols-2 dc__grid-rows-2 dc__no-shrink dc__gap-12", children: o || l ? Array(3).fill(0).map((u, c) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ e.jsx(en, { variant: "mini", props: { isLoading: !0 } }, c)
        )) : r.potentialSavingsMiniCardProps.slice(0, 4).map((u) => /* @__PURE__ */ e.jsx(
          en,
          {
            ...u
          },
          u.props.category
        )) })
      ] }),
      /* @__PURE__ */ e.jsx(
        io,
        {
          breakdownViewType: t,
          resourceName: s,
          subResource: Tg[t]
        }
      )
    ] }),
    t === V.CLUSTERS && /* @__PURE__ */ e.jsx(
      jn,
      {
        props: { subResource: ["namespace"], itemName: s, breakdownViewType: t },
        type: "specific",
        variant: "detail"
      }
    ),
    /* @__PURE__ */ e.jsx(
      jn,
      {
        props: {
          subResource: [
            t === V.APPLICATIONS ? "deployment" : "application"
          ],
          itemName: s,
          breakdownViewType: t
        },
        type: "specific",
        variant: "detail"
      }
    ),
    /* @__PURE__ */ e.jsx(jn, { type: "resourceKind", props: { breakdownViewType: t, itemName: s }, variant: "detail" })
  ] });
}, $g = (s) => xe($e(z.COST_CUSTOM_VIEW, { clusterName: s })), Kg = async (s) => {
  try {
    return await ia($e(z.COST_CUSTOM_VIEW, { id: s })), Se.showToast({
      variant: Ne.success,
      description: "Custom view deleted successfully"
    }), !0;
  } catch (t) {
    return ve(t), !1;
  }
}, Hg = ({ customViews: s, refetchCustomViews: t }) => {
  const { path: a } = Ts(), { view: n, breakdownViewType: o, detail: r, ...l } = ce(), i = ae(), { timeRange: u } = Ke(), { searchParams: c } = Re(), p = c[qe.CURRENCY] || "", [d, m] = E(null), [_, g] = E(!1), x = {
    ...l,
    breakdownViewType: o
  }, C = (w) => us(
    Q(a, {
      ...x,
      view: w.id,
      [Tn.DETAIL]: void 0
    }),
    u,
    p
  ), f = () => {
    const w = us(
      $e("", {
        [Bt.SHOW_CUSTOM_VIEW_MODAL]: !0
      }),
      u,
      p
    );
    is({
      category: "cost-breakdown-item-details",
      action: "COST_BREAKDOWN_CLUSTER_ADD_CUSTOM_VIEW"
    }), i.push({
      search: w.slice(1)
    });
  }, h = (w) => () => {
    is({
      category: "cost-breakdown-details-nav",
      action: `COST_BREAKDOWN_${o.toUpperCase()}_BY_${w.toUpperCase()}`
    });
  }, b = () => [
    {
      type: "heading",
      id: "resource-kinds",
      title: "Resource Kinds",
      items: oo.map((w) => {
        const T = ro(w);
        return {
          type: "item",
          id: T,
          title: w.kind,
          as: "link",
          href: us(
            Q(a, {
              ...x,
              view: Z.RESOURCE_KINDS,
              detail: T
            }),
            u,
            p
          ),
          onClick: h(w.kind)
        };
      })
    }
  ], S = (w) => (T) => {
    if (T.id === Go.EDIT_CUSTOM_VIEW) {
      const I = us(
        $e("", {
          [Bt.SHOW_CUSTOM_VIEW_MODAL]: !0,
          [Bt.CUSTOM_VIEW_NAME]: w.name
        }),
        u,
        p
      );
      i.push({
        search: I.slice(1)
      });
      return;
    }
    T.id === Go.DELETE_CUSTOM_VIEW && m(w || null);
  }, O = () => {
    is({
      category: "cost-breakdown-details-nav",
      action: "COST_BREAKDOWN_CLUSTER_BY_CUSTOM_VIEW"
    });
  }, j = () => [
    {
      type: "heading",
      id: "cost-visibility-custom-views",
      title: "Custom Views",
      trailingItem: {
        type: "button",
        config: {
          dataTestId: "add-custom-view-btn",
          ariaLabel: "Add Custom View",
          icon: /* @__PURE__ */ e.jsx(D, { name: "ic-add", color: null }),
          onClick: f
        }
      },
      items: s.map((w) => {
        const T = w.identifier;
        return {
          type: "item",
          id: T,
          title: w.name,
          as: "link",
          href: us(
            Q(a, {
              ...x,
              view: Z.CUSTOM_VIEWS,
              detail: T
            }),
            u,
            p
          ),
          trailingItem: {
            type: "action-menu",
            config: {
              id: `custom-view-action-menu-${w.id}`,
              onClick: S(w),
              options: Ag,
              buttonProps: {
                dataTestId: `custom-view-action-menu-btn-${w.id}`,
                ariaLabel: `Custom View Action Menu ${w.name}`,
                showAriaLabelInTippy: !1,
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-more-vertical", color: "N900", size: 16 }),
                variant: U.borderLess,
                style: q.neutral,
                size: P.xxs
              }
            }
          },
          onClick: O
        };
      })
    }
  ], v = () => {
    m(null);
  }, A = async () => {
    g(!0);
    const w = await Kg(d.id);
    g(!1), w && (v(), t(), n === Z.CUSTOM_VIEWS && r === d.identifier && i.push(C(Wa)));
  }, N = o === V.CLUSTERS ? Fg(a, x, u, p) : [], L = b(), M = o === V.CLUSTERS ? j() : [], W = (w, T) => /* @__PURE__ */ e.jsx(
    Op,
    {
      nodes: w,
      defaultExpandedMap: {
        [w[0].id]: !0
      },
      selectedId: T ? w[0].items.find((I) => I.type === "item" && I.id === r)?.id : null,
      useOverflowAuto: !1
    }
  ), $ = (w) => () => {
    is({
      category: "cost-breakdown-details-nav",
      action: `COST_BREAKDOWN_${o.toUpperCase()}_BY_${w.id.toUpperCase()}`
    });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto border__primary--right dc__gap-8 px-8 pt-12", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox dc__separated-flexbox--vertical dc__separated-flexbox--vertical-gap-8", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col w-100", children: Eg[o]?.map((w) => /* @__PURE__ */ e.jsxs(
        sm,
        {
          to: C(w),
          className: `flexbox flex-grow-1 dc__gap-8 dc__align-items-center px-8 py-6 br-4 ${n === w.id ? "bcb-1" : "bg__hover"}`,
          onClick: $(w),
          children: [
            /* @__PURE__ */ e.jsx(D, { name: w.iconName, size: 16, color: n === w.id ? "B500" : "N800" }),
            /* @__PURE__ */ e.jsx(
              "span",
              {
                className: `dc__truncate fs-13 fw-4 lh-1-5 ${n === w.id ? "cb-5" : "cn-9"}`,
                children: w.label
              }
            )
          ]
        },
        w.id
      )) }),
      o === V.CLUSTERS && W(N, n === Z.AGGREGATIONS),
      W(L, n === Z.RESOURCE_KINDS),
      o === V.CLUSTERS && W(M, n === Z.CUSTOM_VIEWS)
    ] }) }),
    d && /* @__PURE__ */ e.jsx(
      vt,
      {
        title: "Delete Custom View",
        subtitle: "Are you sure you want to delete this custom view? This action cannot be undone.",
        variant: mt.delete,
        handleClose: v,
        buttonConfig: {
          primaryButtonConfig: {
            text: "Delete",
            onClick: A,
            isLoading: _
          },
          secondaryButtonConfig: {
            text: "Cancel",
            onClick: v
          }
        }
      }
    )
  ] });
}, Yg = ({ keyData: s, value: t, operator: a }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center border__primary bg__primary br-4", children: [
  /* @__PURE__ */ e.jsx("div", { className: "flexbox py-2 px-6 border__secondary--right", children: /* @__PURE__ */ e.jsx(we, { content: s, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-12 fw-6 lh-20 dc__truncate dc__mxw-100", children: s }) }) }),
  /* @__PURE__ */ e.jsx("div", { className: "flexbox py-2 px-6 border__secondary--right", children: /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4 lh-20", children: Ac[a] || a }) }),
  /* @__PURE__ */ e.jsx("div", { className: "flexbox py-2 px-6", children: /* @__PURE__ */ e.jsx(we, { content: t, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-12 fw-4 lh-20 dc__truncate dc__mxw-100", children: t }) }) })
] }), zg = () => {
  const { path: s } = Ts(), t = ce(), { itemName: a, breakdownViewType: n, view: o, detail: r } = t, { searchParams: l } = Re(), i = l[qe.CURRENCY] || "", u = ae(), c = he(), { timeRange: p } = Ke(), d = !!(n === V.CLUSTERS && a), [m, _] = E(!1), {
    data: g,
    isFetching: x,
    error: C,
    refetch: f
  } = se({
    queryKey: ["getGVKsAndCustomViewList", n, a],
    queryFn: () => $g(n === V.CLUSTERS ? a : ""),
    select: ({ result: A }) => (A?.items || []).map((N) => ({
      name: N.name || "",
      description: N.description || "",
      identifier: N.identifier || "",
      id: N.id,
      labels: (N.filters || []).map((L) => ({
        id: vs(),
        key: L.key || "",
        operator: L.operator || yc,
        value: L.value || ""
      }))
    })).sort((N, L) => Ae(N.name, L.name)),
    enabled: d
  }), h = d ? x : !1, b = () => {
    const A = us("", p, i);
    u.push({
      search: A.length ? A.slice(1) : ""
      // slice is used to remove the "?" at the beginning of the string
    });
  }, S = () => {
    if (o !== Z.CUSTOM_VIEWS)
      return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 px-16 pt-16", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-grow-1 dc__align-items-center", children: /* @__PURE__ */ e.jsxs("h2", { className: "m-0 fs-16 fw-6 lh-1-5 cn-9", children: [
          "Cost breakdown ",
          Fo(o, r) ? `by ${Fo(o, r)}` : ""
        ] }) }),
        /* @__PURE__ */ e.jsx(va, {}),
        /* @__PURE__ */ e.jsx(jt, {})
      ] });
    const A = g?.find((N) => N.identifier === r);
    return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 pt-16 px-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8 dc__align-start", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
          /* @__PURE__ */ e.jsxs("h2", { className: "m-0 cn-9 fs-16 fw-6 lh-1-5 dc__truncate", children: [
            "Cost Overview ",
            A ? `'${A.name}'` : ""
          ] }),
          A?.description && /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 dc__truncate lh-1-5", children: A.description })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
          /* @__PURE__ */ e.jsx(va, {}),
          /* @__PURE__ */ e.jsx(jt, {}),
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "edit-selected-custom-view",
              icon: /* @__PURE__ */ e.jsx(D, { name: "ic-pencil", color: null }),
              ariaLabel: "Edit Selected Custom View",
              showAriaLabelInTippy: !1,
              style: q.neutral,
              variant: U.secondary,
              component: me.link,
              size: P.medium,
              linkProps: {
                to: $e(c.pathname, {
                  [Bt.SHOW_CUSTOM_VIEW_MODAL]: !0,
                  [Bt.CUSTOM_VIEW_NAME]: A?.name
                })
              }
            }
          )
        ] })
      ] }),
      A?.labels?.length > 0 && /* @__PURE__ */ e.jsx("div", { className: "flexbox flex-wrap dc__gap-8", children: A.labels.map(({ id: N, key: L, operator: M, value: W }) => /* @__PURE__ */ e.jsx(Yg, { keyData: L, operator: M, value: W }, N)) })
    ] });
  }, O = () => {
    const A = o === Z.AGGREGATIONS && r === rs.APPLICATIONS ? ne.APPLICATION : vg[o];
    return A ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      S(),
      !m && /* @__PURE__ */ e.jsx(Gg, {}),
      /* @__PURE__ */ e.jsx(
        Tc,
        {
          variant: A,
          globalResourceCountConfig: {
            areNoResourcesAvailable: m,
            setAreNoResourcesAvailable: _
          }
        },
        `${n}-${a}-${o}-${r}-table`
      )
    ] }) : null;
  }, j = () => o === Z.OVERVIEW ? /* @__PURE__ */ e.jsx(Wg, {}) : o === Z.RESOURCE_KINDS && !oo.find((A) => ro(A) === r) ? /* @__PURE__ */ e.jsx(Xe, { title: "Invalid resource kind" }) : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__overflow-auto flex-grow-1 h-100", children: O() }), v = async (A) => {
    try {
      const { data: N } = await f(), L = N?.find((M) => M.name === A);
      L && u.push(
        us(
          Q(s, {
            ...t,
            view: Z.CUSTOM_VIEWS,
            detail: L.identifier
          }),
          p,
          i
        )
      );
    } catch (N) {
      ve(N);
    }
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Ga, { children: /* @__PURE__ */ e.jsx(at, { isLoading: h, progressingProps: { pageLoader: !0 }, children: /* @__PURE__ */ e.jsxs("div", { className: "dc__grid breakdown-view-item-details__container flex-grow-1 h-100 dc__overflow-hidden dc__position-rel bg__primary w-100", children: [
      /* @__PURE__ */ e.jsx(
        Hg,
        {
          customViews: g || [],
          refetchCustomViews: f
        }
      ),
      j()
    ] }) }) }),
    !!l[Bt.SHOW_CUSTOM_VIEW_MODAL] && /* @__PURE__ */ e.jsx(
      Pg,
      {
        handleClose: b,
        refetchCustomViews: v,
        customViews: g || [],
        customViewError: C,
        isLoadingViewData: h
      }
    )
  ] });
}, qg = {
  [V.APPLICATIONS]: ne.APPLICATION,
  [V.CLUSTERS]: ne.CLUSTER,
  [V.ENVIRONMENTS]: ne.ENVIRONMENT,
  [V.PROJECTS]: ne.PROJECT
}, Xg = ({ analyticsAction: s }) => {
  const { breakdownViewType: t } = ce(), { searchParams: a } = Re(), n = ae();
  if (t !== V.CLUSTERS && t !== V.ENVIRONMENTS)
    return null;
  const o = Object.values(
    Ns
  ).map((u) => ({
    label: `${u} ${t === V.CLUSTERS ? "Clusters" : "Environments"}`,
    value: u
  })), r = a[Za.typeFilter], l = o.find((u) => u.value === r) || {
    label: `All ${t === V.CLUSTERS ? "Clusters" : "Environments"}`,
    value: Ns.ALL
  }, i = (u) => {
    s && is({
      category: "cost_visibility_prod_non_prod_select",
      action: `${s}_BY_${u.value.toUpperCase()}_${t.toUpperCase()}`
    });
    const c = structuredClone(a);
    n.push({
      search: new URLSearchParams({
        ...c,
        [Za.typeFilter]: u.value
      }).toString()
    });
  };
  return /* @__PURE__ */ e.jsx(
    te,
    {
      inputId: "prod-non-prod-select",
      value: l,
      options: o,
      onChange: i
    }
  );
}, Jg = () => {
  const { serverMode: s } = Ot(), { breakdownViewType: t } = ce(), a = ae(), { path: n } = Ts(), { searchParams: o } = Re(), [r, l] = E(!1), i = s === Vt.EA_ONLY, u = Object.values(V).map((f) => ({
    label: ta(f),
    value: f
  })), { currency: c, timeRange: p, typeFilter: d } = Ke(), m = (f) => {
    is({
      category: "cost_visibility_breakdown_segment",
      action: `COST_BREAKDOWN_BY_${f.value.toUpperCase()}`
    });
    const h = Q(n, {
      breakdownViewType: f.value
    }), b = $e(h, {
      [qe.TIME_RANGE]: o[qe.TIME_RANGE],
      [qe.CURRENCY]: o[qe.CURRENCY]
    });
    a.push(b);
  }, {
    isLoading: _,
    data: g,
    error: x,
    refetch: C
  } = se({
    queryKey: ["getCostBreakdownViewDetail", t, c, p, d],
    queryFn: ({ signal: f }) => Oa({
      ...Ia({
        subResource: null,
        breakdownViewType: t,
        timeRange: p,
        currency: c,
        typeFilter: d,
        resourceName: null,
        isCustomView: !1,
        trendDetailType: "total_only"
      }),
      signal: f
    }),
    select: (f) => Cr(
      fn(f.result, p),
      {
        variant: "expanded"
      },
      p,
      c
    )
  });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "px-16 pt-16 flexbox-col dc__gap-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: `flex ${i ? "right" : "dc__content-space"}`, children: [
        !i && /* @__PURE__ */ e.jsx(
          ca,
          {
            name: "cost-breakdown-view-type",
            segments: u,
            value: t,
            onChange: m
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
          t === V.CLUSTERS || t === V.ENVIRONMENTS ? /* @__PURE__ */ e.jsx(Xg, { analyticsAction: "COST_BREAKDOWN" }) : null,
          /* @__PURE__ */ e.jsx(va, {}),
          /* @__PURE__ */ e.jsx(jt, { analyticsAction: "COST_BREAKDOWN_TIMEFRAME" })
        ] })
      ] }),
      !r && /* @__PURE__ */ e.jsxs("div", { className: "dc__grid-cols-2 dc__gap-12 cost-breakdown-view__charts-container", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "dc__grid dc__gap-12", style: { gridTemplateRows: "1fr min-content" }, children: [
          /* @__PURE__ */ e.jsx(
            Nr,
            {
              ..._ ? { isLoading: !0 } : {
                ...g?.costTrendProps,
                errorConfig: x ? { refetch: C } : null
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            en,
            {
              ..._ || x ? { variant: "expanded", props: { isLoading: !0 } } : g.potentialSavingsCardProps
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(io, { breakdownViewType: t, resourceName: null })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "dc__position-sticky dc__top-0 bg__primary dc__zi-1 h-100 dc__no-shrink flexbox-col", children: /* @__PURE__ */ e.jsx(
      Tc,
      {
        variant: qg[t],
        globalResourceCountConfig: {
          areNoResourcesAvailable: r,
          setAreNoResourcesAvailable: l
        }
      },
      `${t}-table`
    ) })
  ] });
}, Qg = () => {
  const { path: s } = Ts(), { serverMode: t } = Ot(), { replace: a } = ae(), { breakdownViewType: n } = ce(), { isCostVisibilityEnabled: o, metadataError: r, isLoadingMetadata: l, refetchCostVisibilityMetadata: i } = $t();
  return ue(() => {
    t === Vt.EA_ONLY && n !== V.CLUSTERS && a(Q(R.COST_BREAKDOWN_ROUTE, { breakdownViewType: V.CLUSTERS }));
  }, [n]), l ? /* @__PURE__ */ e.jsx(Ga, { children: /* @__PURE__ */ e.jsx("div", { className: "flex column flex-grow-1", children: /* @__PURE__ */ e.jsx(hi, {}) }) }) : r ? /* @__PURE__ */ e.jsx(Ga, { children: /* @__PURE__ */ e.jsx(_t, { code: r.code, reload: i }) }) : o ? /* @__PURE__ */ e.jsxs(rt, { children: [
    /* @__PURE__ */ e.jsx(le, { path: `${s}/${R.COST_BREAKDOWN_DETAIL}`, children: /* @__PURE__ */ e.jsx(zg, {}) }, `${s}/${R.COST_BREAKDOWN_DETAIL}`),
    /* @__PURE__ */ e.jsx(Ga, { children: /* @__PURE__ */ e.jsx(Jg, {}) })
  ] }) : /* @__PURE__ */ e.jsx(Ga, { children: /* @__PURE__ */ e.jsx(bc, {}) });
}, Zg = (s) => s?.enabled ? s.installationStatus === "Installing" || s.installationStatus === "Upgrading" ? {
  style: q.warning,
  text: s.installationStatus
} : s.installationStatus === "Failed" ? { style: q.negative, text: "Installation Failed" } : { style: q.neutral, text: "Enabled" } : { style: q.neutral, text: "Off" }, ex = () => {
  const { searchParams: s } = Re(), t = ae(), {
    data: a,
    isFetching: n,
    error: o,
    refetch: r
  } = se({
    queryKey: ["get-cluster-list"],
    queryFn: ({ signal: g }) => Ip(null, g),
    select: (g) => (g || []).filter((x) => !x.isVirtualCluster)
  }), { renderClusterForm: l } = tg(), i = +s.clusterId, u = (a || []).find((g) => g.clusterId === i), c = (g) => () => {
    is({
      category: "cost-visibility-cluster-config",
      action: "COST_CONFIG_CLUSTER_CONFIG"
    }), t.push({
      search: `?clusterId=${g}`
    });
  }, p = () => {
    t.push({
      search: ""
    });
  }, d = async () => {
    await r();
  }, m = (g, x) => {
    const C = Zg(g?.costModuleConfig);
    return /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-16 dc__align-items-center dc__content-space flexbox dc__gap-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-16 dc__align-items-center", children: [
        n ? /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading icon-dim-24" }) : /* @__PURE__ */ e.jsx(
          wp,
          {
            clusterStatus: g.status,
            isVirtualCluster: g.isVirtualCluster
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: `flexbox-col ${n ? "dc__gap-4" : ""}`, children: n ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-18 w-120" }),
          /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-180" })
        ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(we, { content: g.clusterName, children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 dc__truncate", children: g.clusterName }) }),
          /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4 lh-1-5", children: g.isProd ? "Production" : "Non Production" })
        ] }) })
      ] }),
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "open-cluster-edit-modal",
          style: C.style,
          text: C.text,
          onClick: c(g?.clusterId),
          endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-caret-right", color: null }),
          isLoading: n,
          variant: U.borderLess,
          size: P.medium
        }
      )
    ] }, x);
  }, _ = () => n ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    m(null, 1),
    m(null, 2),
    m(null, 3)
  ] }) : o ? /* @__PURE__ */ e.jsx(
    hs,
    {
      title: "Error loading cluster list",
      subTitle: o.errors?.[0]?.userMessage || "Something went wrong while fetching the cluster list",
      description: "",
      reload: r
    }
  ) : a.length === 0 ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      title: "No clusters found",
      subTitle: "No clusters are connected to track infra costs."
    }
  ) : a.map((g) => m(g, g.clusterId));
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 h-100 dc__overflow-hidden flexbox-col dc__content-space bg__secondary", children: [
      /* @__PURE__ */ e.jsx(Sr, {}),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-center p-16 flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20 flex-grow-1 dc__mxw-600", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
          /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-15 fw-6 lh-1-5", children: "Preference" }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-16 px-16 py-12 dc__align-items-center br-8 border__secondary bg__primary", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
              /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-1-5", children: "Currency (Default)" }),
              /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 lh-1-5", children: "Cost will be displayed in the default currency" })
            ] }),
            /* @__PURE__ */ e.jsx(
              va,
              {
                useDefaultValue: !0,
                variant: We.COMPACT,
                analyticsAction: "COST_CONFIG_CURRENCY_CHANGED"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__align-items-center", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
              /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-15 fw-6 lh-1-5", children: "Cost tracking" }),
              /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-13 fw-4 lh-1-5", children: "Manage infra cost tracking for connected clusters" })
            ] }),
            /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: "reload-cluster-list",
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-clockwise", color: null }),
                onClick: d,
                isLoading: n,
                ariaLabel: "Reload Cluster List",
                showAriaLabelInTippy: !1,
                variant: U.borderLess,
                size: P.medium,
                style: q.neutral
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox-col br-8 border__secondary bg__primary", children: _() })
        ] })
      ] }) })
    ] }),
    !!i && /* @__PURE__ */ e.jsx(
      Vs,
      {
        position: "right",
        width: "1000px",
        onClose: p,
        onEscape: p,
        children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 bg__primary", onClick: Rs, children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-align-center dc__border-bottom flex-justify bg__primary py-12 px-20", children: [
            /* @__PURE__ */ e.jsx(
              "h2",
              {
                "data-testid": "add_cluster_header",
                className: "fs-16 fw-6 lh-1-43 m-0 title-padding fw-6 fs-16 cn-9",
                children: "Edit Cluster"
              }
            ),
            /* @__PURE__ */ e.jsx(
              B,
              {
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
                dataTestId: "header-close-icon",
                style: q.negativeGrey,
                size: P.xs,
                variant: U.borderLess,
                ariaLabel: "Close edit cluster drawer",
                onClick: p,
                showAriaLabelInTippy: !1
              }
            )
          ] }),
          u ? l({
            clusterDetails: u,
            handleClose: p,
            handleSuccess: r
          }) : /* @__PURE__ */ e.jsx(Xe, { title: "Cluster not found" })
        ] })
      }
    )
  ] });
}, wl = ({
  isLoading: s,
  category: t,
  value: a,
  delta: n,
  yAxisValues: o,
  xAxisLabels: r,
  additionalContext: l
}) => {
  const { currency: i } = Ke(), u = de(
    () => s ? null : {
      id: `at-a-glance-${t.toLowerCase()}-chart`,
      type: "area",
      datasets: {
        datasetName: t,
        color: rc[ic(n)],
        yAxisValues: o
      },
      hideAxis: !0,
      xAxisLabels: r
    },
    [n, t, o, r]
  );
  return /* @__PURE__ */ e.jsxs(Ze, { shimmerVariant: "A", isLoading: s, variant: "secondary--outlined", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox p-16 dc__gap-12 dc__overflow-hidden flex-grow-1", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 flex-grow-1", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 cn-9 lh-1-5", children: t }),
        /* @__PURE__ */ e.jsx("span", { className: "dc__truncate font-ibm-plex-sans fw-6 lh-1-5 fs-24 cn-9", children: a })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "w-120", children: /* @__PURE__ */ e.jsx(
        na,
        {
          ...u,
          yScaleTickFormat: (c) => Te(Number(c), i),
          tooltipConfig: {
            datasetValueFormatter: (c) => Te(c, i)
          }
        }
      ) })
    ] }),
    l && /* @__PURE__ */ e.jsx("div", { className: "border__secondary--top py-12 px-16 flexbox dc__gap-12 dc__content-space dc__align-items-center", children: /* @__PURE__ */ e.jsx("span", { className: "fs-12 cn-7 fw-4 lh-1-5", children: l }) })
  ] });
}, sx = (s) => {
  const t = s.summary;
  if (!t?.overall)
    return {
      datasets: [],
      xAxisLabels: []
    };
  const { plotPoints: a } = t.overall, n = a.map((r) => r.label);
  return {
    datasets: [
      {
        datasetName: "Total",
        yAxisValues: t.overall.plotPoints.map((r) => r.value),
        color: "CharcoalGray500"
      },
      {
        datasetName: "CPU",
        yAxisValues: t.cpu.plotPoints.map((r) => r.value),
        color: fa[Y.CPU]
      },
      {
        datasetName: "Memory",
        yAxisValues: t.memory.plotPoints.map((r) => r.value),
        color: fa[Y.MEMORY]
      },
      {
        datasetName: "Storage",
        yAxisValues: t.storage.plotPoints.map((r) => r.value),
        color: fa[Y.STORAGE]
      },
      {
        datasetName: "Network",
        yAxisValues: t.network.plotPoints.map((r) => r.value),
        color: fa[Y.NETWORK]
      },
      {
        datasetName: "GPU",
        yAxisValues: t.gpu.plotPoints.map((r) => r.value),
        color: fa[Y.GPU]
      }
    ],
    xAxisLabels: n
  };
}, tx = ({ cardVariant: s }) => {
  const { currency: t } = Ke(), [a, n] = E(Fs), {
    isFetching: o,
    data: r,
    error: l,
    refetch: i
  } = se({
    queryKey: [t, a, "cost-trend-by-time"],
    queryFn: ({ signal: c }) => Oa({
      ...Ia({
        breakdownViewType: V.CLUSTERS,
        currency: t,
        timeRange: a,
        resourceName: null,
        isCustomView: !1,
        subResource: null,
        typeFilter: null,
        trendDetailType: "all"
      }),
      signal: c
    }),
    select: ({ result: c }) => sx(fn(c, a))
  }), u = () => o ? /* @__PURE__ */ e.jsx("div", { className: "shimmer w-100 h-100" }) : l ? /* @__PURE__ */ e.jsx(hs, { reload: i, rootClassName: "h-100" }) : /* @__PURE__ */ e.jsx(
    na,
    {
      id: "cost-trend-overview-chart",
      type: "line",
      ...r,
      yScaleTickFormat: (c) => Te(Number(c), t),
      xScaleTickFormat: Ef(a),
      tooltipConfig: {
        datasetValueFormatter: (c) => Te(c, t)
      }
    }
  );
  return /* @__PURE__ */ e.jsxs(Ze, { variant: s, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 px-16 py-12 border__secondary--bottom", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 fw-6", children: "Cost trend for" }),
      /* @__PURE__ */ e.jsx(
        jt,
        {
          stateConfig: { timeRange: a, setTimeRange: n },
          variant: We.COMPACT,
          size: P.small,
          analyticsAction: "COST_OVERVIEW_COST_TREND_TIMEFRAME"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { style: { height: "456px" }, className: "p-16", children: u() })
  ] });
}, ax = ({
  name: s,
  totalCost: t,
  currency: a,
  timeRange: n,
  efficiencyPercent: o,
  breakdownViewType: r
}) => {
  const { push: l } = ae(), i = () => {
    const c = Q(
      `${cc(r)}/${R.COST_BREAKDOWN_DETAIL}`,
      {
        view: Z.OVERVIEW,
        itemName: s
      }
    );
    l(us(c, n, a));
  }, u = (c) => {
    (c.key === "Enter" || c.key === " ") && i();
  };
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      onClick: i,
      tabIndex: 0,
      role: "button",
      onKeyDown: u,
      className: "flexbox px-12 py-8 br-4 dc__align-start dc__gap-12 dc__hover-n50 dc__transition--background dc__tab-focus",
      children: [
        /* @__PURE__ */ e.jsx(D, { name: "ic-coins", color: "B500", size: 20 }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 flexbox-col", children: [
          /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 cn-9 lh-1-5", children: s }),
          /* @__PURE__ */ e.jsxs("div", { className: "fs-12 fw-4 cn-7 lh-1-5", children: [
            "Cost ",
            Zt[n].toLowerCase(),
            " ",
            Te(t, a)
          ] })
        ] }),
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-1-5", children: o })
      ]
    }
  );
}, nx = (s) => s.map((t) => ({
  name: t.name,
  totalCost: t.totalCost,
  efficiencyPercent: `${(100 - t.savingsPercent).toFixed(1)}%`
})), ox = ({ breakdownViewType: s, timeRange: t }) => {
  const { view: a } = ce(), { currency: n, typeFilter: o } = Ke(), {
    isLoading: r,
    data: l,
    error: i,
    refetch: u
  } = se({
    queryKey: [
      "mostEfficientResources",
      s,
      o,
      n,
      t,
      a
    ],
    queryFn: ({ signal: p }) => pa({
      ...gn({
        pageSize: 5,
        offset: 0,
        isCustomView: !1,
        breakdownViewType: s,
        resourceName: null,
        subResource: null,
        currency: n,
        searchKey: "",
        sortBy: "efficiencyPercentage",
        sortOrder: Ss.DESC,
        timeRange: t,
        typeFilter: o
      }),
      signal: p
    }),
    select: (p) => nx(p?.result?.overallBreakdown?.items ?? [])
  }), c = () => r ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "shimmer br-4 h-20 mb-8", style: { width: "60%" } }),
    /* @__PURE__ */ e.jsx("div", { className: "shimmer br-4 h-20", style: { width: "40%" } })
  ] }) : l.map((p, d) => /* @__PURE__ */ e.jsx(
    ax,
    {
      name: p.name,
      totalCost: p.totalCost,
      efficiencyPercent: p.efficiencyPercent,
      currency: n,
      timeRange: t,
      breakdownViewType: s
    },
    d
  ));
  return i ? /* @__PURE__ */ e.jsx(hs, { reload: u, rootClassName: "h-100" }) : /* @__PURE__ */ e.jsx("div", { className: "p-8 flexbox-col dc__overflow-auto", children: c() });
}, rx = ({ cardVariant: s }) => {
  const { serverMode: t } = Ot(), [a, n] = E(Fs), [o, r] = E(
    t === Vt.EA_ONLY ? V.CLUSTERS : V.PROJECTS
  ), l = de(
    () => Ea.find((u) => u.value === o),
    [o]
  ), i = (u) => {
    is({
      category: "cost_visibility_most_efficient",
      action: `COST_OVERVIEW_COST_EFFICIENT_${u.value.toUpperCase()}`
    }), r(u.value);
  };
  return /* @__PURE__ */ e.jsxs(Ze, { variant: s, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox py-12 px-16 dc__gap-4 border__secondary--bottom", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 fw-6 cn-9", children: "Most cost efficient" }),
      t === Vt.EA_ONLY ? /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 fw-6 cn-9", children: "Cluster" }) : /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "most-efficient-overview-cost-breakdown-select",
          value: l,
          onChange: i,
          options: Ea,
          variant: We.COMPACT,
          size: P.small,
          shouldMenuAlignRight: !0
        }
      ),
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-1-5 fw-6 cn-9", children: "in" }),
      /* @__PURE__ */ e.jsx(
        jt,
        {
          stateConfig: { timeRange: a, setTimeRange: n },
          variant: We.COMPACT,
          size: P.small,
          analyticsAction: "COST_OVERVIEW_COST_EFFICIENT_TIMEFRAME"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(ox, { breakdownViewType: o, timeRange: a })
  ] });
}, lx = (s, t) => !s || !s.totalCount || !s.items ? { totalCount: 0, items: [] } : {
  totalCount: s.totalCount,
  items: s.items.map((a) => ({
    name: a.name,
    cost: Te(a.potentialSavings, t),
    potentialSavings: Math.round(a.savingsPercent)
  }))
}, Pl = 5, wc = ({
  category: s,
  currency: t,
  timeRange: a = ts.LAST_30_DAYS,
  typeFilter: n = Ns.ALL,
  isCurrencyLoading: o = !1
}) => {
  const {
    isFetching: r,
    isError: l,
    data: i,
    refetch: u
  } = se({
    queryKey: [pc, s, t, n, a, o],
    queryFn: ({ signal: p }) => pa({
      ...gn({
        breakdownViewType: V.CLUSTERS,
        resourceName: null,
        isCustomView: !1,
        subResource: null,
        currency: t,
        timeRange: a,
        typeFilter: n,
        offset: 0,
        pageSize: Pl,
        sortBy: "potentialSavings",
        sortOrder: Ss.DESC,
        searchKey: ""
      }),
      signal: p
    }),
    select: (p) => lx(p?.result?.overallBreakdown ?? { totalCount: 0, items: [] }, t),
    enabled: !o
  }), c = () => r || o ? Array(3).fill(0).map((p, d) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "dc__grid py-8 px-12 dc__gap-12",
      style: { gridTemplateColumns: "1fr 48px" },
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
          /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-75 br-4 mb-6" }),
          /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-14 w-50 br-4" })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-100 br-4" })
      ]
    },
    `shimmer-${d}`
  )) : l ? /* @__PURE__ */ e.jsx(hs, { subTitle: "", reload: u }) : i.items.length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    i.items.map((p, d) => /* @__PURE__ */ e.jsxs(
      as,
      {
        to: Q(`${R.COST_BREAKDOWN_CLUSTERS}/${R.COST_BREAKDOWN_DETAIL}`, {
          view: Z.OVERVIEW,
          itemName: p.name
        }),
        className: "dc__grid py-8 px-12 dc__gap-12 pointer dc__hover-n50 br-8 dc__no-decor dc__transition--background",
        style: { gridTemplateColumns: "1fr 64px" },
        children: [
          /* @__PURE__ */ e.jsxs("span", { className: "flexbox-col flex-grow-1", children: [
            /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 cn-9 lh-1-5 dc__truncate", children: p.name }),
            /* @__PURE__ */ e.jsxs("span", { className: "fs-12 fw-4 cg-7 lh-1-5 dc__truncate", children: [
              "Potential savings ",
              p.potentialSavings,
              "%"
            ] })
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "fw-6 lh-1-5 cn-9 font-ibm-plex-sans fs-13 dc__align-right", children: p.cost })
        ]
      },
      d
    )),
    i.totalCount > Pl && /* @__PURE__ */ e.jsx("div", { className: "flex border__secondary--top py-8", children: /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "view-all-opportunities",
        text: "View all",
        variant: U.text,
        component: me.link,
        linkProps: {
          to: R.COST_BREAKDOWN_CLUSTERS
        }
      }
    ) })
  ] }) : /* @__PURE__ */ e.jsx(
    cn,
    {
      iconName: "ic-coins",
      title: "Cost tracking is not enabled",
      subtitle: "Get insights into your infrastructure spending and cost optimization opportunities.",
      buttonConfig: {
        dataTestId: "enable-cost",
        variant: U.secondary,
        text: "Enable cost tracking",
        size: P.xs,
        component: me.link,
        linkProps: {
          to: R.COST_CONFIGURATIONS
        }
      }
    }
  );
  return /* @__PURE__ */ e.jsxs(Ze, { variant: "secondary--outlined", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-16 flexbox dc__gap-8 border__secondary--bottom", children: [
      /* @__PURE__ */ e.jsx("h4", { className: "fw-6 fs-13 m-0 cn-9 lh-1-5", children: "Top saving opportunities" }),
      /* @__PURE__ */ e.jsx(
        D,
        {
          tooltipProps: {
            alwaysShowTippyOnHover: !0,
            content: `Cluster list sorted by highest potential savings based on ${Zt[a].toLowerCase()} of usage`
          },
          name: "ic-help-outline",
          size: 16,
          color: "N700"
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col p-8", children: c() })
  ] });
}, ix = {
  cpu: "CPU Cost",
  gpu: "GPU Cost",
  memory: "RAM Cost",
  network: "Network Cost",
  storage: "PV Cost",
  overall: "Total Cost"
}, Rl = {
  Installed: "enabled",
  "Installation failed": "failed",
  "In Progress": "inProgress",
  "Not enabled": "notEnabled"
}, cx = {
  Installed: "bcg-5",
  "Installation failed": "bcr-5",
  "In Progress": "bco-5",
  "Not enabled": "bcn-5"
}, dx = (s, t, a) => s === "overall" ? Zt[a] : t > 0.01 && t < 100 ? `${t.toFixed(2)}% of total cost` : `No cost ${Zt[a].toLowerCase()}`, ux = ({ summary: { cpu: s, gpu: t, memory: a, overall: n, storage: o, network: r } }, l, i) => {
  const { potentialSavingsPercentage: u, potentialSavings: c, recommendedCost: p } = n;
  return {
    atAGlanceCardProps: Object.entries({ overall: n, cpu: s, memory: a, storage: o, gpu: t, network: r }).map(
      ([d, { totalCost: m, plotPoints: _, trend: g }]) => ({
        category: ix[d],
        value: Te(m, i),
        delta: g,
        yAxisValues: _.map(({ value: x }) => x),
        xAxisLabels: _.map(({ label: x }) => x),
        additionalContext: dx(
          d,
          m / n.totalCost * 100,
          l
        )
      })
    ),
    potentialSavingsCardProp: {
      potentialSavingsPercentage: u,
      recommendedCost: Te(p, i),
      potentialSavings: Te(c, i)
    }
  };
}, px = (s) => (s || []).filter((t) => !t.isVirtualCluster).reduce(
  (t, a) => {
    if (t.total += 1, !a.costModuleConfig?.enabled)
      return t.notEnabled += 1, t;
    switch (a.costModuleConfig?.installationStatus) {
      case "Success":
        t.enabled += 1;
        break;
      case "Upgrading":
      case "Installing":
        t.inProgress += 1;
        break;
      case "Failed":
        t.failed += 1;
        break;
      case "NotInstalled":
        t.notEnabled += 1;
        break;
    }
    return t;
  },
  { enabled: 0, total: 0, inProgress: 0, failed: 0, notEnabled: 0 }
), mx = () => {
  const {
    data: s,
    isFetching: t,
    error: a,
    refetch: n
  } = se({
    queryKey: ["cost-enablement-info"],
    queryFn: ({ signal: l }) => tr(l),
    select: ({ result: l }) => px(l || [])
  }), o = () => {
    is({
      category: "cost_visibility_overview",
      action: "COST_OVERVIEW_GO_TO_CONFIGURATIONS"
    });
  }, r = () => a ? /* @__PURE__ */ e.jsx(hs, { reload: n }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox dc__separated-flexbox--vertical dc__separated-flexbox--vertical-gap-12 p-16 dc__gap-12", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 cn-9 lh-1-5", children: "Cost visibility enabled for " }),
        t ? /* @__PURE__ */ e.jsx("div", { className: "shimmer h-24" }) : /* @__PURE__ */ e.jsxs("span", { className: "fs-15 fw-6 cn-9 lh-1-5", children: [
          s.enabled,
          " of ",
          s.total,
          " Clusters"
        ] })
      ] }),
      t ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
        /* @__PURE__ */ e.jsx("div", { className: "shimmer h-12 w-100" }),
        /* @__PURE__ */ e.jsx("div", { className: "shimmer h-12 w-80" })
      ] }) : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-8", children: Object.keys(Rl).map((l) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-8 dc__align-items-center", children: [
        /* @__PURE__ */ e.jsx("div", { className: `icon-dim-12 ${cx[l]} br-4 dc__no-shrink` }),
        /* @__PURE__ */ e.jsx("span", { className: "flex-grow-1 fs-13 lh-1-5 cn-9 fw-6", children: l }),
        /* @__PURE__ */ e.jsxs("span", { className: "dc__no-shrink fs-13 lh-1-5 cn-9 fw-4", children: [
          s[Rl[l]],
          " clusters"
        ] })
      ] }, l)) })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flex left py-12 px-16 border__secondary--top", children: /* @__PURE__ */ e.jsx(
      B,
      {
        component: me.link,
        linkProps: {
          to: R.COST_CONFIGURATIONS
        },
        dataTestId: "cost-overview-go-to-configurations",
        text: "Go to Configurations",
        endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-right", color: null }),
        variant: U.text,
        onClick: o
      }
    ) })
  ] });
  return s && s.enabled === s.total ? null : /* @__PURE__ */ e.jsx("div", { className: "flexbox-col br-8 border__secondary bg__primary", children: r() });
}, hx = () => {
  const [s, t] = E(!0), { currency: a } = Ke(), [n, o] = E(Fs), { isCostVisibilityEnabled: r, isLoadingMetadata: l, metadataError: i, refetchCostVisibilityMetadata: u } = $t(), {
    isLoading: c,
    data: p,
    error: d,
    refetch: m
  } = se({
    queryKey: [n, a, "getCostVisibilityOverviewCostSummary"],
    queryFn: ({ signal: C }) => Oa({
      ...Ia({
        breakdownViewType: V.CLUSTERS,
        currency: a,
        timeRange: n,
        resourceName: null,
        isCustomView: !1,
        subResource: null,
        typeFilter: null,
        trendDetailType: "all"
      }),
      signal: C
    }),
    select: (C) => ux(fn(C.result, n), n, a)
  }), _ = () => {
    t(!1);
  }, g = () => {
    t(!0);
  }, x = () => l ? /* @__PURE__ */ e.jsx("div", { className: "flex column flex-grow-1", children: /* @__PURE__ */ e.jsx(hi, {}) }) : i || d ? /* @__PURE__ */ e.jsx(
    _t,
    {
      code: i?.code || d?.code,
      reload: i ? u : m,
      on404Redirect: ks
    }
  ) : r ? /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flex-grow-1 dc__grid cost-visibility__overview cost-visibility__overview${s ? "--expanded" : "--collapsed"} dc__overflow-auto`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__overflow-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-16 py-12 dc__content-space border__secondary--bottom dc__align-items-center", children: [
            /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-8", children: /* @__PURE__ */ e.jsx(va, {}) }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 lh-1-5 cn-9", children: "Updates every hour" }),
              /* @__PURE__ */ e.jsx(
                B,
                {
                  icon: /* @__PURE__ */ e.jsx(D, { name: "ic-help-outline", color: null }),
                  ariaLabel: "Info on hourly update of cost data",
                  showAriaLabelInTippy: !1,
                  dataTestId: "cost-visibility-overview-hourly-update-info",
                  variant: U.borderLess,
                  size: P.xxxs,
                  component: me.anchor,
                  anchorProps: {
                    href: Pp
                  },
                  style: q.neutral
                }
              ),
              !s && /* @__PURE__ */ e.jsx(
                B,
                {
                  dataTestId: "cost-visibility-overview-open-sidebar",
                  onClick: g,
                  variant: U.borderLess,
                  style: q.neutral,
                  icon: /* @__PURE__ */ e.jsx(D, { name: "ic-right-panel-collapse", rotateBy: 180, color: null }),
                  ariaLabel: "Close sidebar",
                  showAriaLabelInTippy: !1,
                  size: P.medium
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-32 dc__overflow-auto p-20 flex-grow-1", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-16", children: [
                /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-20 fw-4 lh-1-5", children: "At a Glance" }),
                /* @__PURE__ */ e.jsx(jt, { stateConfig: { timeRange: n, setTimeRange: o } })
              ] }),
              /* @__PURE__ */ e.jsx("div", { className: "dc__grid dc__gap-8 at-a-glance", children: c ? Array(6).fill(0).map((C, f) => /* @__PURE__ */ e.jsx(wl, { isLoading: !0 }, f)) : p.atAGlanceCardProps.map((C, f) => (
                // Don't need to worry about re-ordering
                // eslint-disable-next-line react/no-array-index-key
                /* @__PURE__ */ e.jsx(wl, { ...C }, f)
              )) })
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
              /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-20 fw-4 lh-1-5", children: "Potential Savings" }),
              /* @__PURE__ */ e.jsx(
                en,
                {
                  variant: "expanded",
                  props: {
                    ...c ? { isLoading: !0 } : {
                      ...p.potentialSavingsCardProp,
                      cardVariant: "secondary--outlined"
                    }
                  }
                }
              )
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
              /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-20 fw-4 lh-1-5", children: "Track Performance" }),
              /* @__PURE__ */ e.jsx(tx, { cardVariant: "secondary--outlined" }),
              /* @__PURE__ */ e.jsx(jn, { variant: "overview" }),
              /* @__PURE__ */ e.jsxs("div", { className: "dc__grid dc__grid-cols-2 dc__gap-16 optimality-insights", children: [
                /* @__PURE__ */ e.jsx(rx, { cardVariant: "secondary--outlined" }),
                /* @__PURE__ */ e.jsx(io, { variant: "overview" })
              ] })
            ] })
          ] })
        ] }),
        s && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__overflow-auto border__secondary--left bg__primary", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space py-12 px-16 border__secondary--bottom dc__align-items-center", children: [
            /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-14 fw-6 lh-1-5", children: "Actions & Insights" }),
            /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: "cost-visibility-overview-close-sidebar",
                onClick: _,
                variant: U.borderLess,
                style: q.neutral,
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-right-panel-collapse", color: null }),
                ariaLabel: "Close sidebar",
                showAriaLabelInTippy: !1,
                size: P.medium
              }
            )
          ] }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1 dc__overflow-auto flexbox-col p-16 dc__gap-16", children: [
            /* @__PURE__ */ e.jsx(mx, {}),
            /* @__PURE__ */ e.jsx(wc, { category: V.CLUSTERS, currency: a })
          ] })
        ] })
      ]
    }
  ) : /* @__PURE__ */ e.jsx(bc, {});
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space dc__overflow-auto bg__secondary flex-grow-1", children: [
    /* @__PURE__ */ e.jsx(Sr, {}),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: x() })
  ] });
}, _x = () => {
  const { isSuperAdmin: s } = Ot();
  return /* @__PURE__ */ e.jsxs(rt, { children: [
    /* @__PURE__ */ e.jsx(le, { path: R.COST_VISIBILITY_OVERVIEW, exact: !0, children: /* @__PURE__ */ e.jsx(yn, { children: /* @__PURE__ */ e.jsx(hx, {}) }) }, R.COST_VISIBILITY_OVERVIEW),
    /* @__PURE__ */ e.jsx(le, { path: R.COST_BREAKDOWN_ROUTE, children: /* @__PURE__ */ e.jsx(yn, { children: /* @__PURE__ */ e.jsx(Qg, {}) }) }, R.COST_BREAKDOWN_ROUTE),
    /* @__PURE__ */ e.jsx(le, { path: R.COST_CONFIGURATIONS, exact: !0, children: s ? /* @__PURE__ */ e.jsx(yn, { children: /* @__PURE__ */ e.jsx(ex, {}) }) : /* @__PURE__ */ e.jsx(rn, {}) }, R.COST_CONFIGURATIONS),
    /* @__PURE__ */ e.jsx(pn, { to: R.COST_VISIBILITY_OVERVIEW })
  ] });
};
var ps = /* @__PURE__ */ ((s) => (s.VOLUME_SNAPSHOT = "volume-snapshot", s.STORAGE_LOCATION = "storage-location", s.RESTORE = "restore", s.BACKUP = "backup", s.BACKUP_SCHEDULE = "backup-schedule", s))(ps || {});
const fx = {
  [ps.RESTORE]: "Restore Deletion Status",
  [ps.BACKUP]: "Backup Deletion Status",
  [ps.BACKUP_SCHEDULE]: "Backup Schedule Deletion Status",
  [ps.STORAGE_LOCATION]: "Storage Location Deletion Status",
  [ps.VOLUME_SNAPSHOT]: "Volume Snapshot Deletion Status"
}, To = {
  [ps.RESTORE]: {
    title: "Delete Restores",
    subtitle: "",
    confirmationKeyword: "Restores"
  },
  [ps.STORAGE_LOCATION]: {
    title: "Delete Storage Locations",
    subtitle: "",
    confirmationKeyword: "Storage Locations"
  },
  [ps.VOLUME_SNAPSHOT]: {
    title: "Delete Volume Snapshots",
    subtitle: "",
    confirmationKeyword: "Volume Snapshots"
  },
  [ps.BACKUP]: {
    title: "Delete Backups",
    subtitle: "",
    confirmationKeyword: "Backups"
  },
  [ps.BACKUP_SCHEDULE]: {
    title: "Delete Backup Schedules",
    subtitle: "",
    confirmationKeyword: "Backup Schedules"
  }
}, gx = (s) => {
  const { Pending: t, Progressing: a, Completed: n } = s;
  return t || a ? /* @__PURE__ */ e.jsx("span", { className: "dc__loading-dots", children: "Deleting" }) : `${n} item(s) deleted successfully`;
}, Er = ({
  action: s,
  selections: t,
  onClose: a,
  isBulkSelectionApplied: n,
  bulkOperationModalData: { reloadDataAfterBulkOperation: o, handleDelete: r }
}) => {
  const { handleBulkSelection: l } = nr(), i = de(() => n ? [
    {
      name: "All Selected Items",
      operation: (p) => r(p.current, "*")
    }
  ] : (Object.values(t) || []).map(({ data: p }) => p).map((p) => ({
    name: p.name,
    operation: (d) => r(d.current, p.id)
  })), [s, t, n]), u = () => {
    l({ action: fi.CLEAR_ALL_SELECTIONS }), o();
  };
  return /* @__PURE__ */ e.jsx(
    Rp,
    {
      operations: i,
      textConfig: {
        prompt: _i,
        resultsHeader: fx[s]
      },
      confirmationModalConfig: {
        title: To[s].title,
        subtitle: To[s].subtitle,
        variant: mt.delete,
        buttonConfig: {
          primaryButtonConfig: {
            text: "Initiate Delete"
          },
          secondaryButtonConfig: {
            text: "Cancel"
          }
        },
        confirmationConfig: {
          identifier: `${s}-confirmation`,
          confirmationKeyword: To[s].confirmationKeyword
        }
      },
      handleModalClose: a,
      handleReloadDataAfterBulkOperation: u,
      getResultsChartSummaryText: gx
    }
  );
}, gt = ({ children: s }) => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-16 p-20 br-8 border__secondary bg__primary", children: s }), ga = ({ heading: s, subHeading: t, children: a }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-16 dc__align-items-center", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-1-5", children: s }),
    /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4 lh-1-5", children: t })
  ] }),
  a
] });
var ms = /* @__PURE__ */ ((s) => (s.EQUALS = "Equals", s.EXISTS = "Exists", s.DOES_NOT_EXIST = "DoesNotExist", s.IN = "In", s.NOT_IN = "NotIn", s))(ms || {}), ut = /* @__PURE__ */ ((s) => (s.KEY = "key", s.OPERATOR = "operator", s.VALUE = "value", s))(ut || {}), Nt = /* @__PURE__ */ ((s) => (s.IN = "In", s.NOT_IN = "NotIn", s.EXISTS = "Exists", s.DOES_NOT_EXIST = "DoesNotExist", s))(Nt || {});
const Wo = ms.EQUALS, xx = [
  {
    label: "Key",
    key: ut.KEY,
    width: "264px"
  },
  {
    label: "Operator",
    key: ut.OPERATOR,
    width: "140px"
  },
  {
    label: "Value",
    key: ut.VALUE,
    width: "1fr"
  }
], sn = [
  ms.EXISTS,
  ms.DOES_NOT_EXIST
], Ll = {
  [ms.DOES_NOT_EXIST]: Nt.DOES_NOT_EXIST,
  [ms.EXISTS]: Nt.EXISTS,
  [ms.IN]: Nt.IN,
  [ms.NOT_IN]: Nt.NOT_IN
}, Cx = {
  [Nt.DOES_NOT_EXIST]: ms.DOES_NOT_EXIST,
  [Nt.EXISTS]: ms.EXISTS,
  [Nt.IN]: ms.IN,
  [Nt.NOT_IN]: ms.NOT_IN
}, Gt = () => ({
  key: "",
  value: "",
  operator: Wo,
  id: vs()
}), bx = (s) => ({
  data: {
    [ut.KEY]: {
      value: s?.key || "",
      type: ws.TEXT,
      props: {
        placeholder: "Key"
      }
    },
    [ut.OPERATOR]: {
      value: s?.operator || ms.EQUALS,
      type: ws.DROPDOWN,
      props: {
        options: Object.values(ms).map((t) => ({
          label: t,
          value: t
        })),
        placeholder: "Select operator"
      }
    },
    [ut.VALUE]: {
      value: s?.value || "",
      type: ws.TEXT,
      disabled: sn.includes(s?.operator),
      tooltip: {
        content: sn.includes(s?.operator) ? "Value not required for this operator" : ""
      },
      props: {
        placeholder: "Enter value or variable"
      }
    }
  },
  id: s?.id || vs()
}), Sx = (s) => s.reduce(
  (t, a) => {
    const n = a.key?.trim();
    if (!n || !a.operator)
      return t;
    if (a.operator === ms.EQUALS)
      t.matchLabels[n] = a.value.trim();
    else {
      const o = sn.includes(a.operator) ? {
        key: n,
        operator: Ll[a.operator]
      } : {
        key: n,
        operator: Ll[a.operator],
        values: a.value.trim().split(",").map((r) => r.trim())
      };
      t.matchExpressions.push(o);
    }
    return t;
  },
  {
    matchLabels: {},
    matchExpressions: []
  }
), kl = (s) => {
  const t = [];
  return Object.entries(s.matchLabels || {}).forEach(([a, n]) => {
    !a || !n || t.push({
      key: a,
      value: n,
      operator: ms.EQUALS,
      id: vs()
    });
  }), (s.matchExpressions || []).forEach((a) => {
    const n = Cx[a.operator];
    if (!(!n || !a.key))
      if (sn.includes(n)) {
        const o = n;
        t.push({
          key: a.key,
          operator: o,
          id: vs()
        });
      } else {
        const o = n;
        t.push({
          key: a.key,
          value: (a.values || []).join(", "),
          operator: o,
          id: vs()
        });
      }
  }), t;
}, Pc = ({
  labelSelectors: s,
  orLabelSelectors: t
}) => {
  const a = (t || []).concat([s]).map(Sx).filter((n) => n.matchExpressions.length > 0 || Object.keys(n.matchLabels).length > 0);
  return {
    labelSelectors: a.length === 1 ? a[0] : void 0,
    orLabelSelectors: a.length > 1 ? a : void 0
  };
}, Dl = ({ selectors: s, handleSelectorChange: t, shouldDeleteSelectorGroupOnEmpty: a }) => {
  const n = s.map(bx), o = () => {
    const i = [Gt(), ...s];
    t(i);
  }, r = (i, u, c) => {
    const p = s.map((d) => {
      if (d.id === i.id) {
        const m = { ...d };
        switch (u) {
          case ut.KEY:
            m.key = c || "";
            break;
          case ut.VALUE:
            m.value = c || "";
            break;
          case ut.OPERATOR: {
            const _ = c || Wo;
            sn.includes(_) && (m.value = ""), m.operator = _;
            break;
          }
        }
        return m;
      }
      return d;
    });
    t(p);
  }, l = (i) => {
    const u = s.length === 1;
    if (u && a) {
      t(null);
      return;
    }
    const c = u ? [
      {
        id: i.id,
        key: "",
        value: "",
        operator: Wo
      }
    ] : s.filter((p) => p.id !== i.id);
    t(c);
  };
  return /* @__PURE__ */ e.jsx(
    Zo,
    {
      headers: xx,
      rows: n,
      onRowAdd: o,
      onRowEdit: r,
      onRowDelete: l,
      shouldAutoFocusOnMount: !1
    }
  );
}, Rc = ({
  labelSelectors: s,
  handleLabelSelectorChange: t,
  orLabelSelectors: a,
  handleOrLabelSelectorsChange: n
}) => {
  const o = (l) => (i) => {
    if (!i) {
      const c = a.filter((p, d) => d !== l);
      n(c);
      return;
    }
    const u = a.map(
      (c, p) => p === l ? i : c
    );
    n(u);
  }, r = () => {
    n([...a, [Gt()]]);
  };
  return /* @__PURE__ */ e.jsxs(gt, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-2", children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-14 fw-6 lh-1-5", children: "Filter resources using label selectors" }),
      /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4 lh-18", children: "Use label selectors to define precise resource filters. Labels within the same group are evaluated with AND logic, and separate groups are evaluated with OR logic. The 'in' and 'not in' operators accept multiple comma-separated values." })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsx(Dl, { selectors: s, handleSelectorChange: t }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
        /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-6 lh-1-5", children: "OR" }),
        /* @__PURE__ */ e.jsx("div", { className: "divider divider--secondary w-100" })
      ] }),
      a.map((l, i) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12", children: /* @__PURE__ */ e.jsx(
          Dl,
          {
            selectors: l,
            handleSelectorChange: o(i),
            shouldDeleteSelectorGroupOnEmpty: !0
          }
        ) }, i),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
          /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-6 lh-1-5", children: "OR" }),
          /* @__PURE__ */ e.jsx("div", { className: "divider divider--secondary w-100" })
        ] })
      ] })),
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "add-or-label-selector-button",
          text: "OR label selector",
          size: P.medium,
          variant: U.text,
          startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-add", color: null }),
          onClick: r
        }
      )
    ] })
  ] });
}, vr = ({ signal: s }) => xe(z.SCHEDULE_LIST_MIN, { signal: s }), Nx = ({ signal: s }) => xe(z.BACKUP_LIST_MIN, { signal: s }), Lc = ({ clusterId: s, signal: t }) => xe(Q(z.CONFIG_MAP_LIST_MIN, { clusterId: s }), {
  signal: t
}), kc = ({ signal: s }) => xe(z.VOLUME_SNAPSHOT_LIST_MIN, { signal: s }), Dc = ({ signal: s }) => xe(z.STORAGE_LOCATION_LIST_MIN, { signal: s });
var ss = /* @__PURE__ */ ((s) => (s.NANOSECONDS = "ns", s.MICROSECONDS = "us", s.MICROSECONDS_ALT = "µs", s.MILLISECONDS = "ms", s.SECONDS = "s", s.MINUTES = "m", s.HOURS = "h", s))(ss || {});
const Mc = {
  [ss.NANOSECONDS]: 1e-9,
  [ss.MICROSECONDS]: 1e-6,
  [ss.MICROSECONDS_ALT]: 1e-6,
  [ss.MILLISECONDS]: 1e-3,
  [ss.SECONDS]: 1,
  [ss.MINUTES]: 60,
  [ss.HOURS]: 3600
}, Ml = [
  { label: "Seconds", value: ss.SECONDS },
  { label: "Minutes", value: ss.MINUTES },
  { label: "Hours", value: ss.HOURS }
], Vn = ({ idPrefix: s, value: t, unit: a, onUnitChange: n, onValueChange: o }) => {
  const r = (i) => {
    const u = i.target.value === "" ? null : Number(i.target.value);
    o(u);
  }, l = (i) => {
    n(i.value);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox", children: [
    /* @__PURE__ */ e.jsx(
      ke,
      {
        name: `${s}-timeout-value`,
        type: "number",
        value: t || "",
        placeholder: "Eg. 30",
        onChange: r,
        borderRadiusConfig: {
          right: !1
        },
        borderConfig: {
          right: !1
        }
      }
    ),
    /* @__PURE__ */ e.jsx(
      te,
      {
        inputId: `${s}-timeout-unit-select`,
        classNamePrefix: `${s}-timeout-unit-select`,
        options: Ml,
        value: Ml.find((i) => i.value === a) || null,
        onChange: l,
        isSearchable: !1,
        size: P.large,
        menuSize: P.small,
        borderRadiusConfig: {
          left: !1
        },
        shouldMenuAlignRight: !0
      }
    )
  ] });
}, Ex = (s) => {
  const t = Object.values(ss).join("|"), a = new RegExp(`(-?\\d+(?:\\.\\d+)?)(${t})`, "g");
  let n = a.exec(s), o = 0;
  for (; n !== null; ) {
    const r = parseFloat(n[1]), l = n[2], i = Mc[l];
    if (i === void 0)
      return gi(new Error(`Unknown unit: ${l}`)), 0;
    o += r * i, n = a.exec(s);
  }
  return o;
};
function Ao(s) {
  return !s || typeof s != "string" ? {
    value: null,
    unit: ss.SECONDS
  } : { value: Ex(s), unit: ss.SECONDS };
}
function Gn(s, t) {
  return Number.isNaN(s) ? null : `${s * Mc[t]}s`;
}
var xn = /* @__PURE__ */ ((s) => (s.GCP = "gcp", s))(xn || {});
const Cn = () => ({
  "data-protection-management": {
    component: /* @__PURE__ */ e.jsx(
      B,
      {
        linkProps: {
          to: R.DATA_PROTECTION_OVERVIEW
        },
        component: me.link,
        variant: U.borderLess,
        dataTestId: "data-protection-mgm-overview-btn",
        icon: /* @__PURE__ */ e.jsx(D, { name: "ic-database-backup", color: null }),
        showAriaLabelInTippy: !1,
        size: P.xs,
        ariaLabel: "Navigate to Data Protection Management Overview"
      }
    ),
    linked: !0
  }
});
var Ks = /* @__PURE__ */ ((s) => (s.CONFIG_MAP = "config-map", s.JSON_PATCH = "json-patch", s))(Ks || {}), Zs = /* @__PURE__ */ ((s) => (s.ALL = "all", s.SPECIFIC = "specific", s))(Zs || {}), Dt = /* @__PURE__ */ ((s) => (s.BACKUP = "backup", s.SCHEDULE = "schedule", s))(Dt || {}), dt = /* @__PURE__ */ ((s) => (s.ALL = "all-resources", s.SPECIFIC = "specific-resources", s))(dt || {}), $o = /* @__PURE__ */ ((s) => (s.EXISTING = "ExistingResourceModifier", s.NEW = "CreateResourceModifier", s))($o || {});
const vx = ({
  basicDetails: s,
  setFormData: t,
  basicDetailsError: a,
  setFormError: n,
  metadata: o
}) => {
  const r = (d) => {
    const { value: m } = d.target;
    t((_) => ({ ..._, basicDetails: { ..._.basicDetails, name: m } })), n((_) => ({ ..._, basicDetails: { ..._.basicDetails, name: dn(m).message } }));
  }, l = (d) => {
    const { value: m } = d.target;
    t((_) => ({ ..._, basicDetails: { ..._.basicDetails, description: m } })), n((_) => ({
      ..._,
      basicDetails: { ..._.basicDetails, description: ar(m).message }
    }));
  }, i = (d) => {
    t((m) => ({
      ...m,
      basicDetails: {
        ...m.basicDetails,
        labels: d
      }
    }));
  }, u = (d) => {
    n((m) => ({
      ...m,
      basicDetails: { ...m.basicDetails, labels: d }
    }));
  }, c = (d) => {
    const m = d.target.value;
    t((_) => ({
      ..._,
      basicDetails: { ..._.basicDetails, source: { details: null, type: m } }
    })), n((_) => ({
      ..._,
      basicDetails: { ..._.basicDetails, source: null }
    }));
  }, p = (d) => {
    t((m) => ({
      ...m,
      basicDetails: {
        ...m.basicDetails,
        source: { ...m.basicDetails.source, details: { id: d.value, name: d.label } }
      }
    })), n((m) => ({
      ...m,
      basicDetails: { ...m.basicDetails, source: null }
    }));
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(gt, { children: [
      /* @__PURE__ */ e.jsx(
        ke,
        {
          name: "restore-name",
          value: s.name,
          label: "Restore Name",
          placeholder: "Enter Restore Name",
          onChange: r,
          error: a.name,
          required: !0
        }
      ),
      /* @__PURE__ */ e.jsx(
        At,
        {
          label: "Description",
          name: "restore-description",
          placeholder: "Enter a description",
          value: s.description,
          onChange: l,
          error: a.description
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-20", children: "Labels" }),
        /* @__PURE__ */ e.jsx(
          un,
          {
            headerLabel: { key: "Key", value: "Value" },
            placeholder: { key: "Enter key", value: "Enter value" },
            rows: s.labels.map(({ key: d, value: m, id: _ }) => ({
              data: { key: { value: d }, value: { value: m } },
              id: _
            })),
            showError: !0,
            onChange: i,
            onError: u,
            validateEmptyKeys: !0,
            validateDuplicateKeys: !0,
            isSortable: !0
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs(gt, { children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-14 fw-6 lh-1-5", children: "Restore Source" }),
      /* @__PURE__ */ e.jsxs(
        zs,
        {
          name: "restore-source-type",
          className: "radio-group-no-border",
          value: s.source.type,
          onChange: c,
          children: [
            /* @__PURE__ */ e.jsx(Be, { value: Dt.BACKUP, children: "Specific backup" }),
            /* @__PURE__ */ e.jsx(Be, { value: Dt.SCHEDULE, children: "Latest backup created by a schedule" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "restore-source-backup-select",
          label: "Backup to be restored",
          placeholder: "Select a backup",
          value: s.source.details ? {
            value: s.source.details.id,
            label: s.source.details.name
          } : null,
          options: s.source.type === Dt.BACKUP ? o.backupOptions : o.scheduleOptions,
          onChange: p,
          helperText: s.source.type === Dt.SCHEDULE ? "Restore will be created from the latest successful or partially-failed backup created by the schedule" : null,
          error: a.source,
          required: !0,
          fullWidth: !0
        }
      )
    ] })
  ] });
}, Tx = {
  basicDetails: "Basic Details",
  restoreTarget: "Restore Target",
  restoreSettings: "Restore Settings",
  executionControls: "Timeout & Execution Controls"
}, Ax = {
  basicDetails: {
    name: "",
    description: "",
    labels: [{ key: "", value: "", id: vs() }],
    source: {
      type: Dt.BACKUP,
      details: null
    }
  },
  restoreTarget: {
    clusterDetails: null,
    namespaceDetails: {
      type: Zs.ALL
    },
    resourceSelection: {
      type: dt.ALL
    },
    labelSelectors: [Gt()],
    orLabelSelectors: [[Gt()]]
  },
  restoreSettings: {
    resourceStatus: {
      includedResources: [],
      excludedResources: []
    },
    namespaceMapping: [{ key: "", value: "", id: vs() }],
    clusterScopedResourcesPolicy: "auto",
    restoreVolumes: !1,
    preserveNodePorts: !1,
    existingResourcePolicy: "skip-resources",
    restoreModifierConfig: {
      isEnabled: !1,
      type: Ks.CONFIG_MAP,
      configMap: null
    }
  },
  executionControls: {
    parallelFilesDownload: null,
    writeSparseFiles: !1,
    itemTimeout: {
      value: null,
      unit: ss.SECONDS
    }
  }
}, yx = {
  basicDetails: {
    name: null,
    description: null,
    labels: !1,
    source: null
  },
  restoreTarget: {
    clusterDetails: null,
    specificNamespaces: null,
    resourceSelection: null
  },
  restoreSettings: {
    namespaceMapping: !1,
    restoreModifierConfig: null
  },
  executionControls: {
    parallelFilesDownload: null
  }
}, jx = {
  auto: {
    label: "Auto (Recommended)",
    subHeading: "Include cluster resources for full backups; exclude for namespaced backups"
  },
  "include-all": {
    label: "Include all",
    subHeading: "Always include all cluster-scoped resources"
  },
  "exclude-all": {
    label: "Exclude all",
    subHeading: "Always exclude cluster-scoped resources"
  }
}, Bl = Object.entries(jx).map(([s, { label: t, subHeading: a }]) => ({
  label: t,
  value: s,
  subHeading: a
})), Ox = {
  "skip-resources": {
    label: "Skip resources",
    subHeading: "Skip resources that already exist in the cluster"
  },
  "update-resources": {
    label: "Update resources",
    subHeading: "Patch existing resources to match the backup"
  }
}, Ul = Object.entries(
  Ox
).map(([s, { label: t, subHeading: a }]) => ({
  label: t,
  value: s,
  subHeading: a
})), Ix = [
  "agents.kagent.dev",
  "alertmanagers.monitoring.coreos.com",
  "alerts.notification.toolkit.fluxcd.io",
  "allowlistsynchronizers.auto.gke.io",
  "analysisruns.argoproj.io",
  "apisixclusterconfigs.apisix.apache.org",
  "apisixconsumers.apisix.apache.org",
  "apisixglobalrules.apisix.apache.org",
  "apisixpluginconfigs.apisix.apache.org",
  "apisixroutes.apisix.apache.org",
  "apisixtlses.apisix.apache.org",
  "apisixupstreams.apisix.apache.org",
  "applications.argoproj.io",
  "applicationsets.argoproj.io",
  "appprojects.argoproj.io",
  "audits.warden.gke.io",
  "authorizationpolicies.security.istio.io",
  "backuprepositories.velero.io",
  "backups.postgresql.cnpg.io",
  "backups.velero.io",
  "backupstoragelocations.velero.io",
  "buckets.source.toolkit.fluxcd.io",
  "canaries.flagger.app",
  "capacityrequests.internal.autoscaling.gke.io",
  "certificaterequests.cert-manager.io",
  "certificates.cert-manager.io",
  "challenges.acme.cert-manager.io",
  "cleanuppolicies.kyverno.io",
  "cloudeventsources.eventing.keda.sh",
  "clustercleanuppolicies.kyverno.io",
  "clusterexternalsecrets.external-secrets.io",
  "clusterissuers.cert-manager.io",
  "clusternodemonitorings.monitoring.googleapis.com",
  "clusterpodmonitorings.monitoring.googleapis.com",
  "clusterpolicies.kyverno.io",
  "clusterpushsecrets.external-secrets.io",
  "clusterrules.monitoring.googleapis.com",
  "clusters.postgresql.cnpg.io",
  "clustersecretstores.external-secrets.io",
  "clustertriggerauthentications.keda.sh",
  "computeclasses.cloud.google.com",
  "connectors.tailscale.com",
  "cronworkflows.argoproj.io",
  "databases.postgresql.cnpg.io",
  "datadownloads.velero.io",
  "datauploads.velero.io",
  "deletebackuprequests.velero.io",
  "destinationrules.networking.istio.io",
  "dnsconfigs.tailscale.com",
  "downloadrequests.velero.io",
  "ec2nodeclasses.karpenter.k8s.aws",
  "envoyfilters.networking.istio.io",
  "eventbus.argoproj.io",
  "eventsources.argoproj.io",
  "experiments.argoproj.io",
  "externalartifacts.source.toolkit.fluxcd.io",
  "externalsecrets.external-secrets.io",
  "failoverquorums.postgresql.cnpg.io",
  "gateways.networking.istio.io",
  "gcpdatasources.datalayer.gke.io",
  "gcpresourceallowlists.node.gke.io",
  "generatorstates.generators.external-secrets.io",
  "gitrepositories.source.toolkit.fluxcd.io",
  "gkenetworkparamsets.networking.gke.io",
  "globalrules.monitoring.googleapis.com",
  "helmcharts.source.toolkit.fluxcd.io",
  "helmreleases.helm.toolkit.fluxcd.io",
  "helmrepositories.source.toolkit.fluxcd.io",
  "hibernators.pincher.devtron.ai",
  "httpscaledobjects.http.keda.sh",
  "imagepolicies.image.toolkit.fluxcd.io",
  "imagerepositories.image.toolkit.fluxcd.io",
  "imageupdateautomations.image.toolkit.fluxcd.io",
  "issuers.cert-manager.io",
  "kustomizations.kustomize.toolkit.fluxcd.io",
  "memories.kagent.dev",
  "modelconfigs.kagent.dev",
  "mongodbcommunity.mongodbcommunity.mongodb.com",
  "networks.networking.gke.io",
  "nificonnections.nifi.konpyutaika.com",
  "nifidataflows.nifi.konpyutaika.com",
  "nifinodegroupautoscalers.nifi.konpyutaika.com",
  "nifiparametercontexts.nifi.konpyutaika.com",
  "nifiregistryclients.nifi.konpyutaika.com",
  "nifiresources.nifi.konpyutaika.com",
  "nifiusergroups.nifi.konpyutaika.com",
  "nifiusers.nifi.konpyutaika.com",
  "nodeclaims.karpenter.sh",
  "nodepools.karpenter.sh",
  "nodetopologies.networking.gke.io",
  "ocirepositories.source.toolkit.fluxcd.io",
  "orders.acme.cert-manager.io",
  "peerauthentications.security.istio.io",
  "podmonitorings.monitoring.googleapis.com",
  "podvolumebackups.velero.io",
  "podvolumerestores.velero.io",
  "policies.kyverno.io",
  "poolers.postgresql.cnpg.io",
  "prometheusagents.monitoring.coreos.com",
  "prometheuses.monitoring.coreos.com",
  "providers.notification.toolkit.fluxcd.io",
  "provisioningrequests.autoscaling.x-k8s.io",
  "proxyclasses.tailscale.com",
  "proxyconfigs.networking.istio.io",
  "proxygroups.tailscale.com",
  "publications.postgresql.cnpg.io",
  "pushsecrets.external-secrets.io",
  "receivers.notification.toolkit.fluxcd.io",
  "recorders.tailscale.com",
  "requestauthentications.security.istio.io",
  "restores.velero.io",
  "rules.monitoring.googleapis.com",
  "scaledjobs.keda.sh",
  "scaledobjects.keda.sh",
  "scheduledbackups.postgresql.cnpg.io",
  "schedules.velero.io",
  "secretstores.external-secrets.io",
  "sensors.argoproj.io",
  "serverstatusrequests.velero.io",
  "serviceentries.networking.istio.io",
  "servicefunctionchains.networking.gke.io",
  "sidecars.networking.istio.io",
  "subscriptions.postgresql.cnpg.io",
  "teams.kagent.dev",
  "telemetries.telemetry.istio.io",
  "terraforms.infra.contrib.fluxcd.io",
  "thanosrulers.monitoring.coreos.com",
  "toolservers.kagent.dev",
  "trafficselectors.networking.gke.io",
  "triggerauthentications.keda.sh",
  "trustconfigs.security.cloud.google.com",
  "turndownschedules.kubecost.com",
  "updaterequests.kyverno.io",
  "virtualservices.networking.istio.io",
  "vmrules.operator.victoriametrics.com",
  "vmservicescrapes.operator.victoriametrics.com",
  "volumesnapshotcontents.snapshot.storage.k8s.io",
  "volumesnapshotlocations.velero.io",
  "volumesnapshots.snapshot.storage.k8s.io",
  "wasmplugins.extensions.istio.io",
  "workflowartifactgctasks.argoproj.io",
  "workflowtasksets.argoproj.io",
  "workloadcertificateconfigs.security.cloud.google.com",
  "workloadentries.networking.istio.io",
  "workloadgroups.networking.istio.io",
  "pods.v1",
  "nodes.v1",
  "services.v1",
  "endpoints.v1",
  "persistentvolumes.v1",
  "persistentvolumeclaims.v1",
  "namespaces.v1",
  "events.v1",
  "configmaps.v1",
  "secrets.v1",
  "deployments.apps",
  "statefulsets.apps",
  "daemonsets.apps",
  "replicasets.apps",
  "jobs.batch",
  "cronjobs.batch",
  "horizontalpodautoscalers.autoscaling",
  "ingresses.networking.k8s.io",
  "networkpolicies.networking.k8s.io"
], wx = Ix.map(
  (s) => ({
    label: s,
    value: s
  })
), Px = {
  "skip-resources": "none",
  "update-resources": "update"
}, Rx = `# Example:
version: v1
resourceModifierRules:
- conditions:
    groupResource: pods
    namespaces:
    - ns1
  mergePatches:
  - patchData: |
      {
        "metadata": {
          "annotations": {
            "foo": null
          }
        }
      }`, Bc = (s) => !nn(s) && s !== !1, Lx = (s, t) => {
  const a = { ...t };
  a.name = a.name || Ps(s.name).message;
  const o = s.source.details?.id ? null : "Please select a backup source.";
  return a.source = a.source || o, a;
}, kx = (s, t) => {
  const a = { ...t }, o = s.clusterDetails?.id ? null : "Please select a cluster.";
  if (a.clusterDetails = a.clusterDetails || o, s.namespaceDetails.type === Zs.SPECIFIC) {
    const u = (s.namespaceDetails.includedNamespaces.length || 0) + (s.namespaceDetails.excludedNamespaces.length || 0) > 0 ? null : "Please select at least one namespace.";
    a.specificNamespaces = a.specificNamespaces || u;
  }
  if (s.resourceSelection.type === dt.SPECIFIC) {
    const u = (s.resourceSelection.includedResources.length || 0) + (s.resourceSelection.excludedResources.length || 0) > 0 ? null : "Please select at least one resource.";
    a.resourceSelection = a.resourceSelection || u;
  }
  return a;
}, Dx = (s, t) => {
  const a = {
    ...t
  }, n = s.restoreModifierConfig.type === Ks.CONFIG_MAP ? s.restoreModifierConfig.configMap?.value : s.restoreModifierConfig.jsonPatch, o = !s.restoreModifierConfig.isEnabled || n ? null : "This field is required.";
  return a.restoreModifierConfig = a.restoreModifierConfig || o, a;
}, Mx = (s, t) => {
  const a = structuredClone(t);
  return a.basicDetails = Lx(s.basicDetails, t.basicDetails), a.restoreTarget = kx(
    s.restoreTarget,
    t.restoreTarget
  ), a.restoreSettings = Dx(
    s.restoreSettings,
    t.restoreSettings
  ), { isErrorPresent: Object.keys(a).some((o) => {
    const r = a[o];
    return Object.values(r).some(Bc);
  }), updatedErrorState: a };
}, Bx = (s) => s === Zs.ALL ? {
  type: Zs.ALL
} : {
  type: Zs.SPECIFIC,
  includedNamespaces: [],
  excludedNamespaces: []
}, Ux = (s) => s === dt.ALL ? {
  type: dt.ALL
} : {
  type: dt.SPECIFIC,
  includedResources: [],
  excludedResources: []
}, Fx = (s) => s.isEnabled ? s.type === Ks.CONFIG_MAP ? {
  type: $o.EXISTING,
  name: s.configMap.value
} : {
  type: $o.NEW,
  data: s.jsonPatch
} : null, Vx = (s) => s === "auto" ? null : s !== "exclude-all", Gx = (s) => s.type === Zs.ALL ? {
  isAllNamespacesIncluded: !0
} : {
  isAllNamespacesIncluded: !1,
  includedNamespaces: (s.includedNamespaces || []).map((t) => t.value),
  excludedNamespaces: (s.excludedNamespaces || []).map((t) => t.value)
}, Wx = (s) => ({
  name: s.name,
  description: s.description,
  labels: (s.labels || []).reduce((t, a) => {
    const n = a.key.trim(), o = a.value.trim();
    return n && (t[n] = o), t;
  }, {}),
  clusterBackupId: s.source.type === Dt.BACKUP ? s.source.details.id : null,
  clusterScheduleId: s.source.type === Dt.SCHEDULE ? s.source.details.id : null
}), $x = (s) => ({
  ...Pc({
    labelSelectors: s.labelSelectors,
    orLabelSelectors: s.orLabelSelectors
  }),
  ...Gx(s.namespaceDetails),
  targetClusterId: s.clusterDetails.id,
  includedResources: s.resourceSelection.includedResources?.map((t) => t.value),
  excludedResources: s.resourceSelection.excludedResources?.map((t) => t.value)
}), Kx = (s) => ({
  restoreStatus: {
    includedResources: s.resourceStatus.includedResources?.map((t) => t.value) || null,
    excludedResources: s.resourceStatus.excludedResources?.map((t) => t.value) || null
  },
  namespaceMapping: (s.namespaceMapping || []).reduce(
    (t, a) => {
      const n = a.key.trim(), o = a.value.trim();
      return n && o && (t[n] = o), t;
    },
    {}
  ),
  includeClusterResources: Vx(s.clusterScopedResourcesPolicy),
  restorePVs: s.restoreVolumes,
  preserveNodePorts: s.preserveNodePorts,
  existingResourcePolicy: Px[s.existingResourcePolicy],
  resourceModifierConfig: Fx(s.restoreModifierConfig)
}), Hx = (s) => ({
  itemOperationTimeout: nn(s.itemTimeout.value) ? null : Gn(s.itemTimeout.value, s.itemTimeout.unit),
  uploaderConfig: {
    writeSparseFiles: s.writeSparseFiles,
    parallelFilesDownload: s.parallelFilesDownload
  }
}), Yx = (s) => ({
  ...Wx(s.basicDetails),
  ...$x(s.restoreTarget),
  ...Kx(s.restoreSettings),
  ...Hx(s.executionControls)
}), zx = ({ currentTab: s, setCurrentTab: t, formError: a }) => {
  const n = (r) => !Object.values(a[r]).some((l) => Bc(l)), o = (r) => () => {
    t(r);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col py-20 px-12 dc__gap-12 bg__modal--primary dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: Object.entries(Tx).map(([r, l]) => /* @__PURE__ */ e.jsx(
      "div",
      {
        className: `py-6 px-8 br-4 flexbox dc__gap-8 dc__align-items-center ${r === s ? "bcb-1" : "bg__hover"}`,
        children: /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: "dc__transparent flexbox dc__content-space flex-grow-1 dc__align-items-center dc__gap-8",
            "data-testid": `move-to-${r}-tab`,
            onClick: o(r),
            children: [
              /* @__PURE__ */ e.jsx(
                "span",
                {
                  className: `${r === s ? "fw-6 cb-5" : "fw-4 cn-9"} fs-13 lh-1-5 dc__truncate`,
                  children: l
                }
              ),
              !n(r) && /* @__PURE__ */ e.jsx(D, { name: "ic-warning-fill", size: 16, color: "R500" })
            ]
          }
        )
      },
      r
    )) }),
    /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 dc__align-start", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: "📙 Need help?" }),
      /* @__PURE__ */ e.jsx(
        ln,
        {
          docLinkKey: "DOC_HOME_PAGE",
          text: "View documentation",
          dataTestId: "restore-doc-link",
          showExternalIcon: !0,
          openInNewTab: !0
        }
      )
    ] })
  ] });
}, qx = ({
  executionControls: s,
  executionControlsError: t,
  setFormData: a,
  setFormError: n
}) => {
  const o = (u) => {
    const c = u.target.value ? parseInt(u.target.value, 10) : null;
    a((p) => ({
      ...p,
      executionControls: {
        ...p.executionControls,
        parallelFilesDownload: c
      }
    })), n((p) => ({
      ...p,
      executionControls: {
        ...p.executionControls,
        parallelFilesDownload: c < 0 ? "Parallel files download must be a non-negative number" : null
      }
    }));
  }, r = () => {
    a((u) => ({
      ...u,
      executionControls: {
        ...u.executionControls,
        writeSparseFiles: !u.executionControls.writeSparseFiles
      }
    }));
  }, l = (u) => {
    a((c) => ({
      ...c,
      executionControls: {
        ...c.executionControls,
        itemTimeout: {
          ...c.executionControls.itemTimeout,
          unit: u
        }
      }
    }));
  }, i = (u) => {
    a((c) => ({
      ...c,
      executionControls: {
        ...c.executionControls,
        itemTimeout: {
          ...c.executionControls.itemTimeout,
          value: u
        }
      }
    }));
  };
  return /* @__PURE__ */ e.jsxs(gt, { children: [
    /* @__PURE__ */ e.jsx(
      ke,
      {
        name: "parallelFilesDownload",
        label: "Parallel Files Download",
        type: "number",
        value: s.parallelFilesDownload,
        error: t.parallelFilesDownload,
        placeholder: "Eg. 10",
        onChange: o,
        helperText: "Number of restore operations to run at once. Set to 0 to use the CPU count of the node running the node agent pod."
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "divider divider--secondary" }),
    /* @__PURE__ */ e.jsx(ga, { heading: "Write Sparse Files", subHeading: "Whether to write sparse files during restoring volumes", children: /* @__PURE__ */ e.jsx(
      ft,
      {
        name: "writeSparseFiles",
        ariaLabel: "write-sparse-files-switch",
        isChecked: s.writeSparseFiles,
        onChange: r
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "divider divider--secondary" }),
    /* @__PURE__ */ e.jsx(
      ga,
      {
        heading: "Item Operation Timeout",
        subHeading: "How long to wait for async plugin operations before timeout",
        children: /* @__PURE__ */ e.jsx(
          Vn,
          {
            idPrefix: "execution-control",
            value: s.itemTimeout.value,
            unit: s.itemTimeout.unit,
            onUnitChange: l,
            onValueChange: i
          }
        )
      }
    )
  ] });
}, Xx = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
  /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "A resource modifier ConfigMap lets you customize Kubernetes resources during a restore by applying JSON patch rules before they are recreated on the target cluster. This helps make backups portable and ensures smooth restores across different environments." }),
  /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-6 lh-20", children: "Example use cases:" }),
  /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Cluster migrations: Change storageClassNames in PVCs to match storage classes available in the new cluster. How to use: Create a ConfigMap with JSON patch rules defining the changes you want. Velero will automatically apply these rules to your resources during the restore, allowing you to tailor them for your target cluster's setup." })
] }), Jx = ({
  restoreSettings: s,
  restoreSettingsError: t,
  setFormData: a,
  setFormError: n,
  configMapOptions: o
}) => {
  const r = (c) => {
    const d = c.target.value === Ks.CONFIG_MAP ? {
      type: Ks.CONFIG_MAP,
      configMap: null
    } : {
      type: Ks.JSON_PATCH,
      jsonPatch: ""
    };
    a((m) => ({
      ...m,
      restoreSettings: {
        ...m.restoreSettings,
        restoreModifierConfig: {
          isEnabled: m.restoreSettings.restoreModifierConfig.isEnabled,
          ...d
        }
      }
    })), n((m) => ({
      ...m,
      restoreSettings: {
        ...m.restoreSettings,
        restoreModifierConfig: null
      }
    }));
  }, l = (c) => {
    const p = {
      type: Ks.CONFIG_MAP,
      configMap: c
    };
    a((d) => ({
      ...d,
      restoreSettings: {
        ...d.restoreSettings,
        restoreModifierConfig: {
          isEnabled: d.restoreSettings.restoreModifierConfig.isEnabled,
          ...p
        }
      }
    })), n((d) => ({
      ...d,
      restoreSettings: {
        ...d.restoreSettings,
        restoreModifierConfig: null
      }
    }));
  }, i = (c) => {
    const p = {
      type: Ks.JSON_PATCH,
      jsonPatch: c
    };
    a((d) => ({
      ...d,
      restoreSettings: {
        ...d.restoreSettings,
        restoreModifierConfig: {
          isEnabled: d.restoreSettings.restoreModifierConfig.isEnabled,
          ...p
        }
      }
    })), n((d) => ({
      ...d,
      restoreSettings: {
        ...d.restoreSettings,
        restoreModifierConfig: Ps(c).message
      }
    }));
  }, u = () => {
    a((c) => ({
      ...c,
      restoreSettings: {
        ...c.restoreSettings,
        restoreModifierConfig: {
          ...c.restoreSettings.restoreModifierConfig,
          isEnabled: !c.restoreSettings.restoreModifierConfig.isEnabled
        }
      }
    }));
  };
  return /* @__PURE__ */ e.jsx(gt, { children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center dc__content-space", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6", children: [
        /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-14 fw-6 lh-1-5", children: "Modify resources during restore" }),
        /* @__PURE__ */ e.jsx(
          Tt,
          {
            heading: "Modify resources during restore",
            infoText: Xx()
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(
        ft,
        {
          name: "toggle-enable-modify-resources-switch",
          ariaLabel: "Enable Modify Resources Switch",
          isChecked: s.restoreModifierConfig.isEnabled,
          onChange: u
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(Qo, { expand: s.restoreModifierConfig.isEnabled, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      /* @__PURE__ */ e.jsxs(
        zs,
        {
          className: "no-border",
          value: s.restoreModifierConfig.type,
          name: "restore-modifier-config-radio-group",
          onChange: r,
          children: [
            /* @__PURE__ */ e.jsx(
              Be,
              {
                value: Ks.CONFIG_MAP,
                dataTestId: "restore-target-namespace-all-checkbox",
                children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Select ConfigMap" })
              }
            ),
            /* @__PURE__ */ e.jsx(
              Be,
              {
                value: Ks.JSON_PATCH,
                dataTestId: "restore-target-namespace-specific-checkbox",
                children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Provide Resource Modifier" })
              }
            )
          ]
        }
      ),
      s.restoreModifierConfig.type === Ks.CONFIG_MAP ? /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "restore-modifier-config-config-map",
          options: o.options || [],
          value: s.restoreModifierConfig.configMap,
          onChange: l,
          placeholder: "Select a ConfigMap",
          label: "Resource Modifier ConfigMap",
          required: !0,
          fullWidth: !0,
          error: t.restoreModifierConfig,
          isLoading: o.isLoading,
          optionListError: o.error,
          reloadOptionList: o.refetch
        }
      ) : /* @__PURE__ */ e.jsx(
        bs,
        {
          value: s.restoreModifierConfig.jsonPatch,
          mode: ht.YAML,
          height: 300,
          onChange: i,
          placeholder: Rx,
          children: t.restoreModifierConfig && /* @__PURE__ */ e.jsx(bs.ErrorBar, { text: t.restoreModifierConfig })
        }
      )
    ] }) })
  ] }) });
}, Qx = ({
  restoreSettings: s,
  setFormData: t
}) => {
  const a = (r) => (l) => {
    t((i) => ({
      ...i,
      restoreSettings: {
        ...i.restoreSettings,
        resourceStatus: {
          ...i.restoreSettings.resourceStatus,
          includedResources: r ? i.restoreSettings.resourceStatus.includedResources : l || [],
          excludedResources: r ? l || [] : i.restoreSettings.resourceStatus.excludedResources || []
        }
      }
    }));
  }, n = (r) => (l) => {
    const i = { label: l, value: l }, u = r ? [...s.resourceStatus.excludedResources || [], i] : [...s.resourceStatus.includedResources || [], i];
    a(r)(u);
  }, o = (r) => /* @__PURE__ */ e.jsx(
    te,
    {
      inputId: r ? "status-excluded-resources-select" : "status-included-resources-select",
      isMulti: !0,
      label: r ? "Status Excluded Resources" : "Status Included Resources",
      helperText: `Resources to ${r ? "exclude" : "include"} in the restore status, formatted as resourceKind.group, such as storageclasses.storage.k8s.io`,
      placeholder: `Type resource to ${r ? "exclude" : "include"}`,
      options: wx,
      value: r ? s.resourceStatus.excludedResources : s.resourceStatus.includedResources,
      isCreatable: !0,
      onCreateOption: n(r),
      onChange: a(r)
    }
  );
  return /* @__PURE__ */ e.jsxs(gt, { children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-14 fw-6 lh-1-5", children: "Resource Status" }),
    o(!1),
    o(!0)
  ] });
}, Zx = ({
  restoreSettings: s,
  restoreSettingsError: t,
  setFormData: a,
  setFormError: n,
  configMapOptions: o
}) => {
  const r = (d) => {
    a((m) => ({
      ...m,
      restoreSettings: {
        ...m.restoreSettings,
        namespaceMapping: d
      }
    }));
  }, l = (d) => {
    n((m) => ({
      ...m,
      restoreSettings: { ...m.restoreSettings, namespaceMapping: d }
    }));
  }, i = (d) => {
    a((m) => ({
      ...m,
      restoreSettings: {
        ...m.restoreSettings,
        clusterScopedResourcesPolicy: d.value
      }
    }));
  }, u = () => {
    a((d) => ({
      ...d,
      restoreSettings: {
        ...d.restoreSettings,
        restoreVolumes: !d.restoreSettings.restoreVolumes
      }
    }));
  }, c = () => {
    a((d) => ({
      ...d,
      restoreSettings: {
        ...d.restoreSettings,
        preserveNodePorts: !d.restoreSettings.preserveNodePorts
      }
    }));
  }, p = (d) => {
    a((m) => ({
      ...m,
      restoreSettings: {
        ...m.restoreSettings,
        existingResourcePolicy: d.value
      }
    }));
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Qx, { restoreSettings: s, setFormData: a }),
    /* @__PURE__ */ e.jsxs(gt, { children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-14 fw-6 lh-1-5", children: "Namespace Mapping" }),
      /* @__PURE__ */ e.jsx(
        un,
        {
          headerLabel: { key: "Source Namespace", value: "Target Namespace" },
          placeholder: { key: "Eg. prod", value: "Eg. prod-2" },
          rows: s.namespaceMapping.map(({ key: d, value: m, id: _ }) => ({
            data: { key: { value: d }, value: { value: m } },
            id: _
          })),
          showError: !0,
          onChange: r,
          onError: l,
          validateEmptyKeys: !0,
          validateDuplicateKeys: !0,
          isSortable: !0
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs(gt, { children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-14 fw-6 lh-1-5", children: "More Settings" }),
      /* @__PURE__ */ e.jsx(
        ga,
        {
          heading: "Include cluster resources",
          subHeading: "Whether to include cluster-scoped resources in the restore",
          children: /* @__PURE__ */ e.jsx(
            te,
            {
              inputId: "cluster-resource-policy",
              options: Bl,
              value: Bl.find(
                (d) => d.value === s.clusterScopedResourcesPolicy
              ) || null,
              onChange: i,
              variant: We.COMPACT,
              shouldMenuAlignRight: !0
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "divider divider--secondary" }),
      /* @__PURE__ */ e.jsx(ga, { heading: "Restore Volume", subHeading: "Whether to restore volumes from snapshot", children: /* @__PURE__ */ e.jsx(
        ft,
        {
          name: "restore-volume-switch",
          ariaLabel: "Restore Volume Switch",
          isChecked: s.restoreVolumes,
          onChange: u
        }
      ) }),
      /* @__PURE__ */ e.jsx("div", { className: "divider divider--secondary" }),
      /* @__PURE__ */ e.jsx(
        ga,
        {
          heading: "Preserve Node Ports",
          subHeading: "Whether to preserve node ports of services during restore",
          children: /* @__PURE__ */ e.jsx(
            ft,
            {
              name: "preserve-node-ports-switch",
              ariaLabel: "Preserve Node Ports Switch",
              isChecked: s.preserveNodePorts,
              onChange: c
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "divider divider--secondary" }),
      /* @__PURE__ */ e.jsx(
        ga,
        {
          heading: "Existing Resource Policy",
          subHeading: "Defines how to handle resources if they already exist in the cluster during restore",
          children: /* @__PURE__ */ e.jsx(
            te,
            {
              inputId: "existing-resource-policy",
              options: Ul,
              value: Ul.find(
                (d) => d.value === s.existingResourcePolicy
              ) || null,
              onChange: p,
              variant: We.COMPACT,
              shouldMenuAlignRight: !0
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      Jx,
      {
        restoreSettings: s,
        restoreSettingsError: t,
        setFormData: a,
        setFormError: n,
        configMapOptions: o
      }
    )
  ] });
}, eC = ({
  restoreTarget: s,
  setFormData: t,
  restoreTargetError: a,
  setFormError: n,
  metadata: o
}) => {
  const r = (c) => {
    t((p) => {
      const d = {
        ...p.restoreTarget,
        clusterDetails: {
          id: c.value,
          name: c.label
        }
      };
      return {
        ...p,
        restoreTarget: d
      };
    }), n((p) => ({
      ...p,
      restoreTarget: {
        ...p.restoreTarget,
        clusterDetails: null
      }
    }));
  }, l = (c) => {
    const p = c.target.value;
    t((d) => {
      const m = {
        ...d.restoreTarget,
        namespaceDetails: Bx(p)
      };
      return {
        ...d,
        restoreTarget: m
      };
    }), n((d) => ({
      ...d,
      restoreTarget: {
        ...d.restoreTarget,
        specificNamespaces: null
      }
    }));
  }, i = (c) => (p) => {
    const d = {
      ...s,
      namespaceDetails: {
        type: Zs.SPECIFIC,
        includedNamespaces: c ? s.namespaceDetails.includedNamespaces : p || [],
        excludedNamespaces: c ? p || [] : s.namespaceDetails.excludedNamespaces
      }
    }, m = (d.namespaceDetails.includedNamespaces.length || 0) + (d.namespaceDetails.excludedNamespaces.length || 0);
    t((_) => ({
      ..._,
      restoreTarget: d
    })), n((_) => ({
      ..._,
      restoreTarget: {
        ..._.restoreTarget,
        specificNamespaces: m > 0 ? null : "Please enter namespaces to include or exclude"
      }
    }));
  }, u = (c) => (p) => {
    const d = { label: p, value: p }, m = c ? [...s.namespaceDetails.excludedNamespaces || [], d] : [...s.namespaceDetails.includedNamespaces || [], d];
    i(c)(m);
  };
  return /* @__PURE__ */ e.jsxs(gt, { children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-14 fw-6 lh-1-5", children: "Restore to" }),
    /* @__PURE__ */ e.jsx(
      te,
      {
        inputId: "restore-target-cluster",
        label: "Restore to",
        options: o.clusterOptions || [],
        value: s.clusterDetails ? {
          label: s.clusterDetails.name,
          value: s.clusterDetails.id
        } : null,
        required: !0,
        placeholder: "Select a Cluster",
        isClearable: !1,
        onChange: r,
        error: a.clusterDetails
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(
        zs,
        {
          className: "no-border",
          value: s.namespaceDetails.type,
          name: "restore-target-namespace-type",
          onChange: l,
          children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
            /* @__PURE__ */ e.jsx(
              Be,
              {
                value: Zs.ALL,
                dataTestId: "restore-target-namespace-all-checkbox",
                children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "All Namespaces" })
              }
            ),
            /* @__PURE__ */ e.jsxs(
              Be,
              {
                value: Zs.SPECIFIC,
                dataTestId: "restore-target-namespace-specific-checkbox",
                children: [
                  /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Specific Namespaces" }),
                  a.specificNamespaces && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                    /* @__PURE__ */ e.jsx("br", {}),
                    /* @__PURE__ */ e.jsx("span", { className: "cr-5 fs-12 fw-4 lh-18", children: a.specificNamespaces })
                  ] })
                ]
              }
            )
          ] })
        }
      ),
      s.namespaceDetails.type === Zs.SPECIFIC && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "included-namespaces-select",
            isMulti: !0,
            label: "Included Namespaces",
            placeholder: "Type and Enter to include namespace",
            options: [],
            value: s.namespaceDetails.includedNamespaces,
            isCreatable: !0,
            onCreateOption: u(!1),
            onChange: i(!1)
          }
        ),
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "excluded-namespaces-select",
            label: "Excluded Namespaces",
            placeholder: "Type and Enter to exclude namespace",
            isMulti: !0,
            options: [],
            value: s.namespaceDetails.excludedNamespaces,
            isCreatable: !0,
            onCreateOption: u(!0),
            onChange: i(!0)
          }
        )
      ] })
    ] })
  ] });
}, sC = ({
  restoreTarget: s,
  setFormData: t,
  restoreTargetError: a,
  setFormError: n
}) => {
  const o = (i) => {
    const u = i.target.value;
    t((c) => {
      const p = {
        ...c.restoreTarget,
        resourceSelection: Ux(u)
      };
      return {
        ...c,
        restoreTarget: p
      };
    }), n((c) => ({
      ...c,
      restoreTarget: {
        ...c.restoreTarget,
        resourceSelection: null
      }
    }));
  }, r = (i) => (u) => {
    const c = {
      ...s,
      resourceSelection: {
        type: dt.SPECIFIC,
        includedResources: i ? s.resourceSelection.includedResources : u || [],
        excludedResources: i ? u || [] : s.resourceSelection.excludedResources || []
      }
    }, p = (c.resourceSelection.includedResources.length || 0) + (c.resourceSelection.excludedResources.length || 0);
    t((d) => ({
      ...d,
      restoreTarget: c
    })), n((d) => ({
      ...d,
      restoreTarget: {
        ...d.restoreTarget,
        resourceSelection: p > 0 ? null : "Please enter resources to include or exclude"
      }
    }));
  }, l = (i) => (u) => {
    const c = { label: u, value: u }, p = i ? [...s.resourceSelection.excludedResources || [], c] : [...s.resourceSelection.includedResources || [], c];
    r(i)(p);
  };
  return /* @__PURE__ */ e.jsxs(gt, { children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-14 fw-6 lh-1-5", children: "Resources to restore based on resource kind" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(
        zs,
        {
          className: "no-border",
          value: s.resourceSelection.type,
          name: "restore-target-resource-selection-type",
          onChange: o,
          children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
            /* @__PURE__ */ e.jsx(
              Be,
              {
                value: dt.ALL,
                dataTestId: "restore-target-resource-selection-all-checkbox",
                children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "All Resources" })
              }
            ),
            /* @__PURE__ */ e.jsxs(
              Be,
              {
                value: dt.SPECIFIC,
                dataTestId: "restore-target-resource-selection-specific-checkbox",
                children: [
                  /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Specific Resource" }),
                  /* @__PURE__ */ e.jsx("br", {}),
                  /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-12 fw-4 lh-18", children: "Select resource kinds or enter specific resources, formatted as resourceKind.group, such as storageclasses.storage.k8s.io" }),
                  a.resourceSelection && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                    /* @__PURE__ */ e.jsx("br", {}),
                    /* @__PURE__ */ e.jsx("span", { className: "cr-5 fs-12 fw-4 lh-18", children: a.resourceSelection })
                  ] })
                ]
              }
            )
          ] })
        }
      ),
      s.resourceSelection.type === dt.SPECIFIC && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "included-resources-select",
            isMulti: !0,
            label: "Included Resources",
            placeholder: "Type and Enter to include resource",
            options: [],
            value: s.resourceSelection.includedResources,
            isCreatable: !0,
            onCreateOption: l(!1),
            onChange: r(!1)
          }
        ),
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "excluded-resources-select",
            label: "Excluded Resources",
            placeholder: "Type and Enter to exclude resource",
            isMulti: !0,
            options: [],
            value: s.resourceSelection.excludedResources,
            isCreatable: !0,
            onCreateOption: l(!0),
            onChange: r(!0)
          }
        )
      ] })
    ] })
  ] });
}, tC = ({
  restoreTarget: s,
  setFormData: t,
  restoreTargetError: a,
  setFormError: n,
  metadata: o
}) => {
  const r = (i) => {
    t((u) => ({
      ...u,
      restoreTarget: {
        ...u.restoreTarget,
        labelSelectors: i
      }
    }));
  }, l = (i) => {
    t((u) => ({
      ...u,
      restoreTarget: {
        ...u.restoreTarget,
        orLabelSelectors: i
      }
    }));
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      eC,
      {
        restoreTarget: s,
        setFormData: t,
        restoreTargetError: a,
        setFormError: n,
        metadata: o
      }
    ),
    /* @__PURE__ */ e.jsx(
      sC,
      {
        restoreTarget: s,
        setFormData: t,
        restoreTargetError: a,
        setFormError: n
      }
    ),
    /* @__PURE__ */ e.jsx(
      Rc,
      {
        labelSelectors: s.labelSelectors,
        handleLabelSelectorChange: r,
        handleOrLabelSelectorsChange: l,
        orLabelSelectors: s.orLabelSelectors
      }
    )
  ] });
}, aC = async (s) => {
  try {
    return await _s(z.CLUSTER_BACKUP_RESTORE, Yx(s)), !0;
  } catch (t) {
    return ve(t), !1;
  }
}, nC = async ({
  signal: s
}) => {
  const [t, a, n] = await Promise.all([
    Nx({ signal: s }),
    vr({ signal: s }),
    or(s)
  ]);
  return {
    backupOptions: (t.result || []).sort((o, r) => Ae(o.name, r.name)).map((o) => ({
      label: o.name,
      value: o.id
    })),
    scheduleOptions: (a.result || []).sort((o, r) => Ae(o.name, r.name)).map((o) => ({
      label: o.name,
      value: o.id
    })),
    clusterOptions: n.sort((o, r) => Ae(o.name, r.name)).map((o) => ({
      label: o.name,
      value: o.id
    }))
  };
}, co = ({ handleClose: s, onSuccess: t }) => {
  const [a, n] = E(structuredClone(Ax)), [o, r] = E(structuredClone(yx)), [l, i] = E("basicDetails"), [u, c] = E(!1), {
    isFetching: p,
    error: d,
    data: m,
    refetch: _
  } = se({
    queryKey: ["get-restore-creation-metadata"],
    queryFn: ({ signal: S }) => nC({ signal: S })
  }), {
    isFetching: g,
    data: x,
    error: C,
    refetch: f
  } = se({
    queryKey: ["get-config-map-list", a.restoreTarget.clusterDetails?.id],
    queryFn: ({ signal: S }) => Lc({
      signal: S,
      clusterId: a.restoreTarget.clusterDetails?.id
    }),
    select: (S) => (S.result || []).map((O) => ({ label: O, value: O })).sort((O, j) => Ae(O.label, j.label)),
    enabled: !!a.restoreTarget.clusterDetails?.id,
    meta: {
      showToastError: !1
    }
  }), h = async () => {
    const { isErrorPresent: S, updatedErrorState: O } = Mx(a, o);
    if (S) {
      r(O), Se.showToast({
        variant: Ne.error,
        description: "Please resolve all the errors before saving."
      });
      return;
    }
    c(!0), await aC(a) && (s(), t()), c(!1);
  }, b = () => {
    switch (l) {
      case "basicDetails":
        return /* @__PURE__ */ e.jsx(
          vx,
          {
            basicDetails: a.basicDetails,
            setFormData: n,
            basicDetailsError: o.basicDetails,
            setFormError: r,
            metadata: m
          }
        );
      case "restoreTarget":
        return /* @__PURE__ */ e.jsx(
          tC,
          {
            restoreTarget: a.restoreTarget,
            setFormData: n,
            restoreTargetError: o.restoreTarget,
            setFormError: r,
            metadata: m
          }
        );
      case "restoreSettings":
        return /* @__PURE__ */ e.jsx(
          Zx,
          {
            restoreSettings: a.restoreSettings,
            restoreSettingsError: o.restoreSettings,
            setFormData: n,
            setFormError: r,
            configMapOptions: {
              isLoading: g,
              error: C,
              refetch: f,
              options: x
            }
          }
        );
      case "executionControls":
        return /* @__PURE__ */ e.jsx(
          qx,
          {
            executionControls: a.executionControls,
            executionControlsError: o.executionControls,
            setFormData: n,
            setFormError: r
          }
        );
      default:
        return null;
    }
  };
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", width: "1024px", onEscape: s, onClose: s, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
      onClick: Rs,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom", children: [
            /* @__PURE__ */ e.jsx("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: "Create Restore" }),
            /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: "header-close-button",
                ariaLabel: "Close",
                showAriaLabelInTippy: !1,
                onClick: s,
                variant: U.borderLess,
                style: q.negativeGrey,
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
                size: P.xs
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx(
            at,
            {
              isLoading: p,
              error: d,
              progressingProps: {
                pageLoader: !0
              },
              errorScreenManagerProps: {
                code: d?.code,
                reload: _,
                on404Redirect: s
              },
              children: /* @__PURE__ */ e.jsxs("div", { className: "dc__grid create-restore-modal__container dc__overflow-auto flex-grow-1", children: [
                /* @__PURE__ */ e.jsx(
                  zx,
                  {
                    currentTab: l,
                    setCurrentTab: i,
                    formError: o
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto flexbox-col flex-grow-1 dc__overflow-auto w-100 p-20 dc__gap-20 bg__modal--secondary", children: b() })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "footer-cancel-button",
              variant: U.secondary,
              text: "Cancel",
              style: q.neutral,
              size: P.large,
              onClick: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "footer-apply-button",
              variant: U.primary,
              disabled: p || !!d,
              size: P.large,
              text: "Save",
              isLoading: u,
              onClick: h
            }
          )
        ] })
      ]
    }
  ) });
};
var st = /* @__PURE__ */ ((s) => (s.BACKUP = "backup", s.SCHEDULE = "schedule", s))(st || {});
const Ue = {
  CREATE_FROM_SCRATCH: `/create/:type(${Object.values(st).join("|")})`,
  EDIT_SCHEDULE: "/edit/schedule/:id",
  CREATE_FROM_SCHEDULE: "/create/from-schedule/:id?",
  CREATE_RESTORE: "/create-restore"
}, Uc = ({
  name: s,
  metadata: t,
  icon: a,
  additionalInfo: n,
  primaryButtonProps: o,
  secondaryButtonProps: r,
  actionMenuProps: l
}) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col px-16 py-20 dc__separated-flexbox dc__separated-flexbox--vertical w-300 dc__no-shrink border__primary--right dc__overflow-auto", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
      /* @__PURE__ */ e.jsx("div", { className: "bg__tertiary br-12 dc__align-self-start flex left p-8", children: a }),
      /* @__PURE__ */ e.jsx("h2", { className: "fs-16 fw-7 cn-9 m-0 font-merriweather p-0", children: s })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 flex-wrap", children: [
      /* @__PURE__ */ e.jsx(B, { ...o }),
      r?.map((i) => /* @__PURE__ */ e.jsx(B, { ...i }, i.dataTestId)),
      l && /* @__PURE__ */ e.jsx(
        xi,
        {
          id: "backup-additional-options",
          buttonProps: {
            dataTestId: "restore-backup-more-options-btn",
            variant: U.secondary,
            ariaLabel: "More Options",
            style: q.neutral,
            showAriaLabelInTippy: !1,
            icon: /* @__PURE__ */ e.jsx(D, { name: "ic-more-vertical", color: null })
          },
          alignment: "end",
          ...l
        }
      )
    ] })
  ] }),
  n && /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12", children: n.map(({ label: i, content: u }, c) => (
    // Not sorting there index works as key
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ e.jsxs("div", { className: "dc__grid dc__gap-12", style: { gridTemplateColumns: "140px 1fr" }, children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 cn-7 lh-1-5", children: i }),
      u
    ] }, c)
  )) }),
  /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12", children: t.map(({ label: i, value: u, component: c }, p) => (
    // Not sorting there index works as key
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
      /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-20", children: i }),
      u ? /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 fw-4 cn-9 dc__truncate", children: u }) : c
    ] }, p)
  )) })
] }), Fl = "backup-detail-meta-container", oC = [
  {
    label: "Resources",
    value: "resources",
    isDisabled: !0,
    tooltipProps: {
      content: "Coming soon"
    }
  },
  {
    label: "Volume Backup",
    value: "volume-backup",
    isDisabled: !0,
    tooltipProps: {
      content: "Coming soon"
    }
  },
  {
    label: "Logs",
    value: "logs"
  },
  {
    label: "Manifest",
    value: "manifest"
  }
], Vl = "tab", rC = {
  Completed: "Completed",
  InProgress: "In Progress",
  Failed: "Failed",
  PartiallyFailed: "Partially Failed",
  Deleting: "Deleting",
  FailedValidation: "Failed",
  New: "In Progress",
  InstallationPending: "Installation Pending",
  InstallationFailed: "Installation Failed",
  InstallationSuccess: "Installation Success"
}, Fc = {
  Completed: "Completed",
  "In Progress": "InProgress",
  Failed: "Failed",
  "Partially Failed": "PartiallyFailed",
  "Failed Validation": "FailedValidation",
  Deleting: "Deleting",
  "Installation Pending": "InstallationPending",
  "Installation Failed": "InstallationFailed",
  "Installation Success": "InstallationSuccess"
}, lC = {
  backupDate: "startedOn",
  name: "name",
  cluster: "clusterName",
  expiresIn: "expiresAt",
  status: "status"
}, iC = {
  cluster: "clusterName",
  scheduleName: "name",
  lastBackup: "lastBackupTime",
  status: "pauseState"
}, Vc = async ({
  createdBy: s,
  offset: t,
  pageSize: a,
  scheduleId: n,
  searchKey: o,
  signal: r,
  sortBy: l,
  sortOrder: i,
  status: u
}) => {
  try {
    const { result: c } = await _s(
      z.BACKUP_LIST,
      {
        searchByName: o,
        sortBy: lC[l],
        sortOrder: i,
        size: a,
        offset: t,
        filters: [
          { key: "createdBy", values: s },
          { key: "scheduleId", values: n },
          {
            key: "status",
            values: u.map(
              (d) => Fc[d]
            )
          }
        ].filter(({ values: d }) => !!d && Array.isArray(d) && d.length > 0)
      },
      { signal: r }
    ), p = c?.data?.map((d) => yC(d)) ?? null;
    return p === null ? {
      totalRows: 0,
      rows: []
    } : {
      totalRows: c.totalCount,
      rows: p.map((d) => ({
        data: d,
        id: d.id.toString()
      }))
    };
  } catch (c) {
    if (!Ci(c))
      throw c;
    return null;
  }
}, cC = async ({
  signal: s,
  pageSize: t,
  lastBackupStatus: a,
  offset: n,
  pauseState: o,
  searchKey: r,
  snapshotLocationId: l,
  sortBy: i,
  sortOrder: u,
  storageLocationId: c
}) => {
  try {
    const { result: p } = await _s(
      z.SCHEDULE_LIST,
      {
        offset: n,
        searchByName: r,
        sortBy: iC[i],
        sortOrder: u,
        size: t,
        filters: [
          { key: "storageLocationId", values: c },
          { key: "snapshotLocationId", values: l },
          { key: "pauseState", values: o },
          {
            key: "lastBackupStatus",
            values: a.map((m) => Fc[m])
          }
        ].filter(({ values: m }) => !!m?.length)
      },
      { signal: s }
    ), d = p?.data?.map((m) => OC(m)) ?? null;
    return d === null ? {
      totalRows: 0,
      rows: []
    } : {
      totalRows: p.totalCount,
      rows: d.map((m) => ({
        data: m,
        id: m.id.toString()
      }))
    };
  } catch (p) {
    if (!Ci(p))
      throw p;
    return null;
  }
}, dC = async (s) => ia(Q(z.BACKUP_DETAIL, { id: s })), Gc = async (s) => ia(Q(z.SCHEDULE_DETAIL, { id: s })), uC = ({
  row: {
    data: { status: s }
  }
}) => /* @__PURE__ */ e.jsx("div", { className: "flex left", children: /* @__PURE__ */ e.jsx(rr, { status: Tr(s), message: s, showAnimatedIcon: !0 }) }), pC = ({
  row: {
    data: { status: s }
  }
}) => {
  let t = null;
  const a = {
    label: s,
    size: P.xs
  };
  switch (s) {
    case "Enabled":
      t = { ...a, variant: "positive" };
      break;
    case "FailedValidation":
      t = { ...a, variant: "negative" };
      break;
    case "Paused":
      t = { ...a, variant: "warning" };
      break;
    case "Unknown":
      t = {
        ...a,
        variant: "custom",
        bgColor: "N50",
        startIconProps: { name: "ic-unknown" },
        fontColor: "N700"
      };
      break;
    default:
      return gi(`Unknown Backup Schedule status type ${s}`), s;
  }
  return /* @__PURE__ */ e.jsx("div", { className: "flex left", children: /* @__PURE__ */ e.jsx(yt, { ...t }) });
}, mC = ({
  row: {
    data: {
      lastBackup: { status: s }
    }
  }
}) => /* @__PURE__ */ e.jsx("div", { className: "flex left", children: /* @__PURE__ */ e.jsx(
  rr,
  {
    status: Tr(s),
    message: s === "Never" ? "Never run yet" : s,
    showAnimatedIcon: !0,
    hideIcon: s === "Never"
  }
) }), Gl = ({
  field: s,
  signals: t,
  value: a,
  row: {
    id: n,
    data: { id: o }
  },
  filterData: { searchKey: r }
}) => {
  const l = Ms(null), { push: i } = ae(), u = s === "scheduleName";
  ue(() => {
    const d = ({ detail: { activeRowData: m } }) => {
      m.id === n && l.current?.click();
    };
    return t.addEventListener(Sa.ENTER_PRESSED, d), () => {
      t.removeEventListener(Sa.ENTER_PRESSED, d);
    };
  }, []);
  const c = a, p = () => {
    i(
      Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE_DETAIL, {
        id: o,
        view: u ? "schedules" : "backups"
      })
    );
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-4 dc__visible-hover dc__visible-hover--parent", children: [
    /* @__PURE__ */ e.jsx(we, { content: c, children: /* @__PURE__ */ e.jsx(
      "button",
      {
        type: "button",
        className: "dc__unset-button-styles dc__align-left dc__truncate",
        onClick: p,
        ref: l,
        children: /* @__PURE__ */ e.jsx(
          "span",
          {
            className: "dc__link cursor",
            dangerouslySetInnerHTML: {
              __html: ni.sanitize(
                bi({
                  searchText: r,
                  text: String(c),
                  highlightClasses: "p-0 fw-6 bcy-2"
                })
              )
            }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(Xn, { content: String(c), rootClassName: "p-2 dc__visible-hover--child", iconSize: 16 })
  ] });
}, hC = ({
  row: {
    data: {
      createdBy: { type: s, label: t }
    }
  }
}) => {
  const a = () => {
    switch (s) {
      case "user":
        return oi(t, "dc__no-shrink m-0-imp");
      case "schedule":
        return /* @__PURE__ */ e.jsx(D, { name: "ic-clock-counterclockwise", color: "N700", size: 16 });
      case "external":
        return /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-square-out", color: "N700", size: 16 });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ e.jsx(we, { alwaysShowTippyOnHover: !0, content: TC(s), children: /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-6", children: [
    a(),
    /* @__PURE__ */ e.jsx("span", { className: "dc__truncate fs-13 cn-9 lh-20", children: t })
  ] }) });
}, _C = ({
  row: {
    data: { cron: s }
  }
}) => /* @__PURE__ */ e.jsx(we, { alwaysShowTippyOnHover: !0, content: lr(s), children: /* @__PURE__ */ e.jsx("div", { className: "flex left", children: /* @__PURE__ */ e.jsx("span", { className: "dc__underline-dotted cn-9 fs-13 lh-1-5 dc__truncate", children: s }) }) }), fC = ({
  reloadTableData: s,
  row: { data: t }
}) => {
  const { view: a } = ce(), [n, o] = E(!1), { push: r } = ae(), { url: l } = Ts(), { search: i, pathname: u } = he(), c = () => {
    o(!1);
  }, p = () => {
    o(!0);
  };
  if (Object.hasOwn(t, "scheduleName") && a === be.Schedules) {
    const C = t, f = async () => {
      await Gc(C.id), s();
    };
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-4 dc__gap-4 dc__content-end dc__align-items-center", children: [
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "edit-schedule-button",
            icon: /* @__PURE__ */ e.jsx(D, { name: "ic-pencil", color: null }),
            component: me.link,
            style: q.neutral,
            variant: U.borderLess,
            ariaLabel: `Edit ${C.scheduleName}`,
            showAriaLabelInTippy: !1,
            size: P.small,
            linkProps: {
              to: {
                pathname: `${u}${Q(Ue.EDIT_SCHEDULE, { id: C.id })}`,
                search: i
              }
            }
          }
        ),
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "delete-schedule-button",
            icon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
            component: me.button,
            style: q.negative,
            variant: U.borderLess,
            ariaLabel: `Delete ${C.scheduleName} schedule`,
            showAriaLabelInTippy: !1,
            size: P.small,
            onClick: p
          }
        )
      ] }),
      n && /* @__PURE__ */ e.jsx(
        Xa,
        {
          title: C.scheduleName,
          component: "schedule",
          subtitle: "Are you sure you want to delete this backup schedule?",
          closeConfirmationModal: c,
          onDelete: f,
          successToastMessage: "Schedule deleted successfully"
        }
      )
    ] });
  }
  const d = t, { id: m, name: _ } = d, g = async () => {
    await dC(m), s();
  }, x = () => {
    r({ pathname: `${l}${Ue.CREATE_RESTORE}`, search: i });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox px-4 dc__gap-4 dc__content-end dc__align-items-center", children: [
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "restore-backup-button",
          icon: /* @__PURE__ */ e.jsx(D, { name: "ic-clock-counterclockwise", color: null }),
          component: me.button,
          style: q.neutral,
          variant: U.borderLess,
          ariaLabel: `Restore ${_} backup`,
          showAriaLabelInTippy: !1,
          size: P.small,
          onClick: x
        }
      ),
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "delete-backup-button",
          icon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
          component: me.button,
          style: q.negative,
          variant: U.borderLess,
          ariaLabel: `Delete ${_} backup`,
          showAriaLabelInTippy: !1,
          size: P.small,
          onClick: p
        }
      )
    ] }),
    n && /* @__PURE__ */ e.jsx(
      Xa,
      {
        title: _,
        component: "backup",
        subtitle: "Are you sure you want to delete this backup?",
        closeConfirmationModal: c,
        onDelete: g,
        successToastMessage: "Backup deleted successfully"
      }
    )
  ] });
};
var Ee = /* @__PURE__ */ ((s) => (s.STATUS = "status", s.CREATED_BY_USER = "createdBy", s.CREATED_BY_SCHEDULE = "scheduleId", s))(Ee || {}), ie = /* @__PURE__ */ ((s) => (s.SCHEDULE_STATUS = "pauseState", s.STORAGE_LOCATION = "storageLocationId", s.LAST_BACKUP_STATUS = "lastBackupStatus", s.SNAPSHOT_LOCATION = "snapshotLocationId", s))(ie || {});
const Wc = (s) => ({
  [Ee.STATUS]: s.getAll(Ee.STATUS),
  [Ee.CREATED_BY_USER]: s.getAll(Ee.CREATED_BY_USER),
  [Ee.CREATED_BY_SCHEDULE]: s.getAll(Ee.CREATED_BY_SCHEDULE)
}), gC = (s) => ({
  [ie.SCHEDULE_STATUS]: s.getAll(
    ie.SCHEDULE_STATUS
  ),
  [ie.LAST_BACKUP_STATUS]: s.getAll(
    ie.LAST_BACKUP_STATUS
  ),
  [ie.STORAGE_LOCATION]: s.getAll(ie.STORAGE_LOCATION)
}), $c = {
  Completed: "Completed",
  Failed: "Failed",
  "Partially Failed": "PartiallyFailed",
  "Failed Validation": "FailedValidation",
  Deleting: "Deleting",
  "In Progress": "InProgress",
  "Installation Pending": "InstallationPending",
  "Installation Failed": "InstallationFailed",
  "Installation Success": "InstallationSuccess"
}, Kc = (s) => s === be.Backups ? [
  {
    field: "name",
    label: "Name",
    size: {
      range: {
        startWidth: 242,
        minWidth: 80,
        maxWidth: 600
      }
    },
    horizontallySticky: !0,
    isSortable: !0,
    CellComponent: Gl
  },
  {
    field: "cluster",
    label: "Cluster",
    size: {
      range: {
        startWidth: 120,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0
  },
  {
    field: "createdBy",
    label: "Created By",
    size: {
      range: {
        startWidth: 200,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0,
    CellComponent: hC
  },
  {
    field: "status",
    label: "Status",
    size: {
      range: {
        startWidth: 120,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0,
    CellComponent: uC
  },
  {
    field: "backupDate",
    label: "Backup Date",
    size: {
      range: {
        startWidth: 200,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0
  },
  {
    field: "expiresIn",
    label: "Expires In",
    size: {
      range: {
        startWidth: 80,
        minWidth: 80,
        maxWidth: 600
      }
    }
  }
] : [
  {
    field: "scheduleName",
    label: "Schedule Name",
    size: {
      range: {
        startWidth: 242,
        minWidth: 80,
        maxWidth: 600
      }
    },
    horizontallySticky: !0,
    isSortable: !0,
    CellComponent: Gl
  },
  {
    field: "status",
    label: "Status",
    size: {
      range: {
        startWidth: 180,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0,
    CellComponent: pC
  },
  {
    field: "cluster",
    label: "Cluster",
    size: {
      range: {
        startWidth: 120,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0
  },
  {
    field: "storageLocation",
    label: "Storage Location",
    size: {
      range: {
        startWidth: 200,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0
  },
  {
    field: "cron",
    label: "Cron",
    CellComponent: _C,
    size: {
      range: {
        startWidth: 120,
        minWidth: 80,
        maxWidth: 600
      }
    }
  },
  {
    field: "lastBackup",
    label: "Last Backup",
    size: {
      range: {
        startWidth: 200,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0,
    CellComponent: mC
  },
  {
    field: "lastSkipped",
    label: "Last Skipped",
    size: {
      range: {
        startWidth: 120,
        minWidth: 80,
        maxWidth: 600
      }
    },
    isSortable: !0
  }
], Hc = (s) => ({
  [Ee.STATUS]: s[Ee.STATUS] ?? [],
  [Ee.CREATED_BY_USER]: s[Ee.CREATED_BY_USER] ?? "",
  [Ee.CREATED_BY_SCHEDULE]: s[Ee.CREATED_BY_SCHEDULE] ?? ""
}), Yc = (s) => ({
  [ie.SCHEDULE_STATUS]: s[ie.SCHEDULE_STATUS] ?? [],
  [ie.STORAGE_LOCATION]: s[ie.STORAGE_LOCATION] ?? [],
  [ie.LAST_BACKUP_STATUS]: s[ie.LAST_BACKUP_STATUS] ?? [],
  [ie.SNAPSHOT_LOCATION]: s[ie.SNAPSHOT_LOCATION] ?? []
}), xC = (s, t) => {
  const { updateSearchParams: a } = s, n = Hc(s), o = n[Ee.STATUS].map((c) => ({ label: c, value: c })), r = t.userFilterOptions.options?.filter(
    (c) => n[Ee.CREATED_BY_USER].includes(String(c.value))
  ) ?? [], l = t.scheduleFilterOptions.options?.filter(
    (c) => n[Ee.CREATED_BY_SCHEDULE].includes(String(c.value))
  ) ?? [], i = (c) => (p) => {
    a({ [c]: p.map((d) => String(d.value)) });
  }, u = {
    [Ee.STATUS]: {
      placeholder: "Status",
      inputId: "backup-list-status-select",
      options: Object.entries($c).map(([c, p]) => ({
        label: c,
        value: p
      })),
      appliedFilterOptions: o,
      handleApplyFilter: i(Ee.STATUS),
      isDisabled: !1,
      isLoading: !1
    },
    [Ee.CREATED_BY_USER]: {
      placeholder: "Created By User",
      inputId: "backup-list-created-by-user-select",
      options: t.userFilterOptions.options,
      appliedFilterOptions: r,
      handleApplyFilter: i(Ee.CREATED_BY_USER),
      isDisabled: !1,
      isLoading: t.userFilterOptions.isLoading,
      optionListError: t.userFilterOptions.error,
      reloadOptionList: t.userFilterOptions.refetch
    },
    [Ee.CREATED_BY_SCHEDULE]: {
      placeholder: "Created By Schedule",
      inputId: "backup-list-created-by-schedule-select",
      options: t.scheduleFilterOptions.options,
      appliedFilterOptions: l,
      handleApplyFilter: i(Ee.CREATED_BY_SCHEDULE),
      isDisabled: !1,
      isLoading: t.scheduleFilterOptions.isLoading,
      optionListError: t.scheduleFilterOptions.error,
      reloadOptionList: t.scheduleFilterOptions.refetch
    }
  };
  return {
    options: [
      {
        groupLabel: "Filter by",
        items: [
          {
            id: Ee.STATUS,
            label: "Status"
          },
          {
            id: Ee.CREATED_BY_USER,
            label: "Created By"
          },
          {
            id: Ee.CREATED_BY_SCHEDULE,
            label: "Created By Schedule"
          }
        ]
      }
    ],
    filterSelectPickerPropsMap: u,
    isFilterApplied: !!(o.length || r.length)
  };
}, CC = (s, t) => {
  const { updateSearchParams: a } = s, n = Yc(s), o = n[ie.SCHEDULE_STATUS].map((d) => ({ label: d, value: d })), r = t.storageLocationOptions.options?.filter(
    (d) => n[ie.STORAGE_LOCATION].includes(String(d.value))
  ) ?? [], l = n[ie.LAST_BACKUP_STATUS].map((d) => ({ label: d, value: d })), i = t.snapshotLocationOptions.options?.filter(
    (d) => n[ie.SNAPSHOT_LOCATION].includes(String(d.value))
  ) ?? [], u = (d) => (m) => {
    a({ [d]: m.map((_) => String(_.value)) });
  }, c = {
    Enabled: !1,
    Paused: !0
  }, p = {
    [ie.SCHEDULE_STATUS]: {
      placeholder: "Schedule Status",
      inputId: "backup-schedule-list-schedule-status-select",
      options: Object.entries(c).map(([d, m]) => ({
        label: d,
        value: `${m}`
      })),
      appliedFilterOptions: o,
      handleApplyFilter: u(ie.SCHEDULE_STATUS),
      isDisabled: !1,
      isLoading: !1
    },
    [ie.STORAGE_LOCATION]: {
      placeholder: "Storage Location",
      inputId: "backup-schedule-list-storage-location-select",
      options: t.storageLocationOptions.options,
      appliedFilterOptions: r,
      handleApplyFilter: u(ie.STORAGE_LOCATION),
      isDisabled: !1,
      isLoading: t.storageLocationOptions.isLoading,
      optionListError: t.storageLocationOptions.error,
      reloadOptionList: t.storageLocationOptions.refetch
    },
    [ie.SNAPSHOT_LOCATION]: {
      placeholder: "Snapshot Location",
      inputId: "backup-schedule-list-snapshot-location-select",
      options: t.snapshotLocationOptions.options,
      appliedFilterOptions: i,
      handleApplyFilter: u(ie.SNAPSHOT_LOCATION),
      isDisabled: !1,
      isLoading: t.snapshotLocationOptions.isLoading,
      optionListError: t.snapshotLocationOptions.error,
      reloadOptionList: t.snapshotLocationOptions.refetch
    },
    [ie.LAST_BACKUP_STATUS]: {
      placeholder: "Last Backup Status",
      inputId: "backup-schedule-list-last-backup-status-select",
      options: Object.entries($c).map(([d, m]) => ({ label: d, value: m })),
      appliedFilterOptions: l,
      handleApplyFilter: u(ie.LAST_BACKUP_STATUS),
      isDisabled: !1,
      isLoading: !1
    }
  };
  return {
    options: [
      {
        groupLabel: "Filter by",
        items: [
          {
            id: ie.SCHEDULE_STATUS,
            label: "Schedule Status"
          },
          {
            id: ie.STORAGE_LOCATION,
            label: "Storage Location"
          },
          {
            id: ie.SNAPSHOT_LOCATION,
            label: "Snapshot Location"
          },
          {
            id: ie.LAST_BACKUP_STATUS,
            label: "Last Backup Status"
          }
        ]
      }
    ],
    filterSelectPickerPropsMap: p,
    isFilterApplied: !!(o.length || r.length || l.length)
  };
}, bC = (s) => {
  switch (s) {
    case Ee.CREATED_BY_USER:
      return "Created By";
    default:
      return s;
  }
}, SC = (s) => {
  switch (s) {
    case ie.LAST_BACKUP_STATUS:
      return "Last Backup Status";
    case ie.SCHEDULE_STATUS:
      return "Schedule Status";
    case ie.STORAGE_LOCATION:
      return "Storage Location";
    case ie.SNAPSHOT_LOCATION:
      return "Snapshot Location";
    default:
      return s;
  }
}, NC = (s, t, { scheduleFilterOptions: a }) => {
  switch (s) {
    case Ee.CREATED_BY_SCHEDULE:
      return a.options.find((n) => String(n.value) === t)?.label.toString() ?? "";
    default:
      return t;
  }
}, EC = (s, t, {
  snapshotLocationOptions: a,
  storageLocationOptions: n
}) => {
  switch (s) {
    case ie.STORAGE_LOCATION:
      return n.options.find((o) => String(o.value) === t)?.label.toString() ?? t;
    case ie.SNAPSHOT_LOCATION:
      return a.options.find((o) => String(o.value) === t)?.label.toString() ?? t;
    case ie.SCHEDULE_STATUS:
      return t === "true" ? "Paused" : "Enabled";
    default:
      return t;
  }
}, Tr = (s) => {
  switch (s) {
    case "Completed":
    case "Installation Success":
      return Ht.SUCCEEDED;
    case "In Progress":
    case "Installation Pending":
      return Ht.PROGRESSING;
    case "Failed":
    case "Installation Failed":
    case "Failed Validation":
      return Ht.FAILED;
    case "Deleting":
      return Ht.DEGRADED;
    case "Partially Failed":
      return "warning";
    default:
      return Ht.UNKNOWN;
  }
}, vC = (s, t) => [
  {
    groupLabel: "Create backup",
    items: [
      {
        id: "created-backup__from-scratch",
        label: "From Scratch",
        componentType: "link",
        to: {
          pathname: Q(`${s}${Ue.CREATE_FROM_SCRATCH}`, {
            type: st.BACKUP
          }),
          search: t
        }
      },
      {
        id: "create-backup__from-schedule",
        label: "From Schedule",
        componentType: "link",
        to: {
          pathname: `${s}${Q(Ue.CREATE_FROM_SCHEDULE)}`,
          search: t
        }
      }
    ]
  },
  {
    items: [
      {
        id: "create-backup-schedule",
        label: "Create Backup Schedule",
        componentType: "link",
        to: {
          pathname: Q(`${s}${Ue.CREATE_FROM_SCRATCH}`, {
            type: st.SCHEDULE
          }),
          search: t
        }
      }
    ]
  }
], TC = (s) => {
  switch (s) {
    case "user":
      return "Backup created by user";
    case "schedule":
      return "Backup created by schedule";
    case "external":
      return "Backup created by external system";
    default:
      return null;
  }
}, AC = (s) => {
  if (!s) return "Unknown";
  const t = Ut(s), a = Ut(), n = t.diff(a, "days");
  return n <= 0 ? "Expired" : n === 1 ? "1 day" : `${n} days`;
}, zc = (s) => {
  if (!s)
    return "Unknown";
  switch (s.phase) {
    case "InstallationPending":
      return "Installation Pending";
    case "InstallationFailed":
      return "Installation Failed";
    case "InstallationSuccess":
      return "Installation Success";
    case "New":
    case "InProgress":
      return "In Progress";
    case "Completed":
      return "Completed";
    case "PartiallyFailed":
      return "Partially Failed";
    case "Failed":
    case "FailedValidation":
      return "Failed";
    case "Deleting":
      return "Deleting";
    default:
      return "Failed";
  }
}, yC = (s) => {
  const t = s.scheduleName ? { label: s.scheduleName, type: "schedule" } : { label: s.createdBy || "Unknown", type: "user" };
  return {
    id: s.id,
    name: s.name,
    cluster: s.clusterName,
    expiresIn: AC(s.status?.expiration),
    backupDate: s.status?.startTimestamp ? Ut(s.status.startTimestamp).format(ls.DD_MMM_YYYY_HH_MM) : "Unknown",
    status: zc(s.status),
    createdBy: t
  };
}, jC = (s) => s.paused ? "Paused" : s.status?.phase ?? "Unknown", OC = (s) => ({
  id: s.id,
  scheduleName: s.name,
  status: jC(s),
  cluster: s.clusterName,
  storageLocation: s.storageLocationName,
  cron: s.schedule,
  lastBackup: s.status?.lastBackup ? {
    time: Ut(s.status.lastBackup).format("llll"),
    status: "Completed"
  } : {
    status: "Never"
  },
  lastSkipped: s.status?.lastSkippedTime ? Ut(s.status.lastSkippedTime).format(ls.DD_MMM_YYYY_HH_MM) : "Never"
}), qc = ({ label: s }) => /* @__PURE__ */ e.jsx(
  Lp,
  {
    size: P.xs,
    label: s,
    startIconProps: { name: "ic-storage", color: "N700" },
    style: "neutral"
  }
), IC = ({
  backupDetail: s,
  onActionMenuClick: t,
  onBackupRestoreClick: a
}) => ({
  name: s.name,
  icon: /* @__PURE__ */ e.jsx(D, { name: "ic-backup-color", size: 40, color: null }),
  primaryButtonProps: {
    text: "Restore Backup",
    dataTestId: "restore-backup-btn",
    startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-clock-counterclockwise", color: null }),
    variant: U.primary,
    onClick: a
  },
  actionMenuProps: {
    onClick: t,
    options: [
      {
        items: [
          {
            label: "Delete",
            id: "delete-backup",
            type: "negative",
            startIcon: { name: "ic-delete" }
          }
        ]
      }
    ]
  },
  metadata: [
    { label: "Backup for", value: s.backupFor },
    {
      label: "Created by",
      component: s.createdBy.type === "schedule" ? /* @__PURE__ */ e.jsx(
        B,
        {
          variant: U.text,
          dataTestId: "created-by-schedule-btn",
          size: P.xs,
          component: me.link,
          text: s.createdBy.label,
          linkProps: {
            to: Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE_DETAIL, {
              view: "schedules",
              id: s.id
            })
          }
        }
      ) : /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 cn-9", children: s.createdBy.label })
    },
    { label: "Duration", value: s.duration },
    {
      label: "Snapshot locations",
      component: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-4", children: s.snapshotLocations.map((n) => /* @__PURE__ */ e.jsx(qc, { label: n }, n)) })
    },
    ...s.backupScope.map(([n, o]) => ({
      label: n,
      value: o
    }))
  ],
  additionalInfo: [
    {
      label: "Status",
      content: /* @__PURE__ */ e.jsx("div", { className: "flex right", children: /* @__PURE__ */ e.jsx(
        rr,
        {
          status: Tr(s.status),
          message: s.status,
          showAnimatedIcon: !0
        }
      ) })
    },
    ...s.warningsAndErrors.length > 0 ? [
      {
        label: "Warnings & Errors",
        content: /* @__PURE__ */ e.jsx("div", { className: "flex right dc__gap-6", children: s.warningsAndErrors.map((n) => /* @__PURE__ */ e.jsx(
          yt,
          {
            label: n.count.toString(),
            variant: n.type === "error" ? "negative" : "warning",
            startIconProps: {
              name: n.type === "error" ? "ic-close-small" : "ic-warning"
            }
          },
          `${n.type}-${n.count}`
        )) })
      }
    ] : [],
    {
      label: "Resources",
      content: /* @__PURE__ */ e.jsx("div", { className: "flex right", children: /* @__PURE__ */ e.jsxs("span", { className: "fs-13 fw-4 cn-9 lh-1-5", children: [
        s.completedResources,
        "/",
        s.totalResources
      ] }) })
    }
  ]
}), wC = (s) => s.sourceType === "schedule" && s.scheduleName ? {
  label: s.scheduleName,
  type: "schedule"
} : s.createdBy ? {
  label: s.createdBy,
  type: "user"
} : {
  label: "External",
  type: "external"
}, PC = (s) => {
  const t = [];
  s.status.warnings && s.status.warnings > 0 && t.push({
    type: "warning",
    message: "Backup completed with warnings",
    count: s.status.warnings
  }), s.status.errors && s.status.errors > 0 && t.push({
    type: "error",
    message: "Backup completed with errors",
    count: s.status.errors
  }), s.status.validationErrors?.length && t.push({
    type: "error",
    message: `Validation failed: ${s.status.validationErrors.join(", ")}`,
    count: s.status.validationErrors.length
  });
  const a = [];
  if (s.includedNamespaces?.length && a.push(["Included Namespaces", s.includedNamespaces.join(", ")]), s.excludedNamespaces?.length && a.push(["Excluded Namespaces", s.excludedNamespaces.join(", ")]), s.includedResources?.length && a.push(["Included Resources", s.includedResources.join(", ")]), s.excludedResources?.length && a.push(["Excluded Resources", s.excludedResources.join(", ")]), s.labelSelector?.matchLabels && Object.keys(s.labelSelector.matchLabels).length > 0) {
    const n = Object.entries(s.labelSelector.matchLabels).map(([o, r]) => `${o}=${r}`).join(", ");
    a.push(["Label Selector", n]);
  }
  return {
    id: s.id,
    name: s.name,
    status: rC[s.status?.phase] ?? "Unknown",
    warningsAndErrors: t,
    completedResources: s.status?.progress?.itemsBackedUp || 0,
    totalResources: s.status?.progress?.totalItems || 0,
    backupFor: s.clusterName,
    createdBy: wC(s),
    duration: Si({
      startTime: s.status?.startTimestamp,
      endTime: s.status?.completionTimestamp
    }),
    snapshotLocations: s.snapshotLocationNames || [],
    backupScope: a,
    k8sManifestDetail: {
      clusterId: s.clusterId,
      gvk: s.manifestGvk.gvk,
      namespace: s.manifestGvk.veleroNamespace,
      name: s.name
    }
  };
}, RC = async ({ id: s, signal: t }) => {
  const { result: a } = await xe(Q(z.BACKUP_DETAIL, { id: s }), { signal: t });
  return PC(a);
}, LC = async ({ id: s, signal: t }) => {
  const {
    result: { logs: a }
  } = await xe(Q(z.BACKUP_LOGS, { id: s }), { signal: t });
  return a;
}, kC = () => {
  const { id: s } = ce(), {
    data: t,
    isFetching: a,
    error: n,
    refetch: o
  } = se({
    queryFn: ({ signal: l }) => LC({ signal: l, id: +s }),
    queryKey: ["backup-log", s]
  }), r = () => a ? /* @__PURE__ */ e.jsx(cs, { size: 32 }) : n ? /* @__PURE__ */ e.jsx(_t, { code: n.code, reload: o }) : /* @__PURE__ */ e.jsx(bs, { mode: ht.PLAINTEXT, value: t, height: "fitToParent", theme: Oo.dark, readOnly: !0 });
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1", children: r() });
}, DC = ({
  detail: s,
  isDetailLoading: t,
  detailError: a,
  refetchDetail: n
}) => {
  const { path: o, url: r } = Ts(), { replace: l, push: i } = ae(), { search: u } = he(), { searchParams: c } = Re(), p = c[Vl] ?? "manifest", d = ({ value: j }) => {
    const v = new URLSearchParams(u);
    v.set(Vl, j), i({ search: v.toString() });
  }, {
    data: m,
    isLoading: _,
    error: g,
    refetch: x
  } = se({
    queryKey: ["backup-manifest", s],
    queryFn: ({ signal: j }) => Yn({
      clusterId: s.k8sManifestDetail.clusterId,
      gvk: s.k8sManifestDetail.gvk,
      name: s.k8sManifestDetail.name,
      namespace: s.k8sManifestDetail.namespace,
      signal: j
    }),
    select: (j) => ir(j.manifestResponse.manifest),
    enabled: p === "manifest" && !!s
  }), C = () => {
    l(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, { view: be.Backups });
  };
  if (t)
    return /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 });
  if (a)
    return /* @__PURE__ */ e.jsx(_t, { reload: n, on404Redirect: C, code: a.code });
  const f = () => {
    switch (p) {
      case "resources":
        return /* @__PURE__ */ e.jsx("div", { children: "Resources View" });
      case "volume-backup":
        return /* @__PURE__ */ e.jsx("div", { children: "Volume Backup View" });
      case "logs":
        return /* @__PURE__ */ e.jsx(kC, {});
      case "manifest":
        return g ? /* @__PURE__ */ e.jsx(_t, { reload: x, code: g.code }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            bs,
            {
              loading: _,
              readOnly: !0,
              height: "100%",
              mode: ht.YAML,
              value: m ?? ""
            }
          ),
          m && /* @__PURE__ */ e.jsx(Ni, { portalParentId: Fl, children: /* @__PURE__ */ e.jsx(
            Xn,
            {
              variant: "button--secondary",
              size: P.small,
              content: m
            }
          ) })
        ] });
      default:
        return null;
    }
  }, h = async (j) => {
    switch (j.id) {
      case "delete-backup":
        try {
          await ia(Q(z.BACKUP_DETAIL, { id: s.id })), Se.showToast({
            variant: Ne.success,
            description: "Backup deleted successfully"
          });
        } catch (v) {
          ve(v);
        }
        break;
    }
  }, b = () => {
    i(`${r}${Ue.CREATE_RESTORE}`);
  }, S = () => {
    l({ pathname: r.replace(Ue.CREATE_RESTORE, ""), search: u });
  }, O = () => {
    n(), S();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox h-100 w-100 dc__overflow-hidden", children: [
      /* @__PURE__ */ e.jsx(Uc, { ...IC({ backupDetail: s, onActionMenuClick: h, onBackupRestoreClick: b }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-16 py-12 px-16 border__secondary--bottom dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            ca,
            {
              name: "backup-view-control",
              value: p,
              segments: oC,
              onChange: d
            }
          ),
          /* @__PURE__ */ e.jsx("div", { id: Fl })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 dc__overflow-hidden flexbox-col", children: f() })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(le, { path: `${o}${Ue.CREATE_RESTORE}`, children: /* @__PURE__ */ e.jsx(co, { onSuccess: O, handleClose: S }) })
  ] });
}, MC = ({
  backupScheduleDetail: s,
  onCreateBackupFromThisScheduleClick: t,
  onUpdateScheduleEnabledState: a,
  isPauseUnpauseScheduleAPICallInProgress: n,
  onActionMenuClick: o
}) => ({
  name: s.name,
  icon: /* @__PURE__ */ e.jsx(D, { name: "ic-backup-schedule-color", size: 40, color: null }),
  primaryButtonProps: s.status === "Paused" ? {
    text: "Resume Schedule",
    dataTestId: "resume-schedule-btn",
    startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-play-outline", color: null }),
    variant: U.primary,
    isLoading: n,
    onClick: a
  } : {
    text: "Pause Schedule",
    dataTestId: "pause-schedule-btn",
    startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-pause", color: null }),
    variant: U.primary,
    isLoading: n,
    style: q.warning,
    onClick: a
  },
  secondaryButtonProps: [
    {
      dataTestId: "backup-schedule-upload-btn",
      variant: U.secondary,
      ariaLabel: "Create backup from this schedule",
      showAriaLabelInTippy: !0,
      tooltipProps: { placement: "bottom" },
      style: q.neutral,
      icon: /* @__PURE__ */ e.jsx(D, { name: "ic-cloud-upload", color: null }),
      onClick: t
    }
  ],
  actionMenuProps: {
    onClick: o,
    options: [
      {
        items: [
          {
            label: "Edit",
            startIcon: { name: "ic-pencil" },
            id: "edit"
          },
          {
            label: "Delete",
            startIcon: { name: "ic-delete" },
            id: "delete-schedule",
            type: "negative"
          }
        ]
      }
    ]
  },
  metadata: [
    { label: "Cluster to backup", value: s.backupFor },
    {
      label: "Created by",
      value: s.createdBy.label
    },
    {
      label: "Last backup",
      value: s.lastBackup ? `${Ut(s.lastBackup.timestamp).format(ls.TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY)} (${s.lastBackup.status})` : "No backups yet"
    },
    {
      label: "Last skipped",
      value: s.lastSkipped ? Ut(s.lastSkipped).format(ls.TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY) : "No backups yet"
    },
    ...s.snapshotLocations ? [
      {
        label: "Snapshot locations",
        component: /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4 flex-wrap", children: s.snapshotLocations.map((r) => /* @__PURE__ */ e.jsx(qc, { label: r }, r)) })
      }
    ] : [],
    {
      label: "Included namespaces",
      value: s.backupScope.includedNamespaces
    },
    {
      label: "Excluded namespaces",
      value: s.backupScope.excludedNamespaces
    }
  ]
}), BC = (s) => {
  let t;
  s.paused ? t = "Paused" : s.status.phase === "FailedValidation" ? t = "FailedValidation" : t = "Enabled";
  const a = s.lastBackup ? {
    name: s.lastBackup.name,
    status: zc(s.lastBackup.status),
    timestamp: s.lastBackup.status?.completionTimestamp || s.lastBackup.status?.startTimestamp || ""
  } : null, n = t === "Enabled" ? lr(s.schedule) : null, o = {
    includedNamespaces: s.includedNamespaces?.join(", ") || "All namespaces",
    excludedNamespaces: s.excludedNamespaces?.join(", ") || "None"
  }, r = {
    label: s.createdBy || "Unknown",
    type: "user"
  };
  return {
    id: s.id,
    name: s.name,
    status: t,
    schedule: s.schedule,
    lastBackup: a,
    nextBackup: n,
    backupFor: s.clusterName,
    createdBy: r,
    backupScope: o,
    snapshotLocations: s.snapshotLocationNames,
    retentionPolicy: s.ttl || "No retention policy",
    lastSkipped: null,
    // Not provided in current API spec
    k8sManifestDetail: {
      clusterId: s.clusterId,
      gvk: s.manifestGvk.gvk,
      namespace: s.manifestGvk.veleroNamespace,
      name: s.name
    }
  };
}, UC = async ({
  id: s,
  signal: t
}) => {
  const { result: a } = await xe(Q(z.SCHEDULE_DETAIL, { id: s }), { signal: t });
  return BC(a);
}, FC = ({
  state: s,
  setState: t
}) => {
  const a = s.advancedTimeoutsAndTuning.CSISnapshotTimeout, n = s.advancedTimeoutsAndTuning.ItemOperationTimeout, o = (u) => {
    t((c) => ({
      ...c,
      advancedTimeoutsAndTuning: {
        ...c.advancedTimeoutsAndTuning,
        CSISnapshotTimeout: {
          ...c.advancedTimeoutsAndTuning.CSISnapshotTimeout,
          unit: u
        }
      }
    }));
  }, r = (u) => {
    t((c) => ({
      ...c,
      advancedTimeoutsAndTuning: {
        ...c.advancedTimeoutsAndTuning,
        CSISnapshotTimeout: {
          ...c.advancedTimeoutsAndTuning.CSISnapshotTimeout,
          value: u
        }
      }
    }));
  }, l = (u) => {
    t((c) => ({
      ...c,
      advancedTimeoutsAndTuning: {
        ...c.advancedTimeoutsAndTuning,
        ItemOperationTimeout: {
          ...c.advancedTimeoutsAndTuning.ItemOperationTimeout,
          unit: u
        }
      }
    }));
  }, i = (u) => {
    t((c) => ({
      ...c,
      advancedTimeoutsAndTuning: {
        ...c.advancedTimeoutsAndTuning,
        ItemOperationTimeout: {
          ...c.advancedTimeoutsAndTuning.ItemOperationTimeout,
          value: u
        }
      }
    }));
  };
  return /* @__PURE__ */ e.jsx(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox dc__separated-flexbox--vertical", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "fs-13 fw-4 lh-20 cn-9 m-0", children: "CSI Snapshot Timeout" }),
        /* @__PURE__ */ e.jsx("p", { className: "fs-12 fw-4 lh-16 cn-7 m-0", children: "How long to wait for CSI snapshot creation before timeout" })
      ] }),
      /* @__PURE__ */ e.jsx(
        Vn,
        {
          idPrefix: "csi-snapshot-timeout",
          value: a.value,
          unit: a.unit,
          onUnitChange: o,
          onValueChange: r
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "fs-13 fw-4 lh-20 cn-9 m-0", children: "Item Operation Timeout" }),
        /* @__PURE__ */ e.jsx("p", { className: "fs-12 fw-4 lh-16 cn-7 m-0", children: "How long to wait for async plugin operations before timeout" })
      ] }),
      /* @__PURE__ */ e.jsx(
        Vn,
        {
          idPrefix: "item-operation-timeout",
          value: n.value,
          unit: n.unit,
          onUnitChange: l,
          onValueChange: i
        }
      )
    ] })
  ] }) });
}, VC = {
  all: "all",
  "all-non-prod": "non-prod",
  "all-prod": "prod",
  specific: "specific"
}, GC = {
  all: "all",
  "non-prod": "all-non-prod",
  prod: "all-prod",
  specific: "specific"
}, WC = {
  basicDetails: "basicDetails",
  backupScopeAndPolicy: "backupScopeAndPolicy",
  storageAndSnapshotLocation: "storageAndSnapshotSettings",
  advancedTimeoutsAndTuning: null
}, $C = `# currently only supports v1 version, Example:
version: v1
volumePolicies:
# each policy consists of a list of conditions and an action
# we could have lots of policies, but if the resource matched the first policy, the latters will be ignored
# each key in the object is one condition, and one policy will apply to resources that meet ALL conditions
# NOTE: capacity or storageClass is suited for [Persistent Volumes](https://kubernetes.io/docs/concepts/storage/persistent-volumes), and pod [Volume](https://kubernetes.io/docs/concepts/storage/volumes) not support it.
- conditions:
    # capacity condition matches the volumes whose capacity falls into the range
    capacity: "10,100Gi"
    # pv matches specific csi driver
    csi:
      driver: ebs.csi.aws.com
    # pv matches one of the storage class list
    storageClass:
    - gp2
    - standard
  action:
    type: skip
- conditions:
    capacity: "0,100Gi"
    # nfs volume source with specific server and path (nfs could be empty or only config server or path)
    nfs:
      server: 192.168.200.90
      path: /mnt/data
  action:
    type: skip
- conditions:
    nfs:
      server: 192.168.200.90
  action:
    type: skip
- conditions:
    # nfs could be empty which matches any nfs volume source
    nfs: {}
  action:
    type: skip
- conditions:
    # csi could be empty which matches any csi volume source
    csi: {}
  action:
    type: skip`, KC = ({ state: s, setState: t }) => {
  const a = (c) => {
    const p = c.target.value;
    if (p === "specific") {
      t({
        ...s,
        backupScopeAndPolicy: {
          ...s.backupScopeAndPolicy,
          resources: "specific",
          resourcesScope: {
            clusterScopedResources: {
              isSelected: !1,
              includedResources: [],
              excludedResources: []
            },
            namespaceScopedResources: {
              isSelected: !1,
              includedResources: [],
              excludedResources: []
            }
          }
        }
      });
      return;
    }
    const d = s.backupScopeAndPolicy;
    delete d.resourcesScope, t({
      ...s,
      backupScopeAndPolicy: {
        ...d,
        resources: p
      }
    });
  }, n = () => {
    t((c) => ({
      ...c,
      backupScopeAndPolicy: {
        ...c.backupScopeAndPolicy,
        resources: "specific",
        resourcesScope: {
          ...c.backupScopeAndPolicy.resourcesScope,
          clusterScopedResources: {
            isSelected: !c.backupScopeAndPolicy.resourcesScope.clusterScopedResources.isSelected,
            includedResources: [],
            excludedResources: []
          }
        }
      }
    }));
  }, o = () => {
    t((c) => ({
      ...c,
      backupScopeAndPolicy: {
        ...c.backupScopeAndPolicy,
        resources: "specific",
        resourcesScope: {
          ...c.backupScopeAndPolicy.resourcesScope,
          namespaceScopedResources: {
            isSelected: !c.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.isSelected,
            includedResources: [],
            excludedResources: []
          }
        }
      }
    }));
  }, r = (c) => (p) => {
    t((d) => ({
      ...d,
      backupScopeAndPolicy: {
        ...d.backupScopeAndPolicy,
        resources: "specific",
        resourcesScope: {
          ...d.backupScopeAndPolicy.resourcesScope,
          clusterScopedResources: {
            ...d.backupScopeAndPolicy.resourcesScope.clusterScopedResources,
            includedResources: c ? d.backupScopeAndPolicy.resourcesScope.clusterScopedResources.includedResources : p || [],
            excludedResources: c ? p || [] : d.backupScopeAndPolicy.resourcesScope.clusterScopedResources.excludedResources
          }
        }
      }
    }));
  }, l = (c) => (p) => {
    const d = { label: p, value: p }, _ = [...c ? s.backupScopeAndPolicy.resourcesScope.clusterScopedResources.excludedResources : s.backupScopeAndPolicy.resourcesScope.clusterScopedResources.includedResources, d];
    r(c)(_);
  }, i = (c) => (p) => {
    t((d) => ({
      ...d,
      backupScopeAndPolicy: {
        ...d.backupScopeAndPolicy,
        resources: "specific",
        resourcesScope: {
          ...d.backupScopeAndPolicy.resourcesScope,
          namespaceScopedResources: {
            ...d.backupScopeAndPolicy.resourcesScope.namespaceScopedResources,
            includedResources: c ? d.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.includedResources : p || [],
            excludedResources: c ? p || [] : d.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.excludedResources
          }
        }
      }
    }));
  }, u = (c) => (p) => {
    const d = { label: p, value: p }, _ = [...c ? s.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.excludedResources : s.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.includedResources, d];
    i(c)(_);
  };
  return /* @__PURE__ */ e.jsxs(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: [
    /* @__PURE__ */ e.jsx("h3", { className: "fs-13 fw-6 lh-20 cn-9 m-0", children: "Resources to backup" }),
    /* @__PURE__ */ e.jsxs(
      zs,
      {
        value: s.backupScopeAndPolicy.resources,
        name: "resource-radio-group",
        onChange: a,
        className: "radio-group-no-border",
        children: [
          /* @__PURE__ */ e.jsx(
            Be,
            {
              dataTestId: "all-resources",
              value: "all",
              children: "All Resources"
            }
          ),
          /* @__PURE__ */ e.jsx(
            Be,
            {
              dataTestId: "specific-resources",
              value: "specific",
              children: "Specific Resources"
            }
          )
        ]
      }
    ),
    s.backupScopeAndPolicy.resources === "specific" && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
      /* @__PURE__ */ e.jsx(
        Ft,
        {
          isChecked: s.backupScopeAndPolicy.resourcesScope.clusterScopedResources.isSelected,
          onChange: n,
          rootClassName: "icon-dim-20 w-100 dc_max-width__max-content mb-0 br-4",
          dataTestId: "toggle-cluster-scoped-resources",
          value: De.CHECKED,
          children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Cluster Scoped" })
        }
      ),
      s.backupScopeAndPolicy.resourcesScope.clusterScopedResources.isSelected && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "cluster-scoped-included-resources-select",
            isMulti: !0,
            label: "Included Resources",
            placeholder: "Type and Enter to include resources",
            options: [],
            value: s.backupScopeAndPolicy.resourcesScope.clusterScopedResources.includedResources,
            isCreatable: !0,
            onCreateOption: l(!1),
            onChange: r(!1)
          }
        ),
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "cluster-scoped-excluded-resources-select",
            label: "Excluded Resources",
            placeholder: "Type and Enter to exclude resources",
            isMulti: !0,
            options: [],
            value: s.backupScopeAndPolicy.resourcesScope.clusterScopedResources.excludedResources,
            isCreatable: !0,
            onCreateOption: l(!0),
            onChange: r(!0)
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(
        Ft,
        {
          isChecked: s.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.isSelected,
          onChange: o,
          rootClassName: "icon-dim-20 w-100 dc_max-width__max-content mb-0 br-4",
          dataTestId: "toggle-namespace-scoped-resources",
          value: De.CHECKED,
          children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Namespace Scoped" })
        }
      ),
      s.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.isSelected && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "namespace-scoped-included-resources-select",
            label: "Included Resources",
            placeholder: "Type and Enter to include resources",
            isMulti: !0,
            options: [],
            value: s.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.includedResources,
            isCreatable: !0,
            onCreateOption: u(!1),
            onChange: i(!1)
          }
        ),
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "namespace-scoped-excluded-resources-select",
            label: "Excluded Resources",
            placeholder: "Type and Enter to exclude resources",
            isMulti: !0,
            options: [],
            value: s.backupScopeAndPolicy.resourcesScope.namespaceScopedResources.excludedResources,
            isCreatable: !0,
            onCreateOption: u(!0),
            onChange: i(!0)
          }
        )
      ] })
    ] })
  ] });
}, HC = ({
  state: s,
  setState: t,
  clusterListConfig: a,
  namespaceListConfig: n,
  formError: o,
  setFormError: r
}) => {
  const { backupScopeAndPolicy: l } = s, i = de(
    () => a.options.filter((d) => d.value === s.backupScopeAndPolicy.selectedClusterId),
    [s.backupScopeAndPolicy.selectedClusterId]
  ), u = (d) => {
    r((g) => ({
      ...g,
      backupScopeAndPolicy: {
        ...g.backupScopeAndPolicy,
        namespaceSelection: null
      }
    }));
    const m = d.target.value;
    if (m === "specific") {
      t({
        ...s,
        backupScopeAndPolicy: {
          ...s.backupScopeAndPolicy,
          namespaces: "specific",
          excludedNamespace: [],
          includedNamespace: []
        }
      });
      return;
    }
    const _ = {
      ...s.backupScopeAndPolicy
    };
    delete _.includedNamespace, delete _.excludedNamespace, t({
      ...s,
      backupScopeAndPolicy: {
        ..._,
        namespaces: m
      }
    });
  }, c = (d) => (m) => {
    const _ = {
      ...s,
      backupScopeAndPolicy: {
        ...s.backupScopeAndPolicy,
        namespaces: "specific",
        includedNamespace: d ? s.backupScopeAndPolicy.includedNamespace : m.map((x) => x.value),
        excludedNamespace: d ? m.map((x) => x.value) : s.backupScopeAndPolicy.excludedNamespace
      }
    }, g = _.backupScopeAndPolicy.includedNamespace.length + _.backupScopeAndPolicy.excludedNamespace.length;
    t(_), r((x) => ({
      ...x,
      backupScopeAndPolicy: {
        ...x.backupScopeAndPolicy,
        namespaceSelection: g === 0 ? "At least one namespace must be selected." : null
      }
    }));
  }, p = (d) => {
    const m = d.value, _ = { ...s.backupScopeAndPolicy };
    delete _.includedNamespace, delete _.excludedNamespace;
    const g = {
      ...s,
      backupScopeAndPolicy: {
        ..._,
        selectedClusterId: m,
        namespaces: "all"
      }
    };
    t(g), r((x) => ({
      ...x,
      backupScopeAndPolicy: {
        ...x.backupScopeAndPolicy,
        selectedClusterId: null
      }
    }));
  };
  return /* @__PURE__ */ e.jsxs(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: [
    /* @__PURE__ */ e.jsx("h3", { className: "fs-13 fw-6 lh-20 cn-9 m-0", children: "Namespaces to backup" }),
    /* @__PURE__ */ e.jsx(
      te,
      {
        label: "Select cluster to backup",
        inputId: "cluster-selection",
        options: a.options,
        value: i,
        optionListError: a.error,
        reloadOptionList: a.refetch,
        onChange: p,
        placeholder: "Select a cluster",
        size: P.large,
        isSearchable: !0,
        isLoading: a.isLoading,
        required: !0,
        error: o.backupScopeAndPolicy.selectedClusterId
      }
    ),
    /* @__PURE__ */ e.jsxs(
      zs,
      {
        value: s.backupScopeAndPolicy.namespaces,
        name: "namespace-option-radio-group",
        onChange: u,
        className: "radio-group-no-border",
        children: [
          /* @__PURE__ */ e.jsx(
            Be,
            {
              dataTestId: "all-namespace",
              value: "all",
              children: "All Namespaces"
            }
          ),
          /* @__PURE__ */ e.jsx(
            Be,
            {
              dataTestId: "all-prod-namespace",
              value: "all-prod",
              children: "All Production Environments"
            }
          ),
          /* @__PURE__ */ e.jsx(
            Be,
            {
              dataTestId: "all-non-prod-namespace",
              value: "all-non-prod",
              children: "All Non-Production Environments"
            }
          ),
          /* @__PURE__ */ e.jsxs(
            Be,
            {
              dataTestId: "specific-namespace",
              value: "specific",
              children: [
                "Specific Namespaces",
                o.backupScopeAndPolicy.namespaceSelection && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  /* @__PURE__ */ e.jsx("br", {}),
                  /* @__PURE__ */ e.jsx("span", { className: "cr-5 fs-12 fw-4 lh-18", children: o.backupScopeAndPolicy.namespaceSelection })
                ] })
              ]
            }
          )
        ]
      }
    ),
    l?.namespaces === "specific" && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "include-namespace-select",
          isMulti: !0,
          label: "Included Namespaces",
          placeholder: "Select namespaces to include",
          value: s.backupScopeAndPolicy.includedNamespace.map((d) => ({
            label: d,
            value: d
          })),
          onChange: c(!1),
          options: n.options,
          optionListError: n.error,
          isLoading: n.isLoading,
          reloadOptionList: n.refetch
        }
      ),
      /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "exclude-namespace-select",
          isMulti: !0,
          label: "Excluded Namespaces",
          placeholder: "Select namespaces to exclude",
          value: s.backupScopeAndPolicy.excludedNamespace.map((d) => ({
            label: d,
            value: d
          })),
          onChange: c(!0),
          options: n.options,
          optionListError: n.error,
          isLoading: n.isLoading,
          reloadOptionList: n.refetch
        }
      )
    ] })
  ] });
};
var ys = /* @__PURE__ */ ((s) => (s.SELECT_CM = "select-cm", s.PROVIDE_YAML = "provide-yaml", s))(ys || {});
const YC = ({
  state: s,
  setState: t,
  clusterListConfig: a,
  namespaceListConfig: n,
  formError: o,
  setFormError: r,
  configMapListConfig: l
}) => {
  const i = (f) => {
    t((h) => ({
      ...h,
      backupScopeAndPolicy: {
        ...h.backupScopeAndPolicy,
        backupTTL: {
          ...h.backupScopeAndPolicy.backupTTL,
          value: f
        }
      }
    }));
  }, u = (f) => {
    t((h) => ({
      ...h,
      backupScopeAndPolicy: {
        ...h.backupScopeAndPolicy,
        backupTTL: {
          ...h.backupScopeAndPolicy.backupTTL,
          unit: f
        }
      }
    }));
  }, c = () => {
    const h = !s.backupScopeAndPolicy.resourcePolicy.isEnabled ? {
      isEnabled: !0,
      type: ys.SELECT_CM,
      configMapName: null
    } : {
      isEnabled: !1
    };
    t((b) => ({
      ...b,
      backupScopeAndPolicy: {
        ...b.backupScopeAndPolicy,
        resourcePolicy: h
      }
    })), r((b) => ({
      ...b,
      backupScopeAndPolicy: {
        ...b.backupScopeAndPolicy,
        resourcePolicy: null
      }
    }));
  }, p = (f) => {
    const b = f.target.value === ys.SELECT_CM ? {
      type: ys.SELECT_CM,
      configMapName: null
    } : {
      type: ys.PROVIDE_YAML,
      data: ""
    };
    t((S) => ({
      ...S,
      backupScopeAndPolicy: {
        ...S.backupScopeAndPolicy,
        resourcePolicy: {
          ...b,
          isEnabled: !0
        }
      }
    })), r((S) => ({
      ...S,
      backupScopeAndPolicy: {
        ...S.backupScopeAndPolicy,
        resourcePolicy: null
      }
    }));
  }, d = (f) => {
    const h = {
      type: ys.SELECT_CM,
      configMapName: f.value
    };
    t((b) => ({
      ...b,
      backupScopeAndPolicy: {
        ...b.backupScopeAndPolicy,
        resourcePolicy: {
          ...h,
          isEnabled: !0
        }
      }
    })), r((b) => ({
      ...b,
      backupScopeAndPolicy: {
        ...b.backupScopeAndPolicy,
        resourcePolicy: null
      }
    }));
  }, m = (f) => {
    const h = {
      type: ys.PROVIDE_YAML,
      data: f
    };
    t((b) => ({
      ...b,
      backupScopeAndPolicy: {
        ...b.backupScopeAndPolicy,
        resourcePolicy: {
          ...h,
          isEnabled: !0
        }
      }
    })), r((b) => ({
      ...b,
      backupScopeAndPolicy: {
        ...b.backupScopeAndPolicy,
        resourcePolicy: f.trim() ? null : "Resource policy YAML cannot be empty."
      }
    }));
  }, _ = (f) => {
    t((h) => ({
      ...h,
      backupScopeAndPolicy: {
        ...h.backupScopeAndPolicy,
        labelSelectors: f
      }
    }));
  }, g = (f) => {
    t((h) => ({
      ...h,
      backupScopeAndPolicy: {
        ...h.backupScopeAndPolicy,
        orLabelSelectors: f
      }
    }));
  }, x = (f) => {
    t((h) => ({
      ...h,
      backupScopeAndPolicy: {
        ...h.backupScopeAndPolicy,
        orderedResources: f
      }
    }));
  }, C = (f) => {
    r((h) => ({
      ...h,
      backupScopeAndPolicy: {
        ...h.backupScopeAndPolicy,
        orderedResources: f ? "Please fix errors in ordered resources." : null
      }
    }));
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      HC,
      {
        state: s,
        setState: t,
        clusterListConfig: a,
        namespaceListConfig: n,
        formError: o,
        setFormError: r
      }
    ),
    /* @__PURE__ */ e.jsx(KC, { state: s, setState: t }),
    /* @__PURE__ */ e.jsx(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "fs-13 fw-4 lh-20 cn-9 m-0", children: "Backup TTL" }),
        /* @__PURE__ */ e.jsx("p", { className: "fs-12 fw-4 lh-16 cn-7 m-0", children: "How long before the backup can be garbage collected" })
      ] }),
      /* @__PURE__ */ e.jsx(
        Vn,
        {
          idPrefix: "backup-ttl",
          value: s.backupScopeAndPolicy.backupTTL.value,
          unit: s.backupScopeAndPolicy.backupTTL.unit,
          onUnitChange: u,
          onValueChange: i
        }
      )
    ] }) }),
    /* @__PURE__ */ e.jsx(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1", children: /* @__PURE__ */ e.jsx("h4", { className: "fs-13 fw-4 lh-20 cn-9 m-0", children: "Ordered Resources" }) }),
      /* @__PURE__ */ e.jsx(
        un,
        {
          headerLabel: { key: "Key", value: "Value" },
          placeholder: { key: "Enter key", value: "Enter value" },
          rows: s.backupScopeAndPolicy.orderedResources.map(({ key: f, value: h, id: b }) => ({
            data: { key: { value: f }, value: { value: h } },
            id: b
          })),
          showError: !0,
          onChange: x,
          onError: C,
          validateEmptyKeys: !0,
          validateDuplicateKeys: !0,
          isSortable: !0
        }
      )
    ] }) }),
    /* @__PURE__ */ e.jsx(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1", children: [
          /* @__PURE__ */ e.jsx("h4", { className: "fs-13 fw-4 lh-20 cn-9 m-0", children: "Resources Policy" }),
          /* @__PURE__ */ e.jsx("p", { className: "fs-12 fw-4 lh-16 cn-7 m-0", children: "Specify the referenced resource policies that backup should follow" })
        ] }),
        /* @__PURE__ */ e.jsx(
          ft,
          {
            isChecked: s.backupScopeAndPolicy.resourcePolicy.isEnabled,
            onChange: c,
            name: "enable-resource-policy-switch",
            ariaLabel: "Enable Resource Policy Switch"
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(Qo, { expand: s.backupScopeAndPolicy.resourcePolicy.isEnabled, children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          zs,
          {
            className: "no-border",
            value: s.backupScopeAndPolicy.resourcePolicy.type,
            name: "modify-resources-config-radio-group",
            onChange: p,
            children: /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx(
                Be,
                {
                  value: ys.SELECT_CM,
                  dataTestId: "modify-resources-config-select-cm-checkbox",
                  children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Select ConfigMap" })
                }
              ),
              /* @__PURE__ */ e.jsx(
                Be,
                {
                  value: ys.PROVIDE_YAML,
                  dataTestId: "restore-target-namespace-specific-checkbox",
                  children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: "Provide Policy YAML" })
                }
              )
            ] })
          }
        ),
        s.backupScopeAndPolicy.resourcePolicy.type === ys.SELECT_CM ? /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "backup-resource-policy-config-map",
            options: l.options || [],
            value: s.backupScopeAndPolicy.resourcePolicy.configMapName ? {
              label: s.backupScopeAndPolicy.resourcePolicy.configMapName,
              value: s.backupScopeAndPolicy.resourcePolicy.configMapName || ""
            } : null,
            onChange: d,
            placeholder: "Select a ConfigMap",
            label: "Resource Policy ConfigMap",
            required: !0,
            fullWidth: !0,
            isLoading: l.isLoading,
            optionListError: l.error,
            reloadOptionList: l.refetch,
            error: o.backupScopeAndPolicy.resourcePolicy
          }
        ) : /* @__PURE__ */ e.jsx(
          bs,
          {
            value: s.backupScopeAndPolicy.resourcePolicy.data,
            mode: ht.YAML,
            height: 300,
            onChange: m,
            placeholder: $C,
            children: o.backupScopeAndPolicy.resourcePolicy && /* @__PURE__ */ e.jsx(bs.ErrorBar, { text: o.backupScopeAndPolicy.resourcePolicy })
          }
        )
      ] }) })
    ] }) }),
    /* @__PURE__ */ e.jsx(
      Rc,
      {
        labelSelectors: s.backupScopeAndPolicy.labelSelectors,
        handleLabelSelectorChange: _,
        handleOrLabelSelectorsChange: g,
        orLabelSelectors: s.backupScopeAndPolicy.orLabelSelectors
      }
    )
  ] });
}, Ha = ({
  label: s,
  description: t,
  isChecked: a,
  onChange: n
}) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-16 dc__align-start", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex-grow-1", children: [
    /* @__PURE__ */ e.jsx("p", { className: "fs-13 lh-1-5 fw-4 cn-9 m-0", children: s }),
    /* @__PURE__ */ e.jsx("p", { className: "fs-12 lh-1-5 fw-4 cn-7 m-0", children: t })
  ] }),
  /* @__PURE__ */ e.jsx(ft, { name: "snapshot-move-data", isChecked: a, ariaLabel: "Snapshot move data", onChange: n })
] }), zC = (s, t) => [
  {
    key: "basicDetails",
    label: t === st.BACKUP ? "Basic Details" : "Basic & Scheduling",
    isActive: s === "basicDetails"
  },
  {
    key: "backupScopeAndPolicy",
    label: "Backup Scope & Policy",
    isActive: s === "backupScopeAndPolicy"
  },
  {
    key: "storageAndSnapshotLocation",
    label: "Storage & Snapshot location",
    isActive: s === "storageAndSnapshotLocation"
  },
  {
    key: "advancedTimeoutsAndTuning",
    label: "Advanced Timeouts & Tuning",
    isActive: s === "advancedTimeoutsAndTuning"
  }
], qC = (s) => {
  const t = {
    advancedTimeoutsAndTuning: {
      CSISnapshotTimeout: { value: null, unit: ss.SECONDS },
      ItemOperationTimeout: { value: null, unit: ss.SECONDS }
    },
    storageAndSnapshotSettings: {
      volumeSnapshotLocation: null,
      storageLocation: null,
      volumeSnapshotEnabled: !1
    },
    backupScopeAndPolicy: {
      selectedClusterId: 0,
      backupTTL: { value: null, unit: ss.SECONDS },
      resourcePolicy: {
        isEnabled: !1
      },
      labelSelectors: [Gt()],
      orLabelSelectors: [[Gt()]],
      resources: "all",
      namespaces: "all",
      orderedResources: []
    }
  };
  return s === "backup" ? {
    ...t,
    basicBackupDetails: {
      backupName: "",
      labels: []
    }
  } : {
    ...t,
    basicScheduleDetails: {
      scheduleName: "",
      description: "",
      labels: [],
      cronExpression: "",
      paused: !1,
      skipUpcomingRun: !1,
      deleteBackupsOnScheduleDeletion: !1
    }
  };
}, XC = (s) => s.map(({ key: t, value: a, id: n }) => ({
  id: n,
  data: {
    key: { value: t },
    value: { value: a }
  }
})), JC = ({
  state: s,
  formError: t,
  type: a
}) => {
  const n = a === st.BACKUP, o = structuredClone(t.basicDetails), r = n ? s.basicBackupDetails.backupName : s.basicScheduleDetails.scheduleName, l = n ? "" : s.basicScheduleDetails.cronExpression;
  return o.name = o.name || Ps(r).message, n || (o.cronExpression = o.cronExpression || Ps(l).message), o;
}, QC = ({
  state: s,
  formError: t
}) => {
  const a = structuredClone(t.backupScopeAndPolicy), { backupScopeAndPolicy: n } = s, o = n.selectedClusterId ? null : "Cluster selection is required.";
  a.selectedClusterId = a.selectedClusterId || o;
  const r = n.resourcePolicy.type === ys.PROVIDE_YAML ? n.resourcePolicy.data : n.resourcePolicy.configMapName, l = n.resourcePolicy.isEnabled ? Ps(r).message : null;
  a.resourcePolicy = a.resourcePolicy || l;
  const i = n.namespaces === "specific", u = (n.includedNamespace?.length || 0) + (n.excludedNamespace?.length || 0), c = i && u === 0 ? "At least one namespace must be selected." : null;
  return a.namespaceSelection = a.namespaceSelection || c, a;
}, ZC = ({
  state: s,
  formError: t
}) => {
  const a = structuredClone(
    t.storageAndSnapshotSettings
  ), { storageAndSnapshotSettings: n } = s, o = n.storageLocation ? null : "Storage location is required.";
  return a.storageLocation = a.storageLocation || o, a;
}, eb = ({
  state: s,
  formError: t,
  type: a
}) => {
  const n = structuredClone(t);
  return n.basicDetails = JC({ state: s, formError: t, type: a }), n.backupScopeAndPolicy = QC({ state: s, formError: t }), n.storageAndSnapshotSettings = ZC({
    state: s,
    formError: t
  }), { isFormValid: !Object.values(n).some(
    (r) => Object.values(r).some((l) => !!l)
  ), updatedFormErrors: n };
}, Xc = (s, t, a) => ({
  name: s,
  description: t,
  labels: a.reduce((n, { key: o, value: r }) => {
    const l = o.trim();
    return l && (n[l] = r.trim()), n;
  }, {})
}), sb = (s) => {
  const { basicScheduleDetails: t } = s;
  return {
    ...Xc(
      t.scheduleName,
      t.description,
      t.labels
    ),
    schedule: t.cronExpression,
    paused: t.paused,
    skipImmediately: t.skipUpcomingRun,
    useOwnerReferencesInBackup: t.deleteBackupsOnScheduleDeletion
  };
}, tb = (s) => s.isEnabled ? s.type === ys.PROVIDE_YAML ? {
  type: "CreateResourcePolicy",
  data: s.data
} : {
  type: "ExistingResourcePolicy",
  name: s.configMapName
} : null, ab = (s) => s.resources === "all" ? {
  isAllResourcesIncluded: !0
} : {
  isAllResourcesIncluded: !1,
  includedClusterScopedResources: (s.resourcesScope.clusterScopedResources.includedResources || []).map((t) => t.value),
  excludedClusterScopedResources: (s.resourcesScope.clusterScopedResources.excludedResources || []).map((t) => t.value),
  includedNamespaceScopedResources: (s.resourcesScope.namespaceScopedResources.includedResources || []).map((t) => t.value),
  excludedNamespaceScopedResources: (s.resourcesScope.namespaceScopedResources.excludedResources || []).map((t) => t.value)
}, Jc = (s) => ({
  ...ab(s),
  ...Pc({
    labelSelectors: s.labelSelectors,
    orLabelSelectors: s.orLabelSelectors
  }),
  clusterId: s.selectedClusterId,
  namespaceGroup: VC[s.namespaces],
  includedNamespaces: s.includedNamespace || [],
  excludedNamespaces: s.excludedNamespace || [],
  ttl: Gn(s.backupTTL.value, s.backupTTL.unit),
  orderedResources: (s.orderedResources || []).reduce(
    (t, { key: a, value: n }) => {
      const o = a.trim();
      return o && (t[o] = n.trim()), t;
    },
    {}
  ),
  resourcePolicyConfig: tb(s.resourcePolicy)
}), nb = (s) => {
  if (!s.volumeSnapshotEnabled)
    return {
      snapshotVolumes: !1
    };
  const t = s.snapshotVolumeSettings;
  return {
    snapshotVolumes: !0,
    snapshotMoveData: t.moveData,
    defaultVolumesToFsBackup: t.defaultVolumesToFSBackup,
    dataMover: t.dataMover,
    uploaderConfig: {
      parallelFilesUpload: t.parallelFilesUpload
    }
  };
}, Qc = (s) => ({
  ...nb(s),
  storageLocationId: s.storageLocation,
  snapshotLocationIds: s.volumeSnapshotLocation
}), Zc = (s) => ({
  csiSnapshotTimeout: Gn(
    s.CSISnapshotTimeout.value,
    s.CSISnapshotTimeout.unit
  ),
  itemOperationTimeout: Gn(
    s.ItemOperationTimeout.value,
    s.ItemOperationTimeout.unit
  )
}), ed = (s) => ({
  ...sb(s),
  ...Jc(s.backupScopeAndPolicy),
  ...Qc(s.storageAndSnapshotSettings),
  ...Zc(s.advancedTimeoutsAndTuning)
}), ob = (s) => ({
  ...Xc(s.basicBackupDetails.backupName, void 0, s.basicBackupDetails.labels),
  ...Jc(s.backupScopeAndPolicy),
  ...Qc(s.storageAndSnapshotSettings),
  ...Zc(s.advancedTimeoutsAndTuning),
  sourceType: "manual"
}), rb = (s) => {
  const t = GC[s.namespaceGroup];
  return t === "specific" ? {
    namespaces: "specific",
    includedNamespace: s.includedNamespaces || [],
    excludedNamespace: s.excludedNamespaces || []
  } : {
    namespaces: t
  };
}, lb = (s) => s.isAllResourcesIncluded ? {
  resources: "all"
} : {
  resources: "specific",
  resourcesScope: {
    clusterScopedResources: {
      isSelected: (s.includedClusterScopedResources || []).length > 0 || (s.excludedClusterScopedResources || []).length > 0,
      includedResources: (s.includedClusterScopedResources || []).map(
        (t) => ({
          label: t,
          value: t
        })
      ),
      excludedResources: (s.excludedClusterScopedResources || []).map(
        (t) => ({
          label: t,
          value: t
        })
      )
    },
    namespaceScopedResources: {
      isSelected: (s.includedNamespaceScopedResources || []).length > 0 || (s.excludedNamespaceScopedResources || []).length > 0,
      includedResources: (s.includedNamespaceScopedResources || []).map((t) => ({
        label: t,
        value: t
      })),
      excludedResources: (s.excludedNamespaceScopedResources || []).map((t) => ({
        label: t,
        value: t
      }))
    }
  }
}, ib = (s) => s.resourcePolicyConfig ? s.resourcePolicyConfig.type === "CreateResourcePolicy" ? {
  isEnabled: !0,
  type: ys.PROVIDE_YAML,
  data: s.resourcePolicyConfig.data
} : {
  isEnabled: !0,
  type: ys.SELECT_CM,
  configMapName: s.resourcePolicyConfig.name
} : {
  isEnabled: !1
}, cb = (s) => ({
  basicScheduleDetails: {
    scheduleName: s.name || "",
    description: s.description || "",
    labels: Object.entries(s.labels || {}).map(([t, a]) => ({ id: vs(), key: t, value: a })),
    cronExpression: s.schedule || "",
    paused: s.paused || !1,
    skipUpcomingRun: s.skipImmediately || !1,
    deleteBackupsOnScheduleDeletion: s.useOwnerReferencesInBackup || !1
  },
  backupScopeAndPolicy: {
    ...lb(s),
    ...rb(s),
    labelSelectors: s.labelSelectors ? kl(s.labelSelectors) : [Gt()],
    orLabelSelectors: s.orLabelSelectors?.length ? s.orLabelSelectors.map(kl) : [[Gt()]],
    selectedClusterId: s.clusterId,
    backupTTL: Ao(s.ttl),
    orderedResources: Object.entries(s.orderedResources || {}).map(([t, a]) => ({
      key: t,
      value: a,
      id: vs()
    })),
    resourcePolicy: ib(s)
  },
  storageAndSnapshotSettings: {
    storageLocation: s.storageLocationId || null,
    volumeSnapshotLocation: s.snapshotLocationIds || null,
    ...s.snapshotVolumes ? {
      volumeSnapshotEnabled: !0,
      snapshotVolumeSettings: {
        moveData: s.snapshotMoveData || !1,
        defaultVolumesToFSBackup: s.defaultVolumesToFsBackup || !1,
        dataMover: s.dataMover || "",
        parallelFilesUpload: s.uploaderConfig?.parallelFilesUpload || null
      }
    } : {
      volumeSnapshotEnabled: !1
    }
  },
  advancedTimeoutsAndTuning: {
    CSISnapshotTimeout: Ao(s.csiSnapshotTimeout),
    ItemOperationTimeout: Ao(s.itemOperationTimeout)
  }
}), db = (s) => Object.values(s).some((t) => !!t), ub = ({ state: s, setState: t, formError: a, setFormError: n }) => {
  const { type: o, id: r } = ce(), l = !!r, i = o === "backup", u = (x, C) => {
    switch (x) {
      case "backupName":
      case "scheduleName":
        n((f) => ({
          ...f,
          basicDetails: {
            ...f.basicDetails,
            name: dn(C).message
          }
        }));
        break;
      case "cronExpression":
        n((f) => ({
          ...f,
          basicDetails: {
            ...f.basicDetails,
            cronExpression: kp(C).message
          }
        }));
        break;
      case "description":
        n((f) => ({
          ...f,
          basicDetails: {
            ...f.basicDetails,
            description: ar(C).message
          }
        }));
        break;
    }
  }, c = (x) => {
    n((C) => ({
      ...C,
      basicDetails: {
        ...C.basicDetails,
        labels: x ? "Please fix the errors in labels" : ""
      }
    }));
  }, p = (x) => (C) => {
    const { value: f } = C.target;
    if (i) {
      const h = {
        ...s,
        basicBackupDetails: {
          ...s.basicBackupDetails,
          [x]: f
        },
        basicScheduleDetails: void 0
      };
      t(h);
    } else {
      const h = {
        ...s,
        basicBackupDetails: void 0,
        basicScheduleDetails: {
          ...s.basicScheduleDetails,
          [x]: f
        }
      };
      t(h);
    }
    u(x, f);
  }, d = (x) => () => {
    if (!i) {
      const C = {
        ...s,
        basicBackupDetails: void 0,
        basicScheduleDetails: {
          ...s.basicScheduleDetails,
          [x]: !s.basicScheduleDetails[x]
        }
      };
      t(C);
    }
  }, m = (x) => {
    if (i) {
      t({
        ...s,
        basicScheduleDetails: void 0,
        basicBackupDetails: {
          ...s.basicBackupDetails,
          labels: x
        }
      });
      return;
    }
    t({
      ...s,
      basicBackupDetails: void 0,
      basicScheduleDetails: {
        ...s.basicScheduleDetails,
        labels: x
      }
    });
  }, g = i ? "" : ((x) => {
    try {
      return lr(x);
    } catch {
      return "";
    }
  })(s.basicScheduleDetails.cronExpression);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: [
      /* @__PURE__ */ e.jsx(
        ke,
        {
          name: i ? "backup-name" : "schedule-name",
          label: i ? "Backup Name" : "Schedule Name",
          placeholder: i ? "Enter backup name" : "Enter schedule name",
          value: i ? s.basicBackupDetails.backupName : s.basicScheduleDetails.scheduleName,
          onChange: p(i ? "backupName" : "scheduleName"),
          required: !0,
          autoFocus: !0,
          disabled: l,
          size: P.large,
          error: a.basicDetails.name
        }
      ),
      !i && /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4", children: /* @__PURE__ */ e.jsx(
        At,
        {
          label: "Description",
          name: "description",
          placeholder: "Enter a brief description for this schedule",
          value: s.basicScheduleDetails.description || "",
          onChange: p("description"),
          error: a.basicDetails.description
        }
      ) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-1-5 cn-9", children: "Labels" }),
        /* @__PURE__ */ e.jsx(
          un,
          {
            headerLabel: { key: "Key", value: "Value" },
            rows: XC(
              i ? s.basicBackupDetails.labels : s.basicScheduleDetails.labels
            ),
            showError: !0,
            validateEmptyKeys: !0,
            validateDuplicateKeys: !0,
            isSortable: !0,
            placeholder: { key: "Enter label key", value: "Enter label value" },
            onChange: m,
            onError: c
          }
        )
      ] })
    ] }),
    !i && /* @__PURE__ */ e.jsxs(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "fs-13 fw-6 lh-20 cn-9 m-0", children: "Backup Schedule Preferences" }),
      /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox dc__separated-flexbox--vertical", children: [
        /* @__PURE__ */ e.jsx(
          ke,
          {
            name: "cron-expression",
            label: "Backup Schedule",
            placeholder: "Type cron expression",
            value: s.basicScheduleDetails.cronExpression,
            onChange: p("cronExpression"),
            error: a.basicDetails.cronExpression,
            required: !0,
            size: P.large,
            helperText: g ? /* @__PURE__ */ e.jsxs("span", { children: [
              "Cron expression will be evaluated and shown here: ",
              /* @__PURE__ */ e.jsx("span", { className: "cg-7", children: g })
            ] }) : null
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ha,
          {
            label: "Pause schedule",
            description: "Pauses this backup schedule. Pausing this schedule will not create backups.",
            isChecked: s.basicScheduleDetails.paused,
            ariaLabel: "Pause schedule",
            name: "pause-schedule-b&s",
            onChange: d("paused")
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ha,
          {
            label: "Skip upcoming backup",
            description: "Skip the next scheduled backup immediately.",
            isChecked: s.basicScheduleDetails.skipUpcomingRun,
            onChange: d("skipUpcomingRun"),
            name: "skip-upcoming-backup-b&s",
            ariaLabel: "Skip upcoming backup toggle"
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ha,
          {
            label: "Delete backups on schedule deletion",
            description: "If set to true, deleting this schedule will also delete all the backups that were created by this schedule",
            isChecked: s.basicScheduleDetails.deleteBackupsOnScheduleDeletion,
            onChange: d("deleteBackupsOnScheduleDeletion"),
            name: "delete-backups-on-schedule-deletion",
            ariaLabel: "Delete backups on schedule deletion toggle"
          }
        )
      ] })
    ] })
  ] });
}, pb = async (s) => {
  try {
    return await _s(z.BACKUP_CREATE, ob(s)), !0;
  } catch (t) {
    return ve(t), !1;
  }
}, mb = async (s) => {
  try {
    return await _s(z.CLUSTER_BACKUP_SCHEDULE, ed(s)), !0;
  } catch (t) {
    return ve(t), !1;
  }
}, hb = async (s, t) => {
  try {
    return await Aa(z.CLUSTER_BACKUP_SCHEDULE, {
      id: s,
      ...ed(t)
    }), !0;
  } catch (a) {
    return ve(a), !1;
  }
}, _b = async (s, t) => {
  const { result: a } = await xe(`${z.CLUSTER_BACKUP_SCHEDULE}/${s}`, { signal: t });
  return cb(a);
}, fb = ({
  state: s,
  setState: t,
  storageLocationConfig: a,
  volumeSnapshotLocationConfig: n,
  formError: o,
  setFormError: r
}) => {
  const l = (x) => {
    const { value: C } = x, f = {
      ...s,
      storageAndSnapshotSettings: {
        ...s.storageAndSnapshotSettings,
        storageLocation: C
      }
    };
    t(f), r((h) => ({
      ...h,
      storageAndSnapshotSettings: {
        storageLocation: ""
      }
    }));
  }, i = (x) => {
    const C = {
      ...s,
      storageAndSnapshotSettings: {
        ...s.storageAndSnapshotSettings,
        volumeSnapshotLocation: x.map((f) => f.value) || null
      }
    };
    t(C);
  }, u = (x) => {
    const C = x.target.value === "true", f = {
      ...s,
      storageAndSnapshotSettings: {
        ...s.storageAndSnapshotSettings,
        ...C ? {
          volumeSnapshotEnabled: !0,
          snapshotVolumeSettings: {
            moveData: !1,
            defaultVolumesToFSBackup: !1
          }
        } : {
          volumeSnapshotEnabled: !1,
          snapshotVolumeSettings: void 0
        }
      }
    };
    t(f);
  }, c = () => {
    if (!s.storageAndSnapshotSettings.volumeSnapshotEnabled) return;
    const x = {
      ...s,
      storageAndSnapshotSettings: {
        ...s.storageAndSnapshotSettings,
        snapshotVolumeSettings: {
          ...s.storageAndSnapshotSettings.snapshotVolumeSettings,
          moveData: !s.storageAndSnapshotSettings.snapshotVolumeSettings.moveData
        }
      }
    };
    t(x);
  }, p = () => {
    if (!s.storageAndSnapshotSettings.volumeSnapshotEnabled) return;
    const x = {
      ...s,
      storageAndSnapshotSettings: {
        ...s.storageAndSnapshotSettings,
        snapshotVolumeSettings: {
          ...s.storageAndSnapshotSettings.snapshotVolumeSettings,
          defaultVolumesToFSBackup: !s.storageAndSnapshotSettings.snapshotVolumeSettings.defaultVolumesToFSBackup
        }
      }
    };
    t(x);
  }, d = (x) => {
    if (!s.storageAndSnapshotSettings.volumeSnapshotEnabled)
      return;
    const C = {
      ...s,
      storageAndSnapshotSettings: {
        ...s.storageAndSnapshotSettings,
        snapshotVolumeSettings: {
          ...s.storageAndSnapshotSettings.snapshotVolumeSettings,
          dataMover: x.target.value
        }
      }
    };
    t(C);
  }, m = (x) => {
    if (!s.storageAndSnapshotSettings.volumeSnapshotEnabled) return;
    const C = parseInt(x.target.value, 10), f = {
      ...s,
      storageAndSnapshotSettings: {
        ...s.storageAndSnapshotSettings,
        snapshotVolumeSettings: {
          ...s.storageAndSnapshotSettings.snapshotVolumeSettings,
          parallelFilesUpload: Number.isNaN(C) ? void 0 : C
        }
      }
    };
    t(f);
  }, _ = s.storageAndSnapshotSettings, g = _?.volumeSnapshotEnabled ? _.snapshotVolumeSettings : {
    moveData: !1,
    defaultVolumesToFSBackup: !1,
    dataMover: "",
    parallelFilesUpload: ""
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 p-0 fs-13 cn-9 fw-6 lh-1-5", children: "Volume Snapshot & Storage Location" }),
      /* @__PURE__ */ e.jsx(
        te,
        {
          label: "Volume Snapshot Location",
          inputId: "volume-snapshot-location",
          isMulti: !0,
          options: n.options,
          value: n.options.filter(
            (x) => _?.volumeSnapshotLocation?.includes(x.value)
          ),
          onChange: i,
          placeholder: "Select snapshot location",
          size: P.large,
          isSearchable: !0,
          optionListError: n.error,
          reloadOptionList: n.refetch,
          isLoading: n.isLoading,
          isClearable: !0,
          helperText: "List of locations (at most one per provider) where volume snapshots should be stored"
        }
      ),
      /* @__PURE__ */ e.jsx(
        te,
        {
          required: !0,
          label: "Storage Location",
          inputId: "storage-location",
          options: a.options,
          value: a.options.find(
            (x) => x.value === _?.storageLocation
          ),
          onChange: l,
          placeholder: "Select storage location",
          size: P.large,
          optionListError: a.error,
          reloadOptionList: a.refetch,
          isLoading: a.isLoading,
          isSearchable: !0,
          helperText: "Location in which to store the backup",
          error: o.storageAndSnapshotSettings.storageLocation
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs(Ze, { padding: 16, flexGap: 16, variant: "secondary--outlined", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 p-0 fs-13 cn-9 fw-6 lh-1-5", children: "Snapshot Volume Settings" }),
      /* @__PURE__ */ e.jsxs("div", { className: "dc__separated-flexbox dc__separated-flexbox--vertical", children: [
        /* @__PURE__ */ e.jsxs(
          zs,
          {
            value: `${s.storageAndSnapshotSettings.volumeSnapshotEnabled}`,
            name: "snapshot-volume-radio-group",
            onChange: u,
            className: "radio-group-no-border",
            children: [
              /* @__PURE__ */ e.jsx(Be, { dataTestId: "take-snapshot", value: "true", children: "Take snapshot" }),
              /* @__PURE__ */ e.jsx(Be, { dataTestId: "skip-volume-snapshot", value: "false", children: "Skip volume snapshot" })
            ]
          }
        ),
        s.storageAndSnapshotSettings.volumeSnapshotEnabled && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Ha,
            {
              label: "Snapshot Move Data",
              description: "Specify if snapshot data should be moved",
              isChecked: !!g.moveData,
              ariaLabel: "Snapshot move data toggle",
              name: "snapshot-move-data-toggle",
              onChange: c
            }
          ),
          /* @__PURE__ */ e.jsx(
            Ha,
            {
              label: "Default Volumes to FS Backup",
              description: "Use pod volume file system backup by default for volumes",
              isChecked: !!g.defaultVolumesToFSBackup,
              ariaLabel: "Default volumes to FS backup toggle",
              name: "default-volumes-to-fs-backup-toggle",
              onChange: p
            }
          ),
          /* @__PURE__ */ e.jsx(
            ke,
            {
              name: "data-mover-input",
              onChange: d,
              placeholder: "Type data mover",
              label: "Data Mover",
              value: g.dataMover,
              helperText: "Specify the data mover to be used by the backup. If the parameter is not set or set as 'velero', the built-in data mover will be used"
            }
          ),
          /* @__PURE__ */ e.jsx(
            ke,
            {
              name: "parallel-files-upload-input",
              onChange: m,
              placeholder: "Eg. 10",
              label: "Parallel Files Upload",
              value: g.parallelFilesUpload,
              helperText: "Number of files uploads simultaneously when running a backup. This is only applicable for the kopia uploader"
            }
          )
        ] })
      ] })
    ] })
  ] });
}, sd = ({ reloadOnClose: s }) => {
  const { type: t, id: a } = ce(), n = a ? st.SCHEDULE : t, o = !!a, { url: r } = Ts(), { search: l } = he(), { push: i } = ae(), u = de(() => qC(n), [n]), [c, p] = E(u), [d, m] = E({
    storageAndSnapshotSettings: {
      storageLocation: null
    },
    backupScopeAndPolicy: {
      selectedClusterId: null,
      namespaceSelection: null,
      resourcePolicy: null,
      orderedResources: null
    },
    basicDetails: {
      name: null,
      description: null,
      labels: null,
      cronExpression: null
    }
  }), [_, g] = E("basicDetails"), [x, C] = E(!1), {
    isFetching: f,
    data: h,
    error: b,
    refetch: S
  } = se({
    queryKey: ["edit-backup-schedule-form-state", a],
    queryFn: ({ signal: oe }) => _b(+a, oe),
    enabled: o
  }), {
    data: O,
    isFetching: j,
    error: v,
    refetch: A
  } = se({
    queryFn: ({ signal: oe }) => or(oe),
    queryKey: ["create-backup-and-schedule-cluster-list"],
    select: (oe) => (oe || []).filter(({ isVirtual: Fe }) => !Fe).map((Fe) => ({ label: Fe.name, value: Fe.id }))
  }), {
    data: N,
    isFetching: L,
    error: M,
    refetch: W
  } = se({
    queryFn: ({ signal: oe }) => gc(c.backupScopeAndPolicy.selectedClusterId, oe),
    enabled: c.backupScopeAndPolicy.selectedClusterId > 0,
    queryKey: ["create-backup-and-schedule-namespace-list", c.backupScopeAndPolicy.selectedClusterId]
  }), {
    data: $,
    isFetching: w,
    error: T,
    refetch: I
  } = se({
    queryFn: ({ signal: oe }) => Dc({ signal: oe }),
    select: (oe) => (oe?.result || []).map((Fe) => ({
      label: Fe.name,
      value: Fe.id
    })),
    queryKey: ["create-backup-and-schedule-storage-location-list"]
  }), {
    data: y,
    isFetching: k,
    error: G,
    refetch: K
  } = se({
    queryFn: ({ signal: oe }) => kc({ signal: oe }),
    select: (oe) => (oe.result || []).map((Fe) => ({
      label: Fe.name,
      value: Fe.id
    })),
    queryKey: ["create-backup-and-schedule-volume-snapshot-location-list"]
  }), {
    isFetching: X,
    data: Oe,
    error: J,
    refetch: _e
  } = se({
    queryKey: ["get-config-map-list", c.backupScopeAndPolicy.selectedClusterId],
    queryFn: ({ signal: oe }) => Lc({
      signal: oe,
      clusterId: c.backupScopeAndPolicy.selectedClusterId
    }),
    select: (oe) => (oe.result || []).map((Fe) => ({ label: Fe, value: Fe })).sort((Fe, wa) => Ae(Fe.label, wa.label)),
    enabled: !!c.backupScopeAndPolicy.selectedClusterId,
    meta: {
      showToastError: !1
    }
  });
  ue(() => {
    o && h && p(h);
  }, [h, o]), Dp({
    shouldPrompt: x
  });
  const ee = () => {
    const oe = a ? Q(Ue.EDIT_SCHEDULE, { id: a }) : Q(Ue.CREATE_FROM_SCRATCH, { type: n });
    i({
      pathname: r.replace(oe, ""),
      search: l
    });
  }, H = () => o ? "Edit Backup Schedule" : n === "backup" ? "Create Backup" : "Create Backup Schedule", Je = (oe) => {
    g(oe);
  }, Ct = () => {
    switch (_) {
      case "basicDetails":
        return /* @__PURE__ */ e.jsx(
          ub,
          {
            state: c,
            setState: p,
            formError: d,
            setFormError: m
          }
        );
      case "backupScopeAndPolicy":
        return /* @__PURE__ */ e.jsx(
          YC,
          {
            state: c,
            setState: p,
            formError: d,
            setFormError: m,
            clusterListConfig: {
              options: O,
              error: v,
              isLoading: j,
              refetch: A
            },
            namespaceListConfig: {
              options: N,
              error: M,
              isLoading: L,
              refetch: W
            },
            configMapListConfig: {
              isLoading: X,
              error: J,
              options: Oe,
              refetch: _e
            }
          }
        );
      case "storageAndSnapshotLocation":
        return /* @__PURE__ */ e.jsx(
          fb,
          {
            state: c,
            setState: p,
            formError: d,
            setFormError: m,
            storageLocationConfig: {
              error: T,
              isLoading: w,
              options: $,
              refetch: I
            },
            volumeSnapshotLocationConfig: {
              error: G,
              isLoading: k,
              options: y,
              refetch: K
            }
          }
        );
      case "advancedTimeoutsAndTuning":
        return /* @__PURE__ */ e.jsx(FC, { state: c, setState: p });
      default:
        return null;
    }
  }, fs = (oe) => () => {
    Je(oe);
  }, He = async () => {
    const { isFormValid: oe, updatedFormErrors: Fe } = eb({ state: c, formError: d, type: n });
    if (m(Fe), !oe) {
      Se.showToast({
        description: "Please resolve the errors before saving.",
        variant: Ne.error
      });
      return;
    }
    C(!0);
    const wa = o ? await hb(+a, c) : await (n === st.BACKUP ? pb : mb)(c);
    C(!1), wa && (Se.showToast({
      description: `Successfully created backup ${n === st.SCHEDULE ? "schedule" : ""}`,
      variant: Ne.success
    }), s?.(), ee());
  }, It = (oe) => {
    const Fe = d[WC[oe]];
    return Fe ? db(Fe) : !1;
  };
  return /* @__PURE__ */ e.jsx(Vs, { onClose: ee, onEscape: ee, position: "right", width: "1024px", parentClassName: "h-100", children: /* @__PURE__ */ e.jsxs("div", { className: "bg__primary h-100 cn-9 w-100 flexbox-col dc__overflow-hidden p-0", onClick: Rs, children: [
    /* @__PURE__ */ e.jsxs("header", { className: "px-20 py-12 lh-24 flexbox dc__content-space dc__align-items-center dc__border-bottom", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 dc__first-letter-capitalize", children: H() }),
      /* @__PURE__ */ e.jsx(
        B,
        {
          icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
          dataTestId: "backup-schedule-create__cross",
          component: me.button,
          style: q.negativeGrey,
          size: P.xs,
          variant: U.borderLess,
          ariaLabel: `Close ${H().toLowerCase()} drawer`,
          showTooltip: x,
          tooltipProps: {
            content: `${n === "backup" ? "Backup" : "Backup Schedule"} creation in progress`
          },
          disabled: x,
          onClick: ee,
          showAriaLabelInTippy: !1
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox flex-grow-1 dc__overflow-hidden", children: [
      /* @__PURE__ */ e.jsx("div", { className: "w-250 bg__primary flexbox-col dc__no-shrink border__secondary--right", children: /* @__PURE__ */ e.jsxs("div", { className: "p-16 flexbox-col dc__gap-12", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: zC(_, n).map((oe) => /* @__PURE__ */ e.jsxs(
          "button",
          {
            type: "button",
            className: `dc__transparent dc__transition flex left dc__content-space dc__gap-8 py-6 px-8 br-4 ${oe.isActive ? "bcb-1" : "dc__hover-n50"}`,
            onClick: fs(oe.key),
            "aria-label": `View: ${oe.label}`,
            children: [
              /* @__PURE__ */ e.jsx(
                "span",
                {
                  className: `fs-13 lh-20 dc__truncate ${oe.isActive ? "cb-5 fw-6" : "cn-9"}`,
                  children: oe.label
                }
              ),
              It(oe.key) && /* @__PURE__ */ e.jsx(D, { name: "ic-error", color: "R500" })
            ]
          },
          oe.key
        )) }),
        /* @__PURE__ */ e.jsx("div", { className: "divider__secondary--horizontal" }),
        /* @__PURE__ */ e.jsx(
          Mp,
          {
            heading: null,
            documentationLink: "DOC_HOME_PAGE",
            rootClassName: "w-100 dc__no-background-imp"
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 bg__secondary dc__overflow-auto p-20 dc__gap-16 backup-and-schedule-create-form", children: /* @__PURE__ */ e.jsx(
        at,
        {
          isLoading: o && f,
          error: b,
          errorScreenManagerProps: {
            code: b?.code,
            reload: S,
            on404Redirect: ee
          },
          progressingProps: {
            pageLoader: !0
          },
          children: Ct()
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsxs("footer", { className: "flexbox dc__content-end border__secondary--top px-20 pt-15 pb-16 dc__gap-12 dc__no-shrink", children: [
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "cancel-backup-schedule-creation-button",
          text: "Cancel",
          variant: U.secondary,
          style: q.neutral,
          size: P.large,
          onClick: ee,
          disabled: x
        }
      ),
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "create-backup-schedule-button",
          onClick: He,
          size: P.large,
          ...n === "backup" ? {
            startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-play-outline", color: null }),
            text: "Start Backup"
          } : {
            text: "Save"
          },
          isLoading: x || o && f
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(tm, { when: x, message: _i })
  ] }) });
}, td = ({ reloadOnClose: s }) => {
  const { id: t } = ce(), { url: a } = Ts(), { push: n } = ae(), { search: o } = he(), [r, l] = E(null), [i, u] = E(!1), [c, p] = E(null), d = r !== null ? dn(r) : null, {
    data: m,
    isFetching: _,
    error: g,
    refetch: x
  } = se({
    queryKey: ["schedules"],
    queryFn: ({ signal: S }) => vr({ signal: S }),
    select: (S) => (S?.result || []).map(
      ({ name: O, id: j }) => ({ label: O, value: j })
    ).sort((O, j) => Ae(O.label, j.label))
  });
  ue(() => {
    if (t && m) {
      const S = m.find((O) => O.value === +t);
      p(S ?? null);
    }
  }, [t, m]);
  const C = () => {
    n({
      pathname: a.replace(Q(Ue.CREATE_FROM_SCHEDULE, { id: t }), ""),
      search: o
    });
  }, f = (S) => {
    l(S.target.value);
  }, h = (S) => {
    p(S);
  }, b = async () => {
    u(!0);
    try {
      await _s(z.BACKUP_CREATE, {
        name: r,
        scheduleId: c.value,
        sourceType: "schedule"
      }), u(!1), s?.(), C();
    } catch (S) {
      ve(S);
    }
    u(!1);
  };
  return /* @__PURE__ */ e.jsxs(
    En,
    {
      name: "create-backup-from-schedule-modal",
      open: !0,
      closeOnBackdropClick: !0,
      onClose: C,
      onEscape: C,
      children: [
        /* @__PURE__ */ e.jsx(En.Header, { title: "Create backup from schedule" }),
        /* @__PURE__ */ e.jsx(En.Body, { children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-16 p-20 h-250", children: [
          /* @__PURE__ */ e.jsx(
            ke,
            {
              name: "backup-name",
              placeholder: "Eg. Daily Database Backup",
              autoFocus: !0,
              label: "Backup Name",
              onChange: f,
              value: r,
              error: d?.message,
              required: !0
            }
          ),
          /* @__PURE__ */ e.jsx(
            te,
            {
              inputId: "select-backup-schedule",
              required: !0,
              label: "Schedule",
              helperText: "Configurations from the schedule will be used to create the backup",
              options: m,
              isLoading: _,
              optionListError: g,
              reloadOptionList: x,
              onChange: h,
              value: c
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsx(
          En.Footer,
          {
            buttonConfig: {
              secondaryButton: {
                dataTestId: "close-modal--backup-from-schedule",
                text: "Cancel",
                disabled: i,
                onClick: C
              },
              primaryButton: {
                isLoading: i,
                text: "Create Backup",
                dataTestId: "create-backup-from-schedule",
                onClick: b,
                disabled: d === null || !d.isValid || !c
              }
            }
          }
        )
      ]
    }
  );
}, gb = (s) => {
  const { path: t } = Ts();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      le,
      {
        path: [
          `${t}${Ue.CREATE_FROM_SCRATCH}`,
          `${t}${Ue.EDIT_SCHEDULE}`
        ],
        exact: !0,
        children: /* @__PURE__ */ e.jsx(sd, { ...s })
      }
    ),
    /* @__PURE__ */ e.jsx(le, { path: `${t}${Ue.CREATE_FROM_SCHEDULE}`, exact: !0, children: /* @__PURE__ */ e.jsx(td, { ...s }) })
  ] });
}, Wl = "backup-schedule-detail-meta-container", xb = [
  {
    label: "Backups",
    value: "backups"
  },
  {
    label: "Manifest",
    value: "manifest"
  }
], $l = "tab", Cb = ({
  detail: s,
  isDetailLoading: t,
  detailError: a,
  refetchDetail: n
}) => {
  const { replace: o, push: r } = ae(), { path: l, url: i } = Ts(), { search: u } = he(), { searchParams: c } = Re(), p = c[$l] ?? "backups", [d, m] = E(!1), [_, g] = E(!1), x = ({ value: $ }) => {
    const w = new URLSearchParams(u);
    w.set($l, $), r({ search: w.toString() });
  }, {
    data: C,
    isLoading: f,
    error: h,
    refetch: b
  } = se({
    queryKey: ["backup-manifest", s],
    queryFn: ({ signal: $ }) => Yn({
      clusterId: s.k8sManifestDetail.clusterId,
      gvk: s.k8sManifestDetail.gvk,
      name: s.k8sManifestDetail.name,
      namespace: s.k8sManifestDetail.namespace,
      signal: $
    }),
    select: ($) => JSON.stringify($.manifestResponse.manifest),
    enabled: p === "manifest" && !!s
  }), S = de(() => Kc(be.Backups), []), O = Wt(
    ($, w) => Vc({
      ...$,
      [Ee.CREATED_BY_SCHEDULE]: [String(s.id)],
      [Ee.CREATED_BY_USER]: null,
      [Ee.STATUS]: null,
      signal: w
    }),
    [s]
  ), j = () => {
    o(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, { view: be.Schedules });
  }, v = async () => {
    m(!0);
    try {
      await Aa(
        Q(
          s.status === "Enabled" ? z.SCHEDULE_PAUSE : z.SCHEDULE_UNPAUSE,
          {
            id: s.id
          }
        ),
        null
      ), Se.showToast({
        variant: Ne.success,
        description: `Schedule ${s.status === "Enabled" ? "paused" : "resumed"} successfully`
      }), n();
    } catch ($) {
      ve($);
    } finally {
      m(!1);
    }
  }, A = () => {
    r({
      pathname: `${i}${Q(Ue.CREATE_FROM_SCHEDULE, { id: s.id })}`,
      search: u
    });
  };
  if (t)
    return /* @__PURE__ */ e.jsx(cs, { pageLoader: !0 });
  if (a)
    return /* @__PURE__ */ e.jsx(_t, { reload: n, on404Redirect: j, code: a.code });
  const N = () => {
    switch (p) {
      case "backups":
        return /* @__PURE__ */ e.jsx(
          oa,
          {
            loading: t,
            id: "table__backup-and-schedule-list",
            columns: S,
            filtersVariant: la.URL,
            additionalFilterProps: {
              initialSortKey: "backupDate",
              parseSearchParams: Wc
            },
            paginationVariant: ra.PAGINATED,
            getRows: O,
            emptyStateConfig: {
              noRowsConfig: {
                title: "No backups found for this schedule",
                subTitle: "The backups will be created as per the defined schedule (cron expression).",
                imgName: "create-backup-snapshot"
              }
            },
            filter: null
          }
        );
      case "manifest":
        return h ? /* @__PURE__ */ e.jsx(_t, { reload: b, code: h.code }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            bs,
            {
              loading: f,
              readOnly: !0,
              height: "100%",
              mode: ht.YAML,
              value: C ?? ""
            }
          ),
          C && /* @__PURE__ */ e.jsx(Ni, { portalParentId: Wl, children: /* @__PURE__ */ e.jsx(
            Xn,
            {
              variant: "button--secondary",
              size: P.small,
              content: C
            }
          ) })
        ] });
      default:
        return null;
    }
  }, L = async () => {
    await Gc(s.id), o(
      Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, {
        view: be.Schedules
      })
    );
  }, M = () => {
    g(!1);
  }, W = async ($) => {
    switch ($.id) {
      case "delete-schedule":
        g(!0);
        break;
      case "edit":
        r({
          pathname: `${i}${Q(Ue.EDIT_SCHEDULE, { id: s.id })}`,
          search: u
        });
        break;
    }
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox h-100 w-100 dc__overflow-hidden backup-schedule-detail", children: [
      /* @__PURE__ */ e.jsx(
        Uc,
        {
          ...MC({
            backupScheduleDetail: s,
            onUpdateScheduleEnabledState: v,
            onCreateBackupFromThisScheduleClick: A,
            isPauseUnpauseScheduleAPICallInProgress: d,
            onActionMenuClick: W
          })
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-16 py-12 px-16 border__secondary--bottom dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            ca,
            {
              name: "backup-schedule-view-control",
              value: p,
              segments: xb,
              onChange: x
            }
          ),
          /* @__PURE__ */ e.jsx("div", { id: Wl })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1 dc__overflow-hidden flexbox-col", children: N() })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(le, { path: `${l}${Ue.CREATE_FROM_SCHEDULE}`, exact: !0, children: /* @__PURE__ */ e.jsx(td, { reloadOnClose: n }) }),
    /* @__PURE__ */ e.jsx(le, { path: `${l}${Ue.EDIT_SCHEDULE}`, exact: !0, children: /* @__PURE__ */ e.jsx(sd, {}) }),
    _ && /* @__PURE__ */ e.jsx(
      Xa,
      {
        title: s.name,
        component: "schedule",
        subtitle: "Are you sure you want to delete this backup schedule?",
        closeConfirmationModal: M,
        onDelete: L,
        successToastMessage: "Schedule deleted successfully"
      }
    )
  ] });
}, bb = (s, t) => ({
  alias: {
    ...Cn(),
    "backup-and-schedule": {
      component: /* @__PURE__ */ e.jsx(
        as,
        {
          className: "dc__no-decor fs-16 lh-1-5 cb-5 fw-4",
          to: Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, { view: "backups" }),
          children: "Backup & Schedule"
        }
      ),
      linked: !1
    },
    ":view(backups|schedules)": {
      component: /* @__PURE__ */ e.jsx(
        as,
        {
          className: "dc__no-decor fs-16 lh-1-5 cb-5 fw-4",
          to: Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, { view: t }),
          children: ta(t)
        }
      ),
      linked: !1
    },
    detail: null,
    ":id": {
      component: s ? /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 cn-9 lh-1-5", children: s.name }) : /* @__PURE__ */ e.jsx("div", { className: "shimmer h-18 w-120" }),
      linked: !1
    }
  }
}), Sb = () => {
  const { view: s, id: t } = ce(), { path: a } = Ts(), { replace: n } = ae(), { search: o } = he(), {
    data: r,
    isLoading: l,
    error: i,
    refetch: u
  } = se({
    queryKey: ["backup-detail", t, s],
    queryFn: ({ signal: g }) => s === "backups" ? RC({ id: +t, signal: g }) : UC({ id: +t, signal: g })
  }), { breadcrumbs: c } = nt(bb(r, s), [r, s]), p = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: c }), d = {
    detail: r,
    isDetailLoading: l,
    detailError: i,
    refetchDetail: u
  }, m = () => {
    n({ pathname: Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE_DETAIL, { id: t, view: s }), search: o });
  }, _ = async () => {
    await u(), m();
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-hidden flex-grow-1", children: [
      /* @__PURE__ */ e.jsx(xt, { breadCrumbs: p, isBreadcrumbs: !0 }),
      s === "backups" ? /* @__PURE__ */ e.jsx(DC, { ...d }) : /* @__PURE__ */ e.jsx(Cb, { ...d })
    ] }),
    /* @__PURE__ */ e.jsx(le, { path: `${a}${Ue.CREATE_RESTORE}`, children: /* @__PURE__ */ e.jsx(co, { onSuccess: _, handleClose: m }) })
  ] });
}, Nb = (s) => {
  const { children: t, searchKey: a, handleSearch: n, updateSearchParams: o, clearFilters: r } = s, { backupFilterConfigProp: l, backupScheduleFilterConfigProp: i } = s, { search: u } = he(), { url: c } = Ts(), [p, d] = E(!1), { view: m } = ce(), { push: _ } = ae(), g = () => {
    _(
      Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, {
        view: m === be.Backups ? be.Schedules : be.Backups
      })
    );
  }, { areRowsLoading: x, filteredRows: C, areFiltersApplied: f } = s, h = !x && C?.length === 0 && !f, {
    filterSelectPickerPropsMap: b,
    isFilterApplied: S,
    options: O
  } = CC(s, i), {
    filterSelectPickerPropsMap: j,
    isFilterApplied: v,
    options: A
  } = xC(s, l);
  return /* @__PURE__ */ e.jsxs("div", { className: "h-100 dc__overflow-hidden w-100 flexbox-col", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__align-items-center p-16 w-100 dc__gap-8 dc__zi-5", children: [
      /* @__PURE__ */ e.jsx(
        ca,
        {
          name: "backup-n-schedule-control",
          value: m,
          segments: [
            {
              label: "Backups",
              value: be.Backups
            },
            {
              label: "Backup Schedules",
              value: be.Schedules
            }
          ],
          onChange: g
        }
      ),
      !h && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          aa,
          {
            dataTestId: "backup-n-schedule-list-search",
            handleEnter: n,
            initialSearchText: a,
            inputProps: {
              placeholder: m === be.Backups ? "Search backup" : "Search schedule"
            },
            keyboardShortcut: "/"
          }
        ),
        m === be.Backups ? /* @__PURE__ */ e.jsx(
          Na,
          {
            id: "backup-list-filters",
            width: 200,
            isFilterApplied: v,
            options: A,
            filterSelectPickerPropsMap: j
          }
        ) : /* @__PURE__ */ e.jsx(
          Na,
          {
            id: "backup-schedule-list-filters",
            width: 200,
            isFilterApplied: S,
            options: O,
            filterSelectPickerPropsMap: b
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flex-grow-1" }),
      /* @__PURE__ */ e.jsx("div", { className: "dc__separated-flexbox dc__separated-flexbox--gap-8", children: /* @__PURE__ */ e.jsx(
        xi,
        {
          id: "backup-and-schedule-list-action-menu",
          buttonProps: {
            text: "Create Backup",
            size: P.medium,
            endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-caret-right", color: null, rotateBy: p ? 270 : 90 }),
            dataTestId: "create-backup-action-menu--button"
          },
          alignment: "end",
          onOpen: d,
          onClick: ks,
          options: vC(c, u)
        }
      ) })
    ] }),
    !l.scheduleFilterOptions.isLoading && !i.snapshotLocationOptions.isLoading && !i.storageLocationOptions.isLoading && /* @__PURE__ */ e.jsx(
      Jn,
      {
        filterConfig: m === be.Backups ? Hc(s) : Yc(s),
        onRemoveFilter: o,
        clearFilters: r,
        className: "px-20",
        getFormattedLabel: m === be.Backups ? bC : SC,
        getFormattedValue: (N, L) => m === be.Backups ? NC(N, L, l) : EC(
          N,
          L,
          i
        )
      }
    ),
    t
  ] });
}, Eb = ({ onActionClick: s, bulkActionsData: { view: t } }) => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-4", children: /* @__PURE__ */ e.jsx(
  B,
  {
    icon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
    dataTestId: "bs-bulk-action__action-widget--delete",
    component: me.button,
    style: q.negativeGrey,
    variant: U.borderLess,
    ariaLabel: "Delete item(s)",
    size: P.small,
    onClick: s,
    showAriaLabelInTippy: !1,
    "data-key": t === be.Backups ? ps.BACKUP : ps.BACKUP_SCHEDULE
  }
) }), vb = () => {
  const { view: s } = ce(), { url: t, path: a } = Ts(), { search: n } = he(), { replace: o } = ae(), [r, l] = E(!1), { breadcrumbs: i } = nt({
    alias: {
      ...Cn(),
      "backup-and-schedule": {
        component: /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 cn-9 lh-1-5", children: "Backup & Schedule" }),
        linked: !1
      },
      ":view(backups|schedules)": null
    }
  }), { isSuperAdmin: u } = Ot(), c = de(() => Kc(s), [s]), p = Wt(
    (y, k) => s === be.Backups ? Vc({ ...y, signal: k }) : cC({ ...y, signal: k }),
    [s, r]
  ), {
    data: d,
    isFetching: m,
    error: _,
    refetch: g
  } = se({
    queryFn: vr,
    queryKey: ["backup-schedule-list-min"],
    select: (y) => y.result?.map(({ id: k, name: G }) => ({ label: G, value: k })).sort((k, G) => Ae(k.label, G.label)) ?? [],
    enabled: s === be.Backups
  }), {
    data: x,
    isFetching: C,
    error: f,
    refetch: h
  } = se({
    queryFn: ({ signal: y }) => zo(y),
    queryKey: ["user-filter-options-list"],
    select: (y) => y?.map(({ emailId: k }) => ({ label: k, value: k })).sort((k, G) => Ae(k.value, G.value)) ?? [],
    enabled: s === be.Backups
  }), {
    data: b,
    isFetching: S,
    error: O,
    refetch: j
  } = se({
    queryFn: Dc,
    select: (y) => y.result?.map(({ id: k, name: G }) => ({ label: G, value: k })).sort((k, G) => Ae(k.label, G.label)) ?? [],
    queryKey: ["storage-location-list-min"],
    enabled: s === be.Schedules
  }), {
    data: v,
    isFetching: A,
    error: N,
    refetch: L
  } = se({
    queryFn: kc,
    select: (y) => y.result?.map(({ id: k, name: G }) => ({ label: G, value: k })).sort((k, G) => Ae(k.label, G.label)) ?? [],
    queryKey: ["snapshot-location-list-min"],
    enabled: s === be.Schedules
  }), M = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__align-items-center dc__gap-12", children: [
    /* @__PURE__ */ e.jsx(
      B,
      {
        component: me.link,
        linkProps: {
          to: {
            pathname: Q(`${t}${Ue.CREATE_FROM_SCRATCH}`, {
              type: st.SCHEDULE
            }),
            search: n
          }
        },
        dataTestId: "create-backup-schedule",
        text: "Create Backup Schedule",
        startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-clock-counterclockwise", color: null })
      }
    ),
    s === be.Backups && /* @__PURE__ */ e.jsx(
      B,
      {
        component: me.link,
        linkProps: {
          to: {
            pathname: Q(`${t}${Ue.CREATE_FROM_SCRATCH}`, {
              type: st.BACKUP
            }),
            search: n
          }
        },
        variant: U.text,
        dataTestId: "create-one-time-backup",
        text: "One-time Backup"
      }
    )
  ] }), W = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: i }), $ = () => {
    l((y) => !y);
  }, w = () => {
    o({ pathname: t.replace(Ue.CREATE_RESTORE, ""), search: n });
  }, T = () => {
    $(), w();
  }, I = async (y, k) => {
    await ia(
      Q(
        s === be.Backups ? z.BACKUP_DETAIL : z.SCHEDULE_DETAIL,
        { id: k }
      ),
      { signal: y.signal }
    );
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden backup-n-schedule", children: [
      /* @__PURE__ */ e.jsx(xt, { breadCrumbs: W, isBreadcrumbs: !0 }),
      u ? (
        /* TODO: add support for icons if bulk selection is enabled wherein on hover the checkbox should be visible
        Otherwise if it is checked then only show the checkbox */
        /* @__PURE__ */ e.jsx(
          oa,
          {
            id: "table__backup-and-schedule-list",
            columns: c,
            ViewWrapper: Nb,
            filtersVariant: la.URL,
            additionalFilterProps: {
              initialSortKey: s === be.Backups ? "backupDate" : "lastBackup",
              parseSearchParams: s === be.Backups ? Wc : gC
            },
            bulkSelectionConfig: {
              BulkActionsComponent: Eb,
              bulkActionsData: { view: s },
              BulkOperationModal: Er,
              bulkOperationModalData: {
                handleDelete: I,
                reloadDataAfterBulkOperation: $
              },
              getSelectAllDialogStatus: () => Qn.CLOSED,
              disableSelectAllAcrossEvenIfPaginated: !0
            },
            paginationVariant: ra.PAGINATED,
            getRows: p,
            emptyStateConfig: {
              noRowsConfig: {
                title: s === be.Backups ? "Create Backup Snapshot" : "Create Backup Schedule",
                subTitle: s === be.Backups ? "Create new backup snapshots to protect your data" : "Create new backup schedules to automate your data protection",
                isButtonAvailable: !0,
                imgName: s === be.Backups ? "create-backup-snapshot" : "create-backup-schedule",
                renderButton: M
                // Placeholder for a button to create new backups or schedules
              }
            },
            filter: null,
            additionalProps: {
              backupScheduleFilterConfigProp: {
                snapshotLocationOptions: {
                  options: v,
                  isLoading: A,
                  error: N,
                  refetch: L
                },
                storageLocationOptions: {
                  options: b,
                  isLoading: S,
                  error: O,
                  refetch: j
                }
              },
              backupFilterConfigProp: {
                userFilterOptions: {
                  options: x,
                  isLoading: C,
                  error: f,
                  refetch: h
                },
                scheduleFilterOptions: {
                  options: d,
                  isLoading: m,
                  error: _,
                  refetch: g
                }
              },
              reloadTableData: $
            },
            rowActionOnHoverConfig: {
              width: 68,
              Component: fC
            }
          },
          `backup-and-schedule-list-${s}-${+r}`
        )
      ) : /* @__PURE__ */ e.jsx(rn, {})
    ] }),
    u ? /* @__PURE__ */ e.jsx(gb, { reloadOnClose: $ }) : null,
    u && /* @__PURE__ */ e.jsx(le, { path: `${a}${Ue.CREATE_RESTORE}`, children: /* @__PURE__ */ e.jsx(co, { onSuccess: T, handleClose: w }) })
  ] });
}, Tb = () => /* @__PURE__ */ e.jsxs(rt, { children: [
  /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION_BACKUP_AND_SCHEDULE_DETAIL, children: /* @__PURE__ */ e.jsx(Sb, {}) }),
  /* @__PURE__ */ e.jsx(vb, {})
] }), Ko = {
  [xn.GCP]: "ic-google-cloud"
}, Ar = {
  [xn.GCP]: "GCP"
};
var Bs = /* @__PURE__ */ ((s) => (s.AVAILABLE = "Available", s.UNAVAILABLE = "Unavailable", s.UNKNOWN = "Unknown", s))(Bs || {}), Et = /* @__PURE__ */ ((s) => (s.MODAL_TYPE = "modalType", s.UPDATE_LOCATION_ID = "locationId", s))(Et || {}), xs = /* @__PURE__ */ ((s) => (s.EXISTING = "ExistingSecret", s.NEW = "CreateSecret", s))(xs || {}), Ta = /* @__PURE__ */ ((s) => (s.READ_WRITE = "ReadWrite", s.READ_ONLY = "ReadOnly", s))(Ta || {});
const On = {
  createdBy: "createdBy",
  name: "name",
  provider: "provider"
}, tn = {
  createdBy: "createdBy",
  status: "status"
}, Ab = [
  {
    groupLabel: "Filter By",
    items: [
      { id: tn.createdBy, label: "Created By" },
      { id: tn.status, label: "Status" }
    ]
  }
], yb = [
  {
    groupLabel: "Filter By",
    items: [
      {
        id: tn.createdBy,
        label: "Created By"
      }
    ]
  }
], jb = {
  [ge.VOLUME_SNAPSHOT]: "Volume Snapshot Locations",
  [ge.STORAGE]: "Storage Locations"
}, Ob = Object.values(
  ge
).map((s) => ({
  label: jb[s],
  value: s
})), uo = {
  [Bs.AVAILABLE]: "Available",
  [Bs.UNAVAILABLE]: "Unavailable",
  [Bs.UNKNOWN]: "Unknown"
}, Ib = {
  [Bs.AVAILABLE]: "positive",
  [Bs.UNAVAILABLE]: "negative",
  [Bs.UNKNOWN]: "neutral"
}, wb = {
  [Bs.AVAILABLE]: "G500",
  [Bs.UNAVAILABLE]: "R500",
  [Bs.UNKNOWN]: "N500"
}, Pb = {
  name: "name",
  createdBy: "createdBy",
  provider: "provider"
}, ad = ({ statusCountMap: s }) => {
  if (!Object.values(s || {}).some((a) => a > 0))
    return /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center cn-9 fs-13 fw-4 lh-20", children: "-" });
  const t = () => /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-4", children: Object.values(Bs).map(
    (a) => s[a] > 0 ? /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-100 dc__content-space dc__gap-8", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox w-100 dc__gap-6", children: [
        /* @__PURE__ */ e.jsx(D, { name: "ic-circle-small", size: 16, color: wb[a] }),
        /* @__PURE__ */ e.jsx("span", { children: uo[a] })
      ] }),
      /* @__PURE__ */ e.jsx("span", { children: s[a] })
    ] }, a) : null
  ) });
  return /* @__PURE__ */ e.jsx(we, { alwaysShowTippyOnHover: !0, content: t(), placement: "top", children: /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-6 dc_width-max-content", children: Object.values(Bs).map(
    (a) => s[a] > 0 ? /* @__PURE__ */ e.jsx(
      yt,
      {
        variant: Ib[a],
        startIconProps: { name: "ic-circle-small" },
        label: `${s[a]}`
      },
      a
    ) : null
  ) }) });
}, Rb = ({
  row: s,
  signals: t
}) => {
  const a = Ms(null), { type: n } = ce(), o = Q(`${R.DATA_PROTECTION_BACKUP_LOCATIONS}${R.BACKUP_LOCATION_DETAILS}`, {
    type: n,
    locationId: s.data.id
  });
  return ue(() => {
    const r = () => {
      a.current?.click();
    };
    return t.addEventListener(Sa.ENTER_PRESSED, r), () => {
      t.removeEventListener(Sa.ENTER_PRESSED, r);
    };
  }, []), /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(we, { content: s.data.name, children: /* @__PURE__ */ e.jsx(as, { to: o, className: "anchor dc__truncate cb-5 fs-13 fw-4 lh-20", ref: a, children: s.data.name }) }) });
}, Lb = ({ row: s }) => s.data.createdBy ? /* @__PURE__ */ e.jsx(Ei, { identifier: s.data.createdBy }) : /* @__PURE__ */ e.jsx("span", { children: "-" }), kb = ({ row: s }) => /* @__PURE__ */ e.jsx(
  yt,
  {
    variant: "neutral",
    startIconProps: Ko[s.data.provider] ? { name: Ko[s.data.provider] } : null,
    label: Ar[s.data.provider] || s.data.provider,
    size: P.xxs
  }
), Db = ({ row: s }) => /* @__PURE__ */ e.jsx(ad, { statusCountMap: s.data.statusCountMap }), Mb = ({
  row: s
}) => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20", children: Pn(s.data.lastSyncedTime) || "-" }) }), nd = (s, t) => {
  const a = s.split("?")[0].split("#")[0];
  return {
    alias: {
      ...Cn(),
      "backup-locations": {
        component: /* @__PURE__ */ e.jsx(
          as,
          {
            to: Q(R.DATA_PROTECTION_BACKUP_LOCATIONS, {
              type: ge.VOLUME_SNAPSHOT
            }),
            children: /* @__PURE__ */ e.jsx(
              tt,
              {
                isActive: !!Po(a, { path: R.DATA_PROTECTION_BACKUP_LOCATIONS, exact: !0 }),
                heading: "Backup Locations"
              }
            )
          }
        ),
        linked: !1
      },
      [`:type(${Object.values(ge).join("|")})`]: {
        component: null,
        linked: !1
      },
      ":locationId": {
        component: t ? /* @__PURE__ */ e.jsx(tt, { isActive: !0, heading: t }) : /* @__PURE__ */ e.jsx("div", { className: "h-20 w-120 shimmer-loading" }),
        linked: !1
      }
    }
  };
}, Bb = (s) => [
  {
    field: On.name,
    label: "Name",
    size: {
      range: {
        startWidth: s === ge.STORAGE ? 540 : 680,
        maxWidth: 900,
        minWidth: 500
      }
    },
    CellComponent: Rb,
    isSortable: !0,
    horizontallySticky: !0
  },
  {
    field: On.provider,
    label: "Provider",
    size: {
      range: {
        startWidth: 280,
        maxWidth: 320,
        minWidth: 100
      }
    },
    CellComponent: kb,
    isSortable: !0
  },
  ...s === ge.STORAGE ? [
    {
      field: "lastSyncedTime",
      label: "Last Synced",
      size: {
        range: {
          startWidth: 200,
          maxWidth: 250,
          minWidth: 150
        }
      },
      isSortable: !1,
      CellComponent: Mb
    },
    {
      field: "statusCountMap",
      label: "Status",
      size: {
        fixed: 200
      },
      isSortable: !1,
      CellComponent: Db
    }
  ] : [],
  {
    field: On.createdBy,
    label: "Added By",
    size: {
      range: {
        startWidth: 180,
        maxWidth: 250,
        minWidth: 100
      }
    },
    isSortable: !0,
    CellComponent: Lb
  }
], Ub = (s, t) => t === ge.STORAGE, od = (s) => (s || []).reduce(
  (t, a) => (t[a.phase] = (t[a.phase] || 0) + 1, t),
  {}
), rd = (s) => s?.length ? (s || []).reduce(
  (t, a) => (!t.lastSyncedTime && a.lastSyncedTime && (t.lastSyncedTime = a.lastSyncedTime), !t.lastValidationTime && a.lastValidationTime && (t.lastValidationTime = a.lastValidationTime), t.lastSyncedTime = a.lastSyncedTime && Xr(t.lastSyncedTime, a.lastSyncedTime) > 0 ? a.lastSyncedTime : t.lastSyncedTime, t.lastValidationTime = a.lastValidationTime && Xr(t.lastValidationTime, a.lastValidationTime) > 0 ? a.lastValidationTime : t.lastValidationTime, t),
  { lastSyncedTime: null, lastValidationTime: null }
) : {
  lastSyncedTime: null,
  lastValidationTime: null
}, Fb = (s, t) => (s?.data || []).map((a) => ({
  id: a.id,
  name: a.name,
  provider: a.provider,
  createdBy: a.createdBy,
  ...Ub(a, t) ? {
    type: ge.STORAGE,
    statusCountMap: a.status?.length ? od(a.status) : null,
    ...rd(a.status)
  } : { type: ge.VOLUME_SNAPSHOT }
})), yr = (s) => {
  const t = s.getAll(tn.createdBy), a = s.getAll(tn.status).filter((n) => n in uo);
  return {
    createdBy: t.length ? t : void 0,
    status: a.length ? a : void 0
  };
}, Vb = (s, t) => {
  const { createdBy: a = [], status: n = [] } = yr(s), o = (a || []).reduce(
    (l, i) => (l[i] = !0, l),
    {}
  ), r = a.length && t?.createdByOptions.filter(
    (l) => o[l.value]
  ) || null;
  return {
    areFiltersApplied: !!a.length,
    appliedFilterOptions: {
      createdBy: r,
      status: n.map((l) => ({
        label: uo[l] || l,
        value: l
      }))
    }
  };
}, Gb = ({
  createdBy: s,
  status: t
}) => {
  const a = [];
  return s?.length && a.push({
    key: "createdBy",
    values: s
  }), t?.length && a.push({
    key: "status",
    values: t
  }), a.length ? a : null;
}, Kl = Object.values(
  xn
).map((s) => ({
  label: Ar[s],
  startIcon: /* @__PURE__ */ e.jsx(D, { name: Ko[s], color: null }),
  value: s
})), Wb = {
  [Ta.READ_ONLY]: "Read Only",
  [Ta.READ_WRITE]: "Read and Write"
}, Hl = Object.values(
  Ta
).map((s) => ({
  label: Wb[s],
  value: s
})), ld = {
  id: 0,
  name: "",
  provider: xn.GCP,
  config: [{ key: "", value: "", id: vs() }],
  credentialDetails: {
    isEnabled: !1
  }
}, id = {
  name: null,
  config: !1,
  credentialName: null,
  credentialKey: null,
  credentialData: null
}, $b = {
  name: "name",
  config: "config",
  credentialName: "credentialName",
  credentialKey: "credentialKey",
  credentialData: "credentialData"
}, Kb = {
  ...structuredClone(ld),
  bucket: "",
  prefix: "",
  region: "",
  caCert: "",
  accessMode: Ta.READ_WRITE,
  backupSyncPeriod: "",
  validationFrequency: "",
  isDefault: !1
}, Hb = {
  ...structuredClone(id),
  bucket: null
}, Yb = {
  bucket: "bucket"
};
var Hs = /* @__PURE__ */ ((s) => (s.PROVIDER_CONFIGURATION = "Provider Configuration", s.OBJECT_STORAGE_DETAILS = "Object Storage Details", s.SYNC_AND_VALIDATION = "Sync & Validation", s.SET_AS_DEFAULT = "Set as Default", s))(Hs || {});
const zb = ({
  formData: s,
  setFormData: t,
  formError: a,
  setFormError: n
}) => {
  const o = (i) => {
    const u = i.target.value;
    t((c) => ({ ...c, bucket: u })), n((c) => ({ ...c, bucket: Ps(u).message }));
  }, r = (i) => {
    const u = i.target.value;
    t((c) => ({ ...c, prefix: u }));
  }, l = (i) => {
    const u = i?.value;
    t((c) => ({ ...c, accessMode: u }));
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary", children: [
    /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-1-5", children: Hs.OBJECT_STORAGE_DETAILS }),
    /* @__PURE__ */ e.jsx(
      ke,
      {
        name: "storage-bucket",
        value: s.bucket,
        label: "Storage Bucket",
        required: !0,
        autoFocus: !0,
        placeholder: "Enter the object storage bucket/container name",
        onChange: o,
        error: a.bucket,
        fullWidth: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      ke,
      {
        name: "bucket-path-prefix",
        value: s.prefix,
        label: "Bucket Path Prefix",
        placeholder: "Path prefix within the bucket",
        onChange: r,
        fullWidth: !0
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-16 w-100", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "m-0 cn-9 fs-13 fw-4 lh-1-5", children: "Access Mode" }),
        /* @__PURE__ */ e.jsx("p", { className: "m-0 cn-7 fs-12 fw-4 lh-1-5", children: "Set the level of permissions this location has for backups and restores" })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "w-120", children: /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "access-mode-select",
          variant: We.COMPACT,
          options: Hl,
          value: Hl.find((i) => i.value === s.accessMode),
          onChange: l,
          shouldMenuAlignRight: !0
        }
      ) })
    ] })
  ] });
}, cd = ({
  type: s,
  formData: t,
  setFormData: a,
  formError: n,
  setFormError: o
}) => {
  const r = s === ge.VOLUME_SNAPSHOT, l = (h) => {
    const b = h.target.value;
    a((O) => ({ ...O, name: b }));
    const S = dn(b);
    o((O) => ({ ...O, name: S.message }));
  }, i = (h) => {
    a((b) => ({ ...b, provider: h.value }));
  }, u = (h) => {
    a((b) => ({ ...b, config: h }));
  }, c = () => {
    const b = !t.credentialDetails.isEnabled ? {
      isEnabled: !0,
      details: {
        name: "",
        key: "",
        type: xs.EXISTING
      }
    } : {
      isEnabled: !1
    };
    a((S) => ({ ...S, credentialDetails: b })), o((S) => ({
      ...S,
      credentialData: null,
      credentialKey: null,
      credentialName: null
    }));
  }, p = (h) => {
    const b = h.target.value;
    a((S) => {
      const O = {
        isEnabled: !0,
        details: b === xs.EXISTING ? {
          type: b,
          name: S.credentialDetails.details.name,
          key: S.credentialDetails.details.key
        } : {
          type: b,
          name: S.credentialDetails.details.name,
          key: S.credentialDetails.details.key,
          data: ""
        }
      };
      return { ...S, credentialDetails: O };
    }), o((S) => ({
      ...S,
      credentialData: b === xs.NEW ? "" : null
    }));
  }, d = (h) => {
    const b = h.target.value;
    a((S) => ({
      ...S,
      credentialDetails: {
        isEnabled: !0,
        details: {
          ...S.credentialDetails.details,
          name: b
        }
      }
    })), o((S) => ({
      ...S,
      credentialName: Ps(b).message
    }));
  }, m = (h) => {
    const b = h.target.value;
    a((S) => ({
      ...S,
      credentialDetails: {
        isEnabled: !0,
        details: {
          ...S.credentialDetails.details,
          key: b
        }
      }
    })), o((S) => ({
      ...S,
      credentialKey: Ps(b).message
    }));
  }, _ = (h) => {
    t.credentialDetails.details.type === xs.NEW && (a((b) => ({
      ...b,
      credentialDetails: {
        isEnabled: !0,
        details: {
          ...b.credentialDetails.details,
          type: xs.NEW,
          data: h
        }
      }
    })), o((b) => ({
      ...b,
      credentialData: Ps(h).message
    })));
  }, g = (h) => {
    const b = h.target.value;
    a((S) => ({ ...S, caCert: b }));
  }, x = (h) => {
    o((b) => ({ ...b, config: h }));
  }, C = () => r ? /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-2 px-12 pb-12 pt-4", children: /* @__PURE__ */ e.jsxs("ul", { className: "pl-20 mt-8", children: [
    /* @__PURE__ */ e.jsx("li", { children: "It is possible to create additional Volume Snapshot Locations that use their own credentials. This may be necessary if you already have default credentials which don't match the account used by the cloud volumes being backed up." }),
    /* @__PURE__ */ e.jsx("li", { children: "If you create additional Volume Snapshot Locations without specifying the credentials to use, Velero will use the credentials provided at install time and stored in the cloud-credentials secret." })
  ] }) }) : /* @__PURE__ */ e.jsx("div", { className: "p-12", children: /* @__PURE__ */ e.jsx("span", { children: "Credentials are stored in a Kubernetes secret. The secret must be in the same namespace as Velero." }) }), f = () => r ? /* @__PURE__ */ e.jsx("span", { children: "These fields are specific to the selected provider. Pls refer to documentation for further details." }) : /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-20", children: [
    /* @__PURE__ */ e.jsx("span", { children: "Devtron leverages Velero for Backup & Restore capabilities." }),
    /* @__PURE__ */ e.jsx("span", { children: "Velero supports a variety of storage providers for different backup and snapshot operations. Velero has a plugin system which allows anyone to add compatibility for additional backup and volume storage platforms without modifying the Velero codebase." })
  ] });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary", children: [
      /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-1-5", children: "Basic Details" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
        /* @__PURE__ */ e.jsx("div", { className: "w-200 dc__no-shrink", children: /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "provider-configuration-provider-select",
            options: Kl,
            value: Kl.find((h) => h.value === t.provider) || null,
            required: !0,
            label: "Provider",
            onChange: i,
            size: P.large
          }
        ) }),
        /* @__PURE__ */ e.jsx("span", { className: "pt-26 fs-20 lh-36 cn-7 dc__no-shrink", children: "/" }),
        /* @__PURE__ */ e.jsx(
          ke,
          {
            name: "location-name",
            value: t.name,
            label: `${r ? "Volume Snapshot" : "Backup Storage"} Location Name`,
            disabled: !!t.id,
            required: !0,
            autoFocus: !0,
            placeholder: `Type ${r ? "snapshot" : "storage"} location name`,
            onChange: l,
            error: n.name,
            fullWidth: !0
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4", children: [
        /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-1-5", children: r ? "Configuration Fields" : "Storage Configuration" }),
        /* @__PURE__ */ e.jsx(
          Tt,
          {
            heading: r ? "Configuration Fields" : "Storage Configuration",
            infoText: f()
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(
        un,
        {
          headerLabel: { key: "Key", value: "Value" },
          placeholder: { key: "Enter key", value: "Enter value" },
          rows: t.config.map(({ key: h, value: b, id: S }) => ({
            data: { key: { value: h }, value: { value: b } },
            id: S
          })),
          showError: !0,
          onChange: u,
          onError: x,
          validateEmptyKeys: !0,
          validateDuplicateKeys: !0,
          isSortable: !0
        }
      ),
      s === ge.STORAGE && /* @__PURE__ */ e.jsx(
        At,
        {
          label: "CA Certificate",
          name: "ca-certificate",
          placeholder: "Paste CA certificate",
          value: t.caCert,
          onChange: g
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 flex-grow-1", children: [
          /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-1-5", children: "Credentials" }),
          /* @__PURE__ */ e.jsx(Tt, { heading: "Credentials", additionalContent: C() })
        ] }),
        /* @__PURE__ */ e.jsx(
          ft,
          {
            ariaLabel: "Enable Credentials Switch",
            name: "enable-credentials",
            isChecked: t.credentialDetails.isEnabled,
            onChange: c
          }
        )
      ] }),
      t.credentialDetails.isEnabled && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsxs(
          zs,
          {
            name: "credential-type",
            className: "radio-group-no-border",
            value: t.credentialDetails.details.type,
            onChange: p,
            children: [
              /* @__PURE__ */ e.jsx(Be, { value: xs.EXISTING, children: "Select Secret" }),
              /* @__PURE__ */ e.jsx(Be, { value: xs.NEW, children: "Create New Secret" })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-12 dc__grid-rows-2", children: [
          /* @__PURE__ */ e.jsx(
            ke,
            {
              name: "secret-name",
              value: t.credentialDetails.details.name,
              label: "Secret Name",
              required: !0,
              placeholder: "Type secret name",
              onChange: d,
              error: n.credentialName,
              fullWidth: !0
            }
          ),
          /* @__PURE__ */ e.jsx(
            ke,
            {
              name: "secret-key",
              value: t.credentialDetails.details.key,
              label: "Secret Key",
              required: !0,
              placeholder: "Type secret key",
              onChange: m,
              error: n.credentialKey,
              fullWidth: !0
            }
          )
        ] }),
        t.credentialDetails.details.type === xs.NEW && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-6", children: [
          /* @__PURE__ */ e.jsx("span", { className: "dc__required-field cn-7 fs-13 fw-4 lh-20", children: "Credential Data" }),
          /* @__PURE__ */ e.jsx(
            bs,
            {
              mode: ht.PLAINTEXT,
              value: t.credentialDetails.details.data,
              placeholder: "Enter secret data",
              onChange: _,
              children: n.credentialData && /* @__PURE__ */ e.jsx(bs.ErrorBar, { text: n.credentialData })
            }
          )
        ] })
      ] })
    ] })
  ] });
}, qb = async ({
  offset: s,
  pageSize: t,
  sortBy: a,
  sortOrder: n,
  searchKey: o,
  type: r,
  signal: l,
  createdBy: i,
  status: u
}) => {
  const c = r === ge.STORAGE ? z.STORAGE_LOCATION_LIST : z.VOLUME_SNAPSHOT_LIST, p = {
    offset: s,
    size: t,
    sortBy: Pb[a],
    sortOrder: n,
    searchByName: o,
    filters: Gb({ createdBy: i, status: u })
  }, { result: d } = await _s(c, p, {
    signal: l
  });
  return {
    totalCount: d.totalCount,
    data: Fb(d, r)
  };
}, Xb = async (s) => ({
  createdByOptions: (await zo(s) || []).map((a) => ({ label: a.emailId, value: a.emailId }))
}), dd = async ({
  id: s,
  type: t,
  signal: a,
  showToast: n = !0,
  throwError: o = !1
}) => {
  try {
    const r = t === ge.STORAGE ? z.CLUSTER_BACKUP_STORAGE_LOCATION : z.CLUSTER_BACKUP_SNAPSHOT_LOCATION;
    return await ia(`${r}/${s}`, null, { signal: a }), n && Se.showToast({
      variant: Ne.success,
      description: `${t === ge.STORAGE ? "Storage" : "Volume snapshot"} successfully deleted`
    }), !0;
  } catch (r) {
    if (n && ve(r), o)
      throw r;
    return !1;
  }
}, ud = async (s, t) => {
  const { result: a } = await xe(`${z.CLUSTER_BACKUP_SNAPSHOT_LOCATION}/${s}`, { signal: t });
  return a;
}, pd = async (s, t) => {
  const { result: a } = await xe(`${z.CLUSTER_BACKUP_STORAGE_LOCATION}/${s}`, { signal: t });
  return a;
}, Jb = (s) => !s.credential ? {
  isEnabled: !1
} : {
  isEnabled: !0,
  details: s.credential.type === xs.EXISTING ? {
    type: xs.EXISTING,
    name: s.credential.name,
    key: s.credential.key
  } : {
    type: xs.NEW,
    name: s.credential.name || "",
    key: s.credential.key || "",
    data: atob(s.credential.data || "")
  }
}, md = (s) => ({
  id: s.id,
  name: s.name || "",
  provider: s.provider,
  config: [
    {
      key: "",
      value: "",
      id: vs()
    }
  ].concat(
    Object.entries(s.config || {}).map(([t, a]) => ({
      key: t,
      value: a,
      id: vs()
    }))
  ),
  credentialDetails: Jb(s)
}), Qb = (s) => ({
  ...md(s),
  bucket: s.bucket || "",
  prefix: s.prefix || "",
  region: s.region || "",
  caCert: s.caCert || "",
  accessMode: s.accessMode || Ta.READ_WRITE,
  backupSyncPeriod: s.backupSyncPeriod || "",
  validationFrequency: s.validationFrequency || "",
  isDefault: s.isDefault || !1
}), hd = (s) => !nn(s) && s !== !1, _d = (s, t) => {
  const a = structuredClone(t);
  if (a.name = a.name || Ps(s.name).message, s.credentialDetails.isEnabled) {
    const { details: o } = s.credentialDetails;
    a.credentialName = a.credentialName || Ps(o.name).message, a.credentialKey = a.credentialKey || Ps(o.key).message, o.type === xs.NEW ? a.credentialData = a.credentialData || Ps(o.data).message : a.credentialData = null;
  }
  return { isErrorPresent: Object.values(a).some(hd), updatedErrorState: a };
}, Zb = (s, t) => {
  const { updatedErrorState: a } = _d(s, t), n = structuredClone({
    ...t,
    ...a
  });
  return n.bucket = n.bucket || Ps(s.bucket).message, { isErrorPresent: Object.values(n).some(hd), updatedErrorState: n };
}, eS = (s) => {
  if (!s.isEnabled)
    return null;
  if (s.details.type === xs.EXISTING)
    return s.details;
  const t = btoa(s.details.data || "");
  return {
    type: xs.NEW,
    name: s.details.name,
    key: s.details.key,
    data: t
  };
}, fd = (s) => ({
  name: s.name,
  provider: s.provider,
  credential: eS(s.credentialDetails),
  config: s.config.reduce(
    (t, a) => (a.key && (t[a.key] = a.value), t),
    {}
  )
}), sS = async (s, t) => {
  const a = await ud(s, t);
  return md(a);
}, tS = async (s) => {
  try {
    const t = fd(s);
    return s.id ? (await Aa(z.CLUSTER_BACKUP_SNAPSHOT_LOCATION, {
      id: s.id,
      ...t
    }), !0) : (await _s(
      z.CLUSTER_BACKUP_SNAPSHOT_LOCATION,
      t
    ), !0);
  } catch (t) {
    return ve(t), !1;
  }
}, aS = async (s, t) => {
  const a = await pd(s, t);
  return Qb(a);
}, nS = async (s) => {
  try {
    const t = {
      ...fd(s),
      bucket: s.bucket,
      prefix: s.prefix,
      region: s.region,
      caCert: s.caCert,
      accessMode: s.accessMode,
      backupSyncPeriod: s.backupSyncPeriod || null,
      validationFrequency: s.validationFrequency || null,
      isDefault: s.isDefault || !1
    };
    return s.id ? (await Aa(
      z.CLUSTER_BACKUP_STORAGE_LOCATION,
      {
        id: s.id,
        ...t
      }
    ), !0) : (await _s(
      z.CLUSTER_BACKUP_STORAGE_LOCATION,
      t
    ), !0);
  } catch (t) {
    return ve(t), !1;
  }
}, oS = ({
  currentTab: s,
  setCurrentTab: t,
  toggleSetAsDefault: a,
  isDefault: n,
  formError: o
}) => {
  const r = (i) => {
    switch (i) {
      case Hs.PROVIDER_CONFIGURATION:
        return !Object.values($b).some((c) => o[c]);
      case Hs.OBJECT_STORAGE_DETAILS:
        return !Object.values(Yb).some(
          (c) => o[c]
        );
      case Hs.SYNC_AND_VALIDATION:
        return !0;
      default:
        return !0;
    }
  }, l = (i) => () => {
    if (i === Hs.SET_AS_DEFAULT) {
      a();
      return;
    }
    t(i);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col py-20 px-12 dc__gap-12 bg__modal--primary dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col", children: Object.values(Hs).map((i) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `py-6 px-8 br-4 flexbox dc__gap-8 dc__align-items-center ${i === s ? "bcb-1" : "bg__hover"}`,
        children: [
          /* @__PURE__ */ e.jsxs(
            "button",
            {
              type: "button",
              className: `dc__transparent flexbox dc__content-space fs-13 flex-grow-1 dc__align-items-center ${i === s ? "fw-6 cb-5" : "fw-4 cn-9"} lh-1-5`,
              "data-testid": `move-to-${i.replace(" ", "-")}-tab`,
              onClick: l(i),
              children: [
                i,
                !r(i) && /* @__PURE__ */ e.jsx(D, { name: "ic-warning-fill", size: 16, color: "R500" })
              ]
            }
          ),
          i === Hs.SET_AS_DEFAULT && /* @__PURE__ */ e.jsx(
            ft,
            {
              name: "set-as-default-toggle",
              ariaLabel: "Toggle Set as Default",
              isChecked: n,
              onChange: a,
              size: P.small
            }
          )
        ]
      },
      i
    )) }),
    /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4 dc__align-start", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-6 lh-20 cn-9", children: "📙 Need help?" }),
      /* @__PURE__ */ e.jsx(
        ln,
        {
          docLinkKey: "DOC_HOME_PAGE",
          text: "View documentation",
          dataTestId: "storage-location-doc-link",
          showExternalIcon: !0,
          openInNewTab: !0
        }
      )
    ] })
  ] });
}, rS = ({ formData: s, setFormData: t }) => {
  const a = (o) => {
    const r = o.target.value;
    t((l) => ({ ...l, backupSyncPeriod: r }));
  }, n = (o) => {
    const r = o.target.value;
    t((l) => ({ ...l, validationFrequency: r }));
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col p-20 dc__gap-16 br-8 bg__primary border__secondary", children: [
    /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 fs-14 fw-6 lh-1-5", children: "Sync & Validation" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space w-100", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "cn-9 fs-13 fw-4 lh-1-5 m-0", children: "Backup Sync Period" }),
        /* @__PURE__ */ e.jsx("p", { className: "cn-7 fs-12 fw-4 lh-1-5 m-0", children: "How often should backups be synced with this location?" })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "w-150", children: /* @__PURE__ */ e.jsx(
        ke,
        {
          name: "backup-sync-period",
          autoFocus: !0,
          value: s.backupSyncPeriod,
          placeholder: "Eg. 5m, 1h",
          onChange: a
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space w-100", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "cn-9 fs-13 fw-4 lh-1-5 m-0", children: "Validation Frequency" }),
        /* @__PURE__ */ e.jsx("p", { className: "cn-7 fs-12 fw-4 lh-1-5 m-0", children: "How frequently should object store validation be performed?" })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "w-150", children: /* @__PURE__ */ e.jsx(
        ke,
        {
          name: "validation-frequency",
          value: s.validationFrequency,
          placeholder: "Eg. 10m, 2h",
          onChange: n
        }
      ) })
    ] })
  ] });
}, gd = ({ handleClose: s, onSuccess: t, id: a }) => {
  const { searchParams: n } = Re(), o = a || n[Et.UPDATE_LOCATION_ID], r = o ? +o : 0, l = !!r, {
    isFetching: i,
    data: u,
    error: c,
    refetch: p
  } = se({
    queryKey: ["edit-storage-location", r],
    queryFn: ({ signal: v }) => aS(r, v),
    enabled: l
  }), [d, m] = E(structuredClone(Kb)), [_, g] = E(
    structuredClone(Hb)
  ), [x, C] = E(!1), [f, h] = E(Hs.PROVIDER_CONFIGURATION), b = l && i;
  ue(() => {
    l && u && m(u);
  }, [u, l]);
  const S = async () => {
    const { isErrorPresent: v, updatedErrorState: A } = Zb(d, _);
    if (v) {
      g(A), Se.showToast({
        variant: Ne.error,
        description: "Please resolve all the errors before saving."
      });
      return;
    }
    C(!0), await nS(d) && (s(), t()), C(!1);
  }, O = () => {
    m((v) => ({ ...v, isDefault: !v.isDefault }));
  }, j = () => {
    switch (f) {
      case Hs.PROVIDER_CONFIGURATION:
        return /* @__PURE__ */ e.jsx(
          cd,
          {
            type: ge.STORAGE,
            formData: d,
            setFormData: m,
            formError: _,
            setFormError: g
          }
        );
      case Hs.OBJECT_STORAGE_DETAILS:
        return /* @__PURE__ */ e.jsx(
          zb,
          {
            formData: d,
            setFormData: m,
            formError: _,
            setFormError: g
          }
        );
      case Hs.SYNC_AND_VALIDATION:
        return /* @__PURE__ */ e.jsx(rS, { formData: d, setFormData: m });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", width: "1024px", onEscape: s, onClose: s, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
      onClick: Rs,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom", children: [
            /* @__PURE__ */ e.jsxs("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: [
              l ? "Edit" : "Add",
              " Storage Location"
            ] }),
            /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: "header-close-button",
                ariaLabel: "Close",
                showAriaLabelInTippy: !1,
                onClick: s,
                variant: U.borderLess,
                style: q.negativeGrey,
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
                size: P.xs
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx(
            at,
            {
              isLoading: b,
              progressingProps: {
                pageLoader: !0
              },
              error: c,
              errorScreenManagerProps: {
                code: c?.code,
                reload: p
              },
              children: /* @__PURE__ */ e.jsxs("div", { className: "dc__grid create-storage-location-form__container dc__overflow-auto flex-grow-1", children: [
                /* @__PURE__ */ e.jsx(
                  oS,
                  {
                    currentTab: f,
                    setCurrentTab: h,
                    toggleSetAsDefault: O,
                    isDefault: d.isDefault,
                    formError: _
                  }
                ),
                /* @__PURE__ */ e.jsx("div", { className: "dc__overflow-auto flexbox-col flex-grow-1 dc__overflow-auto w-100 p-20 dc__gap-20 bg__modal--secondary", children: j() })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "footer-cancel-button",
              variant: U.secondary,
              text: "Cancel",
              style: q.neutral,
              size: P.large,
              onClick: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "footer-apply-button",
              variant: U.primary,
              size: P.large,
              text: "Save",
              disabled: b || !!c,
              isLoading: x,
              onClick: S
            }
          )
        ] })
      ]
    }
  ) });
}, xd = ({ handleClose: s, onSuccess: t, id: a }) => {
  const { searchParams: n } = Re(), o = a || n[Et.UPDATE_LOCATION_ID], r = o ? +o : 0, l = !!r, {
    isFetching: i,
    data: u,
    error: c,
    refetch: p
  } = se({
    queryKey: ["volume-snapshot", r],
    queryFn: ({ signal: b }) => sS(r, b),
    enabled: l
  }), [d, m] = E(structuredClone(ld)), [_, g] = E(
    structuredClone(id)
  ), [x, C] = E(!1), f = l && i;
  ue(() => {
    l && u && m(u);
  }, [u, l]);
  const h = async () => {
    const { isErrorPresent: b, updatedErrorState: S } = _d(d, _);
    if (b) {
      g(S), Se.showToast({
        variant: Ne.error,
        description: "Please resolve all the errors before saving."
      });
      return;
    }
    C(!0), await tS(d) && (s(), t()), C(!1);
  };
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", width: "800px", onEscape: s, onClose: s, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
      onClick: Rs,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom", children: [
            /* @__PURE__ */ e.jsxs("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: [
              l ? "Edit" : "Add",
              " Volume Snapshot Location"
            ] }),
            /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: "header-close-button",
                ariaLabel: "Close",
                showAriaLabelInTippy: !1,
                onClick: s,
                variant: U.borderLess,
                style: q.negativeGrey,
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
                size: P.xs
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto w-100 p-20 dc__gap-20 bg__modal--secondary", children: /* @__PURE__ */ e.jsx(
            at,
            {
              isLoading: f,
              progressingProps: {
                pageLoader: !0
              },
              error: c,
              errorScreenManagerProps: {
                code: c?.code,
                reload: p
              },
              children: /* @__PURE__ */ e.jsx(
                cd,
                {
                  formData: d,
                  setFormData: m,
                  formError: _,
                  setFormError: g,
                  type: ge.VOLUME_SNAPSHOT
                }
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-end dc__gap-12 py-16 px-20 border__primary--top dc__no-shrink", children: [
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "footer-cancel-button",
              variant: U.secondary,
              text: "Cancel",
              style: q.neutral,
              size: P.large,
              onClick: s
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              dataTestId: "footer-apply-button",
              variant: U.primary,
              size: P.large,
              text: "Save",
              disabled: f || !!c,
              isLoading: x,
              onClick: h
            }
          )
        ] })
      ]
    }
  ) });
}, Cd = ({ id: s, name: t, type: a, onSuccess: n, handleClose: o }) => {
  const [r, l] = E(!1), i = async () => {
    l(!0), await dd({
      id: s,
      type: a
    }) && (n(), o()), l(!1);
  };
  return /* @__PURE__ */ e.jsx(
    vt,
    {
      title: `Are you sure you want to delete '${t}'?`,
      variant: mt.delete,
      handleClose: o,
      confirmationConfig: {
        identifier: `delete-${a}-location`,
        confirmationKeyword: t
      },
      buttonConfig: {
        primaryButtonConfig: {
          text: "Delete",
          onClick: i,
          isLoading: r
        },
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: o
        }
      }
    }
  );
};
var Ho = /* @__PURE__ */ ((s) => (s.MODAL_TYPE = "modalType", s))(Ho || {}), Yo = /* @__PURE__ */ ((s) => (s.EDIT = "edit", s))(Yo || {});
const lS = ({
  locationDetails: s,
  refetchLocationDetails: t
}) => {
  const a = he(), n = ae(), { searchParams: o } = Re(), [r, l] = E(!1), i = () => {
    n.push({
      pathname: a.pathname,
      search: ""
    });
  }, u = () => {
    l(!1);
  }, c = () => {
    l(!0);
  }, p = () => {
    n.push({
      pathname: Q(R.DATA_PROTECTION_BACKUP_LOCATIONS, { type: s.type })
    });
  }, d = () => r ? /* @__PURE__ */ e.jsx(
    Cd,
    {
      name: s.name,
      type: s.type,
      id: s.id,
      onSuccess: p,
      handleClose: u
    }
  ) : o[Ho.MODAL_TYPE] === Yo.EDIT ? s.type === ge.VOLUME_SNAPSHOT ? /* @__PURE__ */ e.jsx(
    xd,
    {
      handleClose: i,
      onSuccess: t,
      id: s.id
    }
  ) : /* @__PURE__ */ e.jsx(
    gd,
    {
      handleClose: i,
      onSuccess: t,
      id: s.id
    }
  ) : null, m = (_, g) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-20", children: _ }),
    /* @__PURE__ */ e.jsx(we, { content: g, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: g }) })
  ] });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto h-100 py-20 px-16 dc__gap-20 border__primary--right", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12", children: /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 font-merriweather fs-16 fw-7 lh-1-5 dc__word-break", children: s.name }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "edit-backup-location-button",
            startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-pencil", color: null }),
            text: "Edit",
            size: P.medium,
            component: me.link,
            linkProps: {
              to: {
                pathname: a.pathname,
                search: $e("", {
                  [Ho.MODAL_TYPE]: Yo.EDIT
                })
              }
            }
          }
        ),
        /* @__PURE__ */ e.jsx(
          B,
          {
            dataTestId: "delete-backup-location-button",
            icon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
            ariaLabel: "Delete Backup Location",
            showAriaLabelInTippy: !1,
            variant: U.secondary,
            style: q.negativeGrey,
            size: P.medium,
            onClick: c
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        s.type === ge.STORAGE && /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-12", children: [
          /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-20", children: "Status" }),
          /* @__PURE__ */ e.jsx(ad, { statusCountMap: s.statusCountMap })
        ] }),
        m("Added by", s.createdBy),
        m(
          "Provider",
          Ar[s.provider] || s.provider
        ),
        s.type === ge.STORAGE && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          m(
            "Last Synchronization",
            Pn(s.lastSyncedTime) || "-"
          ),
          m(
            "Last Validation",
            Pn(s.lastValidationTime) || "-"
          ),
          m("Object Storage Bucket", s.bucket)
        ] })
      ] })
    ] }),
    d()
  ] });
}, iS = async (s, t, a) => {
  const o = await (t === ge.STORAGE ? pd : ud)(s, a), r = {
    name: o.name,
    createdBy: o.createdBy,
    provider: o.provider,
    id: o.id
  };
  if (t === ge.VOLUME_SNAPSHOT)
    return {
      ...r,
      type: ge.VOLUME_SNAPSHOT
    };
  const l = o;
  return {
    ...r,
    ...rd(l.status),
    type: ge.STORAGE,
    statusCountMap: od(l.status),
    bucket: l.bucket
  };
}, cS = async (s, t) => {
  const n = (await Yn({
    ...s,
    signal: t
  }))?.manifestResponse?.manifest;
  return ir(n) || "";
}, dS = async (s, t, a) => {
  const n = Q(
    s === ge.STORAGE ? z.STORAGE_CLUSTER_LIST : z.VOLUME_SNAPSHOT_CLUSTER_LIST,
    { id: t }
  ), { result: o } = await xe(n, { signal: a });
  return (o || []).filter((r) => !!r.clusterId).map((r) => ({
    id: r.clusterId,
    name: r.clusterName || "-",
    manifestPayload: r.resourceIdentifier ? {
      name: r.resourceIdentifier.name,
      namespace: r.resourceIdentifier.namespace,
      clusterId: r.clusterId,
      gvk: r.resourceIdentifier.groupVersionKind ? {
        Group: r.resourceIdentifier.groupVersionKind.Group,
        Version: r.resourceIdentifier.groupVersionKind.Version,
        Kind: r.resourceIdentifier.groupVersionKind.Kind
      } : null
    } : null
  }));
}, uS = ({ clusterList: s }) => {
  const [t, a] = E(s?.[0]), {
    isFetching: n,
    data: o,
    error: r,
    refetch: l
  } = se({
    queryKey: ["backup-location-manifest", t?.manifestPayload],
    queryFn: ({ signal: c }) => cS(t?.manifestPayload, c),
    enabled: !!t
  });
  if (!t)
    return /* @__PURE__ */ e.jsx(Xe, { title: "No Cluster found", subTitle: "No associated cluster found" });
  const i = (c) => {
    const p = s.find((d) => d.id === c.value);
    a(p);
  }, u = (s || []).map((c) => ({
    label: c.name,
    value: c.id
  }));
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col h-100 dc__content-space flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-16 flexbox dc__content-space dc__align-items-center border__secondary--bottom", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
        /* @__PURE__ */ e.jsx("h2", { className: "m-0 cn-9 fs-13 fw-6 lh-1-5", children: "Manifest for cluster" }),
        /* @__PURE__ */ e.jsx(
          te,
          {
            inputId: "backup-location-manifest-cluster-select",
            options: u,
            value: u.find((c) => c.value === t?.id),
            isClearable: !1,
            onChange: i,
            variant: We.BORDER_LESS,
            size: P.small
          }
        )
      ] }),
      o && /* @__PURE__ */ e.jsx(Xn, { content: o })
    ] }),
    /* @__PURE__ */ e.jsx(
      at,
      {
        isLoading: n,
        error: r,
        genericSectionErrorProps: {
          reload: l,
          rootClassName: "flex-grow-1"
        },
        children: /* @__PURE__ */ e.jsx(bs, { mode: ht.YAML, value: o || "", height: "fitToParent", readOnly: !0 })
      }
    )
  ] });
}, pS = () => {
  const s = he(), { locationId: t, type: a } = ce(), {
    isFetching: n,
    data: o,
    error: r,
    refetch: l
  } = se({
    queryKey: ["backup-location-details", t, a],
    queryFn: ({ signal: _ }) => iS(+t, a, _),
    enabled: !!t
  }), {
    isFetching: i,
    data: u,
    error: c,
    refetch: p
  } = se({
    queryKey: ["backup-location-cluster-list", t, a],
    queryFn: ({ signal: _ }) => dS(a, +t, _),
    enabled: !!t
  }), { breadcrumbs: d } = nt(nd(s.pathname, o?.name), [
    s.pathname,
    o
  ]), m = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: d });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space flex-grow-1 h-100 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(xt, { isBreadcrumbs: !0, breadCrumbs: m }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsx(
      at,
      {
        isLoading: n,
        error: r,
        progressingProps: { pageLoader: !0 },
        errorScreenManagerProps: {
          code: r?.code,
          reload: l,
          redirectURL: Q(R.DATA_PROTECTION_BACKUP_LOCATIONS, { type: a })
        },
        children: o && /* @__PURE__ */ e.jsxs("div", { className: "dc__grid backup-location-details__container dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsx(
            lS,
            {
              locationDetails: o,
              refetchLocationDetails: l
            }
          ),
          /* @__PURE__ */ e.jsx(
            at,
            {
              isLoading: i,
              error: c,
              progressingProps: { pageLoader: !0 },
              errorScreenManagerProps: {
                code: c?.code,
                reload: p,
                redirectURL: Q(R.DATA_PROTECTION_BACKUP_LOCATIONS, { type: a })
              },
              children: /* @__PURE__ */ e.jsx(uS, { clusterList: u })
            }
          )
        ] })
      }
    ) })
  ] });
}, mS = () => {
  const s = ae(), t = he(), { type: a } = ce(), { isFetching: n, error: o, data: r, refetch: l } = se({
    queryKey: ["backup-location-list-grouped-select-metadata"],
    queryFn: ({ signal: g }) => Xb(g)
  }), { areFiltersApplied: i, appliedFilterOptions: u } = de(
    () => Vb(new URLSearchParams(t.search), r),
    [t.search, r]
  ), { createdByOptions: c } = r || { createdByOptions: [] }, p = (g) => (x) => {
    const C = new URLSearchParams(t.search);
    C.delete(g), x.forEach((f) => {
      C.append(g, f.value);
    }), s.replace({ search: C.toString() });
  }, d = {
    createdBy: {
      inputId: "backup-location-list-created-by-filter",
      placeholder: "Select User",
      options: c,
      appliedFilterOptions: u.createdBy,
      handleApplyFilter: p("createdBy"),
      isDisabled: n,
      isLoading: n,
      optionListError: o,
      reloadOptionList: l,
      isUserIdentifier: !0
    },
    status: {
      inputId: "backup-location-list-status-filter",
      placeholder: "Select Status",
      options: Object.entries(uo).map(
        ([g, x]) => ({ label: x, value: g })
      ),
      appliedFilterOptions: u.status,
      handleApplyFilter: p("status"),
      isDisabled: !1,
      isLoading: !1
    }
  };
  if (a === ge.STORAGE)
    return /* @__PURE__ */ e.jsx(
      Na,
      {
        id: "backup-location-list-grouped-filter-select",
        isFilterApplied: i,
        width: 120,
        options: Ab,
        filterSelectPickerPropsMap: d
      }
    );
  const { status: m, ..._ } = d;
  return /* @__PURE__ */ e.jsx(
    Na,
    {
      id: "backup-location-list-grouped-filter-select",
      isFilterApplied: i,
      width: 120,
      options: yb,
      filterSelectPickerPropsMap: _
    }
  );
}, bd = ({ label: s = "Add" }) => {
  const { type: t } = ce(), a = he(), n = () => {
    const o = new URLSearchParams(a.search);
    return o.set(Et.MODAL_TYPE, t), o.toString();
  };
  return /* @__PURE__ */ e.jsx(
    B,
    {
      dataTestId: `create-${t}-button`,
      component: me.link,
      text: s,
      startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-add", color: null }),
      size: P.medium,
      linkProps: {
        to: {
          pathname: a.pathname,
          search: n()
        }
      }
    }
  );
}, hS = ({
  children: s,
  searchKey: t,
  handleSearch: a,
  hideTableFilters: n
}) => {
  const o = ae(), r = he(), { type: l } = ce(), i = new URLSearchParams(r.search), u = yr(i), c = () => {
    o.push({
      search: ""
    });
  }, p = (m) => {
    const _ = new URLSearchParams(r.search);
    Object.entries(m).forEach(([g, x]) => {
      x ? Array.isArray(x) ? (_.delete(g), x.forEach((C) => _.append(g, C))) : _.set(g, x) : _.delete(g);
    }), o.push({
      search: _.toString()
    });
  }, d = (m) => {
    o.push(Q(R.DATA_PROTECTION_BACKUP_LOCATIONS, { type: m.value }));
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-hidden flex-grow-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__content-space p-16", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
          /* @__PURE__ */ e.jsx(
            ca,
            {
              segments: Ob,
              value: l,
              name: "backup-location-tabs",
              onChange: d
            }
          ),
          !n && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(
              aa,
              {
                initialSearchText: t,
                handleEnter: a,
                keyboardShortcut: "/"
              }
            ),
            /* @__PURE__ */ e.jsx(mS, {})
          ] })
        ] }),
        !n && /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center dc__gap-8", children: /* @__PURE__ */ e.jsx(bd, {}) })
      ] }),
      /* @__PURE__ */ e.jsx(
        Jn,
        {
          className: "px-20 pb-16 py-2",
          filterConfig: {
            createdBy: u.createdBy,
            status: u.status
          },
          onRemoveFilter: p,
          clearFilters: c
        }
      )
    ] }),
    s
  ] });
}, _S = ({ onActionClick: s }) => {
  const { type: t } = ce();
  return /* @__PURE__ */ e.jsx(
    B,
    {
      dataTestId: "bulk-delete-location-button",
      icon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
      component: me.button,
      style: q.negativeGrey,
      variant: U.borderLess,
      ariaLabel: "Delete Selected Locations",
      size: P.small,
      onClick: s,
      showAriaLabelInTippy: !1,
      "data-key": t === ge.STORAGE ? ps.STORAGE_LOCATION : ps.VOLUME_SNAPSHOT
    }
  );
}, fS = ({
  row: s,
  handleShowDeleteModal: t
}) => {
  const { type: a } = ce(), n = he(), o = () => {
    t(s.data);
  }, r = () => {
    const l = new URLSearchParams(n.search);
    return l.set(Et.MODAL_TYPE, a), l.set(Et.UPDATE_LOCATION_ID, String(s.data.id)), l.toString();
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox py-8 px-4 dc__gap-4 dc__content-end dc__align-items-center", children: [
    /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "edit-location-button",
        icon: /* @__PURE__ */ e.jsx(D, { name: "ic-pencil", color: null }),
        component: me.link,
        style: q.neutral,
        variant: U.borderLess,
        ariaLabel: `Edit ${s.data.name}`,
        showAriaLabelInTippy: !1,
        size: P.small,
        linkProps: {
          to: {
            pathname: n.pathname,
            search: r()
          }
        }
      }
    ),
    /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "bulk-delete-restore-button",
        icon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
        component: me.button,
        style: q.negativeGrey,
        variant: U.borderLess,
        ariaLabel: "Delete Selected Locations",
        size: P.small,
        onClick: o,
        showAriaLabelInTippy: !1
      }
    )
  ] });
}, gS = () => {
  const [s, t] = E(!1), [a, n] = E(!1), [o, r] = E(null), { type: l } = ce(), i = ae(), u = he(), { searchParams: c } = Re(), p = Wt(
    async ({
      sortBy: b,
      sortOrder: S,
      searchKey: O,
      offset: j,
      pageSize: v,
      createdBy: A,
      status: N
    }, L) => {
      try {
        t(!1);
        const M = await qb({
          offset: j,
          pageSize: v,
          sortBy: b,
          sortOrder: S,
          searchKey: O,
          signal: L,
          createdBy: A,
          type: l,
          status: N
        }), W = !!O || !!A?.length || !!N?.length || j > 0;
        return t(!W && M.totalCount === 0), {
          rows: (M.data || []).map(($) => ({
            id: String($.id),
            data: $
          })),
          totalRows: M.totalCount || 0
        };
      } catch (M) {
        throw M.code === Xo.PERMISSION_DENIED && t(!0), M;
      }
    },
    [l, a]
  ), d = (b) => {
    r(b);
  }, m = () => {
    r(null);
  }, _ = de(() => Bb(l), [l]), g = () => {
    const b = new URLSearchParams(u.search);
    Object.values(Et).forEach((S) => {
      b.delete(S);
    }), i.replace({ search: b.toString() });
  }, x = () => {
    n((b) => !b);
  }, C = async (b, S) => {
    S !== "*" ? await dd({
      id: S,
      type: l,
      signal: b.signal,
      showToast: !1,
      throwError: !0
    }) : Se.showToast({
      variant: Ne.error,
      description: "Coming Soon! Bulk delete of all backup locations is not supported yet."
    });
  }, f = () => o ? /* @__PURE__ */ e.jsx(
    Cd,
    {
      name: o.name,
      id: o.id,
      type: o.type,
      onSuccess: x,
      handleClose: m
    }
  ) : c[Et.MODAL_TYPE] === ge.VOLUME_SNAPSHOT ? /* @__PURE__ */ e.jsx(xd, { handleClose: g, onSuccess: x }) : c[Et.MODAL_TYPE] === ge.STORAGE ? /* @__PURE__ */ e.jsx(gd, { handleClose: g, onSuccess: x }) : null, h = () => /* @__PURE__ */ e.jsx(
    bd,
    {
      label: l === ge.STORAGE ? "Add Storage Location" : "Add Snapshot Location"
    }
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      oa,
      {
        id: `table__hero-listing-backup-locations-${l}`,
        columns: _,
        emptyStateConfig: {
          noRowsConfig: {
            imgName: "img-no-backup-location",
            title: l === ge.STORAGE ? "No storage locations added" : "No snapshot locations added",
            isButtonAvailable: !0,
            renderButton: h
          },
          noRowsForFilterConfig: {
            title: "No results",
            subTitle: "We couldn't find any matching results"
          }
        },
        paginationVariant: ra.PAGINATED,
        additionalFilterProps: {
          initialSortKey: On.name,
          parseSearchParams: yr
        },
        bulkSelectionConfig: {
          BulkActionsComponent: _S,
          bulkActionsData: null,
          BulkOperationModal: Er,
          bulkOperationModalData: {
            handleDelete: C,
            reloadDataAfterBulkOperation: x
          },
          getSelectAllDialogStatus: () => Qn.CLOSED
        },
        getRows: p,
        filtersVariant: la.URL,
        ViewWrapper: hS,
        additionalProps: {
          hideTableFilters: s,
          handleShowDeleteModal: d
        },
        filter: ks,
        rowActionOnHoverConfig: {
          width: 72,
          Component: fS
        }
      },
      a ? "backup-location-table-1" : "backup-location-table-0"
    ),
    f()
  ] });
}, xS = () => {
  const s = he(), { breadcrumbs: t } = nt(nd(s.pathname), [s.pathname]), a = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: t });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space flex-grow-1 h-100 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(xt, { isBreadcrumbs: !0, breadCrumbs: a }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsx(gS, {}) })
  ] });
}, CS = () => /* @__PURE__ */ e.jsxs(rt, { children: [
  /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION_BACKUP_LOCATIONS, exact: !0, children: /* @__PURE__ */ e.jsx(xS, {}) }),
  /* @__PURE__ */ e.jsx(le, { path: `${R.DATA_PROTECTION_BACKUP_LOCATIONS}${R.BACKUP_LOCATION_DETAILS}`, exact: !0, children: /* @__PURE__ */ e.jsx(pS, {}) })
] });
var Ya = /* @__PURE__ */ ((s) => (s.BACKUPS_INITIATED = "backupsInitiated", s.RESTORES_INITIATED = "restoresInitiated", s.BACKUP_SCHEDULES = "totalSchedules", s))(Ya || {}), za = /* @__PURE__ */ ((s) => (s.BACKUP_STATUS = "backupStatus", s.RESTORE_STATUS = "restoreStatus", s.SCHEDULE_STATUS = "scheduleStatus", s))(za || {}), Wn = /* @__PURE__ */ ((s) => (s.UNAVAILABLE_STORAGE_LOCATION = "unavailableStorageLocation", s.PAUSED_SCHEDULE = "pausedSchedule", s))(Wn || {});
const bS = {
  [Ya.BACKUPS_INITIATED]: {
    metricTitle: "Backups Initiated",
    iconName: "ic-bg-backups",
    tooltipContent: "Total number of backups initiated."
  },
  [Ya.RESTORES_INITIATED]: {
    metricTitle: "Restores Initiated",
    iconName: "ic-bg-restore",
    tooltipContent: "Total number of restores initiated."
  },
  [Ya.BACKUP_SCHEDULES]: {
    metricTitle: "Backup Schedules",
    iconName: "ic-bg-backup-schedule",
    tooltipContent: "Total number of backups scheduled."
  }
}, Yl = Object.values(
  Ns
).map((s) => ({
  label: `${s} Clusters`,
  value: s
})), po = {
  AT_A_GLANCE_METRICS: "atAGlanceMetrics",
  BACKUP_AND_RESTORE_SUMMARY: "backupAndRestoreSummary",
  BACKUP_SUCCESS_RATE: "backupSuccessRate"
}, SS = {
  [Wn.UNAVAILABLE_STORAGE_LOCATION]: {
    dataTestId: "unavailable-storage-locations",
    metricTitle: "Unavailable Storage Locations",
    iconName: "ic-bg-storage-locations",
    tooltipContent: "Number of backup storage locations that are currently unavailable.",
    subtitle: "View unavailable storage locations",
    subtitleRedirection: $e(
      Q(R.DATA_PROTECTION_BACKUP_LOCATIONS, {
        type: ge.STORAGE
      }),
      { status: Bs.UNAVAILABLE }
    )
  },
  [Wn.PAUSED_SCHEDULE]: {
    dataTestId: "paused-schedules",
    metricTitle: "Paused Schedules",
    iconName: "ic-bg-pause-schedule",
    tooltipContent: "Number of backup schedules that are currently paused.",
    subtitle: "View paused schedules",
    subtitleRedirection: $e(
      Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, {
        view: be.Schedules
      }),
      { pauseState: "true" }
    )
  }
}, zl = {
  Completed: "Completed",
  Failed: "Failed",
  InProgress: "In Progress",
  Deleting: "Deleting",
  PartiallyFailed: "Partially Failed"
}, ql = {
  Completed: "LimeGreen500",
  Failed: "CoralRed500",
  InProgress: "SunsetOrange500",
  Deleting: "CoralRed200",
  PartiallyFailed: "GoldenYellow500"
}, NS = {
  fullBackupSchedule: "Full Backup Schedule",
  partialBackupSchedule: "Partial Backup Schedule",
  notCoveredSchedule: "Not Covered Schedule"
}, ES = {
  fullBackupSchedule: "LimeGreen500",
  partialBackupSchedule: "SunsetOrange500",
  notCoveredSchedule: "CharcoalGray500"
}, vS = [
  {
    key: za.BACKUP_STATUS,
    id: "backups-status",
    title: "Backup Status",
    emptyStateTitle: "No Backups Initiated",
    labelMap: zl,
    colorMap: ql
  },
  {
    key: za.RESTORE_STATUS,
    id: "restore-status",
    title: "Restore Status",
    emptyStateTitle: "No Restores Initiated",
    labelMap: zl,
    colorMap: ql
  },
  {
    key: za.SCHEDULE_STATUS,
    id: "clusters-with-backup-schedule",
    title: "Clusters with Backup Schedule",
    emptyStateTitle: "No Backup Schedules",
    labelMap: NS,
    colorMap: ES
  }
], TS = (s, t, a) => Object.entries(s).reduce(
  (n, [o, r]) => {
    const l = t[o], i = a[o];
    return l && i && (n.xAxisLabels.push(l), n.colors.push(i), n.yAxisValues.push(r)), n;
  },
  { xAxisLabels: [], colors: [], yAxisValues: [] }
), AS = (s) => vS.map((t) => {
  const { xAxisLabels: a, colors: n, yAxisValues: o } = TS(
    s?.[t.key] ?? {},
    t.labelMap,
    t.colorMap
  );
  return {
    id: t.id,
    title: t.title,
    xAxisLabels: a,
    datasets: {
      colors: n,
      datasetName: t.title,
      yAxisValues: o
    },
    emptyStateTitle: t.emptyStateTitle
  };
}), yS = (s) => se({
  queryKey: [po.AT_A_GLANCE_METRICS, s],
  queryFn: ({ signal: t }) => xe(
    $e(z.OVERVIEW_GLANCE_METRICS, {
      clusterType: s.toLowerCase()
    }),
    { signal: t }
  ),
  select: (t) => Object.entries(bS).map(
    ([a, n]) => ({
      dataTestId: a,
      metricValue: (t.result?.[a] ?? 0).toLocaleString(),
      ...n
    })
  )
}), jS = (s) => se({
  queryKey: [po.BACKUP_AND_RESTORE_SUMMARY, s],
  queryFn: ({ signal: t }) => xe(
    $e(z.OVERVIEW_BACKUP_AND_RESTORE_SUMMARY, {
      clusterType: s.toLowerCase()
    }),
    { signal: t }
  ),
  select: (t) => ({
    chartsConfig: AS(t?.result),
    cardsConfig: Object.entries(SS).map(
      ([a, n]) => ({
        dataTestId: a,
        metricValue: (t.result?.[a]?.count ?? 0).toLocaleString(),
        valueOutOf: (t.result?.[a]?.total ?? 0).toLocaleString(),
        ...n
      })
    )
  })
}), OS = ({
  clusterType: s,
  sortConfig: { sortBy: t, sortOrder: a },
  offset: n,
  pageSize: o
}) => se({
  queryKey: [
    po.BACKUP_SUCCESS_RATE,
    s,
    t,
    a,
    n,
    o
  ],
  queryFn: ({ signal: r }) => xe(
    $e(z.OVERVIEW_BACKUP_SUCCESS_RATE, {
      clusterType: s.toLowerCase(),
      sortBy: t,
      sortOrder: a,
      offset: n,
      size: o
    }),
    { signal: r }
  ),
  select: (r) => {
    const { clusterNames: l, successRates: i } = (r.result?.data ?? []).reduce(
      (u, c) => (u.clusterNames.push(c.clusterName), u.successRates.push(c.successPercentage), u),
      { clusterNames: [], successRates: [] }
    );
    return {
      clusterNames: l,
      successRates: i,
      totalCount: r.result?.totalCount ?? 0
    };
  }
}), IS = ({ clusterType: s }) => {
  const t = Bp(), [a, n] = E(!1), o = async () => {
    n(!0), await Promise.all(
      // Refetch all queries on overview page
      Object.values(po).map(
        (p) => t.refetchQueries({
          queryKey: [p]
        })
      )
    ), n(!1);
  }, { isFetching: r, isError: l, data: i, refetch: u } = yS(s), c = () => r ? /* @__PURE__ */ e.jsx("div", { className: "dc__grid cards-wrapper", children: Object.keys(Ya).map((p) => /* @__PURE__ */ e.jsx(vi, {}, p)) }) : l ? /* @__PURE__ */ e.jsx(
    hs,
    {
      subTitle: "",
      reload: u,
      rootClassName: "bg__primary br-8 border__secondary"
    }
  ) : /* @__PURE__ */ e.jsx("div", { className: "dc__grid cards-wrapper", children: i.map(({ dataTestId: p, ...d }) => /* @__PURE__ */ e.jsx(Ti, { dataTestId: p, ...d }, p)) });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-20 fw-4 lh-1-5 cn-9", children: "At A Glance" }),
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "refresh-overview-data",
          icon: /* @__PURE__ */ e.jsx(D, { name: a ? "ic-circle-loader" : "ic-arrows-clockwise", color: null }),
          variant: U.borderLess,
          style: q.neutral,
          size: P.small,
          ariaLabel: "Refresh data",
          showAriaLabelInTippy: !1,
          disabled: a,
          onClick: o,
          isLoading: a
        }
      )
    ] }),
    c()
  ] });
}, yo = [
  { label: "High to Low", value: { sortBy: "successPercentage", sortOrder: Ss.DESC } },
  { label: "Low to High", value: { sortBy: "successPercentage", sortOrder: Ss.ASC } },
  { label: "A to Z", value: { sortBy: "clusterName", sortOrder: Ss.ASC } },
  { label: "Z to A", value: { sortBy: "clusterName", sortOrder: Ss.DESC } }
], wS = ({ clusterType: s }) => {
  const [t, a] = E(
    yo[0].value
  ), { offset: n, pageSize: o, changePage: r, changePageSize: l } = qn({
    defaultPageSize: go[0].value
  }), { isFetching: i, isError: u, refetch: c, data: p } = OS({
    clusterType: s,
    sortConfig: t,
    offset: n,
    pageSize: o
  }), d = (_) => {
    r(1), a(_.value);
  }, m = () => i ? /* @__PURE__ */ e.jsx("div", { className: "p-16", children: /* @__PURE__ */ e.jsx("div", { className: "w-100 h-200 br-8 shimmer" }) }) : u ? /* @__PURE__ */ e.jsx(hs, { subTitle: "", reload: c }) : (p?.clusterNames ?? []).length ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: "p-16 mh-200 mxh-600", style: { height: (p.clusterNames.length + 1) * 40 }, children: /* @__PURE__ */ e.jsx(
      na,
      {
        id: "backup-success-rate-chart",
        type: "stackedBarHorizontal",
        xAxisLabels: p.clusterNames,
        datasets: [
          {
            datasetName: "Success Rate (%)",
            color: "SkyBlue500",
            yAxisValues: p.successRates
          }
        ],
        yScaleTickFormat: (_) => `${_}%`,
        xAxisMax: 100
      }
    ) }),
    p.totalCount > go[0].value && /* @__PURE__ */ e.jsx(
      ui,
      {
        size: p?.totalCount,
        offset: n,
        pageSize: o,
        changePage: r,
        changePageSize: l,
        pageSizeOptions: go,
        rootClassName: "flex dc__content-space border__secondary--top px-16"
      }
    )
  ] }) : /* @__PURE__ */ e.jsx(Xe, { title: "No Data Available", classname: "h-300" });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col bg__primary border__secondary br-8", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-16 py-12 border__secondary--bottom", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-14 fw-6 lh-1-5 cn-9", children: "Backup Success Rate by Clusters" }),
      /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "success-rate-sort-select",
          options: yo,
          variant: We.COMPACT,
          value: Xt(yo, t),
          onChange: d,
          isDisabled: i
        }
      )
    ] }),
    m()
  ] });
}, PS = ({ isFetching: s, data: t, isError: a, refetch: n }) => s ? /* @__PURE__ */ e.jsx("div", { className: "dc__grid-half dc__gap-8", children: Object.values(Wn).map((o) => /* @__PURE__ */ e.jsx(vi, { withSubtitle: !0 }, o)) }) : a ? /* @__PURE__ */ e.jsx(hs, { subTitle: "", reload: n, rootClassName: "bg__primary br-8 border__secondary" }) : /* @__PURE__ */ e.jsx("div", { className: "dc__grid-half dc__gap-8", children: t.cardsConfig.map((o) => /* @__PURE__ */ e.jsx(Ti, { dataTestId: o.dataTestId, ...o }, o.dataTestId)) }), RS = ({
  id: s,
  title: t,
  emptyStateTitle: a,
  xAxisLabels: n,
  datasets: o
}) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col bg__primary br-8 border__secondary", children: [
  /* @__PURE__ */ e.jsx("div", { className: "p-12 border__secondary--bottom", children: /* @__PURE__ */ e.jsx("span", { className: "fs-14 fw-6 lh-1-5", children: t }) }),
  /* @__PURE__ */ e.jsx("div", { className: "flex px-16 py-24 h-200", children: n.length ? /* @__PURE__ */ e.jsx(na, { id: s, type: "pie", xAxisLabels: n, datasets: o }) : /* @__PURE__ */ e.jsx(cn, { title: a }) })
] }), LS = ({ isFetching: s, data: t, isError: a }) => s ? /* @__PURE__ */ e.jsx("div", { className: "dc__grid cards-wrapper", children: Object.values(za).map((n) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col bg__primary br-8 border__secondary", children: [
  /* @__PURE__ */ e.jsx("div", { className: "flex left px-16 py-12 border__secondary--bottom", children: /* @__PURE__ */ e.jsx("span", { className: "shimmer w-100px" }) }),
  /* @__PURE__ */ e.jsx(Up, {})
] }, n)) }) : a ? null : /* @__PURE__ */ e.jsx("div", { className: "dc__grid cards-wrapper", children: t?.chartsConfig.map((n) => /* @__PURE__ */ e.jsx(RS, { id: n.id, ...n }, n.id)) }), kS = ({ clusterType: s }) => {
  const t = jS(s);
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
    /* @__PURE__ */ e.jsx("span", { className: "fs-20 fw-4 lh-1-5 cn-9", children: "Backup & Restore Summary" }),
    /* @__PURE__ */ e.jsx(LS, { ...t }),
    /* @__PURE__ */ e.jsx(PS, { ...t }),
    /* @__PURE__ */ e.jsx(wS, { clusterType: s })
  ] });
}, DS = () => {
  const { pathname: s } = he(), { breadcrumbs: t } = nt(
    {
      alias: {
        ...Cn(),
        overview: {
          component: /* @__PURE__ */ e.jsx(tt, { heading: "Overview", isActive: !0 })
        }
      }
    },
    [s]
  ), a = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: t });
  return /* @__PURE__ */ e.jsx(xt, { isBreadcrumbs: !0, breadCrumbs: a });
}, MS = () => {
  const [s, t] = E(Ns.ALL), a = (n) => {
    t(n.value);
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(DS, {}),
    /* @__PURE__ */ e.jsx("div", { className: "data-protection-overview flex-grow-1 bg__secondary dc__overflow-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "p-20 w-100 flexbox-col dc__gap-20 dc__mxw-1200 min-w-800 dc__m-auto", children: [
      /* @__PURE__ */ e.jsx("div", { className: "w-150", children: /* @__PURE__ */ e.jsx(
        te,
        {
          inputId: "prod-non-prod-select",
          options: Yl,
          value: Xt(Yl, s),
          onChange: a
        }
      ) }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-32", children: [
        /* @__PURE__ */ e.jsx(IS, { clusterType: s }),
        /* @__PURE__ */ e.jsx(kS, { clusterType: s })
      ] })
    ] }) })
  ] });
}, BS = ({ row: s }) => {
  const { searchParams: t } = Re(), a = t[Ai.SEARCH_KEY] || "";
  return /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx(we, { content: s.data.name, children: /* @__PURE__ */ e.jsx(
    as,
    {
      to: Q(R.DATA_PROTECTION_RESTORES_DETAIL, { restoreId: s.data.id }),
      className: "anchor dc__truncate cb-5 fs-13 fw-4 lh-20",
      dangerouslySetInnerHTML: {
        __html: ni.sanitize(
          bi({
            searchText: a,
            text: s.data.name,
            highlightClasses: "bcy-2"
          })
        )
      }
    }
  ) }) });
}, US = ({ row: s }) => {
  const t = mo[s.data.status] || ta(s.data.status || "-"), a = Sd[s.data.status] || null;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
    a,
    /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: t })
  ] });
}, FS = ({ row: s }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
  !!s.data.backupSource.name && /* @__PURE__ */ e.jsx(D, { name: "ic-database-backup", size: 16, color: "B500" }),
  /* @__PURE__ */ e.jsx(we, { content: s.data.backupSource.name, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: s.data.backupSource.name || "-" }) })
] }), VS = ({ row: s }) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
  !!s.data.schedule.name && /* @__PURE__ */ e.jsx(D, { name: "ic-job-color", size: 16, color: "B500" }),
  /* @__PURE__ */ e.jsx(we, { content: s.data.schedule.name, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: s.data.schedule.name || "-" }) })
] }), GS = ({ row: s }) => /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-items-center", children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: s.data.date || "-" }) }), WS = ({ row: s }) => s.data.createdBy ? /* @__PURE__ */ e.jsx(Ei, { identifier: s.data.createdBy }) : /* @__PURE__ */ e.jsx("div", { className: "flex", children: "-" });
var Me = /* @__PURE__ */ ((s) => (s.NEW = "New", s.IN_PROGRESS = "InProgress", s.COMPLETED = "Completed", s.PARTIALLY_FAILED = "PartiallyFailed", s.FAILED = "Failed", s.FAILED_VALIDATION = "FailedValidation", s.UNKNOWN = "Unknown", s.INSTALLATION_PENDING = "InstallationPending", s.INSTALLATION_FAILED = "InstallationFailed", s.INSTALLATION_SUCCESS = "InstallationSuccess", s))(Me || {}), $n = /* @__PURE__ */ ((s) => (s.ADD_RESTORE = "addRestore", s))($n || {});
const mo = {
  [Me.COMPLETED]: "Completed",
  [Me.FAILED]: "Failed",
  [Me.FAILED_VALIDATION]: "Failed Validation",
  [Me.IN_PROGRESS]: "In Progress",
  [Me.NEW]: "New",
  [Me.PARTIALLY_FAILED]: "Partially Failed",
  [Me.UNKNOWN]: "Unknown",
  [Me.INSTALLATION_FAILED]: "Installation Failed",
  [Me.INSTALLATION_PENDING]: "Installation Pending",
  [Me.INSTALLATION_SUCCESS]: "Installation Success"
}, Sd = {
  [Me.NEW]: /* @__PURE__ */ e.jsx(D, { name: "ic-in-progress", size: 16, color: "O500" }),
  [Me.IN_PROGRESS]: /* @__PURE__ */ e.jsx(D, { name: "ic-in-progress", size: 16, color: "O500" }),
  [Me.COMPLETED]: /* @__PURE__ */ e.jsx(D, { name: "ic-success", size: 16, color: "G500" }),
  [Me.FAILED]: /* @__PURE__ */ e.jsx(D, { name: "ic-error", size: 16, color: "R500" }),
  [Me.PARTIALLY_FAILED]: /* @__PURE__ */ e.jsx(D, { name: "ic-warning-fill", size: 16, color: "Y500" }),
  [Me.FAILED_VALIDATION]: /* @__PURE__ */ e.jsx(D, { name: "ic-error", size: 16, color: "R500" }),
  [Me.UNKNOWN]: /* @__PURE__ */ e.jsx(D, { name: "ic-unknown", size: 16, color: "N500" }),
  [Me.INSTALLATION_FAILED]: /* @__PURE__ */ e.jsx(D, { name: "ic-error", size: 16, color: "R500" }),
  [Me.INSTALLATION_PENDING]: /* @__PURE__ */ e.jsx(D, { name: "ic-warning-fill", size: 16, color: "Y500" }),
  [Me.INSTALLATION_SUCCESS]: /* @__PURE__ */ e.jsx(D, { name: "ic-success", size: 16, color: "G500" })
}, Rt = {
  name: "name",
  status: "status",
  targetCluster: "targetCluster",
  backupSource: "backupSource",
  schedule: "schedule",
  date: "date",
  createdBy: "createdBy"
}, $S = [
  {
    field: Rt.name,
    label: "Restore Name",
    size: {
      range: {
        startWidth: 334,
        maxWidth: 500,
        minWidth: 100
      }
    },
    CellComponent: BS,
    isSortable: !0,
    horizontallySticky: !0
  },
  {
    field: Rt.status,
    label: "Status",
    size: {
      range: {
        startWidth: 140,
        maxWidth: 250,
        minWidth: 120
      }
    },
    CellComponent: US,
    isSortable: !0
  },
  {
    field: Rt.targetCluster,
    label: "Target Cluster",
    size: {
      range: {
        startWidth: 200,
        maxWidth: 300,
        minWidth: 100
      }
    },
    isSortable: !0
  },
  {
    field: Rt.backupSource,
    label: "Backup Source",
    size: {
      range: {
        startWidth: 200,
        maxWidth: 300,
        minWidth: 100
      }
    },
    isSortable: !0,
    CellComponent: FS
  },
  {
    field: Rt.schedule,
    label: "Schedule",
    size: {
      range: {
        startWidth: 200,
        maxWidth: 300,
        minWidth: 100
      }
    },
    isSortable: !0,
    CellComponent: VS
  },
  {
    field: Rt.createdBy,
    label: "Created By",
    size: {
      range: {
        startWidth: 180,
        maxWidth: 250,
        minWidth: 100
      }
    },
    isSortable: !0,
    CellComponent: WS
  },
  {
    field: Rt.date,
    label: "Date",
    size: {
      range: {
        startWidth: 180,
        maxWidth: 250,
        minWidth: 100
      }
    },
    isSortable: !0,
    CellComponent: GS
  }
], pt = {
  status: "status",
  clusterName: "clusterName",
  createdBy: "createdBy"
}, KS = [
  {
    groupLabel: "Filter By",
    items: [
      { id: pt.status, label: "Status" },
      { id: pt.clusterName, label: "Cluster Name" },
      { id: pt.createdBy, label: "Created By" }
    ]
  }
], Nd = Object.entries(
  mo
).map(([s, t]) => ({ value: s, label: t })), HS = {
  name: "name",
  status: "status",
  targetCluster: "targetClusterName",
  backupSource: "backupName",
  schedule: "scheduleName",
  date: "createdOn",
  createdBy: "createdBy"
}, Ed = (s, t) => {
  const a = s.split("?")[0].split("#")[0];
  return {
    alias: {
      ...Cn(),
      restores: {
        component: /* @__PURE__ */ e.jsx(tt, { isActive: a === R.DATA_PROTECTION_RESTORES, heading: "Restores" }),
        linked: a !== R.DATA_PROTECTION_RESTORES
      },
      ":restoreId": {
        component: t ? /* @__PURE__ */ e.jsx(tt, { isActive: !0, heading: t }) : /* @__PURE__ */ e.jsx("div", { className: "h-20 w-120 shimmer-loading" }),
        linked: !1
      }
    }
  };
}, vd = (s) => {
  const t = s.getAll(pt.status), a = s.getAll(pt.clusterName), n = s.getAll(pt.createdBy);
  return {
    status: t.length ? t : void 0,
    clusterName: a.length ? a : void 0,
    createdBy: n.length ? n : void 0
  };
}, YS = (s, t) => {
  const a = s.getAll(pt.status), n = s.getAll(pt.clusterName), o = s.getAll(pt.createdBy), r = (a || []).reduce(
    (d, m) => (d[m] = !0, d),
    {}
  ), l = (n || []).reduce(
    (d, m) => (d[m] = !0, d),
    {}
  ), i = (o || []).reduce(
    (d, m) => (d[m] = !0, d),
    {}
  ), u = a.length && Nd.filter((d) => r[d.value]) || null, c = n.length && t?.clusterOptions.filter((d) => l[d.value]) || null, p = o.length && t?.createdByOptions.filter((d) => i[d.value]) || null;
  return {
    areFiltersApplied: !!(a.length || n.length || o.length),
    appliedFilterOptions: {
      status: u,
      clusterName: c,
      createdBy: p
    }
  };
}, zS = (s) => ({
  id: s.id,
  name: s.name || "",
  status: s.status?.phase || Me.UNKNOWN,
  targetCluster: s.targetClusterName || "",
  backupSource: {
    name: s.backupName || "",
    id: s.clusterBackupId
  },
  schedule: {
    name: s.scheduleName || "",
    id: null
  },
  date: Pn(s.createdOn) || "",
  createdBy: s.createdBy
});
var et = /* @__PURE__ */ ((s) => (s.NAMESPACE_MAPPING = "namespace-mapping", s.MANIFEST = "manifest", s))(et || {}), Td = /* @__PURE__ */ ((s) => (s.TAB = "tab", s.SORT_BY = "sortBy", s))(Td || {});
const Xl = {
  [et.NAMESPACE_MAPPING]: "Namespace Mapping",
  [et.MANIFEST]: "Manifest"
}, qS = [
  {
    label: Xl[et.NAMESPACE_MAPPING],
    value: et.NAMESPACE_MAPPING
  },
  {
    label: Xl[et.MANIFEST],
    value: et.MANIFEST
  }
], XS = [
  {
    field: "sourceNamespace",
    label: "SOURCE NAMESPACE",
    size: {
      range: {
        startWidth: 250,
        maxWidth: 600,
        minWidth: 100
      }
    },
    isSortable: !0,
    comparator: Ae,
    horizontallySticky: !0
  },
  {
    field: "targetNamespace",
    label: "TARGET NAMESPACE",
    size: {
      range: {
        startWidth: 250,
        maxWidth: 600,
        minWidth: 120
      }
    },
    isSortable: !0,
    comparator: Ae
  }
], JS = ({ children: s }) => /* @__PURE__ */ e.jsx("div", { children: s }), QS = ({ namespaceMapping: s }) => {
  const t = s.map((a) => ({
    data: a,
    id: `${a.sourceNamespace}-${a.targetNamespace}`
  }));
  return /* @__PURE__ */ e.jsx(
    oa,
    {
      id: "table__restore-details-namespace-mapping",
      columns: XS,
      rows: t,
      emptyStateConfig: {
        noRowsConfig: {
          title: "No Mapped Namespaces Found",
          subTitle: "There are no namespace mappings available for this restore."
        }
      },
      filtersVariant: la.URL,
      paginationVariant: ra.NOT_PAGINATED,
      filter: null,
      additionalFilterProps: {
        initialSortKey: "sourceNamespace"
      },
      ViewWrapper: JS
    }
  );
}, ZS = async ({
  offset: s,
  pageSize: t,
  sortBy: a,
  searchKey: n,
  sortOrder: o,
  signal: r,
  status: l,
  createdBy: i,
  clusterName: u
}) => {
  const c = [
    ...l?.length ? [{ key: "status", values: l }] : [],
    ...i?.length ? [{ key: "createdBy", values: i }] : [],
    ...u?.length ? [{ key: "clusterName", values: u }] : []
  ], p = {
    offset: s,
    searchByName: n,
    size: t,
    sortOrder: o,
    sortBy: HS[a],
    filters: c.length ? c : null
  }, { result: d } = await _s(z.CLUSTER_BACKUP_RESTORE_LIST, p, {
    signal: r
  });
  return {
    totalCount: d.totalCount,
    data: (d.data || []).map(zS)
  };
}, eN = async (s) => {
  const [t, a] = await Promise.all([zo(s), or(s)]), n = (a || []).filter((r) => !r.isVirtual).sort((r, l) => Ae(r.name, l.name)).map((r) => ({
    label: r.name,
    value: r.name
  })), o = (t || []).filter((r) => !!r.emailId).sort((r, l) => Ae(r.emailId, l.emailId)).map((r) => ({ label: r.emailId, value: r.emailId }));
  return {
    clusterOptions: n,
    createdByOptions: o
  };
}, Ad = async ({
  id: s,
  signal: t,
  showToast: a = !0,
  throwError: n = !1
}) => {
  try {
    return await ia(`${z.CLUSTER_BACKUP_RESTORE}/${s}`, null, { signal: t }), a && Se.showToast({
      variant: Ne.success,
      description: "Restore deleted successfully"
    }), !0;
  } catch (o) {
    if (a && ve(o), n)
      throw o;
    return !1;
  }
}, yd = ({ id: s, name: t, handleSuccess: a, handleClose: n }) => {
  const [o, r] = E(!1), l = async () => {
    r(!0), await Ad({
      id: s
    }) && (a(), n()), r(!1);
  };
  return /* @__PURE__ */ e.jsx(
    vt,
    {
      title: `Are you sure you want to delete '${t}' restore?`,
      variant: mt.delete,
      handleClose: n,
      confirmationConfig: {
        identifier: "delete-restore-dialog-input",
        confirmationKeyword: t
      },
      buttonConfig: {
        primaryButtonConfig: {
          text: "Delete",
          onClick: l,
          isLoading: o
        },
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: n
        }
      }
    }
  );
}, sN = ({ restoreDetails: s }) => {
  const t = ae(), [a, n] = E(!1), o = () => {
    n(!1);
  }, r = () => {
    n(!0);
  }, l = () => {
    t.push(R.DATA_PROTECTION_RESTORES);
  }, i = () => a ? /* @__PURE__ */ e.jsx(
    yd,
    {
      id: s.id,
      name: s.name,
      handleClose: o,
      handleSuccess: l
    }
  ) : null, u = (p, d) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-20", children: p }),
    typeof d == "string" ? /* @__PURE__ */ e.jsx(we, { content: d, children: /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__truncate", children: d }) }) : d
  ] }), c = (p, d) => /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space dc__gap-12 align-center", children: [
    /* @__PURE__ */ e.jsx("span", { className: "cn-7 fs-13 fw-4 lh-1-5", children: p }),
    d
  ] });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto h-100 py-20 px-16 dc__gap-20 border__primary--right", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col dc__gap-12", children: /* @__PURE__ */ e.jsx("h3", { className: "m-0 cn-9 font-merriweather fs-16 fw-7 lh-1-5 dc__word-break", children: s.name }) }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__gap-8", children: /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "delete-backup-location-button",
          startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
          text: "Delete",
          variant: U.secondary,
          style: q.negative,
          size: P.medium,
          onClick: r
        }
      ) }),
      /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        c(
          "Status",
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox align-center dc__gap-6", children: [
            Sd[s.status],
            /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-1-5", children: mo[s.status] || s.status })
          ] })
        ),
        c(
          "Warnings & Errors",
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-6 dc__align-items-center", children: [
            s.warningCount > 0 && /* @__PURE__ */ e.jsx(
              yt,
              {
                label: `${s.warningCount}`,
                size: P.xxs,
                variant: "warning",
                startIconProps: {
                  name: "ic-warning-stroke"
                }
              }
            ),
            s.errorCount > 0 && /* @__PURE__ */ e.jsx(
              yt,
              {
                label: `${s.errorCount}`,
                size: P.xxs,
                variant: "negative",
                startIconProps: {
                  name: "ic-error"
                }
              }
            ),
            s.warningCount === 0 && s.errorCount === 0 && "-"
          ] })
        ),
        c(
          "Resources",
          /* @__PURE__ */ e.jsxs("span", { className: "cn-9 fs-13 fw-4 lh-1-5 dc__truncate", children: [
            s.resourceCount,
            "/",
            s.totalResourceCount
          ] })
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "divider divider--n1" }),
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
        u("Target cluster", s.targetCluster),
        u("Created by", s.createdBy),
        u(
          "Restored from backup",
          s.backupDetails.id ? /* @__PURE__ */ e.jsx(
            as,
            {
              to: Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE_DETAIL, {
                view: be.Backups,
                id: s.backupDetails.id
              }),
              children: s.backupDetails.name || "-"
            }
          ) : "-"
        ),
        u("Duration", s.duration),
        u(
          "Included resources",
          /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__word-break", children: s.includeResources.join(", ") })
        ),
        u(
          "Excluded resources",
          /* @__PURE__ */ e.jsx("span", { className: "cn-9 fs-13 fw-4 lh-20 dc__word-break", children: s.excludedResources.join(", ") })
        )
      ] })
    ] }),
    i()
  ] });
}, tN = (s) => !s.manifestGvk || !s.manifestGvk?.gvk || !s.name || !s.targetClusterId || !s.manifestGvk?.veleroNamespace ? null : {
  name: s.name,
  namespace: s.manifestGvk.veleroNamespace,
  clusterId: s.targetClusterId,
  gvk: {
    Group: s.manifestGvk.gvk.Group,
    Version: s.manifestGvk.gvk.Version,
    Kind: s.manifestGvk.gvk.Kind
  }
}, aN = (s) => ({
  id: s.id,
  name: s.name || "",
  status: s.status?.phase || Me.UNKNOWN,
  warningCount: s.status?.warnings || 0,
  errorCount: s.status?.errors || 0,
  resourceCount: s.status?.progress?.itemsRestored || 0,
  totalResourceCount: s.status?.progress?.totalItems || 0,
  targetCluster: s.targetClusterName || "",
  createdBy: s.createdBy || "",
  backupDetails: {
    id: s.clusterBackupId,
    name: s.backupName
  },
  duration: Si({
    startTime: s.status?.startTimestamp,
    endTime: s.status?.completionTimestamp,
    fallbackString: "-"
  }),
  includeResources: s.includedResources || [],
  excludedResources: s.excludedResources || [],
  namespaceMapping: Object.entries(s.namespaceMapping || {}).map(([t, a]) => ({
    sourceNamespace: t,
    targetNamespace: a
  })),
  manifestPayload: tN(s)
}), nN = async (s, t) => {
  const { result: a } = await xe(`${z.CLUSTER_BACKUP_RESTORE}/${s}`, { signal: t });
  return aN(a);
}, oN = async (s, t) => {
  const n = (await Yn({
    ...s,
    signal: t
  }))?.manifestResponse?.manifest;
  return ir(n) || "";
}, rN = () => {
  const s = he(), t = ae(), { searchParams: a } = Re(), { restoreId: n } = ce(), o = a[Td.TAB] || et.NAMESPACE_MAPPING, {
    isFetching: r,
    data: l,
    error: i,
    refetch: u
  } = se({
    queryKey: ["restore-details", n],
    queryFn: ({ signal: f }) => nN(+n, f)
  }), {
    isFetching: c,
    data: p,
    error: d,
    refetch: m
  } = se({
    queryKey: ["restore-manifest", n, l, o],
    queryFn: ({ signal: f }) => oN(l.manifestPayload, f),
    enabled: o === et.MANIFEST && !!l
  }), { breadcrumbs: _ } = nt(Ed(s.pathname, l?.name), [
    s.pathname,
    l
  ]), g = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: _ }), x = (f) => {
    const h = new URLSearchParams(s.search);
    f.value === et.NAMESPACE_MAPPING ? h.delete("tab") : h.set("tab", f.value), t.replace({ search: h.toString() });
  }, C = () => o === et.MANIFEST ? /* @__PURE__ */ e.jsx("div", { className: "flex column flex-grow-1", children: /* @__PURE__ */ e.jsx(
    at,
    {
      isLoading: c,
      error: d,
      progressingProps: { pageLoader: !0 },
      genericSectionErrorProps: {
        reload: m
      },
      children: /* @__PURE__ */ e.jsx(bs, { value: p || "", mode: ht.YAML, height: "100%", readOnly: !0 })
    }
  ) }) : /* @__PURE__ */ e.jsx(QS, { namespaceMapping: l.namespaceMapping });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space flex-grow-1 h-100 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(xt, { isBreadcrumbs: !0, breadCrumbs: g }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsx(
      at,
      {
        isLoading: r,
        error: i,
        progressingProps: { pageLoader: !0 },
        errorScreenManagerProps: {
          code: i?.code,
          reload: u,
          redirectURL: R.DATA_PROTECTION_RESTORES
        },
        children: l && /* @__PURE__ */ e.jsxs("div", { className: "dc__grid restore-details__container dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ e.jsx(sN, { restoreDetails: l }),
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-auto dc__content-space h-100", children: [
            /* @__PURE__ */ e.jsx("div", { className: "py-12 px-16 flexbox dc__align-items-center border__secondary--bottom", children: /* @__PURE__ */ e.jsx(
              ca,
              {
                name: "restore-details-tabs",
                segments: qS,
                onChange: x,
                value: o
              }
            ) }),
            C()
          ] })
        ] })
      }
    ) })
  ] });
}, jd = () => {
  const s = he(), t = () => {
    const a = new URLSearchParams(s.search);
    return a.set($n.ADD_RESTORE, "true"), `${s.pathname}?${a.toString()}`;
  };
  return /* @__PURE__ */ e.jsx(
    B,
    {
      dataTestId: "create-restore-button",
      text: "New Restore",
      startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-add", color: null }),
      component: me.link,
      size: P.medium,
      linkProps: {
        to: t()
      }
    }
  );
}, lN = () => {
  const s = ae(), t = he(), { isFetching: a, error: n, data: o, refetch: r } = se({
    queryKey: ["restore-list-grouped-select-metadata"],
    queryFn: ({ signal: m }) => eN(m)
  }), { areFiltersApplied: l, appliedFilterOptions: i } = de(
    () => YS(new URLSearchParams(t.search), o),
    [t.search, o]
  ), { clusterOptions: u, createdByOptions: c } = o || { clusterOptions: [], createdByOptions: [] }, p = (m) => (_) => {
    const g = new URLSearchParams(t.search);
    g.delete(m), _.forEach((x) => {
      g.append(m, x.value);
    }), s.replace({ search: g.toString() });
  }, d = {
    status: {
      inputId: "restore-list-status-filter",
      placeholder: "Select Status",
      options: Nd,
      appliedFilterOptions: i.status,
      handleApplyFilter: p("status"),
      isDisabled: !1,
      isLoading: !1
    },
    clusterName: {
      inputId: "restore-list-cluster-name-filter",
      placeholder: "Select Cluster",
      options: u,
      appliedFilterOptions: i.clusterName,
      handleApplyFilter: p("clusterName"),
      isDisabled: a,
      isLoading: a,
      optionListError: n,
      reloadOptionList: r
    },
    createdBy: {
      inputId: "restore-list-created-by-filter",
      placeholder: "Select User",
      options: c,
      appliedFilterOptions: i.createdBy,
      handleApplyFilter: p("createdBy"),
      isDisabled: a,
      isLoading: a,
      optionListError: n,
      isUserIdentifier: !0,
      reloadOptionList: r
    }
  };
  return /* @__PURE__ */ e.jsx(
    Na,
    {
      id: "restore-list-grouped-filter-select",
      isFilterApplied: l,
      width: 120,
      options: KS,
      filterSelectPickerPropsMap: d
    }
  );
}, iN = ({
  children: s,
  searchKey: t,
  handleSearch: a,
  isUnauthorized: n
}) => {
  const o = ae(), r = he(), l = new URLSearchParams(r.search), i = vd(l), u = () => {
    o.push({
      search: ""
    });
  }, c = (d) => {
    const m = new URLSearchParams(r.search);
    Object.entries(d).forEach(([_, g]) => {
      g ? Array.isArray(g) ? (m.delete(_), g.forEach((x) => m.append(_, x))) : m.set(_, g) : m.delete(_);
    }), o.push({
      search: m.toString()
    });
  }, p = (d, m) => d === pt.status && mo[m] || m;
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__overflow-hidden flex-grow-1", children: [
    !n && /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__content-space p-16", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center", children: [
          /* @__PURE__ */ e.jsx(aa, { initialSearchText: t, handleEnter: a, keyboardShortcut: "/" }),
          /* @__PURE__ */ e.jsx(lN, {})
        ] }),
        /* @__PURE__ */ e.jsx(jd, {})
      ] }),
      /* @__PURE__ */ e.jsx(
        Jn,
        {
          className: "px-20 pb-16 py-2",
          filterConfig: {
            status: i.status,
            clusterName: i.clusterName,
            createdBy: i.createdBy
          },
          onRemoveFilter: c,
          clearFilters: u,
          getFormattedValue: p
        }
      )
    ] }),
    s
  ] });
}, cN = ({ onActionClick: s }) => /* @__PURE__ */ e.jsx(
  B,
  {
    dataTestId: "bulk-delete-restore-button",
    icon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
    component: me.button,
    style: q.negativeGrey,
    variant: U.borderLess,
    ariaLabel: "Delete Selected Restores",
    size: P.small,
    onClick: s,
    showAriaLabelInTippy: !1,
    "data-key": ps.RESTORE
  }
), dN = ({
  row: s,
  handleShowDeleteModal: t
}) => {
  const a = () => {
    t(s.data);
  };
  return /* @__PURE__ */ e.jsx("div", { className: "flex py-8 px-4", children: /* @__PURE__ */ e.jsx(
    B,
    {
      dataTestId: "bulk-delete-restore-button",
      icon: /* @__PURE__ */ e.jsx(D, { name: "ic-delete", color: null }),
      component: me.button,
      style: q.negativeGrey,
      variant: U.borderLess,
      ariaLabel: "Delete Selected Restores",
      size: P.small,
      onClick: a,
      showAriaLabelInTippy: !1
    }
  ) });
}, uN = () => /* @__PURE__ */ e.jsx(jd, {}), pN = () => {
  const s = he(), t = ae(), [a, n] = E(!1), [o, r] = E(null), [l, i] = E(!1), { searchParams: u } = Re(), c = u[$n.ADD_RESTORE] === "true", p = Wt(
    async ({
      sortBy: f,
      sortOrder: h,
      searchKey: b,
      offset: S,
      pageSize: O,
      status: j,
      clusterName: v,
      createdBy: A
    }, N) => {
      try {
        n(!1);
        const L = await ZS({
          offset: S,
          pageSize: O,
          sortBy: f,
          sortOrder: h,
          searchKey: b,
          signal: N,
          status: j,
          clusterName: v,
          createdBy: A
        });
        return {
          rows: (L.data || []).map((M) => ({
            id: String(M.id),
            data: M
          })),
          totalRows: L.totalCount || 0
        };
      } catch (L) {
        throw L.code === Xo.PERMISSION_DENIED && n(!0), L;
      }
    },
    [l]
  ), d = (f) => {
    r(f);
  }, m = () => {
    r(null);
  }, _ = () => {
    const f = new URLSearchParams(s.search);
    f.delete($n.ADD_RESTORE), t.replace({
      pathname: s.pathname,
      search: f.toString()
    });
  }, g = () => {
    i((f) => !f);
  }, x = async (f, h) => {
    h !== "*" ? await Ad({
      id: h,
      signal: f.signal,
      showToast: !1,
      throwError: !0
    }) : Se.showToast({
      variant: Ne.error,
      description: "Coming Soon! Bulk delete of restores is not supported yet."
    });
  }, C = () => o ? /* @__PURE__ */ e.jsx(
    yd,
    {
      id: o.id,
      name: o.name,
      handleClose: m,
      handleSuccess: g
    }
  ) : c ? /* @__PURE__ */ e.jsx(co, { handleClose: _, onSuccess: g }) : null;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      oa,
      {
        id: "table__restore-list",
        columns: $S,
        emptyStateConfig: {
          noRowsConfig: {
            imgName: "img-no-restores",
            title: "Restore a backup",
            subTitle: "Restore a previously saved backup to a target cluster",
            isButtonAvailable: !0,
            renderButton: uN
          },
          noRowsForFilterConfig: {
            title: "No results",
            subTitle: "We couldn't find any matching results"
          }
        },
        paginationVariant: ra.PAGINATED,
        additionalFilterProps: {
          initialSortKey: Rt.name,
          parseSearchParams: vd
        },
        bulkSelectionConfig: {
          BulkActionsComponent: cN,
          bulkActionsData: null,
          BulkOperationModal: Er,
          bulkOperationModalData: {
            handleDelete: x,
            reloadDataAfterBulkOperation: g
          },
          getSelectAllDialogStatus: () => Qn.CLOSED
        },
        getRows: p,
        filtersVariant: la.URL,
        ViewWrapper: iN,
        additionalProps: {
          isUnauthorized: a,
          handleShowDeleteModal: d
        },
        filter: ks,
        rowActionOnHoverConfig: {
          width: 32,
          Component: dN
        }
      },
      `restore-list-table-${+l}`
    ),
    C()
  ] });
}, mN = () => {
  const s = he(), { breadcrumbs: t } = nt(Ed(s.pathname), [s.pathname]), a = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: t });
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__content-space flex-grow-1 h-100 dc__overflow-auto", children: [
    /* @__PURE__ */ e.jsx(xt, { isBreadcrumbs: !0, breadCrumbs: a }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto", children: /* @__PURE__ */ e.jsx(pN, {}) })
  ] });
}, hN = () => /* @__PURE__ */ e.jsxs(rt, { children: [
  /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION_RESTORES, exact: !0, children: /* @__PURE__ */ e.jsx(mN, {}) }, R.DATA_PROTECTION_RESTORES),
  /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION_RESTORES_DETAIL, children: /* @__PURE__ */ e.jsx(rN, {}) }, R.DATA_PROTECTION_RESTORES_DETAIL)
] }), _N = () => /* @__PURE__ */ e.jsxs(rt, { children: [
  /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION_OVERVIEW, exact: !0, children: /* @__PURE__ */ e.jsx(MS, {}) }, R.DATA_PROTECTION_OVERVIEW),
  /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, children: /* @__PURE__ */ e.jsx(Tb, {}) }, R.DATA_PROTECTION_BACKUP_AND_SCHEDULE),
  /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION_RESTORES, children: /* @__PURE__ */ e.jsx(hN, {}) }, R.DATA_PROTECTION_RESTORES),
  /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION_BACKUP_LOCATIONS, children: /* @__PURE__ */ e.jsx(CS, {}) }, R.DATA_PROTECTION_BACKUP_LOCATIONS),
  /* @__PURE__ */ e.jsx(pn, { to: R.DATA_PROTECTION_OVERVIEW, path: R.DATA_PROTECTION_OVERVIEW })
] }), dT = ({ AppConfig: s, OfflinePipelineModalAppView: t }) => {
  const { serverMode: a } = Ot();
  return /* @__PURE__ */ e.jsxs(rt, { children: [
    a === Vt.FULL && [
      /* @__PURE__ */ e.jsx(le, { path: R.APPLICATION_MANAGEMENT, children: /* @__PURE__ */ e.jsx(
        _f,
        {
          AppConfig: s,
          OfflinePipelineModalAppView: t
        }
      ) }),
      window._env_.FEATURE_STORAGE_ENABLE && /* @__PURE__ */ e.jsx(le, { path: R.DATA_PROTECTION, children: /* @__PURE__ */ e.jsx(_N, {}) })
    ],
    /* @__PURE__ */ e.jsx(le, { path: R.COST_VISIBILITY, children: /* @__PURE__ */ e.jsx(_x, {}) })
  ] });
}, fN = {
  UPGRADE_COMPATIBILITY: "upgrade-compatibility",
  COST_BREAKDOWN_QUERY_KEY: mc,
  COST_METADATA_QUERY_KEY: hc,
  COST_OPPORTUNITIES_QUERY_KEY: pc
}, gN = () => se({
  queryKey: [fN.UPGRADE_COMPATIBILITY],
  queryFn: ({ signal: s }) => xe(
    $e(z.UPGRADE_COMPATIBILITY, { excludeUpToDate: !0 }),
    { signal: s }
  ),
  select: ({ result: s }) => ({
    latestVersion: s?.latestVersion || "",
    canCurrentUserUpgrade: s?.canCurrentUserUpgrade || !1,
    clusterList: (s?.clusterList ?? []).map(({ endOfLife: t, ...a }) => ({
      ...a,
      ...t ? { endOfLife: Pe(t).format(ls.DD_MMM_YYYY) } : {}
    })).sort((t, a) => Ae(t.clusterName, a.clusterName, Ss.ASC))
  })
}), Jl = 5, xN = () => {
  const { push: s } = ae(), [t, a] = E(""), [n, o] = E(null), [r, l] = E(!1), { isFetching: i, isError: u, data: c, refetch: p } = gN(), { latestVersion: d, canCurrentUserUpgrade: m, clusterList: _ } = c || {}, g = de(
    () => r ? _ : _?.slice(0, Jl),
    [r, _]
  ), x = ({ clusterId: S, clusterName: O, currentVersion: j, upgradePath: v }) => () => {
    o({ clusterId: S, clusterName: O, currentVersion: j, upgradePath: v }), a(v?.[0] ?? "");
  }, C = () => {
    const S = Q(Fp.CLUSTER_UPGRADE, {
      clusterId: n.clusterId
    }), O = $e(S, {
      [Vp]: t
    });
    s(O);
  }, f = () => {
    o(null);
  }, h = () => {
    l((S) => !S);
  }, b = () => i ? Array(3).fill(0).map((S, O) => /* @__PURE__ */ e.jsx(
    "div",
    {
      className: "py-8 px-12",
      children: /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__gap-6", children: [
        /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-16 w-75 br-4" }),
        /* @__PURE__ */ e.jsx("div", { className: "shimmer-loading h-14 w-50 br-4" })
      ] })
    },
    `shimmer-${O}`
  )) : u || !c || !_ ? /* @__PURE__ */ e.jsx(hs, { subTitle: "", reload: p }) : _.length ? /* @__PURE__ */ e.jsx(e.Fragment, { children: (g ?? []).map(
    ({ clusterId: S, clusterName: O, currentVersion: j, upgradePath: v, endOfLife: A }) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "py-8 px-12 dc__visible-hover dc__visible-hover--parent dc__hover-n50 br-8 flexbox-col dc__gap-2",
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flexbox dc__content-space", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col", children: [
              /* @__PURE__ */ e.jsx("span", { className: "fs-13 fw-4 cn-9 lh-1-5 dc__truncate", children: O }),
              /* @__PURE__ */ e.jsxs("span", { className: "fs-12 fw-4 cn-7 lh-1-5 dc__truncate", children: [
                "v",
                j
              ] })
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__align-start dc__visible-hover--child", children: /* @__PURE__ */ e.jsx(
              B,
              {
                dataTestId: `upgrade-button-${S}`,
                icon: /* @__PURE__ */ e.jsx(D, { name: "ic-logs", color: null }),
                ariaLabel: "Upgrade cluster",
                showAriaLabelInTippy: !1,
                size: P.xxs,
                variant: U.borderLess,
                onClick: x({
                  clusterId: S,
                  clusterName: O,
                  currentVersion: j,
                  upgradePath: v
                }),
                disabled: !m,
                showTooltip: !0,
                tooltipProps: {
                  content: m ? "Check compatibility" : "You are not authorized to check compatibility"
                }
              }
            ) })
          ] }),
          A && /* @__PURE__ */ e.jsx(
            yt,
            {
              variant: "warning",
              label: `Upgrade before ${A}`,
              startIconProps: {
                name: "ic-warning-stroke"
              },
              size: P.xxxs
            }
          )
        ]
      },
      `${S}-${O}`
    )
  ) }) : /* @__PURE__ */ e.jsx(
    cn,
    {
      iconName: "ic-party",
      title: "All upgraded",
      subtitle: "All clusters are on latest K8s version"
    }
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col br-8 border__secondary bg__primary", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "py-12 px-16 flexbox-col border__secondary--bottom", children: [
        /* @__PURE__ */ e.jsx("h4", { className: "fw-6 fs-13 m-0 cn-9 lh-1-5", children: "Check cluster update compatibility" }),
        i ? /* @__PURE__ */ e.jsx("span", { className: "w-100px h-16 mt-2 shimmer" }) : c?.latestVersion && /* @__PURE__ */ e.jsxs("span", { className: "fs-12 fw-4 cn-7 lh-1-5", children: [
          "Latest stable Kubernetes version is ",
          d
        ] })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flexbox-col p-8", children: b() }),
      _?.length > Jl && /* @__PURE__ */ e.jsx("div", { className: "flex left border__secondary--top px-16 py-8", children: /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "show-all-upgradable-clusters",
          text: r ? "Show less" : "Show all",
          variant: U.text,
          onClick: h,
          endIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-caret-down-small", color: null, rotateBy: r ? 180 : 0 })
        }
      ) })
    ] }),
    n && /* @__PURE__ */ e.jsx(
      Du,
      {
        clusterName: n.clusterName,
        currentVersion: n.currentVersion,
        latestVersion: d,
        handleCloseClusterDialog: f,
        handleOpenScanClusterTab: C,
        targetVersion: t,
        setTargetVersion: a,
        clusterListOptions: (n.upgradePath ?? []).map(
          (S) => Mu({
            version: S,
            isLatest: S === d
          })
        )
      }
    )
  ] });
}, uT = () => {
  const { data: s, isFetching: t } = fc();
  return /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 bg__primary border__secondary--left dc__overflow-hidden", children: [
    /* @__PURE__ */ e.jsx("div", { className: "p-16 border__secondary--bottom", children: /* @__PURE__ */ e.jsx("span", { className: "fs-14 fw-6 lh-1-5 cn-9", children: "Actions & Insights" }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12 p-16 dc__overflow-auto", children: [
      /* @__PURE__ */ e.jsx(
        wc,
        {
          category: V.CLUSTERS,
          currency: s?.defaultCurrency,
          isCurrencyLoading: t
        }
      ),
      /* @__PURE__ */ e.jsx(xN, {})
    ] })
  ] });
}, pT = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col dc__gap-12", children: [
  /* @__PURE__ */ e.jsx("div", { className: "flexbox dc__content-space dc__align-items-center", children: /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "fs-20 fw-4 lh-1-5 cn-9 m-0", children: "Cost Visibility" }),
    /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "redirect-to-cost-visibility",
        icon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-square-out", color: null }),
        ariaLabel: "Cost Visibility",
        showAriaLabelInTippy: !0,
        variant: U.borderLess,
        style: q.neutral,
        size: P.small,
        component: me.link,
        linkProps: {
          to: R.COST_BREAKDOWN_CLUSTERS
        }
      }
    )
  ] }) }),
  /* @__PURE__ */ e.jsx(Cc, { hideCategoryFilter: !0 })
] }), CN = [
  {
    title: "Deployment Window",
    dataTestId: "click-on-policies-deployment-window",
    id: "application-management-policies-deployment-window",
    href: Ce.APPLICATION_MANAGEMENT_POLICIES_DEPLOYMENT_WINDOW,
    keywords: ["policy"]
  },
  {
    title: "Approval Policy",
    dataTestId: "click-on-policies-approval-policy",
    id: "application-management-policies-approval-policy",
    href: Ce.APPROVAL_POLICY_LIST,
    keywords: ["policy"]
  },
  {
    title: "Plugin Policy",
    dataTestId: "click-on-policies-plugin-policy",
    id: "application-management-policies-plugin-policy",
    href: Ce.PLUGIN_POLICY_PROFILE_LIST,
    keywords: ["policy"]
  },
  {
    title: "Pull Image Digest",
    dataTestId: "click-on-policies-pull-image-digest",
    id: "application-management-policies-pull-image-digest",
    href: Ce.APPLICATION_MANAGEMENT_POLICIES_PULL_IMAGE_DIGEST,
    keywords: ["policy"]
  },
  {
    title: "Tag Policy",
    dataTestId: "click-on-policies-tag-policy",
    id: "application-management-policies-tag-policy",
    href: Ce.APPLICATION_MANAGEMENT_POLICIES_TAG_POLICY,
    keywords: ["policy"]
  },
  {
    title: "Filter Conditions",
    dataTestId: "click-on-policies-filter-conditions",
    id: "application-management-policies-filter-conditions",
    href: Ce.APPLICATION_MANAGEMENT_POLICIES_FILTER_CONDITIONS,
    keywords: ["policy"]
  },
  {
    title: "Image Promotion",
    dataTestId: "click-on-policies-image-promotion",
    id: "application-management-policies-image-promotion",
    href: Ce.APPLICATION_MANAGEMENT_POLICIES_IMAGE_PROMOTION,
    keywords: ["policy"],
    forceHideEnvKey: "FEATURE_IMAGE_PROMOTION_ENABLE"
  },
  {
    title: "Lock Deployment Configuration",
    dataTestId: "click-on-policies-lock-deployment-configuration",
    id: "application-management-policies-lock-deployment-configuration",
    href: Ce.APPLICATION_MANAGEMENT_POLICIES_LOCK_DEPLOYMENT_CONFIGURATION,
    keywords: ["policy"]
  }
], bN = [
  {
    title: "Clusters",
    dataTestId: "cost-breakdown-clusters",
    id: "cost-visibility-cost-breakdown-clusters",
    href: R.COST_BREAKDOWN_CLUSTERS,
    keywords: ["cost"],
    isAvailableInEA: !0
  },
  {
    title: "Environments",
    dataTestId: "cost-breakdown-environments",
    id: "cost-visibility-cost-breakdown-environments",
    href: R.COST_BREAKDOWN_ENVIRONMENTS,
    keywords: ["cost"]
  },
  {
    title: "Projects",
    dataTestId: "cost-breakdown-projects",
    id: "cost-visibility-cost-breakdown-projects",
    href: R.COST_BREAKDOWN_PROJECTS,
    keywords: ["cost"]
  },
  {
    title: "Applications",
    dataTestId: "cost-breakdown-applications",
    id: "cost-visibility-cost-breakdown-applications",
    href: R.COST_BREAKDOWN_APPLICATIONS,
    keywords: ["cost"]
  }
], mT = {
  title: "Policies",
  dataTestId: "click-on-policies",
  id: "application-management-policies",
  hasSubMenu: !0,
  subItems: CN
}, hT = {
  title: "Application Templates",
  dataTestId: "click-on-application-templates",
  id: "application-management-application-templates",
  icon: "ic-application-template",
  href: R.APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP,
  forceHideEnvKey: "FEATURE_APPLICATION_TEMPLATES_ENABLE"
}, _T = {
  title: "Resource Watcher",
  dataTestId: "resource-watcher",
  id: "infrastructure-management-resource-watcher",
  icon: "ic-resource-watcher",
  href: R.INFRASTRUCTURE_MANAGEMENT_RESOURCE_WATCHER,
  forceHideEnvKey: "FEATURE_RESOURCE_WATCHER_ENABLE",
  isAvailableInEA: !0
}, fT = {
  title: "Security Enablement",
  dataTestId: "security-enablement",
  id: "security-center-security-enablement",
  href: R.SECURITY_CENTER_SECURITY_ENABLEMENT,
  icon: "ic-security-scan"
}, gT = {
  id: "software-release-management",
  title: "Software Release Management",
  icon: "ic-software-release-management",
  items: [
    {
      title: "Overview",
      dataTestId: "software-release-management-overview",
      id: "software-release-management-overview",
      icon: "ic-chart-line-up",
      href: "/dummy-url",
      disabled: !0
    },
    {
      title: "Release Hub",
      dataTestId: "release-hub",
      id: "software-release-management-release-hub",
      icon: "ic-release-hub",
      href: Ce.RELEASES
    },
    {
      title: "Tenants",
      dataTestId: "tenants",
      id: "software-release-management-tenants",
      icon: "ic-tenants",
      href: Ce.TENANTS
    }
  ],
  forceHideEnvKey: "FEATURE_SOFTWARE_DISTRIBUTION_HUB_ENABLE"
}, xT = {
  id: "cost-visibility",
  title: "Cost Visibility",
  icon: "ic-cost-visibility",
  items: [
    {
      title: "Overview",
      dataTestId: "cost-visibility-overview",
      id: "cost-visibility-overview",
      icon: "ic-chart-line-up",
      href: R.COST_VISIBILITY_OVERVIEW,
      isAvailableInEA: !0
    },
    {
      title: "Cost Breakdown",
      dataTestId: "cost-breakdown",
      id: "cost-visibility-cost-breakdown",
      hasSubMenu: !0,
      subItems: bN,
      isAvailableInEA: !0
    },
    {
      title: "Configurations",
      dataTestId: "cost-visibility-configurations",
      id: "cost-visibility-configurations",
      icon: "ic-gear",
      href: R.COST_CONFIGURATIONS,
      isAvailableInEA: !0
    }
  ],
  isAvailableInEA: !0
}, CT = {
  title: "Data Protection Management",
  id: "data-protection-management",
  icon: "ic-database-backup",
  items: [
    {
      title: "Overview",
      dataTestId: "data-protection-overview",
      id: "data-protection-overview",
      icon: "ic-chart-line-up",
      href: R.DATA_PROTECTION_OVERVIEW
    },
    {
      title: "Backup & Schedule",
      dataTestId: "data-protection-backup-and-schedule",
      id: "data-protection-backup-and-schedule",
      icon: "ic-backup-and-schedule",
      href: Q(R.DATA_PROTECTION_BACKUP_AND_SCHEDULE, { view: "backups" })
    },
    {
      title: "Restores",
      dataTestId: "data-protection-restores",
      id: "data-protection-restores",
      icon: "ic-clock-counterclockwise",
      href: R.DATA_PROTECTION_RESTORES
    },
    {
      title: "Backup Locations",
      dataTestId: "backup-locations",
      id: "data-protection-backup-locations",
      icon: "ic-backup-location",
      href: Q(R.DATA_PROTECTION_BACKUP_LOCATIONS, {
        type: ge.VOLUME_SNAPSHOT
      })
    }
  ],
  forceHideEnvKey: "FEATURE_STORAGE_ENABLE"
}, SN = () => {
  const { breadcrumbs: s } = nt(
    {
      alias: {
        ...Gp(),
        "security-enablement": {
          component: /* @__PURE__ */ e.jsx(tt, { heading: "Security Enablement", isActive: !0 })
        }
      }
    },
    []
  ), t = () => /* @__PURE__ */ e.jsx(ot, { breadcrumbs: s });
  return /* @__PURE__ */ e.jsx(xt, { isBreadcrumbs: !0, breadCrumbs: t, docPath: sr.SECURITY_CENTER });
};
var qa = /* @__PURE__ */ ((s) => (s.SCAN_ENABLED = "scanEnabled", s.SCAN_NOT_ENABLED = "scanNotEnabled", s.ALL = "all", s))(qa || {}), xa = /* @__PURE__ */ ((s) => (s.APP_NAME = "appName", s.WORKFLOW_NAME = "workflowName", s.SCAN_ENABLED = "scanEnabled", s.ENVIRONMENTS = "environments", s))(xa || {}), Kn = /* @__PURE__ */ ((s) => (s.ENABLE = "enable-security-scan", s.DISABLE = "disable-security-scan", s))(Kn || {});
const Od = (s) => ({
  workflowScanType: s.get("workflowScanType") || qa.ALL,
  application: s.getAll("application") || [],
  environment: s.getAll("environment") || [],
  cluster: s.getAll("cluster") || []
}), NN = (s) => {
  const t = new URLSearchParams(s);
  return {
    ...Od(t),
    searchQuery: t.get(Ai.SEARCH_KEY) || ""
  };
}, Id = (s, t) => $e(`${R.APPLICATION_MANAGEMENT_APP}/${s}/${R.APP_CONFIG}/workflow`, {
  workflowName: t
}), EN = ({
  row: s
}) => {
  const { data: t } = s, { workflowName: a } = t;
  return /* @__PURE__ */ e.jsx("div", { className: "flex left py-10", children: /* @__PURE__ */ e.jsx(we, { content: a, children: /* @__PURE__ */ e.jsx(as, { className: "dc__truncate", to: Id(`${t.appId}`, a), children: a }) }) });
}, vN = ({
  row: s
}) => {
  const { data: t } = s;
  return /* @__PURE__ */ e.jsx("div", { className: "flex left py-10", children: /* @__PURE__ */ e.jsx(we, { content: t.environments, children: /* @__PURE__ */ e.jsx("span", { className: "dc__truncate", children: t.environments }) }) });
}, TN = [
  {
    label: "All Workflows",
    value: qa.ALL
  },
  {
    label: "Scan enabled",
    value: qa.SCAN_ENABLED
  },
  {
    label: "Scan not enabled",
    value: qa.SCAN_NOT_ENABLED
  }
], AN = [
  {
    items: [
      { id: "application", label: "Application" },
      { id: "environment", label: "Environment" },
      { id: "cluster", label: "Cluster" }
    ]
  }
], yN = [
  {
    label: "Enable Security Scan",
    value: Kn.ENABLE
  },
  {
    label: "Disable Security Scan",
    value: Kn.DISABLE
  }
], jN = {
  alreadyDisabled: {
    title: "Already Disabled",
    iconName: "ic-success",
    color: "G500"
  },
  alreadyEnabled: {
    title: "Already Enabled",
    iconName: "ic-success",
    color: "G500"
  },
  succeeded: {
    title: "Succeeded",
    iconName: "ic-success",
    color: "G500"
  },
  failed: {
    title: "Failed",
    iconName: "ic-error",
    color: "R500"
  },
  notAuthorized: {
    title: "Not Authorized",
    iconName: "ic-locked",
    color: "Y500"
  },
  cannotEnable: {
    title: "Cannot Enable",
    iconName: "ic-error",
    color: "R500"
  },
  cannotDisable: {
    title: "Cannot Disable",
    iconName: "ic-error",
    color: "R500"
  }
}, ON = [
  {
    label: "Workflow Name",
    field: xa.WORKFLOW_NAME,
    size: {
      fixed: 200
    },
    isSortable: !0,
    CellComponent: EN
  },
  {
    label: "App Name",
    field: xa.APP_NAME,
    size: {
      fixed: 200
    },
    isSortable: !0
  },
  {
    label: "Environments",
    field: xa.ENVIRONMENTS,
    size: {
      fixed: 300
    },
    CellComponent: vN
  },
  {
    label: "Scan",
    field: xa.SCAN_ENABLED,
    size: {
      fixed: 200
    },
    isSortable: !0
  }
], IN = async ({
  offset: s,
  pageSize: t,
  searchKey: a,
  sortBy: n,
  sortOrder: o,
  workflowScanType: r,
  application: l,
  environment: i,
  cluster: u
}) => {
  const c = await _s(z.SCAN_WORKFLOW_LIST, {
    offset: s,
    size: t,
    sortBy: n,
    sortOrder: o,
    searchQuery: a,
    scanEnablement: r,
    appIds: l.map(Number),
    envIds: i.map(Number),
    clusterIds: u.map(Number)
  });
  return {
    totalRows: c.result?.total ?? 0,
    rows: (c.result?.workflows ?? []).map(
      ({ workflowId: p, workflowName: d, appId: m, appName: _, environments: g, scanEnabled: x }) => ({
        id: `${p}-${d}-${m}`,
        data: {
          workflowId: p,
          workflowName: d,
          appId: m,
          appName: _,
          environments: (g ?? []).join(", "),
          scanEnabled: x ? "Enabled" : "Not Enabled"
        }
      })
    )
  };
}, wN = () => Wp({
  mutationFn: (s) => _s(z.SCAN_UPDATE_SCANNING, {
    ...s
  })
}), PN = () => {
  const { isResourcesOptionsLoading: s, refetchResourcesOptions: t, resourcesOptionsError: a, resourcesOptionsMap: n } = $p({
    resourcesToFetch: [
      Is.devtronApplication,
      Is.cluster,
      Is.environment
    ]
  });
  return {
    appOptions: (n[Is.devtronApplication] ?? []).reduce((o, r) => (o.push(...r.appList.map((l) => ({ label: l.name, value: `${l.id}` }))), o), []).sort((o, r) => Ae(o.label, r.label)),
    environmentOptions: (n[Is.environment] ?? []).flatMap(
      ({ envList: o }) => o.map((r) => ({
        label: r.name,
        value: `${r.id}`
      }))
    ).sort((o, r) => Ae(o.label, r.label)),
    clusterOptions: (n[Is.cluster] ?? []).map(({ name: o, id: r }) => ({
      label: o,
      value: `${r}`
    })).sort((o, r) => Ae(o.label, r.label)),
    isResourcesOptionsLoading: s,
    refetchResourcesOptions: t,
    resourcesOptionsError: a
  };
}, RN = ({ onActionClick: s }) => {
  const t = (a) => {
    const n = {
      currentTarget: {
        dataset: {
          key: a.value
        }
      }
    };
    setTimeout(() => {
      s(n);
    }, 100);
  };
  return /* @__PURE__ */ e.jsx(
    te,
    {
      inputId: "enable-disable-security-scan",
      options: yN,
      placeholder: "Enable/Disable Security Scan",
      onChange: t,
      value: null,
      menuPosition: "absolute",
      isSearchable: !1
    }
  );
}, LN = ({ scanEnableTriggerStatus: s }) => {
  const { title: t, iconName: a, color: n } = jN[s];
  return /* @__PURE__ */ e.jsxs("div", { className: "flex left dc__gap-8", children: [
    /* @__PURE__ */ e.jsx(D, { name: a, color: n }),
    /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-9 fw-4", children: t })
  ] });
}, kN = ({
  headerTitle: s,
  handleClose: t,
  isBulkScanEnable: a,
  mutationProps: { isPending: n, isError: o, error: r, data: l, mutate: i }
}) => {
  const { handleSorting: u, sortBy: c, sortOrder: p } = qn({
    initialSortKey: "workflowName"
  }), d = (f) => () => {
    u(f);
  }, m = de(
    () => (l?.result?.workflows ?? []).sort(
      (f, h) => Ae(f[c], h[c], p)
    ),
    [l, c, p]
  ), _ = de(
    () => (l?.result?.workflows ?? []).filter((f) => f.scanEnableTriggerStatus === "failed"),
    [l]
  ), g = _.length, x = () => {
    const f = {
      workflowIds: _.map((h) => h.workflowId),
      enableScanning: a
    };
    i(f);
  }, C = () => n ? /* @__PURE__ */ e.jsx(
    Xe,
    {
      title: "Operation in progress",
      image: /* @__PURE__ */ e.jsx(pi, { name: "img-mechanical-operation" })
    }
  ) : o ? /* @__PURE__ */ e.jsx(_t, { code: r?.code }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "px-20 py-6 dc__grid trigger-status-row", children: [
      /* @__PURE__ */ e.jsx(
        Da,
        {
          title: "Workflow Name",
          isSortable: !0,
          triggerSorting: d("workflowName"),
          sortOrder: p,
          disabled: !1,
          isSorted: c === "workflowName"
        }
      ),
      /* @__PURE__ */ e.jsx(
        Da,
        {
          title: "App Name",
          isSortable: !0,
          triggerSorting: d("appName"),
          sortOrder: p,
          disabled: !1,
          isSorted: c === "appName"
        }
      ),
      /* @__PURE__ */ e.jsx(
        Da,
        {
          title: "Environments",
          isSortable: !1,
          triggerSorting: ks,
          sortOrder: Ss.ASC,
          disabled: !1,
          isSorted: !1
        }
      ),
      /* @__PURE__ */ e.jsx(
        Da,
        {
          title: "Trigger Status",
          isSortable: !0,
          triggerSorting: d("scanEnableTriggerStatus"),
          sortOrder: p,
          disabled: !1,
          isSorted: c === "scanEnableTriggerStatus"
        }
      ),
      /* @__PURE__ */ e.jsx(
        Da,
        {
          title: "Message",
          isSortable: !1,
          triggerSorting: ks,
          sortOrder: Ss.ASC,
          disabled: !1,
          isSorted: !1
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 mh-0 dc__overflow-auto", children: m.map(
      ({
        workflowId: f,
        workflowName: h,
        appName: b,
        appId: S,
        environments: O,
        scanEnableTriggerStatus: j,
        message: v
      }) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "dc__grid trigger-status-row px-20 py-12",
          children: [
            /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(we, { content: h, children: /* @__PURE__ */ e.jsx(
              as,
              {
                className: "fs-13 lh-20 fw-4 dc__truncate",
                to: Id(`${S}`, h),
                children: h
              }
            ) }) }),
            /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(we, { content: b, children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-9 fw-4 dc__truncate", children: b }) }) }),
            /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(we, { content: (O ?? []).join(", "), children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-9 fw-4 dc__truncate", children: (O ?? []).join(", ") }) }) }),
            /* @__PURE__ */ e.jsx(LN, { scanEnableTriggerStatus: j }),
            /* @__PURE__ */ e.jsx(we, { content: v, children: /* @__PURE__ */ e.jsx("span", { className: "fs-13 lh-20 cn-9 fw-4 dc__truncate", children: v }) })
          ]
        },
        `${f}-${h}-${b}`
      )
    ) })
  ] });
  return /* @__PURE__ */ e.jsx(Vs, { position: "right", width: "1024px", onClose: t, onEscape: t, children: /* @__PURE__ */ e.jsxs("div", { className: "bg__primary h-100 flexbox-col flex-grow-1", onClick: Rs, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex dc__content-space px-20 py-12 border__secondary--bottom", children: [
      /* @__PURE__ */ e.jsx("span", { className: "fs-16 fw-6 lh-24 cn-9", children: s }),
      /* @__PURE__ */ e.jsx(
        B,
        {
          dataTestId: "close-status-drawer",
          onClick: t,
          icon: /* @__PURE__ */ e.jsx(D, { name: "ic-close-large", color: null }),
          ariaLabel: "Close",
          showAriaLabelInTippy: !1,
          size: P.xs,
          variant: U.borderLess,
          style: q.negativeGrey
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden", children: C() }),
    !n && !o && g > 0 && /* @__PURE__ */ e.jsx("div", { className: "flex right px-20 py-12 border__secondary--top", children: /* @__PURE__ */ e.jsx(
      B,
      {
        dataTestId: "retry-failed",
        startIcon: /* @__PURE__ */ e.jsx(D, { name: "ic-arrow-clockwise", color: null }),
        text: "Retry failed",
        onClick: x
      }
    ) })
  ] }) });
}, DN = ({
  action: s,
  onClose: t,
  selections: a,
  bulkOperationModalData: { reloadAfterBulkAction: n }
}) => {
  const { search: o } = he(), { checkboxValue: r } = nr(), { mutate: l, ...i } = wN(), [u, c] = E(!1), p = s === Kn.ENABLE, { application: d, environment: m, cluster: _, searchQuery: g, workflowScanType: x } = NN(o), C = r === De.BULK_CHECKED ? {
    appIds: d.map(Number),
    envIds: m.map(Number),
    clusterIds: _.map(Number),
    scanEnablement: x,
    enableScanning: p,
    searchQuery: g
  } : {
    workflowIds: a.map((S) => S.data.workflowId),
    enableScanning: p
  }, f = () => {
    c(!0), l(C);
  }, h = () => {
    t(), c(!1), n();
  };
  return u ? /* @__PURE__ */ e.jsx(
    kN,
    {
      isBulkScanEnable: p,
      handleClose: h,
      headerTitle: `Scan ${p ? "Enablement" : "Disablement"} Status`,
      mutationProps: { ...i, mutate: l }
    }
  ) : /* @__PURE__ */ e.jsx(
    vt,
    {
      title: `Bulk security scan ${p ? "enablement" : "disablement"} works only for workflows that have build pipelines.`,
      subtitle: "If a workflow doesn’t include a build pipeline, you can still manage security scanning via plugins.",
      variant: mt.info,
      buttonConfig: {
        primaryButtonConfig: {
          text: p ? "Enable Scan" : "Disable Scan",
          onClick: f
        },
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: t
        }
      },
      handleClose: t
    }
  );
}, MN = ({
  children: s,
  handleSearch: t,
  updateSearchParams: a,
  workflowScanType: n,
  application: o,
  environment: r,
  cluster: l,
  clearFilters: i,
  searchKey: u
}) => {
  const {
    appOptions: c,
    environmentOptions: p,
    clusterOptions: d,
    isResourcesOptionsLoading: m,
    refetchResourcesOptions: _,
    resourcesOptionsError: g
  } = PN(), x = (S) => {
    a({
      workflowScanType: S.value
    });
  }, C = (S) => (O) => {
    a({
      [S]: O.map((j) => j.value)
    });
  }, f = (S, O) => {
    switch (S) {
      case "application":
        return Xt(c, O)?.label ?? O;
      case "environment":
        return Xt(p, O)?.label ?? O;
      case "cluster":
        return Xt(d, O)?.label ?? O;
      default:
        return O;
    }
  }, h = {
    isDisabled: m,
    isLoading: m,
    reloadOptionList: _,
    optionListError: g
  }, b = {
    application: {
      ...h,
      placeholder: "Select Application",
      inputId: "workflow-scan-list-application-filter",
      options: c,
      appliedFilterOptions: xo(c, o),
      handleApplyFilter: C("application")
    },
    environment: {
      ...h,
      placeholder: "Select Environment",
      inputId: "workflow-scan-list-environment-filter",
      options: p,
      appliedFilterOptions: xo(p, r),
      handleApplyFilter: C("environment")
    },
    cluster: {
      ...h,
      placeholder: "Select Cluster",
      inputId: "workflow-scan-list-cluster-filter",
      options: d,
      appliedFilterOptions: xo(d, l),
      handleApplyFilter: C("cluster")
    }
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: "p-16 flex dc__content-space", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex dc__gap-8", children: [
        /* @__PURE__ */ e.jsx(
          ca,
          {
            name: "workflow-list-scan-segments",
            segments: TN,
            value: n,
            onChange: x
          }
        ),
        /* @__PURE__ */ e.jsx(
          aa,
          {
            inputProps: { placeholder: "Search workflow" },
            handleEnter: t,
            keyboardShortcut: "/",
            initialSearchText: u
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx(
        Na,
        {
          id: "workflow-scan-list-filters",
          options: AN,
          filterSelectPickerPropsMap: b,
          isFilterApplied: !!(o.length || r.length || l.length)
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      Jn,
      {
        filterConfig: {
          application: o,
          environment: r,
          cluster: l
        },
        clearFilters: i,
        onRemoveFilter: a,
        className: "px-20",
        getFormattedValue: f
      }
    ),
    s
  ] });
}, BN = () => {
  const { replace: s } = ae(), { pathname: t } = he(), { handleBulkSelection: a } = nr(), [n, o] = E(!1), r = () => {
    a({ action: fi.CLEAR_ALL_SELECTIONS }), s(t), o((l) => !l);
  };
  return /* @__PURE__ */ e.jsx(
    oa,
    {
      id: "table__workflow-scan-list",
      columns: ON,
      getRows: IN,
      emptyStateConfig: {
        noRowsConfig: {
          title: "No workflows found"
        }
      },
      filtersVariant: la.URL,
      filter: () => !0,
      paginationVariant: ra.PAGINATED,
      ViewWrapper: MN,
      additionalFilterProps: {
        initialSortKey: xa.WORKFLOW_NAME,
        parseSearchParams: Od
      },
      bulkSelectionConfig: {
        BulkActionsComponent: RN,
        getSelectAllDialogStatus: () => Qn.CLOSED,
        BulkOperationModal: DN,
        bulkActionsData: {},
        bulkOperationModalData: {
          reloadAfterBulkAction: r
        }
      }
    },
    `${n}`
  );
}, bT = () => /* @__PURE__ */ e.jsxs("div", { className: "flexbox-col flex-grow-1 dc__overflow-hidden", children: [
  /* @__PURE__ */ e.jsx(SN, {}),
  /* @__PURE__ */ e.jsx(BN, {})
] });
export {
  ET as AIChat,
  vT as AIResponseWidget,
  TT as ALLOWED_ADDITIONAL_ROLES_MAP,
  mT as APPLICATION_MANAGEMENT_POLICIES_NAV_ITEM,
  hT as APPLICATION_MANAGEMENT_TEMPLATES_NAV_ITEM,
  uT as ActionsAndInsights,
  Bv as AllowedWithWarningTippy,
  lI as AppDetailsDownloadCard,
  AT as ApplyResourceRecommendationModal,
  yT as ApprovalCountBadge,
  jT as ApprovalEmptyState,
  OT as ApprovalInfoTippy,
  IT as ApprovalMaterial,
  wT as ApprovalMaterialModal,
  PT as ApprovalNodeEdge,
  Pu as ApprovalPolicy,
  RT as ApproveRequestTippy,
  LT as ApprovedImagesMessage,
  kT as AskValueAtRuntimeCheckbox,
  DT as AssignCategorySelect,
  MT as AuthenticationTypeRadio,
  Zv as AuthorizationGlobalConfigWrapper,
  eT as AutoAssignToggleTile,
  BT as BADGE_BASE_CLASS,
  UT as BULK_EDIT_README_OPTIONS,
  FT as BULK_EDIT_VALIDATOR_SCHEMA,
  lT as BestPractices,
  VT as BitBucketDCCredentials,
  GT as BitbucketCloudAndServerToggleSection,
  WT as BuildInfraRouter,
  $T as BulkCDStrategy,
  KT as BulkDeployLink,
  iI as BulkDeployResistanceTippy,
  HT as BulkManageTrafficDrawer,
  YT as BulkStatusUpdateDropdown,
  kv as CDMaterialInfo,
  cI as CIListHeader,
  xT as COST_VISIBILITY_NAV_GROUP,
  zT as CacheConfiguration,
  dI as Catalog,
  qT as ChangeImageSource,
  XT as ChartCategoryFilters,
  JT as ChartSecurityTab,
  QT as ClonePipelineMenuButton,
  ZT as ClonePipelineModal,
  eA as ClusterAddOns,
  sA as ClusterBulkSelectionActionWidget,
  tA as ClusterConfig,
  aA as ClusterConfigContent,
  nA as ClusterCostConfig,
  pT as ClusterCostVisibility,
  oA as ClusterInstallationStatusDialog,
  rA as CompareClusterButton,
  lA as CompareClusterViewWrapper,
  iA as CompareFromApprovalSelector,
  cA as ConfigApproversInfoTippy,
  dA as ConfigDriftModal,
  uA as ConfigMapSecretApproveButton,
  pA as ConfigSyncStatusButton,
  mA as ConfigurableGUIViewModel,
  hA as ConfigurableGUIViewPanel,
  uI as ConfigurationsAppEnvSelector,
  _A as ConfigurePatchDialog,
  fA as ConfiguredFilters,
  iT as CostMetrics,
  cT as CostVisibilityRenderProvider,
  gA as CreateClusterForm,
  CT as DATA_PROTECTION_MANAGEMENT_NAV_GROUP,
  xA as DEPLOYMENT_APPROVER_ROLE_VALUE,
  CA as DISABLE_DATA_TYPE_CHANGE_HELPER_MESSAGE,
  bA as DISABLE_DELETE_TOOLTIP_TEXT,
  SA as DeleteModal,
  NA as DeleteOverrideDraftModal,
  vv as DependencyList,
  EA as DeploymentApprovalInfo,
  vA as DeploymentChartActionButton,
  TA as DeploymentChartDetailRouter,
  pI as DeploymentHistoryTriggerMetaText,
  AA as DeploymentStrategyCard,
  yA as DeploymentTemplateLockedDiff,
  wu as DeploymentWindow,
  Av as DeploymentWindowConfirmationDialog,
  yv as DeploymentWindowInfoBar,
  Iv as DeploymentWindowModal,
  jv as DeploymentWindowOverview,
  Ov as DeploymentWindowStatusCard,
  Iv as DeploymentWindowStatusModal,
  jA as DeprecatedTag,
  Fr as DevtronAppTemplates,
  OA as DownloadFileFolderButton,
  IA as DownloadManifestForVirtualEnvironmentButton,
  wA as DraftComments,
  PA as DryRunEditorModeSelect,
  dT as EnterpriseRouter,
  RA as EnvironmentLabels,
  Tv as ExcludedUsersDescription,
  LA as ExpireApproval,
  ju as ExplainWithAIButton,
  Cv as ExpressDeleteDraftModal,
  bv as ExpressEditButton,
  Sv as ExpressEditConfirmationModal,
  kA as ExpressEditDeploymentTemplateCTA,
  Nv as ExpressEditDiffEditor,
  Ev as ExpressEditHeader,
  DA as FilterActionBar,
  Jv as FilterButton,
  Dv as FilterConditions,
  mI as GeneratedHelmDownload,
  Pv as GenericDirectApprovalModal,
  hI as HelmManifestPush,
  MA as HibernationRulesModal,
  fN as INFRA_OVERVIEW_QUERY_KEYS,
  Ru as ImagePromotion,
  BA as ImagePromotionInfoChip,
  UA as ImagePromotionLink,
  FA as KubeConfigButton,
  VA as KubeConfigModal,
  GA as KubeConfigRowCheckbox,
  WA as LINKED_CD_SOURCE_VARIANT,
  $A as LicenseInfoDialog,
  Rv as LinkedCDNode,
  ku as LockDeploymentConfiguration,
  KA as MANGER_ROLE_DEPRECATION_WARNING,
  HA as MONITORING_DASHBOARD_TAB_NAME,
  wv as MaintenanceWindowInfoBar,
  YA as ManageAllAccessToggle,
  zA as ManageCategories,
  qA as ManageCategoryButton,
  XA as ManageTrafficButton,
  JA as ManageTrafficDrawer,
  Uv as MandatoryPluginWarning,
  nT as MandatoryTagWarning,
  QA as MandatoryTagsContainer,
  ZA as ManifestGUIView,
  ey as ManualApproval,
  sy as MergePatchWithTemplateCheckbox,
  ty as MigrateClusterVersionInfoBar,
  Fv as MissingPluginBlockState,
  ay as MonitoringDashboard,
  ny as NetworkStatusInterface,
  oy as OCIRegistryUseActionHelmPushMessage,
  ry as OpenSecurityModalButton,
  ly as OtherGitOpsForm,
  Cc as OverviewCostBreakdown,
  _I as PartOfReleaseTrack,
  iy as PatchStrategyTooltipInfo,
  sT as PermissionGroupInfoBar,
  Vv as PipelineTaskActionConfirmationDialog,
  Lu as PluginsPolicy,
  Hv as PodRestart,
  Yv as PodRestartIcon,
  Kv as PodRestartModal,
  cy as PodSpreadModal,
  Gv as PolicyEnforcementMessage,
  dy as ProtectConfigShowCommentsButton,
  uy as ProtectedDeploymentTemplateCTA,
  py as ProtectionViewTabGroup,
  my as ProtectionViewToolbarPopupNode,
  T_ as PullImageDigest,
  hy as RBBulkOperations,
  _y as RBBulkSelectionActions,
  fy as RBPageHeaderPopup,
  gy as RBRestartWorkloadModal,
  xy as RB_MONITORING_DRAGGABLE_HANDLE_CLASS,
  Cy as REDFISH_COMPONENTS_BASE_CLASS,
  by as REDFISH_NODE_UI_TABS,
  Xs as RESOURCE_FILTER_KEYS,
  Sy as RESOURCE_RECOMMENDER_HEADER_TO_TITLE_MAP,
  Ny as RESOURCE_RECOMMENDER_HEADER_TO_WIDTH_MAP,
  _T as RESOURCE_WATCHER_NAV_ITEM,
  Ce as ROUTER_URLS,
  fI as RegistryHelmPushCheckbox,
  Xv as RemoteConnectionRadio,
  gI as ResistantInput,
  Ey as ResourceRecommendationChip,
  vy as ResourceRecommender,
  Ty as ResourceRecommenderActionMenu,
  Ay as ResourceWatcherRouter,
  yy as RuntimeParamTabs,
  jy as RuntimeParameters,
  Oy as SCOPED_VARIABLES_TEMPLATE_DATA,
  gT as SDH_NAV_GROUP,
  fT as SECURITY_ENABLEMENT_NAV_ITEM,
  Iy as SaveChangesModal,
  wy as ScopedVariablesEnvironmentDetailsRouter,
  Py as ScopedVariablesEnvironmentListContainer,
  bT as SecurityEnablement,
  Ry as SecurityModalSidebar,
  Ly as SelectDeploymentStrategy,
  ky as ShowIneligibleChangesModal,
  Dy as SkipHibernatedCheckbox,
  xI as SoftwareDistributionHub,
  CI as SoftwareDistributionHubRenderProvider,
  My as StatusCell,
  By as StatusFilterDropdown,
  Uy as StatusHeaderCell,
  Fy as SwapTraffic,
  Vy as SwapTrafficDialog,
  Lv as SyncEnvironment,
  oT as TagListContainer,
  Gy as TemplateList,
  an as Timer,
  Wy as ToggleEnableRole,
  $y as ToggleManifestConfigurationMode,
  Ky as ToggleSecurityScan,
  Hy as TriggerBlockEmptyState,
  Yy as TriggerBlockedError,
  zy as UpdateCreateClusterAction,
  tT as UserAutoAssignedRoleGroupsTable,
  qy as UserConfigChangeActionType,
  Xy as UserGroupCell,
  Jy as UserGroupSelector,
  Qy as UserListFilterToolbar,
  aT as UserPermissionConfirmationModal,
  q_ as UserPermissionsInfoBar,
  Zy as UserStatusUpdate,
  ej as ViewIsPipelineRBACConfigured,
  bI as VirtualAppDetailsEmptyState,
  SI as VirtualClusterForm,
  NI as VirtualEnvHelpTippy,
  EI as VirtualEnvSelectionInfoText,
  vI as VirtualHistoryArtifact,
  sj as WebhookAddImageButton,
  tj as WebhookAddImageModal,
  aj as WorkflowActionRouter,
  nj as changeStatusToInactiveIfTemporary,
  oj as checkForIneligibleChanges,
  rj as convertUTCToTimezoneDate,
  lj as createDevtronAppUsingTemplate,
  ij as createResource,
  cj as deleteInstalledCluster,
  dj as downloadManifestForVirtualEnvironment,
  uj as dryRunBulkEditScript,
  pj as generatePanelDataStoreFromResponse,
  mj as getAccessManagerRoles,
  hj as getAdditionalRolesAccordingToAccess,
  _j as getAllDrafts,
  fj as getAppEnvsMin,
  gj as getApprovalPolicyConfigForApp,
  xj as getApprovalPolicyConfigForEnv,
  K_ as getAuthorizationGlobalConfig,
  Cj as getBrowserTimezone,
  bj as getBrowserTimezoneOffset,
  Sj as getBulkEditConfig,
  Wv as getCIBlockState,
  Nj as getCategoryPayload,
  rT as getCloudProviderForCluster,
  Ej as getClusterNamespaces,
  vj as getConfigAfterOperations,
  Tj as getDefaultStatusAndTimeout,
  Aj as getDefaultUserStatusAndTimeout,
  yj as getDefaultValueForPanelConfiguration,
  jj as getDeleteDraftPopupButtonConfig,
  Oj as getDeploymentNotAllowedState,
  Ij as getDeploymentStrategies,
  wj as getDeploymentStrategyDetails,
  Pj as getDeploymentWindowProfileMetaData,
  Rj as getDeploymentWindowState,
  Lj as getDeploymentWindowStateAppGroup,
  tu as getDeploymentWindowTimeStampIcon,
  kj as getDesiredAndLiveManifest,
  Dj as getDevtronLicenseDetails,
  Mj as getDownloadManifestUrl,
  Bj as getDraft,
  Uj as getDraftByResourceName,
  Fj as getEditHistoryPopupButtonConfig,
  TI as getEnvFormattedOptionLabel,
  Vj as getExpressDeleteDraftPopupButtonConfig,
  Gj as getFilterCriteria,
  Zi as getFilterOptionsFromSearchParams,
  Wj as getFilteredPatches,
  $j as getFormattedTimeToLive,
  Kj as getHibernationPatchConfig,
  Hj as getImageLabelsFromApplications,
  Yj as getInstallationClusterConfig,
  zj as getInstallationClusterConfigs,
  qj as getIsStatusDropdownDisabled,
  Xj as getJsonPath,
  Jj as getLockConfigEligibleAndIneligibleChanges,
  Qj as getLockFilteredTemplate,
  Zj as getLockedJSON,
  eO as getLockedManifestKeys,
  sO as getManageTrafficMenuButtonConfig,
  tO as getManifestGUISchema,
  aO as getMonitoringDashboardTabConfig,
  nO as getPanelTemplateAttributeKey,
  Br as getParsedPluginPolicyConsequenceData,
  oO as getParsedUserGroupList,
  rO as getPermissionActionValue,
  lO as getPolicyConsequences,
  iO as getRecommendationChipIconAndClass,
  cO as getRemaining,
  zv as getRemoteConnectionConfig,
  Yn as getResourceManifestResult,
  dO as getResourceRecommendationLabel,
  uO as getResourceRecommendationListPayload,
  pO as getResourceRecommendationsCSVData,
  mO as getResourceRecommenderTabConfig,
  hO as getResourceScanDetails,
  _O as getRoleConfig,
  fO as getRuntimeParams,
  gO as getRuntimeParamsPayload,
  qv as getSSHConfig,
  xO as getStatusAndTimeoutPayload,
  CO as getStatusExportText,
  bO as getStatusFromSearchParams,
  Mv as getTaskActionPluginValidationStatus,
  SO as getTermsAndConditions,
  NO as getToggleViewLockedKeysPopupButtonConfig,
  EO as getTotalEligibleApproverCount,
  vO as getUnlockedJSON,
  TO as getUserEmailsFromApproversList,
  AO as getUserExportToCsvConfiguration,
  yO as getUserGroupsPayload,
  zo as getUserListMin,
  jO as getUserStatus,
  OO as getUserStatusAndTimeoutPayload,
  IO as getUserTypeToFetchFromSelectedConfigOptions,
  wO as getUsersEligibleForNotification,
  PO as handleCreateResourceError,
  RO as isFELibAvailable,
  LO as makeObjectFromJsonPathArray,
  kO as migrateUserPreferences,
  DO as parseDataStoreConfigToLayoutList,
  MO as parseRecommendationGVKListDTO,
  BO as parseResourceRecommendationDTO,
  UO as parseSearchParams,
  FO as postBulkEditScript,
  VO as processDeploymentWindowAppGroupOverviewMap,
  GO as processDeploymentWindowMetadata,
  WO as processDeploymentWindowStateAppGroup,
  $v as processPluginData,
  AI as processVirtualEnvironmentDeploymentData,
  $O as reapplyRemovedLockedKeysToYaml,
  KO as removeLockedKeysFromYaml,
  HO as renderApprovalStatusIcon,
  yI as renderCIListHeader,
  YO as renderConfigDriftDetectedText,
  jI as renderDeploymentApprovalInfo,
  OI as renderDeploymentHistoryTriggerMetaText,
  zO as renderOutOfSyncWarning,
  II as renderRunSource,
  wI as renderRunSourceInDropdown,
  qO as renderVirtualEnvironmentInfoText,
  PI as renderVirtualHistoryArtifacts,
  XO as restartRBWorkload,
  JO as sanitizeUserApprovalConfig,
  Qv as scopedVariablesHelpTippyText,
  QO as submitDraftRequest,
  ZO as tableFilter,
  eI as updatePipelineRBACView,
  sI as updateResourceManifest,
  tI as useClusterUpgradeCompatibilityInfo,
  tg as useCostVisibilityRenderContext,
  Hn as useDeploymentWindow,
  aI as useEnterpriseLicenseConfig,
  RI as useReleaseConfigurationContext,
  C_ as validatePlugins,
  nI as validateRuntimeParameters,
  oI as validateUserApprovalConfig,
  LI as virtualClusterSaveUpdateApi
};
